/*! @twilio/flex-ui.js 1.18.0
The following license applies to all parts of this software except as documented below.

Copyright (c) 2018 Twilio, Inc.
All rights reserved.

 Licensed under the Apache License, Version 2.0 (the “License”);
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an “AS IS” BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.


This software includes react under the following license.

Copyright (c) Facebook, Inc. and its affiliates.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.


This software includes redux under the following license.
Copyright (c) 2015-present Dan Abramov

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.


This software includes semver under the following license.
Copyright (c) Isaac Z. Schlueter and Contributors

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.


This software includes loglevel under the following license.
Copyright (c) 2013 Tim Perry

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without
restriction, including without limitation the rights to use,
copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following
conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
OTHER DEALINGS IN THE SOFTWARE.


This software includes hoist-non-react-statics under the following license.

Software License Agreement (BSD License)
========================================

Copyright (c) 2015, Yahoo! Inc. All rights reserved.
----------------------------------------------------

Redistribution and use of this software in source and binary forms, with or
without modification, are permitted provided that the following conditions are
met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.
  * Neither the name of Yahoo! Inc. nor the names of YUI's contributors may be
    used to endorse or promote products derived from this software without
    specific prior written permission of Yahoo! Inc.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.*/
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Flex = t() : (e.Twilio = e.Twilio || {}, e.Twilio.Flex = t());
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/assets/", n(n.s = 219);
  }([function (e, t) {
    e.exports = require("@twilio/flex-ui-core");
  }, function (e, t) {
    e.exports = require("react");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(35),
        o = n(36);
    t.default = r.default, t.withTheme = function (e) {
      return o.withTheme(e);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(66),
        o = n(106),
        i = n(24),
        a = n(237),
        s = function s(e) {
      return e.flex;
    },
        c = function () {
      function e() {}

      return e.init = function (t, n) {
        void 0 === n && (n = s), e.stateCallback = n, e.store = t;
      }, Object.defineProperty(e, "state", {
        get: function get() {
          if (!e.stateCallback) throw new Error("FlexModule not initialized");
          return e.stateCallback(e.store.getState());
        },
        enumerable: !0,
        configurable: !0
      }), e.dispatch = function (t) {
        if (!e.store) throw new Error("FlexModule not initialized");
        return e.store.dispatch(t);
      }, Object.defineProperty(e, "chatClient", {
        get: function get() {
          return this._chatClient;
        },
        set: function set(e) {
          this._chatClient = e, e && a.ChatListener.init(e);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e, "workerClient", {
        get: function get() {
          return this._workerClient;
        },
        set: function set(e) {
          this._workerClient = e;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e, "insightsClient", {
        get: function get() {
          return this._insightsClient;
        },
        set: function set(e) {
          this._insightsClient = e;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e, "voiceClient", {
        get: function get() {
          return this._voiceClient;
        },
        enumerable: !0,
        configurable: !0
      }), e.events = new i.FlexEventEmitter(), e._voiceClient = o.Device, e;
    }();

    t.FlexModule = c, t.connect = function (e, t, n, o) {
      return r.connect(function (t, n) {
        var r = c.stateCallback(t);
        return e(r, n);
      }, t, n, o);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(0);
    t.Template = r.Template, t.CompiledTemplate = r.CompiledTemplate;
    var o = r.templates;
    t.templates = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(226),
        o = n(108),
        i = n(109),
        a = r.getLogger("twilio-flex-ui");
    t.default = a, t.log = a;
    var s = r.getLogger("twilio-frame-ui"),
        c = new o.LogManager({
      identifier: "Default Flex Log Manager",
      spies: [{
        type: i.PredefinedSpies.Loglevel,
        target: a,
        targetAlias: "Flex loglevel",
        methods: ["trace", "info", "debug", "warn", "error"],
        onStart: function onStart(e) {
          e.info("Flex UI logger decorated");
        }
      }, {
        type: i.PredefinedSpies.Loglevel,
        target: s,
        targetAlias: "Frame loglevel",
        methods: ["trace", "info", "debug", "warn", "error"],
        onStart: function onStart(e) {
          e.info("Frame UI logger decorated");
        }
      }, {
        type: i.PredefinedSpies.DOMEvents,
        target: window,
        events: ["error"]
      }]
    });
    t.logManager = c, c.isReady() && c.start();
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(0),
        a = n(5);
    t.tryInvokeAction = function (e, t) {
      return r(this, void 0, Promise, function () {
        var n;
        return o(this, function (r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 2,, 3]), [4, i.Actions.invokeAction(e, t)];

            case 1:
              return [2, r.sent()];

            case 2:
              return (n = r.sent()) instanceof Error && n.message === "Action " + e + " cancelled by before event" || a.log.error(n), [2, Promise.reject(n)];

            case 3:
              return [2];
          }
        });
      });
    }, t.isAdmin = function (e) {
      return e.roles.indexOf("admin") >= 0;
    }, t.isSupervisor = function (e) {
      return e.roles.indexOf("supervisor") >= 0;
    }, t.templateStr = function (e, t) {
      var n = Object.keys(t).reduce(function (e, n) {
        return e.replace("${" + n + "}", t[n]);
      }, e),
          r = n.match(/\$\{[a-zA-Z0-9]+\}/g);
      if (r) throw r = r.map(function (e) {
        return e.substr(2, e.length - 3);
      }), new Error("Missing parameters: " + r.join(", "));
      return n;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(0),
        o = n(22),
        i = n(3),
        a = n(12),
        s = n(30),
        c = function () {
      function e(e) {
        this.task = e;
      }

      return Object.defineProperty(e.prototype, "lastChatMessage", {
        get: function get() {
          return console.warn("Warning! Getter 'TaskHelper.lastChatMessage' has been deprecated, please use 'chat.lastMessage' instead!"), this.chat.lastMessage;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "chat", {
        get: function get() {
          if (e.isChatBasedTask(this.task)) {
            if (this.chatChannelHelper) return this.chatChannelHelper;
            var t = o.StateHelper.getChatChannelStateForTask(this.task);
            if (t) return this.chatChannelHelper = new r.ChatChannelHelper(t), this.chatChannelHelper;
          }
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "durationSinceUpdate", {
        get: function get() {
          return r.Utils.formatTimeDuration(Math.max(Date.now() - this.task.dateUpdated.getTime(), 0));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "durationSinceUpdateShort", {
        get: function get() {
          return r.Utils.formatTimeDuration(Math.max(Date.now() - (this.task.age + this.task.dateUpdated.getTime()), 0), "compact");
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "jsonString", {
        get: function get() {
          return JSON.stringify(this.task, void 0, 2);
        },
        enumerable: !0,
        configurable: !0
      }), e.isLiveCall = function (e) {
        return this.isCallTask(e) && "accepted" === e.status;
      }, e.isCallOnHold = function (t) {
        return !!e.isLiveCall(t) && (!(e.isRegularConferenceCall(t) || !i.FlexModule.state.phone.connection || !i.FlexModule.state.phone.connection.oldHold) || !!t.conference && t.conference.participants.some(function (e) {
          return "customer" === e.participantType && e.onHold;
        }));
      }, e.canKickWorkerParticipant = function (t, n) {
        return e.isLiveCall(t) && e.isMyTask(t) && !e.amIOnHold(t) && !(t.outgoingTransferObject && "initiated" === t.outgoingTransferObject.status) && "joined" === n.status;
      }, e.canHold = function (t) {
        return e.isLiveCall(t) && e.isMyTask(t) && !e.amIOnHold(t) && !(t.outgoingTransferObject && "initiated" === t.outgoingTransferObject.status);
      }, e.amIOnHold = function (t) {
        if (!e.isRegularConferenceCall(t)) return !1;
        var n = t.conference.participants.find(function (e) {
          return e.isMyself && "joined" === e.status;
        });
        return !!n && n.onHold;
      }, e.canTransfer = function (t) {
        return !(!e.isLiveCall(t) || !e.isMyTask(t)) && !!e.isRegularConferenceCall(t) && (!t.outgoingTransferObject || "initiated" !== t.outgoingTransferObject.status) && !e.amIOnHold(t);
      }, e.isRegularConferenceCall = function (e) {
        return e.conference && e.conference.participants.length > 0;
      }, e.isGroupCall = function (e) {
        return !!e.conference && e.conference.liveParticipantCount > 2;
      }, e.isLiveChat = function (e) {
        return this.isChatBasedTask(e) && "accepted" === e.status;
      }, e.isIncomingCall = function (e) {
        return this.isCallTask(e) && this.isPending(e);
      }, e.isChatBasedTask = function (e) {
        var t = a.TaskChannels.getForTask(e);
        return !!t && t.capabilities.has(s.TaskChannelCapability.Chat);
      }, e.isCallTask = function (e) {
        if (!e) return !1;
        var t = a.TaskChannels.getForTask(e);
        return !!t && t.capabilities.has(s.TaskChannelCapability.Call);
      }, e.isVideoCallTask = function (e) {
        var t = a.TaskChannels.getForTask(e);
        return !!t && t.capabilities.has(s.TaskChannelCapability.Video);
      }, e.getTaskChatChannelSid = function (e) {
        return (e.attributes.channelSid || "").trim();
      }, e.isPending = function (e) {
        return "pending" === e.status;
      }, e.isInWrapupMode = function (e) {
        return "wrapping" === e.status;
      }, e.isCompleted = function (e) {
        return "completed" === e.status;
      }, e.isMyTask = function (e) {
        return e.workerSid && e.workerSid === i.FlexModule.workerClient.sid;
      }, e.getTaskFromChannelSid = function (t) {
        for (var n = Array.from(i.FlexModule.state.worker.tasks.values()).find(function (n) {
          return t === e.getTaskChatChannelSid(n);
        }), r = 0; !n && r < i.FlexModule.state.supervisor.workers.length;) {
          n = i.FlexModule.state.supervisor.workers[r].tasks.find(function (n) {
            return t === e.getTaskChatChannelSid(n);
          }), r++;
        }

        return n;
      }, e.getTaskByTaskSid = function (e) {
        return i.FlexModule.state.worker.tasks.get(e);
      }, e.isTaskAccepted = function (t) {
        return e.isCompleted(t) || e.isInWrapupMode(t) || "accepted" === t.status;
      }, e.isOutboundCallTask = function (t) {
        return e.isCallTask(t) && !!t.routingTarget && "outbound" === t.attributes.direction;
      }, e.isInitialOutboundAttemptTask = function (t) {
        return e.isOutboundCallTask(t) && !t.incomingTransferObject && e.isPending(t);
      }, e;
    }();

    t.TaskHelper = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(74),
        o = "https://preview.twilio.com/iam/Accounts/{accountSid}",
        i = {
      flexServiceUrl: "https://preview.twilio.com/Flex",
      chatOrchestrationServiceUrl: "https://preview.twilio.com/Flex/WebChannels",
      flexConfigServiceUrl: "https://flex-api.twilio.com/v1/Configuration",
      flexInsightsIdentityUrl: "https://identity.ytica.com/identity",
      flexPublicConfigServiceUrl: "https://flex-api.twilio.com/v1/Configuration/Public",
      callRecordingCallbackUrl: "https://webhooks.twilio.com/v1/Accounts/{accountSid}/Workspaces/{workspaceSid}/Tasks/{taskSid}/FlexRecordingWebhook",
      ssoLoginUrl: o + "/authenticate",
      ssoTokenRefreshUrl: o + "/Tokens/refresh",
      twilioServiceLoginUrl: "https://www.twilio.com/service-login/flex",
      twilioTaskQueuesUrl: "https://www.twilio.com/console/taskrouter/workspaces/{workspaceSid}/taskqueues",
      pluginServiceUrl: "https://flex.twilio.com/plugins",
      sessionUrl: "https://flex.twilio.com/api/v1/Session",
      workspaceTaskQueues: "https://taskrouter.twilio.com/v1/Workspaces/{workspaceSid}/TaskQueues"
    };
    t.flexPublicConfigServiceUrl = i.flexPublicConfigServiceUrl, t.twilioServiceLoginUrl = i.twilioServiceLoginUrl, t.deprecatedFlexLookupServiceUrl = "https://flex.twilio.com/lookup", t.getTwilioTaskQueuesUrl = function (e) {
      return i.twilioTaskQueuesUrl.replace("{workspaceSid}", e);
    }, t.getFlexServiceUrl = function (e) {
      return e.flexServiceUrl || i.flexServiceUrl;
    }, t.getChatOrchestrationServiceUrl = function (e) {
      return e.chatOrchestrationServiceUrl || i.chatOrchestrationServiceUrl;
    }, t.getFlexConfigServiceUrl = function (e) {
      return e.flexConfigServiceUrl || i.flexConfigServiceUrl;
    }, t.getCallRecordingCallbackUrl = function (e) {
      return e.call_recording_callback_url || i.callRecordingCallbackUrl;
    }, t.getSSOLoginUrl = function (e, t) {
      return (e.loginUrl || i.ssoLoginUrl).replace("{accountSid}", t);
    }, t.getSSOTokenRefreshUrl = function (e, t) {
      return (e.tokenRefreshUrl || i.ssoTokenRefreshUrl).replace("{accountSid}", t);
    }, t.getPluginServiceUrl = function (e) {
      var t = e.pluginService;
      return t && t.url || i.pluginServiceUrl;
    }, t.getPublicConfigServiceUrl = function (e, t) {
      return void 0 === t && (t = {}), (t.publicConfigServiceUrl || i.flexPublicConfigServiceUrl) + "?AccountSid=" + e;
    }, t.getSessionUrl = function (e) {
      return e.sessionUrl || i.sessionUrl;
    }, t.getFlexInsightsIdentityUrl = function (e) {
      return e.insights && e.insights.identityUrl || i.flexInsightsIdentityUrl;
    }, t.getFlexInsightsBaseUrl = function (e) {
      return e.insights && e.insights.baseUrl || "https://app.ytica.com";
    }, t.getFlexInsightsQuestionnairesUrl = function (e) {
      return e.insights && e.insights.questionnairesUrl || "https://apps.ytica.com/assessments";
    }, t.getFlexInsightsSSOUrl = function (e) {
      return e.insights && e.insights.ssoUrl || "https://apigw.ytica.com/provisioning/token-generator";
    }, t.getFlexInsightsPlayerConfig = function (e) {
      return e.insights && e.insights.player || r.defaultEnvConfig;
    }, t.getWorkspaceTaskQueuesUrl = function (e) {
      return i.workspaceTaskQueues.replace("{workspaceSid}", e);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(14));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    },
        i = this && this.__metadata || function (e, t) {
      if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
    },
        a = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        s = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var c = n(15),
        l = n(0),
        u = n(77),
        p = n(120),
        d = n(3),
        f = n(26),
        h = n(78),
        m = n(82),
        g = n(257);
    t.defaultConfiguration = g.default;

    var y = n(126),
        v = n(33),
        b = n(43),
        C = n(5),
        _ = n(128),
        k = n(56),
        w = n(31),
        T = n(12),
        O = n(260),
        P = n(129),
        S = n(8),
        x = n(70),
        E = n(131),
        A = n(6),
        j = n(263),
        L = n(19),
        I = n(42),
        N = function N(e) {
      return e.flex.chat;
    },
        M = function () {
      function e(e, t) {
        this._initialized = !1, this._store = t, this.configureReduxStore(), this.updateConfig(g.default, e);
      }

      var t, n;
      return e.getInstance = function () {
        return this._instance;
      }, e.validateConfig = function (e) {
        "string" == typeof e.colorTheme && (e.colorTheme = {
          baseName: e.colorTheme
        });
      }, e.create = function (t, n, r) {
        return a(this, void 0, Promise, function () {
          var o,
              i,
              c,
              u,
              p,
              d = this;
          return s(this, function (g) {
            switch (g.label) {
              case 0:
                return "object" != typeof t && (t = n, n = r, C.log.warn("Deprecated signature of Manager.create called and will not be supported by the future releases. Please change accordingly. Pass first parameter as configuration object and optionally your own Redux store as second parameter.")), C.log.setLevel(void 0 === t.logLevel ? "error" : t.logLevel), C.log.info("Creating manager. flex-ui version:", w.VERSION, "core-ui version:", l.VERSION), n || (o = m.default(t.router), n = h.createDefaultStore({
                  history: o
                })), n.getState().flex ? (c = function c() {
                  return a(d, void 0, void 0, function () {
                    return s(this, function (e) {
                      switch (e.label) {
                        case 0:
                          return !A.isAdmin(i.user) && !A.isSupervisor(i.user) || !I.FeatureFlags.isEnabled(L.FeatureFlag.FlexInsights) && void 0 !== I.FeatureFlags.isEnabled(L.FeatureFlag.FlexInsights) ? [3, 2] : [4, E.InsightsService.init()];

                        case 1:
                          e.sent(), e.label = 2;

                        case 2:
                          return [2];
                      }
                    });
                  });
                }, [4, v.SSOLoginHandler.create(t.sso)]) : [2, Promise.reject(new Error("Invalid Redux store passed. 'flex' key not found in state."))];

              case 1:
                return u = g.sent(), [4, (i = new e(t, n)).fetchConfiguration()];

              case 2:
                if (p = g.sent(), !i.validateServiceVersion()) throw new Error("Service version is not compatible");
                return i.updateConfig(p, t), e._instance = i, [4, j.fetchFlexFeatures(i)];

              case 3:
                return g.sent(), [4, f.Actions.ssoLogin(u)];

              case 4:
                return g.sent(), [4, Promise.all([c(), y.loadPlugins(P.Flex, i)])];

              case 5:
                return g.sent(), C.log.debug("ready to launch"), [2, i];
            }
          });
        });
      }, e.prototype.updateConfig = function () {
        for (var t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }

        var r = t.reduce(function (e, t) {
          return l.Utils.merge(e, t);
        }, this.configuration);

        if (e.validateConfig(r), this.setStringsFromConfig(r), r.componentProps && l.Utils.updateDefaultProps(k, r.componentProps), r.notifications && void 0 !== r.notifications.browser) {
          var o = r.notifications.browser;
          o && !window.Notification && (C.log.warn("This browser does not support Notification capabilities"), o = !1), l.Notifications.toggleNotificationHandler(l.DefaultNotificationHandlerType.Browser, o);
        }

        p.Actions.initConfig(r);
      }, Object.defineProperty(e.prototype, "configuration", {
        get: function get() {
          return d.FlexModule.state.config;
        },
        set: function set(t) {
          e.validateConfig(t), e.validateConfig(g.default), t = l.Utils.merge(g.default, t), this.setStringsFromConfig(t), t.componentProps && l.Utils.updateDefaultProps(k, t.componentProps), p.Actions.initConfig(t);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "serviceConfiguration", {
        get: function get() {
          return this._serviceConfiguration;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "store", {
        get: function get() {
          return this._store;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "events", {
        get: function get() {
          return d.FlexModule.events;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "strings", {
        get: function get() {
          if (!this._strings) throw new Error("Strings not set");
          return this._strings;
        },
        set: function set(e) {
          this._strings = e, this._initialized && l.initWithStrings(e);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "user", {
        get: function get() {
          var e = d.FlexModule.state.session.ssoTokenPayload;
          return {
            identity: e.identity,
            roles: e.roles,
            token: e.token,
            tokenExpirationDate: new Date(Date.parse(e.expiration))
          };
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "chatClient", {
        get: function get() {
          return d.FlexModule.chatClient;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "voiceClient", {
        get: function get() {
          return d.FlexModule.voiceClient;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "workerClient", {
        get: function get() {
          return d.FlexModule.workerClient;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "insightsClient", {
        get: function get() {
          return d.FlexModule.insightsClient;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.loadInitialData = function () {
        return this._initialized || (l.initWithStrings(this.strings), T.initAllRegisteredTaskChannels(k), x.loadChatChannelsForTasks(), this._initialized = !0), Promise.resolve();
      }, e.prototype.fetchConfiguration = function () {
        var e = this,
            t = v.SSOLoginHandler.getTokenInfo().token,
            n = S.getFlexConfigServiceUrl(this.configuration);
        return c.default.get(n, {
          auth: {
            username: "token",
            password: t
          },
          params: {
            UiVersion: w.VERSION
          }
        }).then(function (t) {
          var n = t.data;
          return e._serviceConfiguration = n, r(r({}, n.ui_attributes), {
            sso: {
              accountSid: n.account_sid
            },
            serviceBaseUrl: n.runtime_domain
          });
        }).catch(function (e) {
          throw C.log.error("Failed to fetch configuration", e), e;
        });
      }, e.prototype.validateServiceVersion = function () {
        if (!this._serviceConfiguration) throw new Error("No service configuration");
        var e = this._serviceConfiguration.ui_attributes;
        if (!e) throw new Error("No ui_attributes in service configuration");
        return O.isCompatible(e.version_compatibility, e.version_message);
      }, e.prototype.configureReduxStore = function () {
        d.FlexModule.init(this._store), l.ChatModule.init(this._store, N);
      }, e.prototype.setStringsFromConfig = function (e) {
        if (this.configuration.language !== e.language) {
          var t = e.language || "default",
              n = b.languages[t] || b.languages.default;
          this.strings = n;
        }
      }, o([_.deprecatedSetter("updateConfig"), i("design:type", "function" == typeof (t = void 0 !== u && u.Config) ? t : Object), i("design:paramtypes", ["function" == typeof (n = void 0 !== u && u.Config) ? n : Object])], e.prototype, "configuration", null), e;
    }();

    t.Manager = M;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(1),
        o = function () {
      function e() {}

      return e.getTemplateForStatus = function (e, t, n) {
        if (!t && "" !== t) throw new Error("No template holder");
        return "string" == typeof t ? t : "function" == typeof t ? t(e, n) : "pending" === e.status && t.Pending || "accepted" === e.status && t.Accepted || "wrapping" === e.status && t.Wrapping || "completed" === e.status && t.Completed || "canceled" === e.status && t.Canceled || "pending" === e.status && t.Reserved || "accepted" === e.status && t.Assigned;
      }, e.getIcon = function (e, t, n) {
        if (!t) throw new Error("No icon holder");
        if ("string" == typeof t || r.isValidElement(t)) return t;
        if ("function" == typeof t) return t(e, n);
        var o = t;
        return "wrapping" === e.status && o.Wrapping || "completed" === e.status && o.Completed || "canceled" === e.status && o.Canceled || "pending" === e.status && o.Pending || "accepted" === e.status && o.Accepted || "pending" === e.status && o.Reserved || "accepted" === e.status && o.Assigned;
      }, e.getColor = function (e, t, n) {
        if (!t) throw new Error("No color holder");
        return "string" == typeof t ? t : "function" == typeof t ? t(e, n) : "pending" === e.status && t.Pending || "accepted" === e.status && t.Accepted || "wrapping" === e.status && t.Wrapping || "completed" === e.status && t.Completed || "canceled" === e.status && t.Canceled || "pending" === e.status && t.Reserved || "accepted" === e.status && t.Assigned;
      }, e;
    }();

    t.TaskChannelHelper = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(0),
        o = n(5),
        i = n(238);
    t.DefaultTaskChannels = i, function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(30));
    var a,
        s = n(11);
    t.TaskChannelHelper = s.TaskChannelHelper;

    var c = function () {
      function e() {}

      return e.prototype.getRegistered = function () {
        return a;
      }, e.prototype.getForTask = function (e) {
        var t = a.find(function (t) {
          return t.isApplicable(e);
        });
        return t || (o.log.trace("Task channel definition not found for task, using default", e), i.Default);
      }, e.prototype.register = function (e, t) {
        void 0 === t && (t = !0), a.find(function (t) {
          return t === e || t.name === e.name;
        }) ? o.log.error("Task channel with the same name already registered") : (t && (e = r.Utils.merge(i.Default, e)), o.log.info("Registering custom task channel", e.name, e), a.unshift(e));
      }, e.prototype.unregister = function (e) {
        var t = a && a.find(function (t) {
          return t.name === e.name;
        });

        if (t) {
          o.log.info("Unregistering task channel", t);
          var n = t._registrationCallbacks;
          n && Array.isArray(n) && n.forEach(function (e) {
            return "function" == typeof e && e();
          }), a = a.filter(function (e) {
            return e === t;
          });
        } else o.log.warn("Task channel does not exist", e);
      }, e;
    }();

    t.TaskChannels = new c(), t.registerDefaultTaskChannels = function (e) {
      i.initDefaultChannels(e), a = [i.Call, i.ChatLine, i.ChatMessenger, i.ChatSms, i.ChatWhatsApp, i.Chat];
    }, t.initAllRegisteredTaskChannels = function (e) {
      o.log.debug("Initializing registered task channels"), a.forEach(function (t) {
        o.log.debug("Initializing task channel", t.name, t), l(t, e), u(t);
      });
    };

    var l = function l(e, t) {
      var n,
          r = [],
          i = function i(e) {
        if (e) {
          if (t[e]) {
            var n = t[e].Content;
            if (n) return n;
            o.log.error("Component doest not have dynamic Content", e);
          } else o.log.error("Component doest not exist", e);
        } else o.log.error("Invalid target", e);
      },
          a = function a(t, n) {
        Array.isArray(t) && t.forEach(function (t) {
          var a = t.component,
              s = t.target;

          if (a) {
            var c = i(s);

            if (c) {
              var l = t.options || {};
              l.replace = n;
              var u = l.if;
              l.if = function (t) {
                return t.task && e.isApplicable(t.task) && (!u || u(t));
              }, o.log.debug("Registering custom component. Target=" + s + " replace=" + n + ", channel: " + e.name, e, a), r.push(c.add(a, l));
            }
          } else o.log.error("Invalid component", a);
        });
      };

      a(e.addedComponents, !1), a(e.replacedComponents, !0), n = e.removedComponents, Array.isArray(n) && n.forEach(function (t) {
        var n = t.key,
            a = t.target;

        if (n) {
          var s = i(a);

          if (s) {
            var c = t.options || {},
                l = c.if;
            c.if = function (t) {
              return t.task && e.isApplicable(t.task) && (!l || l(t));
            }, o.log.debug("Registering component removal. Target=" + a + ", key: " + n + " channel: " + e.name, e), r.push(s.remove(n, c));
          }
        } else o.log.error("Invalid key", n);
      }), e._registrationCallbacks = r;
    },
        u = function u(e) {
      var t = e.notifications && e.notifications.override;
      t && r.Notifications.addListener("beforeAddNotification", function (n, o) {
        var i = t[n.id];

        if (void 0 !== i) {
          var a = n.context && n.context.task;
          a && e.isApplicable(a) && (null !== i ? "object" == typeof i ? r.Utils.mergeInto(n, i) : "function" == typeof i && i.call(null, n, o) : o());
        }
      });
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(10);
    t.ContactCenterManager = o.Manager;
    var i = n(108);
    t.Log = i, r(n(10)), r(n(62)), r(n(53));
    var a = n(28);
    t.ConfigError = a.ConfigError, t.ConfigErrorKeys = a.ConfigErrorKeys;
    var s = n(126);
    t.Plugins = s.Plugins;
  }, function (e, t, n) {
    "use strict";

    var _r,
        o = this && this.__extends || (_r = function r(e, t) {
      return (_r = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    },
        s = this && this.__rest || function (e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var c = n(1),
        l = n(139),
        u = n(7),
        p = n(22),
        d = n(12),
        f = n(3);
    t.TaskContext = c.createContext({});

    var h = function h(e, t) {
      var n,
          r = e.worker.tasks.get(t.taskSid);
      return u.TaskHelper.isCallTask(r) && (n = e.conferences.states.get(r.taskSid)), {
        task: r,
        conference: n,
        call: r && (u.TaskHelper.isLiveCall(r) || u.TaskHelper.isInitialOutboundAttemptTask(r)) ? p.StateHelper.getCurrentPhoneCallState() : void 0,
        chatChannel: r && u.TaskHelper.isChatBasedTask(r) ? e.chat.channels[u.TaskHelper.getTaskChatChannelSid(r)] : void 0
      };
    },
        m = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props,
            n = (e.taskSid, e.children),
            r = s(e, ["taskSid", "children"]);
        return r.channelDefinition = r.task ? d.TaskChannels.getForTask(r.task) : void 0, c.createElement(t.TaskContext.Provider, {
          value: r
        }, n);
      }, n = a([f.connect(h)], n);
    }(c.PureComponent);

    t.TaskContextSource = m, t.withTaskContext = function (e) {
      var n;
      return l(((n = function (n) {
        function r() {
          return null !== n && n.apply(this, arguments) || this;
        }

        return o(r, n), r.prototype.render = function () {
          var n = this;
          return c.createElement(t.TaskContext.Consumer, null, function (t) {
            return c.createElement(e, i({}, n.props, t));
          });
        }, r;
      }(c.PureComponent)).displayName = "WithTaskContext(" + e.displayName + ")", n), e);
    };
  }, function (e, t) {
    e.exports = require("axios");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    },
        a = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
        e += arguments[t].length;
      }

      var r = Array(e),
          o = 0;

      for (t = 0; t < n; t++) {
        for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) {
          r[o] = i[a];
        }
      }

      return r;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s,
        c = n(3),
        l = n(115),
        u = n(5),
        p = n(7),
        d = n(17),
        f = n(137);
    !function (e) {
      e[e.none = 0] = "none", e[e.waiting = 1] = "waiting", e[e.monitoring = 2] = "monitoring";
    }(s = t.CallMonitoringStatus || (t.CallMonitoringStatus = {}));
    var h = {
      callMonitoring: {
        status: s.none,
        workers: null,
        task: null
      },
      workers: [],
      stickyWorker: null,
      isLoadingWorkers: !1
    };
    t.ACTION_UPDATE_STATE = "SUPERVISOR_UPDATE", t.ACTION_MONITORING_SUCCEEDED = "SUPERVISOR_INCOMING_CALL", t.ACTION_MONITORING_UPDATED = "SUPERVISOR_INCOMING_CALL_UPDATE", t.reduce = function (e, n) {
      switch (void 0 === e && (e = h), n.type) {
        case t.ACTION_UPDATE_STATE:
          var o = n.payload;
          return r(r({}, e), o);

        case t.ACTION_MONITORING_SUCCEEDED:
        case t.ACTION_MONITORING_UPDATED:
          o = {
            callMonitoring: r(r({}, e.callMonitoring), {
              status: s.monitoring,
              workers: e.callMonitoring.task.conference.liveWorkers.map(function (e) {
                return e.worker;
              })
            })
          };
          return r(r({}, e), o);

        default:
          return e;
      }
    };

    var m = function () {
      function e() {}

      return e.dispatchStateUpdate = function (e, n) {
        var o = this;
        void 0 === n && (n = !0);

        var i = function i(e) {
          o.dispatcher({
            type: t.ACTION_UPDATE_STATE,
            payload: e
          });
        };

        n ? (this.stateUpdateThrottler && (clearTimeout(this.stateUpdateThrottler), this.stateUpdateThrottler = null, i(this.pendingStateUpdate), this.pendingStateUpdate = null), i(e)) : this.stateUpdateThrottler ? this.pendingStateUpdate = r(r({}, this.pendingStateUpdate), e) : (i(e), this.pendingStateUpdate = {}, this.stateUpdateThrottler = window.setTimeout(function () {
          clearTimeout(o.stateUpdateThrottler), i(o.pendingStateUpdate), o.stateUpdateThrottler = null, o.pendingStateUpdate = null;
        }, 500));
      }, Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return this._dispatcher || c.FlexModule.dispatch;
        },
        set: function set(e) {
          this._dispatcher = e;
        },
        enumerable: !0,
        configurable: !0
      }), e.assignInsights = function (t) {
        this.dispatchStateUpdate({
          listener: f.SupervisorWorkersListener.create(t, e)
        });
      }, e.monitorCall = function (e) {
        var n = this;
        return new Promise(function (r, a) {
          if (n.callMonitoringStart) throw a(new Error("Monitoring starting already"));

          var u = setTimeout(function () {
            var t = c.FlexModule.state.supervisor.callMonitoring;
            t.status === s.waiting && t.task.taskSid === e.taskSid && (n.callMonitoringStart.conferenceListener && n.callMonitoringStart.conferenceListener.stop(), n.callMonitoringStart = void 0, n.dispatchStateUpdate({
              callMonitoring: {
                task: null,
                workers: null,
                status: s.none
              }
            }), d.Notifications.showNotification(d.NotificationIds.MonitoringFailed)), a(new Error("Failed to start monitoring"));
          }, 1e4),
              p = function p(e) {
            if ("conf_state" === e.key) return !1;
            var t = new l.ConferenceParticipant(e.value);
            return "supervisor" === t.participantType && t.isMyself;
          },
              f = new l.ConferenceListener(e.taskSid, function (u) {
            return o(n, void 0, void 0, function () {
              var n, o;
              return i(this, function (i) {
                switch (i.label) {
                  case 0:
                    return !c.FlexModule.state.phone.connection || this.isMonitoredWorkerStillInTheCall(u, e) ? [3, 2] : [4, c.FlexModule.state.phone.connection.source.disconnect()];

                  case 1:
                    return i.sent(), [2];

                  case 2:
                    return n = u.children.filter(p), !(o = n.some(function (e) {
                      return "joined" === new l.ConferenceParticipant(e.value).status;
                    })) && n.length > this.callMonitoringStart.startingCountOfMyselvesAsSupervisor && (u.stop(), this.callMonitoringStart = void 0, this.dispatchStateUpdate({
                      callMonitoring: {
                        task: e,
                        workers: null,
                        status: s.none
                      }
                    }), a(new Error("Monitoring stopped"))), o && (this.callMonitoringStart.timer ? (clearTimeout(this.callMonitoringStart.timer), this.callMonitoringStart.timer = null, this.dispatchStateUpdate({}, !0), this.dispatcher({
                      type: t.ACTION_MONITORING_SUCCEEDED,
                      payload: {}
                    }), r()) : this.dispatcher({
                      type: t.ACTION_MONITORING_UPDATED,
                      payload: {}
                    })), [2];
                }
              });
            });
          }),
              h = e.conference.source.children.filter(p);

          n.callMonitoringStart = {
            conferenceListener: f,
            timer: u,
            startingCountOfMyselvesAsSupervisor: h.length
          }, n.dispatchStateUpdate({
            callMonitoring: {
              task: e,
              status: s.waiting
            }
          });
        });
      }, e.isMonitoredWorkerStillInTheCall = function (e, t) {
        return e.children.find(function (e) {
          var n = new l.ConferenceParticipant(e.value);
          return n.workerSid === t.workerSid && "joined" === n.status;
        });
      }, e.manageConferenceListening = function (e, t) {
        var n = this;
        this.listenedConferences || (this.listenedConferences = new Set());
        var r = a(e);
        t && e && r.push(t);
        var o = [];
        r.forEach(function (e) {
          e.tasks.forEach(function (e) {
            p.TaskHelper.isLiveCall(e) && o.push(e);
          });
        }), this.listenedConferences.forEach(function (e) {
          o.find(function (t) {
            return t.taskSid === e;
          }) || (l.ConferenceListenerManager.stopListening(e, "supervisor"), n.listenedConferences.delete(e));
        }), o.forEach(function (e) {
          n.listenedConferences.has(e.taskSid) || (l.ConferenceListenerManager.startListening(e, "supervisor"), n.listenedConferences.add(e.taskSid));
        });
      }, e.updateStateWorkers = function (e) {
        this.manageConferenceListening(e, c.FlexModule.state.supervisor.stickyWorker), this.dispatchStateUpdate({
          workers: e,
          isLoadingWorkers: !1
        }, !1);
      }, e.startLoadingWorkers = function () {
        this.dispatchStateUpdate({
          isLoadingWorkers: !0
        }, !1);
      }, e.updateStateStickyWorker = function (e) {
        this.manageConferenceListening(c.FlexModule.state.supervisor.workers, e), this.dispatchStateUpdate({
          stickyWorker: e
        }, !1);
      }, e.setActiveFilterQuery = function (e, t) {
        c.FlexModule.state.supervisor.listener.setActiveFilterQuery(e, t);
      }, e.setStickyWorkerSid = function (e, t) {
        c.FlexModule.state.supervisor.listener.setStickyWorkerSid(e, t);
      }, e.shutdown = function () {
        u.log.debug("Supervisor state logout"), this.callMonitoringStart && (clearTimeout(this.callMonitoringStart.timer), this.callMonitoringStart.conferenceListener.stop(), this.callMonitoringStart = void 0), this.listenedConferences && (this.listenedConferences.forEach(function (e) {
          l.ConferenceListenerManager.stopListening(e, "supervisor");
        }), this.listenedConferences = void 0);
        var e = c.FlexModule.state.supervisor.listener;
        e && e.unInit();
      }, e;
    }();

    t.Actions = m;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(1),
        i = n(0);
    t.Notifications = i.Notifications, t.NotificationType = i.NotificationType, t.NotificationEvent = i.NotificationEvent;
    var a = n(18),
        s = n(73),
        c = n(6),
        l = n(7),
        u = n(5);
    t.NotificationIds = r(r({}, i.NotificationIds), a), t.registerToNotifications = function () {
      var e = {
        id: t.NotificationIds.PendingReservationsOnLogout,
        content: "PendingReservationsOnLogoutNotification",
        type: i.NotificationType.error
      };
      i.Notifications.registerNotification(e);
      var n = {
        id: t.NotificationIds.PendingReservationsOnActivityStateChange,
        content: "PendingReservationsOnActivityStateChangeNotification",
        type: i.NotificationType.error
      };
      i.Notifications.registerNotification(n);
      var r = {
        id: t.NotificationIds.BrowserVoiceDisabled,
        content: "BrowserVoiceDisabledNotification",
        type: i.NotificationType.error
      };
      i.Notifications.registerNotification(r);
      var a = {
        id: t.NotificationIds.TransferFailed,
        content: "TransferFailedNotification",
        type: i.NotificationType.error
      };
      i.Notifications.registerNotification(a);
      var p = {
        id: t.NotificationIds.TaskCannotBeTransferred,
        content: "TaskCannotBeTransferredNotification",
        type: i.NotificationType.error,
        timeout: 5e3
      };
      i.Notifications.registerNotification(p);
      var d = {
        id: t.NotificationIds.MicTaken,
        content: "MicNotAvailableNotification",
        type: i.NotificationType.error,
        timeout: 5e3
      };
      i.Notifications.registerNotification(d);
      var f = {
        id: t.NotificationIds.CannotChangeOtherWorkerActivity,
        content: "CannotChangeOtherWorkerActivity",
        type: i.NotificationType.error
      };
      i.Notifications.registerNotification(f);
      var h = {
        id: t.NotificationIds.MonitoringFailed,
        content: "MonitoringFailedNotification",
        type: i.NotificationType.error
      };
      i.Notifications.registerNotification(h);
      var m = {
        id: t.NotificationIds.MessageSizeExceeded,
        content: "MessageSizeExceeded",
        type: i.NotificationType.error
      };
      i.Notifications.registerNotification(m), i.Notifications.registerNotification({
        id: t.NotificationIds.ChatOrchestrationAddToChatChannelFailed,
        content: "ChatOrchestrationAddToChatChannelFailed",
        type: i.NotificationType.error
      }), i.Notifications.registerNotification({
        id: t.NotificationIds.ChatOrchestrationDeactivateChatChannelFailed,
        content: "ChatOrchestrationDeactivateChatChannelFailed",
        type: i.NotificationType.error
      }), i.Notifications.registerNotification({
        id: t.NotificationIds.ChatOrchestrationLeaveChatChannelFailed,
        content: "ChatOrchestrationLeaveChatChannelFailed",
        type: i.NotificationType.error
      });
      var g = {
        id: t.NotificationIds.AudioPlayerDeniedErrorNotificationId,
        content: "AudioPlayerDeniedError",
        type: i.NotificationType.error,
        timeout: 0
      };
      i.Notifications.registerNotification(g);
      var y = {
        id: t.NotificationIds.AudioPlayerInvalidMediaErrorNotificationId,
        content: "AudioPlayerInvalidMediaError",
        type: i.NotificationType.error,
        timeout: 0
      };
      i.Notifications.registerNotification(y);
      var v = {
        id: t.NotificationIds.AudioPlayerGenericErrorNotificationId,
        content: "AudioPlayerGenericError",
        type: i.NotificationType.error,
        timeout: 0
      };
      i.Notifications.registerNotification(v);
      var b = {
        id: t.NotificationIds.FlexUiVersionDeprecated,
        content: "UiVersionDeprecated",
        type: i.NotificationType.warning,
        timeout: 0
      };
      i.Notifications.registerNotification(b);
      var C = {
        id: t.NotificationIds.FlexSessionExpired,
        closeButton: !0,
        content: "SessionExpired",
        timeout: 0,
        type: i.NotificationType.warning
      };
      i.Notifications.registerNotification(C);
      var _ = {
        id: t.NotificationIds.RequestBrowserNotificationPermissions,
        closeButton: !0,
        content: "RequestBrowserNotificationPermissions",
        timeout: 0,
        type: i.NotificationType.warning,
        icon: "Bell",
        onClick: function onClick(e) {
          window.Notification.requestPermission(), i.Notifications.dismissNotificationById(t.NotificationIds.RequestBrowserNotificationPermissions), e.preventDefault();
        }
      };
      i.Notifications.registerNotification(_);
      var k = {
        id: t.NotificationIds.IncomingTask
      };
      i.Notifications.registerNotification(k);
      var w = {
        id: t.NotificationIds.QueuesStatsStale,
        content: o.createElement(s.QueueStatsConnectionStatusInfoText, null),
        type: i.NotificationType.warning,
        timeout: 0
      };
      i.Notifications.registerNotification(w);
      var T = {
        id: t.NotificationIds.FlexInsightsLoginFailed,
        closeButton: !0,
        content: "FlexInsightsLoginFailedNotificationTitle",
        timeout: 0,
        type: i.NotificationType.error,
        actions: [o.createElement(i.NotificationBar.Action, {
          label: "FlexInsightsLoginFailedNotificationAction",
          onClick: function onClick(e, t) {
            i.Notifications.dismissNotification(t), c.tryInvokeAction("ReloadWindow");
          }
        })]
      };
      i.Notifications.registerNotification(T);
      var O = {
        id: t.NotificationIds.FlexInsightsPlayerLoadingSegmentFailed,
        content: "FlexInsightsPlayerLoadingSegmentFailed",
        type: i.NotificationType.error,
        timeout: 0
      };
      i.Notifications.registerNotification(O);
      var P = {
        id: t.NotificationIds.NoInputDevice,
        content: "InputDeviceErrorNotification",
        type: i.NotificationType.error
      };
      i.Notifications.registerNotification(P), i.Notifications.addListener(i.NotificationEvent.beforeAddNotification, function (e, n) {
        if (e.id === t.NotificationIds.NewChatMessage) {
          if (!e.context) return;
          var r = e.context.lastMessage;
          if (!r) return;
          var o = l.TaskHelper.getTaskFromChannelSid(r.channel.sid);
          if (!o) return u.log.debug("Task for message chat channel does not exist - not showing notification"), void n();
          e.context.task = o, e.context.helper = new l.TaskHelper(o);
        }
      });
      var S = i.Notifications.registeredNotifications.get(t.NotificationIds.NewChatMessage);
      S && (S.options.browser.onClick = function (e) {
        c.tryInvokeAction("SelectTask", {
          task: e.context.task
        });
      });
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PendingReservationsOnLogout = "PendingReservationsOnLogout", t.PendingReservationsOnActivityStateChange = "PendingReservationsOnActivityStateChange", t.TransferFailed = "TransferFailed", t.TaskCannotBeTransferred = "TaskCannotBeTransferred", t.BrowserVoiceDisabled = "BrowserVoiceDisabled", t.MicTaken = "MicTaken", t.MessageSizeExceeded = "MessageSizeExceeded", t.CannotChangeOtherWorkerActivity = "CannotChangeOtherWorkerActivity", t.MonitoringFailed = "MonitoringFailed", t.ChatOrchestrationAddToChatChannelFailed = "ChatOrchestrationAddToChatChannelFailed", t.ChatOrchestrationDeactivateChatChannelFailed = "ChatOrchestrationDeactivateChatChannelFailed", t.ChatOrchestrationLeaveChatChannelFailed = "ChatOrchestrationLeaveChatChannelFailed", t.AudioPlayerDeniedErrorNotificationId = "AudioPlayerDeniedError", t.AudioPlayerInvalidMediaErrorNotificationId = "AudioPlayerInvalidMediaError", t.AudioPlayerGenericErrorNotificationId = "AudioPlayerGenericError", t.QueuesStatsStale = "QueuesStatsStale", t.FlexUiVersionDeprecated = "FlexUiVersionDeprecated", t.FlexSessionExpired = "FLEX_SESSION_EXPIRED", t.RequestBrowserNotificationPermissions = "RequestBrowserNotificationPermissions", t.IncomingTask = "IncomingTask", t.OutboundCallCanceledGeneric = "OutboundCallCanceledGeneric", t.OutboundCallCanceledBusy = "OutboundCallCanceledBusy", t.OutboundCallCanceledNoAnswer = "OutboundCallCanceledNoAnswer", t.OutboundCallCanceledInvalidNumber = "OutboundCallCanceledInvalidNumber", t.FlexInsightsLoginFailed = "FlexInsightsLoginFailed", t.FlexInsightsPlayerLoadingSegmentFailed = "FlexInsightsPlayerLoadingSegmentFailed", t.NoInputDevice = "NoInputDevice";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e.TestFeature = "test-feature", e.TestPilotFeature = "test-pilot-feature", e.MarkdownSupport = "markdown-support", e.FlexQueuesStats = "flex-queues-stats", e.FlexQueuesStatsSLA = "flex-queues-stats-sla", e.InsightsPlayer = "insights-player", e.FlexInsights = "flex-insights", e.InitialAudioDeviceCheck = "initial-audio-device-check", e.AdvancedTeamsViewFilters = "advanced-teams-view-filters";
    }(t.FeatureFlag || (t.FeatureFlag = {})), function (e) {
      e.Private = "private", e.Pilot = "pilot", e.Beta = "beta", e.ForceEnable = "force-enable", e.ForceDisable = "force-disable";
    }(t.FeatureStage || (t.FeatureStage = {})), t.FEATURE_FLAGS_UPDATE = "FLEX_FEATURE_FLAGS_UPDATE", t.FEATURE_FLAGS_OVERRIDES_UPDATE = "FLEX_FEATURE_FLAGS_OVERRIDES_UPDATE", t.FEATURE_FLAG_OVERRIDE = "FLEX_FEATURE_FLAG_OVERRIDE";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(250);
    t.WORKSPACE_KEY = r.WORKSPACE_KEY, t.initialState = r.initialState, t.reduce = r.reduce, t.Actions = r.Actions;
    var o = n(251);
    t.queuesListArraySelector = o.queuesListArraySelector, t.queuesListSelector = o.queuesListSelector, t.workspaceActiveTasksSelector = o.workspaceActiveTasksSelector, t.workspaceLongestQueueSelector = o.workspaceLongestQueueSelector, t.workspaceStatsSelector = o.workspaceStatsSelector, t.workspaceWaitingTasksSelector = o.workspaceWaitingTasksSelector;
    var i = n(122);
    t.ADD_QUEUE = i.ADD_QUEUE, t.REMOVE_QUEUE = i.REMOVE_QUEUE, t.SET_QUEUES = i.SET_QUEUES, t.SET_WORKSPACE_STATS = i.SET_WORKSPACE_STATS, t.UPDATE_QUEUE = i.UPDATE_QUEUE, t.ActivityStatistic = i.ActivityStatistic, t.Queue = i.Queue, t.QueuesStateActionTypes = i.QueuesStateActionTypes, t.QueuesStateInterface = i.QueuesStateInterface, t.WorkerQueue = i.WorkerQueue, t.WorkspaceStats = i.WorkspaceStats, t.QueuesFilterFunction = i.QueuesFilterFunction;
    var a = n(252);
    t.getAvailableAgentsCount = a.getAvailableAgentsCount, t.getUnavailableAgentsCount = a.getUnavailableAgentsCount, t.getOfflineAgentsCount = a.getOfflineAgentsCount;
  }, function (e, t) {
    e.exports = require("emotion");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(3),
        o = n(7),
        i = function () {
      function e() {}

      return e.getCurrentPhoneCallState = function () {
        return r.FlexModule.state.phone.connection;
      }, e.getChatChannelStateForTask = function (e) {
        var t = o.TaskHelper.getTaskChatChannelSid(e);
        if (t) return r.FlexModule.state.chat.channels[t];
      }, e.getReservation = function (e) {
        var t = r.FlexModule.state.worker.tasks.get(e);
        return t ? t.sourceObject : void 0;
      }, e.getTaskByTaskrouterTaskSid = function (e) {
        return Array.from(r.FlexModule.state.worker.tasks.values()).find(function (t) {
          return t.taskSid === e;
        });
      }, e;
    }();

    t.StateHelper = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(516);
    t.AgentsView = r.AgentsView;
    var o = n(519);
    t.AnalyzeView = o.AnalyzeView;
    var i = n(520);
    t.DashboardsView = i.DashboardsView;
    var a = n(521);
    t.InspectionsView = a.InspectionsView;
    var s = n(522);
    t.QuestionnairesView = s.QuestionnairesView;
    var c = n(523);
    t.SpeechSearchesView = c.SpeechSearchesView;
  }, function (e, t, n) {
    "use strict";

    var _r2,
        o = this && this.__extends || (_r2 = function r(e, t) {
      return (_r2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r2(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
        e += arguments[t].length;
      }

      var r = Array(e),
          o = 0;

      for (t = 0; t < n; t++) {
        for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) {
          r[o] = i[a];
        }
      }

      return r;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a,
        s = n(107),
        c = n(5);
    !function (e) {
      e.viewResized = "viewResized", e.flexSplitterResize = "flexSplitterResize", e.userLoggedIn = "userLoggedIn", e.selectedViewChanged = "selectedViewChanged", e.tokenUpdated = "tokenUpdated", e.tokenExpired = "tokenExpired", e.pluginsLoaded = "pluginsLoaded";
    }(a = t.FlexEvent || (t.FlexEvent = {}));

    var l = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.emitSelectedViewChanged = function (e, n) {
          t.emit(a.selectedViewChanged, e, n);
        }, t;
      }

      return o(t, e), t.prototype.emit = function (t) {
        for (var n = [], r = 1; r < arguments.length; r++) {
          n[r - 1] = arguments[r];
        }

        return c.log.debug("Flex event emitter:", t, n), e.prototype.emit.apply(this, i([t], n));
      }, t.prototype.emitSplitterResize = function () {
        this.emit(a.flexSplitterResize);
      }, t.prototype.emitViewResized = function (e) {
        this.emit(a.viewResized, e);
      }, t.prototype.emitUserLoggedIn = function () {
        this.emit(a.userLoggedIn);
      }, t.prototype.emitTokenUpdated = function (e) {
        this.emit(a.tokenUpdated, e);
      }, t.prototype.emitTokenExpired = function () {
        this.emit(a.tokenExpired);
      }, t.prototype.emitPluginsLoaded = function () {
        this.emit(a.pluginsLoaded);
      }, t;
    }(s.EventEmitter);

    t.FlexEventEmitter = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(5),
        a = n(3),
        s = n(40),
        c = n(58),
        l = function () {
      function e() {}

      return e.destroy = function () {
        this.searches.forEach(function (e) {
          return e.query.removeAllListeners();
        });
      }, e.getWorker = function (e) {
        if ("WK" === e.substr(0, 2)) return this.entities.get(e);
      }, e.getQueue = function (e) {
        if ("WQ" === e.substr(0, 2)) return this.entities.get(e);
      }, e.refreshInfoForEntities = function (e) {
        var t = this;
        return Promise.all(e.map(function (e) {
          return r(t, void 0, void 0, function () {
            var t,
                n,
                r,
                l = this;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  return e ? (t = this.searches.get(e)) && new Date().getTime() - t.time < 1e4 ? [2] : (i.log.debug("InsightsState refreshIdentity " + e), n = "WK" === e.substr(0, 2), [4, a.FlexModule.insightsClient.instantQuery(n ? "tr-worker" : "tr-queue")]) : [2];

                case 1:
                  return r = o.sent(), this.searches.set(e, {
                    query: r,
                    time: new Date().getTime()
                  }), r.on("searchResult", function (t) {
                    Object.keys(t).forEach(function (e) {
                      i.log.debug("InsightsState found data for " + e);
                      var r = t[e],
                          o = n ? new s.InsightsWorker(r) : new s.InsightsQueue(r);
                      l.entities.set(e, o), c.Actions.updateConferencesWithParticipant(e);
                    }), r.removeAllListeners(), l.searches.delete(e);
                  }), n ? r.search('data.worker_sid == "' + e + '"') : r.search('data.queue_sid == "' + e + '"'), [2];
              }
            });
          });
        }));
      }, e.updateCache = function (e) {
        i.log.debug("InsightsState updateCache " + e.sid), this.entities.set(e.sid, e);
      }, e.entities = new Map(), e.searches = new Map(), e;
    }();

    t.InsightsEntityCache = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a,
        s = n(245),
        c = n(246),
        l = n(0),
        u = n(3),
        p = n(5),
        d = n(31),
        f = n(18),
        h = n(71),
        m = n(16),
        g = n(75),
        y = n(119),
        v = n(58),
        b = n(249),
        C = n(33),
        _ = n(10),
        k = n(123),
        w = n(44),
        T = n(45);

    !function (e) {
      e.Unknown = "UNKNOWN", e.LoggingIn = "LOGGING_IN", e.LoggedIn = "LOGGED_IN", e.LoggedOut = "LOGGED_OUT", e.Error = "ERROR";
    }(a = t.LoginState || (t.LoginState = {})), t.INSIGHTS_INIT_TIMEOUT = 1e4, t.ERRORS_FAILED_TO_INIT_INSIGHTS = "Failed to init insights client: ";
    var O = {
      identity: void 0,
      insightsServiceStatus: w.InsightsServiceStatus.Initializing,
      loginHandler: void 0,
      loginState: a.Unknown,
      loginError: void 0,
      ssoTokenPayload: void 0
    };
    t.ACTION_LOGGED_OUT = "FLEX_ACTION_LOGGED_OUT";

    t.reduce = function (e, n) {
      switch (void 0 === e && (e = O), n.type) {
        case "FLEX_ACTION_LOGIN_PENDING":
          return r(r({}, e), {
            loginState: a.LoggingIn,
            loginError: void 0
          });

        case "FLEX_ACTION_LOGIN_REJECTED":
          return r(r({}, e), {
            loginState: a.Error,
            loginError: n.payload
          });

        case "FLEX_ACTION_LOGIN_FULFILLED":
          var o = (s = n.payload.loginHandler) && s.getTokenInfo(),
              i = o ? r(r({}, n.payload), {
            identity: o.identity,
            ssoTokenPayload: o
          }) : n.payload;
          return r(r(r({}, e), i), {
            loginState: a.LoggedIn,
            loginError: void 0
          });

        case "FLEX_ACTION_TOKEN_UPDATED":
          var s = n.payload.loginHandler;
          return r(r({}, e), {
            ssoTokenPayload: s.getTokenInfo()
          });

        case t.ACTION_LOGGED_OUT:
          return r(r({}, O), {
            loginState: a.LoggedOut
          });

        case "FLEX_UPDATE_INSIGHTS_SERVICE_STATUS":
          return r(r({}, e), {
            insightsServiceStatus: n.payload
          });

        default:
          return e;
      }
    };

    var P = function () {
      function e() {}

      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return this._dispatcher || u.FlexModule.dispatch;
        },
        set: function set(e) {
          this._dispatcher = e;
        },
        enumerable: !0,
        configurable: !0
      }), e.init = function () {
        this.dispatcher({
          type: "FLEX_SESSION_INIT"
        });
      }, e.ssoLogin = function (e) {
        return o(this, void 0, Promise, function () {
          var t, n;
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                return t = C.SSOLoginHandler.getTokenInfo(), e.on("tokenUpdated", this.handleTokenUpdated), e.on("tokenExpired", this.handleTokenExpired), n = this.initClients(t).then(function () {
                  return {
                    loginHandler: e
                  };
                }), this.dispatcher({
                  type: "FLEX_ACTION_LOGIN",
                  payload: n
                }), [4, n];

              case 1:
                return r.sent(), u.FlexModule.events.emitUserLoggedIn(), [2];
            }
          });
        });
      }, e.updateInsightsServiceStatus = function (t) {
        e.dispatcher({
          type: "FLEX_UPDATE_INSIGHTS_SERVICE_STATUS",
          payload: t
        });
      }, e.handleTokenExpired = function () {
        u.FlexModule.events.emitTokenExpired(), p.log.trace("Token expired, showing notification"), l.Notifications.showNotification(f.FlexSessionExpired);
      }, e.initClients = function (e) {
        var n = e && e.token,
            o = new b.Supervisor(n, u.FlexModule.state.config.sdkOptions.worker);
        u.FlexModule.workerClient = o;
        var i = new Promise(function (e, t) {
          o.addListener("ready", function () {
            p.log.debug("Worker " + o.sid + " is now ready for work"), h.Actions.init(o), e();
          }), o.addListener("error", function (e) {
            t(Error("Supervisor had an error: " + e));
          }), o.addListener("disconnected", function () {
            p.log.debug("Worker " + o.sid + " disconnected");
          });
        });
        u.FlexModule.state.config.disableBrowserVoice || g.Actions.init(n, u.FlexModule.state.config.sdkOptions.voice);
        var a = r(r({}, u.FlexModule.state.config.sdkOptions.chat), {
          clientMetadata: {
            type: "flex-ui",
            app: "flex-ui",
            appv: d.VERSION
          }
        }),
            f = s.Client.create(n, a).then(function (e) {
          i.then(function () {
            var t = o.attributes.public_identity || o.attributes.full_name;
            t && e.user.updateFriendlyName(t);
          }), u.FlexModule.chatClient = e, l.ChatSessionState.Actions.init(e);
        }).catch(function (e) {
          throw p.log.error("Failed to init Twilio Chat client", e), e;
        }),
            C = new Promise(function (e, o) {
          try {
            var i = r(r({}, u.FlexModule.state.config.sdkOptions.insights), {
              clientMetadata: {
                type: "flex-ui",
                app: "flex-ui",
                appv: d.VERSION
              }
            }),
                a = new c.SyncClient(n, i),
                s = setTimeout(function () {
              o(new Error("Unable to initialize insights client in " + t.INSIGHTS_INIT_TIMEOUT + " ms"));
            }, t.INSIGHTS_INIT_TIMEOUT);
            p.log.debug("Insights Client initial connection state: " + a.connectionState);

            var l = function l(t) {
              p.log.debug("Insights Client new state: " + t), "connected" === t && (u.FlexModule.insightsClient = a, y.Actions.init(a), m.Actions.assignInsights(a), v.Actions.assignInsights(a), a.removeListener("connectionStateChanged", l), k.ConnectionStatusState.init(), clearTimeout(s), e());
            };

            a.on("connectionStateChanged", l);
          } catch (e) {
            p.log.error(t.ERRORS_FAILED_TO_INIT_INSIGHTS + e.message), o(e);
          }
        });
        return Promise.all([i, f, C]);
      }, e.logout = function (e) {
        return o(this, void 0, Promise, function () {
          var n, r, o, a;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                n = _.Manager.getInstance().serviceConfiguration.taskrouter_offline_activity_sid, p.log.info("Session state logout"), null != e.activitySid ? r = h.Actions.setCurrentActivity(e.activitySid) : e.activityName ? (p.log.warn('Logout payload member "activityName" is deprecated. Please, consider using activitySid instead'), r = h.Actions.setCurrentActivityByName(e.activityName)) : r = null != n ? h.Actions.setCurrentActivity(n) : Promise.resolve(), i.label = 1;

              case 1:
                return i.trys.push([1, 3,, 4]), [4, r];

              case 2:
                return i.sent(), [3, 4];

              case 3:
                if (o = i.sent(), p.log.warn("Unable to make worker offline"), !e.forceLogout) throw o;
                return [3, 4];

              case 4:
                return (a = u.FlexModule.state.session.loginHandler) && (a.removeListener("tokenUpdated", this.handleTokenUpdated), a.removeListener("tokenExpired", this.handleTokenExpired), a.logout()), h.Actions.shutdown(), u.FlexModule.state.config.disableBrowserVoice || g.Actions.shutdown(), l.ChatSessionState.Actions.shutdown(), y.Actions.shutdown(), m.Actions.shutdown(), v.Actions.shutdown(), u.FlexModule.workerClient = void 0, u.FlexModule.chatClient = void 0, u.FlexModule.insightsClient = void 0, [4, T.InsightsService.destroy()];

              case 5:
                return i.sent(), this.dispatcher({
                  type: t.ACTION_LOGGED_OUT
                }), [2];
            }
          });
        });
      }, e.handleTokenUpdated = function (t) {
        e.dispatcher({
          type: "FLEX_ACTION_TOKEN_UPDATED",
          payload: {
            loginHandler: t
          }
        });
        var n = u.FlexModule.workerClient,
            r = u.FlexModule.chatClient,
            o = u.FlexModule.voiceClient,
            i = u.FlexModule.insightsClient,
            a = C.SSOLoginHandler.getTokenInfo(),
            s = a && a.token;
        p.log.debug("token updated", a), n && (p.log.debug("Updating worker client token"), n.updateToken(s)), r && (p.log.debug("Updating chat client token"), r.updateToken(s)), !u.FlexModule.state.config.disableBrowserVoice && o && (p.log.debug("Updating voice client token"), o.setup(s, u.FlexModule.state.config.sdkOptions.voice)), i && (p.log.debug("Updating insights client token"), i.updateToken(s)), u.FlexModule.events.emitTokenUpdated(a);
      }, e;
    }();

    t.Actions = P;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r(n(248)), r(n(117));
  }, function (e, t, n) {
    "use strict";

    var _r3,
        o = this && this.__extends || (_r3 = function r(e, t) {
      return (_r3 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r3(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e.accountSid = "accountSid", e.sso = "sso";
    }(t.ConfigErrorKeys || (t.ConfigErrorKeys = {}));

    var i = function (e) {
      function t(n) {
        for (var r = [], o = 1; o < arguments.length; o++) {
          r[o - 1] = arguments[o];
        }

        var i = this;
        return (i = r.length ? e.apply(this, r) || this : e.call(this, "Invalid or missing configuration: " + n + " is required") || this).key = n, Object.setPrototypeOf(i, t.prototype), i;
      }

      return o(t, e), t;
    }(Error);

    t.ConfigError = i, function (e) {
      e.accountSid = "accountSid", e.sso = "sso", e.untrustedDomain = "untrustedDomain", e.invalidCertificate = "invalidCertificate";
    }(t.ValidationErrorKeys || (t.ValidationErrorKeys = {}));

    var a = function (e) {
      function t(n) {
        for (var r = [], o = 1; o < arguments.length; o++) {
          r[o - 1] = arguments[o];
        }

        var i = this;
        return (i = r.length ? e.apply(this, r) || this : e.call(this, "Validation error: invalid " + n) || this).key = n, Object.setPrototypeOf(i, t.prototype), i;
      }

      return o(t, e), t;
    }(Error);

    t.ValidationError = a, function (e) {
      e.windowClosed = "windowClosed", e.popupBlocked = "popupBlocked", e.noWindowOpener = "noWindowOpener", e.redirecting = "redirecting";
    }(t.BrowserErrorKeys || (t.BrowserErrorKeys = {}));

    var s = function (e) {
      function t(n) {
        for (var r = [], o = 1; o < arguments.length; o++) {
          r[o - 1] = arguments[o];
        }

        var i = this;
        return (i = r.length ? e.apply(this, r) || this : e.call(this, "Browser error: " + n) || this).key = n, Object.setPrototypeOf(i, t.prototype), i;
      }

      return o(t, e), t;
    }(Error);

    t.BrowserError = s;

    var c = function (e) {
      function t() {
        for (var n = [], r = 0; r < arguments.length; r++) {
          n[r] = arguments[r];
        }

        var o = this;
        return o = n.length ? e.apply(this, n) || this : e.call(this, "Internal error") || this, Object.setPrototypeOf(o, t.prototype), o;
      }

      return o(t, e), t;
    }(Error);

    t.InternalError = c, function (e) {
      e.loginWindowOpenedFromLoginWindow = "loginWindowOpenedFromLoginWindow", e.metaNoReferrerMissing = "metaNoReferrerMissing";
    }(t.ClientErrorKeys || (t.ClientErrorKeys = {}));

    var l = function (e) {
      function t(n) {
        for (var r = [], o = 1; o < arguments.length; o++) {
          r[o - 1] = arguments[o];
        }

        var i = this;
        return (i = r.length ? e.apply(this, r) || this : e.call(this, "Client error: " + n) || this).key = n, Object.setPrototypeOf(i, t.prototype), i;
      }

      return o(t, e), t;
    }(Error);

    t.ClientError = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(59),
        s = n(3);
    !function (e) {
      e.IN = "IN", e.NOT_IN = "NOT_IN", e.CONTAINS = "CONTAINS";
    }(t.FilterConditions || (t.FilterConditions = {}));

    var c = function () {
      function e(e, t) {
        this.filters = [], this.filters = e, this.type = t;
      }

      return Object.defineProperty(e.prototype, "query", {
        get: function get() {
          return this.filters.reduce(function (e, t) {
            var n = t.values;

            if (Array.isArray(n)) {
              if (0 === n.length) return e;
              n = '["' + n.join('", "') + '"]';
            } else "string" == typeof n && (n = '"' + n + '"');

            return (e ? e + " AND" : "") + " " + t.name + " " + t.condition + " " + n;
          }, "").trim();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "count", {
        get: function get() {
          return this.filters.reduce(function (e, t) {
            var n = t.values;
            return Array.isArray(n) ? e + n.length : "string" == typeof n ? e + 1 : e;
          }, 0);
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    t.ActiveFilters = c;
    var l = {
      isSideNavOpen: !1,
      isOutboundDialerOpen: !1,
      isDirectoryOpen: !1,
      componentViewStates: {},
      filters: {}
    };
    t.ACTION_TOGGLE_SIDEBAR = "VIEW_TOGGLE_SIDEBAR", t.ACTION_TOGGLE_OUTBOUND_DIALER = "VIEW_TOGGLE_OUTBOUND_DIALER", t.ACTION_UPDATE_VIEW = "VIEW_UPDATE", t.ACTION_UPDATE_FILTER = "VIEW_UPDATE_FILTER", t.ACTION_DELETE_FILTER = "VIEW_DELETE_FILTER", t.ACTION_SET_COMPONENT_STATE = "VIEW_SET_COMPONENT_STATE", t.ACTION_DELETE_COMPONENT_STATE = "VIEW_DELETE_COMPONENT_STATE", t.reduce = function (e, n) {
      var o;

      switch (void 0 === e && (e = l), n.type) {
        case t.ACTION_TOGGLE_SIDEBAR:
          return r(r({}, e), {
            isSideNavOpen: !e.isSideNavOpen
          });

        case t.ACTION_TOGGLE_OUTBOUND_DIALER:
          return r(r({}, e), {
            isOutboundDialerOpen: !e.isOutboundDialerOpen
          });

        case t.ACTION_UPDATE_VIEW:
          var i = n.payload;
          return r(r({}, e), i);

        case t.ACTION_SET_COMPONENT_STATE:
          var a = n.payload;
          return e.componentViewStates[a.name] = r(r({}, e.componentViewStates[a.name]), a.state), r({}, e);

        case t.ACTION_DELETE_COMPONENT_STATE:
          return delete e.componentViewStates[n.payload.name], r({}, e);

        case t.ACTION_UPDATE_FILTER:
          var s = r(r({}, e.filters), ((o = {})[n.payload.key] = new c(n.payload.filters, n.payload.key), o));
          return r(r({}, e), {
            filters: s
          });

        case t.ACTION_DELETE_FILTER:
          var u = r({}, e);
          return delete u.filters[n.payload.key], u;

        default:
          return e;
      }
    };

    var u = function () {
      function e() {}

      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return this._dispatcher || s.FlexModule.dispatch;
        },
        set: function set(e) {
          this._dispatcher = e;
        },
        enumerable: !0,
        configurable: !0
      }), e.setComponentState = function (e, n) {
        this.dispatcher({
          type: t.ACTION_SET_COMPONENT_STATE,
          payload: {
            name: e,
            state: n
          }
        });
      }, e.deleteComponentState = function (e) {
        this.dispatcher({
          type: t.ACTION_DELETE_COMPONENT_STATE,
          payload: {
            name: e
          }
        });
      }, e.toggleOutboundDialer = function () {
        this.dispatcher({
          type: t.ACTION_TOGGLE_OUTBOUND_DIALER
        });
      }, e.toggleSidebar = function () {
        this.dispatcher({
          type: t.ACTION_TOGGLE_SIDEBAR
        });
      }, e.hideSidebar = function () {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            isSideNavOpen: !1
          }
        });
      }, e.showSidebar = function () {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            isSideNavOpen: !0
          }
        });
      }, e.setActiveView = function (e) {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            activeView: e,
            isSideNavOpen: !1
          }
        }), s.FlexModule.events.emitSelectedViewChanged(e, !1);
      }, e.showDirectory = function (e) {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            isDirectoryOpen: !0
          }
        });
      }, e.hideDirectory = function () {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            isDirectoryOpen: !1
          }
        });
      }, e.selectTask = function (e) {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            selectedTaskSid: e
          }
        });
      }, e.selectTaskInSupervisor = function (e) {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            selectedTaskInSupervisorSid: e
          }
        });
      }, e.selectWorkerInSupervisor = function (e) {
        this.dispatcher({
          type: t.ACTION_UPDATE_VIEW,
          payload: {
            selectedWorkerInSupervisorSid: e
          }
        });
      }, e.push = function (t) {
        return o(this, void 0, void 0, function () {
          var n;
          return i(this, function (r) {
            return n = s.FlexModule.state.router.location && s.FlexModule.state.router.location.pathname, t !== n && e.dispatcher(a.push.call(this, t)), [2];
          });
        });
      }, e.replace = function (t) {
        return o(this, void 0, void 0, function () {
          return i(this, function (n) {
            return e.dispatcher(a.replace.call(this, t)), [2];
          });
        });
      }, e.go = function (t) {
        return o(this, void 0, void 0, function () {
          return i(this, function (n) {
            return e.dispatcher(a.go.call(this, t)), [2];
          });
        });
      }, e.goForward = function () {
        for (var t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }

        return o(this, void 0, void 0, function () {
          return i(this, function (n) {
            return e.dispatcher(a.goForward.apply(this, t)), [2];
          });
        });
      }, e.goBack = function () {
        for (var t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }

        return o(this, void 0, void 0, function () {
          return i(this, function (n) {
            return e.dispatcher(a.goBack.apply(this, t)), [2];
          });
        });
      }, e.applyListFilters = function (e) {
        this.dispatcher({
          payload: e,
          type: t.ACTION_UPDATE_FILTER
        });
      }, e.removeListFilters = function (e) {
        this.dispatcher({
          payload: e,
          type: t.ACTION_DELETE_FILTER
        });
      }, e;
    }();

    t.Actions = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e.Info = "Info", e.Call = "Call", e.Chat = "Chat", e.Video = "Video", e.Wrapup = "Wrapup";
    }(t.TaskChannelCapability || (t.TaskChannelCapability = {})), function (e) {
      e.Wrapping = "Wrapping", e.Completed = "Completed", e.Canceled = "Canceled", e.Pending = "Pending", e.Accepted = "Accepted", e.Rescinded = "Rescinded", e.Reserved = "Reserved", e.Assigned = "Assigned";
    }(t.ReservationStatuses || (t.ReservationStatuses = {}));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.VERSION = "1.18.0";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.INSIGHTS_PLAYER_SET_MEDIA_LINKS = "INSIGHTS_PLAYER_SET_MEDIA_LINKS", t.INSIGHTS_PLAYER_MEDIA_SELECT = "INSIGHTS_PLAYER_MEDIA_SELECT", function (e) {
      e.VoiceRecording = "VoiceRecording", e.Raw = "Raw", e.Embedded = "Embedded", e.Referenced = "Referenced", e.ChatTranscript = "ChatTranscript";
    }(t.InsightsPlayerMediaLinkType || (t.InsightsPlayerMediaLinkType = {}));
  }, function (e, t, n) {
    "use strict";

    var _r4,
        o = this && this.__extends || (_r4 = function r(e, t) {
      return (_r4 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r4(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        s = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var c = n(15),
        l = n(41),
        u = n(0),
        p = n(5),
        d = n(28),
        f = n(107),
        h = n(34),
        m = n(77);
    t.SSOConfig = m.SSOConfig;
    var g = n(10),
        y = n(8),
        v = n(132);
    t.LOGIN_WINDOW_NAME = "twilioFlexLoginWindow", t.LOGIN_SUCCESSFUL_MESSAGE = "TWILIO_FLEX_LOGIN_SUCCESSFUL";

    var b = {
      products: ["flex"],
      redirectUrl: window.location.href,
      tokenRefreshThresholdMs: 21e5
    },
        C = function (e) {
      function n(t) {
        var r = e.call(this) || this;
        return r._checkTokenExpirationInterval = 0, r.checkTokenExpired = function () {
          p.log.trace("Checking if token is expired");
          var e = n.getTokenFromLocalStorage();
          if (!e || !e.token) return Promise.reject("No token");
          var t = Date.parse(e.expiration) - Date.now();
          return t <= 0 ? (r.handleTokenExpired(), Promise.reject("Current token has expired")) : t < r._config.tokenRefreshThresholdMs && !r._updatingToken ? (p.log.info("Updating token Current token would expire in", t / 1e3, "s"), r.handleTokenUpdate()) : Promise.resolve(r);
        }, r.handleCheckTokenExpirationInterval = function () {
          r.checkTokenExpired().catch(function (e) {
            p.log.warn("Unable to update token:", e);
            var t = !!e && !!e.response && e.response.status || 0;
            t >= 400 && t <= 404 && (p.log.warn("Stopping token updates"), clearInterval(r._checkTokenExpirationInterval));
          });
        }, r._updatingToken = !1, r._config = u.Utils.merge(b, t), r;
      }

      return o(n, e), n.create = function (e) {
        return void 0 === e && (e = {}), new n(e).initialize(!0);
      }, n.tryLogin = function (e) {
        return void 0 === e && (e = {}), new n(e).initialize(!1).then(function () {
          return !0;
        });
      }, n.tryValidateConfig = function (e) {
        if (!e) throw new d.ConfigError(d.ConfigErrorKeys.sso);
        if (!e.accountSid) throw new d.ConfigError(d.ConfigErrorKeys.accountSid);
      }, n.tryLoginInNewWindow = function (e) {
        if (n.isInLoginWindow()) return Promise.reject(new d.ClientError(d.ClientErrorKeys.loginWindowOpenedFromLoginWindow));
        if (!e.idpUrl) return Promise.reject(new d.InternalError("No idpUrl"));
        var r = n.openLoginWindow(e);
        return r ? new Promise(function (e, o) {
          var i = setInterval(function () {
            r.closed && (o(new d.BrowserError(d.BrowserErrorKeys.windowClosed)), clearInterval(i));
          }, 100);
          window.addEventListener("message", function (a) {
            if (a.origin === window.location.origin && a.data === t.LOGIN_SUCCESSFUL_MESSAGE) {
              p.log.debug("Got LOGIN_SUCCESSFUL_MESSAGE");
              var s = window.localStorage.getItem("TWILIO_FLEX_SSO");
              if (!s) return void o(new d.InternalError("No token in localStorage"));
              var c = JSON.parse(s);
              if (!n.isValidTokenPayload(c)) return void o(new d.InternalError("Token is invalid"));
              p.log.debug("Got token from login window"), e(), clearInterval(i), r.close();
            }
          });
        }) : (p.log.error("Unable to open a new window to log in. Pop-up might have been blocked by browser."), Promise.reject(new d.BrowserError(d.BrowserErrorKeys.popupBlocked)));
      }, n.openLoginWindow = function (e) {
        var n = e.loginPopupFeatures || v.stringifyLoginWindowFeatures(v.getDefaultLoginWindowFeatures());
        return p.log.debug("opening login view in a new window", e.idpUrl, n), window.open(e.idpUrl, t.LOGIN_WINDOW_NAME, n);
      }, n.prototype.getTokenInfo = function () {
        return p.log.debug("Instance method getTokenInfo of SSOLoginHandler is deprecated. Consider using a similar static method SSOLoginHandler.getTokenInfo() instead"), n.getTokenInfo();
      }, n.getTokenInfo = function () {
        var e = n.getTokenFromLocalStorage();
        if (e) return n.isValidTokenPayload(e) ? e : void 0;
      }, n.prototype.logout = function () {
        clearInterval(this._checkTokenExpirationInterval), this.clearTokenFromLocalStorage();
      }, n.prototype.initialize = function (e) {
        return a(this, void 0, Promise, function () {
          var r,
              o,
              a,
              c,
              l,
              f,
              m,
              g,
              y,
              b = this;
          return s(this, function (s) {
            switch (s.label) {
              case 0:
                if (r = n.parseTokenPayloadFromQueryString()) {
                  if (n.isInLoginWindow()) return window.opener ? (n.storeTokenPayload(r), window.opener.postMessage(t.LOGIN_SUCCESSFUL_MESSAGE, window.location.origin), [2, Promise.reject("Logging in in another window")]) : (p.log.error("window.opener is not set"), window.close(), [2, Promise.reject(new d.BrowserError(d.BrowserErrorKeys.noWindowOpener))]);
                  if (n.storeTokenPayload(r), o = v.sanitizeSSOParams(window.location.href), window.history.replaceState({}, document.title, o), !(a = document.head.querySelector("meta[name='referrer']")) || "no-referrer" !== a.getAttribute("content")) return c = 'element <meta name="referrer" content="no-referrer"> not found in page <head> section', p.log.warn("Redirecting to clear referrer, " + c + "."), window.location.href = o, [2, Promise.reject(new d.ClientError(d.ClientErrorKeys.metaNoReferrerMissing, "Redirecting because " + c + "."))];
                }

                return !(r = n.getTokenInfo()) && this._config.loginPopup && n.openLoginWindow(i(i({}, this._config), {
                  idpUrl: "about:blank"
                })), r ? (l = Promise.resolve(this), [3, 6]) : [3, 1];

              case 1:
                return this._config.idpUrl ? [3, 5] : [4, this.getAccountSid()];

              case 2:
                return f = s.sent(), [4, v.IdpUrl.get(f, this._config)];

              case 3:
                return m = s.sent(), this._config.accountSid = f, this._config.idpUrl = m, p.log.debug("got the redirect url", m), [4, h.fetchPublicConfiguration(this._config.accountSid, !0, this._config)];

              case 4:
                g = s.sent(), y = g.public_attributes || {}, this._config = u.Utils.merge(y || {}, this._config), s.label = 5;

              case 5:
                this._config.loginPopup ? l = n.tryLoginInNewWindow(this._config) : (p.log.debug("redirecting to ", this._config.idpUrl), window.location.href = this._config.idpUrl, l = Promise.reject(new d.BrowserError(d.BrowserErrorKeys.redirecting))), s.label = 6;

              case 6:
                return [2, l.then(function () {
                  return e ? b.startLoginHandler() : Promise.resolve(b);
                })];
            }
          });
        });
      }, n.prototype.startLoginHandler = function () {
        return this._checkTokenExpirationInterval = setInterval(this.handleCheckTokenExpirationInterval, 1e3), this.checkTokenExpired();
      }, n.getTokenFromLocalStorage = function () {
        var e = window.localStorage.getItem("TWILIO_FLEX_SSO");

        if (e) {
          var t = JSON.parse(e);

          if (!Array.isArray(t.roles)) {
            var n = [];
            t.roles && n.push(t.roles), t.roles = n;
          }

          return t;
        }
      }, n.prototype.clearTokenFromLocalStorage = function () {
        window.localStorage.removeItem("TWILIO_FLEX_SSO");
      }, n.prototype.getAccountSid = function () {
        var e = g.Manager.getInstance();
        return e ? Promise.resolve(e.serviceConfiguration.account_sid) : this._config.accountSid ? Promise.resolve(this._config.accountSid) : Promise.reject(new d.ConfigError(d.ConfigErrorKeys.accountSid));
      }, n.parseTokenPayloadFromQueryString = function () {
        var e = window.location.search;

        if (e) {
          var t = l.parse(e),
              r = [];
          t.Roles && (r = Array.isArray(t.Roles) ? t.Roles : [t.Roles]);
          var o = {
            roles: r,
            identity: t.Identity,
            expiration: t.Expiration,
            token: t.Token
          };
          return n.isValidTokenPayload(o) ? o : void 0;
        }
      }, n.hasValidToken = function () {
        var e = n.parseTokenPayloadFromQueryString() || n.getTokenFromLocalStorage();
        return !!n.isValidTokenPayload(e);
      }, n.storeTokenPayload = function (e) {
        var t = JSON.stringify(e);
        window.localStorage.setItem("TWILIO_FLEX_SSO", t);
      }, n.isValidTokenPayload = function (e) {
        if (!e) return !1;
        var t = e.expiration,
            n = e.identity,
            r = e.roles,
            o = e.token;
        return !(!t || !n || !r || !o || this.isTokenExpired(e, 3e5));
      }, n.isTokenExpired = function (e, t) {
        void 0 === t && (t = 0);
        var n = e.expiration;
        if (!n || "string" != typeof n) return !0;
        var r = (Date.parse(n) || 0) - t > Date.now();
        return r || p.log.debug("Token has expired"), !r;
      }, n.isInLoginWindow = function () {
        return window.name === t.LOGIN_WINDOW_NAME;
      }, n.prototype.fetchNewToken = function (e) {
        var t = this;
        return this.getAccountSid().then(function (n) {
          var r = y.getSSOTokenRefreshUrl(t._config, n);
          return p.log.debug("Fetching new token"), c.default.post(r, {
            token: e
          }).then(function (e) {
            return p.log.debug("Got token info:", e.data), e.data;
          }).catch(function (e) {
            throw p.log.error("Failed to fetch new token", e), e;
          });
        });
      }, n.prototype.handleTokenUpdate = function () {
        var e = this,
            t = n.getTokenFromLocalStorage();
        return this._updatingToken = !0, this.fetchNewToken(t.token).then(function (r) {
          var o = i(i({}, t), {
            expiration: r.expiration,
            token: r.token
          });
          return n.storeTokenPayload(o), e._updatingToken = !1, p.log.info("Token updated successfully"), e.emit("tokenUpdated", e), e;
        }).catch(function (r) {
          throw e._updatingToken = !1, p.log.error("Unable to fetch new token"), e.emit("tokenUpdateFailed", e), n.isTokenExpired(t) && e.handleTokenExpired(), r;
        });
      }, n.prototype.handleTokenExpired = function () {
        p.log.info("Token has expired"), clearInterval(this._checkTokenExpirationInterval), this.emit("tokenExpired", this);
      }, n;
    }(f.EventEmitter);

    t.SSOLoginHandler = C;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r,
        o = n(28),
        i = n(5),
        a = n(76),
        s = n(8),
        c = n(10),
        l = {
      mapDomainToLookup: function mapDomainToLookup(e) {
        return s.flexPublicConfigServiceUrl + "?RuntimeDomain=" + e;
      }
    };

    function u(e, t, n) {
      return void 0 === t && (t = ""), void 0 === n && (n = !0), n && r && r.account_sid === t ? Promise.resolve(r) : fetch(e).then(function (e) {
        if (200 === e.status) return e.json();
        throw i.log.error("Failed to fetch public configuration", e.status), new o.ValidationError(o.ValidationErrorKeys.accountSid);
      }).then(function (e) {
        var t = e.configurations;
        if (!Array.isArray(t) || t.length <= 0) throw i.log.error("Failed to fetch accountSid, no configurations"), new o.ValidationError(o.ValidationErrorKeys.accountSid);
        return r = t[0];
      });
    }

    t.fetchRuntimeDomainInfo = function (e, t) {
      if (void 0 === t && (t = l), !(e = e.trim()).endsWith(".twil.io")) {
        var n = e.match(a.RUNTIME_DOMAIN_REGEXP);
        n && n[1] && (e += ".twil.io");
      }

      return e = e.endsWith("/") ? e.replace(/\/$/, "") : e, u(t.mapDomainToLookup ? t.mapDomainToLookup(e) : l.mapDomainToLookup(e));
    }, t.fetchPublicConfiguration = function (e, t, n) {
      return void 0 === t && (t = !0), void 0 === n && (n = {}), u(s.getPublicConfigServiceUrl(e, n), e, t);
    }, t.getStoredConfig = function () {
      var e = localStorage.getItem("FLEX_CONFIG");
      return e && JSON.parse(e) || {};
    }, t.clearStoredConfig = function () {
      i.log.debug("clearing config from local storage", "FLEX_CONFIG"), localStorage.removeItem("FLEX_CONFIG");
    }, t.storeConfig = function (e) {
      var t = JSON.stringify(e);
      i.log.debug("saving config to local storage", "FLEX_CONFIG", t), localStorage.setItem("FLEX_CONFIG", t);
    }, t.isOutboundCallingEnabled = function () {
      var e = c.Manager.getInstance().serviceConfiguration.outbound_call_flows;
      return Boolean(e && e.default && e.default.enabled);
    };
  }, function (e, t) {
    e.exports = require("react-emotion");
  }, function (e, t) {
    e.exports = require("emotion-theming");
  }, function (e, t, n) {
    "use strict";

    var _r5,
        o = this && this.__extends || (_r5 = function r(e, t) {
      return (_r5 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r5(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(55),
        c = n(6),
        l = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.gotoView = function () {
          c.tryInvokeAction("NavigateToView", {
            viewName: t.props.viewName
          });
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.activeView,
            n = e.showLabel,
            r = e.Badge,
            o = e.viewName,
            c = e.icon,
            l = e.iconActive,
            u = e.template;
        return i.createElement(s.SideLink, {
          icon: c,
          iconActive: l,
          isActive: t === o,
          onClick: this.gotoView,
          showLabel: n,
          Badge: r
        }, i.createElement(a.Template, {
          source: u
        }));
      }, t;
    }(i.PureComponent);

    t.SideLinkView = l;
  }, function (e, t, n) {
    "use strict";

    var _r6,
        o = this && this.__extends || (_r6 = function r(e, t) {
      return (_r6 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r6(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i,
        a = n(1),
        s = n(0),
        c = n(161),
        l = n(517),
        u = n(5),
        p = n(518);
    !function (e) {
      e[e.Fetching = 0] = "Fetching", e[e.Fetched = 1] = "Fetched", e[e.Error = 2] = "Error";
    }(i || (i = {}));

    var d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.hasFetched = !1, t.state = {
          url: "",
          urlStatus: i.Fetching
        }, t.yticaRef = a.createRef(), t.getUrl = function (e) {
          t.hasFetched = !0, t.props.getUrl(e).then(function (e) {
            t.setState({
              url: e,
              urlStatus: i.Fetched
            });
          }).catch(function (e) {
            u.log.error(e), t.setState({
              urlStatus: i.Error
            });
          });
        }, t;
      }

      return o(t, e), Object.defineProperty(t.prototype, "iframeRef", {
        get: function get() {
          return this.yticaRef.current && this.yticaRef.current.iframeRef.current ? this.yticaRef.current.iframeRef.current : null;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.render = function () {
        var e = this;
        return a.createElement(c.Controller, null, function (t) {
          var n = t.status,
              r = t.client;

          if (n === c.ServiceStatus.Ready) {
            if (!e.hasFetched) return e.getUrl(r), a.createElement(s.CircularProgress, {
              borderWidth: 3
            });
            if (e.state.urlStatus === i.Fetched) return a.createElement(l.YticaApp, {
              name: e.props.name,
              src: e.state.url,
              isActive: e.props.isActive,
              onMessage: e.props.onMessage,
              ref: e.yticaRef
            });
          }

          return n === c.ServiceStatus.Initializing || e.state.urlStatus === i.Fetching ? a.createElement(s.CircularProgress, {
            borderWidth: 3
          }) : a.createElement(p.NotAvailable, {
            name: e.props.name
          });
        });
      }, t.defaultProps = {
        isActive: !0
      }, t;
    }(a.Component);

    t.default = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function r(e) {
      this.target = e.target, this.targetAlias = e.targetAlias, this.trigger = e.trigger.bind(null), this.onStart = e.onStart, this.start = this.start.bind(this);
    };

    t.Spy = r;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(3),
        o = n(0),
        i = n(4),
        a = function () {
      function e(e) {
        this.complete = function () {
          throw new Error("Not implemented");
        }, this.setAttributes = function (e) {
          throw new Error("Not implemented");
        }, this.wrapUp = function () {
          throw new Error("Not implemented");
        }, this.transfer = function (e, t) {
          throw new Error("Not implemented");
        }, this.hold = function () {
          throw new Error("Not implemented");
        }, this.unhold = function () {
          throw new Error("Not implemented");
        }, this.holdParticipant = function () {
          throw new Error("Not implemented");
        }, this.unholdParticipant = function () {
          throw new Error("Not implemented");
        }, this.kick = function () {
          throw new Error("Not implemented");
        }, this.cancelTransfer = function () {
          throw new Error("Not implemented");
        }, this._source = e;
      }

      return Object.defineProperty(e.prototype, "source", {
        get: function get() {
          return this._source;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sourceObject", {
        get: function get() {
          return this._source;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "addOns", {
        get: function get() {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "age", {
        get: function get() {
          return this._source.task_age;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "attributes", {
        get: function get() {
          return this._source.attributes;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dateCreated", {
        get: function get() {
          return new Date(this._source.date_created);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dateUpdated", {
        get: function get() {
          return new Date(this._source.date_updated);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "priority", {
        get: function get() {
          return this._source.task_priority;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "queueName", {
        get: function get() {
          return this._source.queue_name;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "queueSid", {
        get: function get() {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "reason", {
        get: function get() {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "taskSid", {
        get: function get() {
          return this._source.task_sid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "status", {
        get: function get() {
          var e = this._source.status;
          return "wrapup" === e && (e = "wrapping"), e;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "taskStatus", {
        get: function get() {
          return this._source.task_status;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "taskChannelSid", {
        get: function get() {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "taskChannelUniqueName", {
        get: function get() {
          return this._source.task_channel_unique_name;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "timeout", {
        get: function get() {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "workflowName", {
        get: function get() {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "workflowSid", {
        get: function get() {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sid", {
        get: function get() {
          return this._source.reservation_sid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "workerSid", {
        get: function get() {
          return this._source.worker_sid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "routingTarget", {
        get: function get() {
          return this._source.task_routing_target;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "defaultFrom", {
        get: function get() {
          var e = this.attributes;
          return (e.name ? e.name : this.routingTarget && "outbound" === e.direction ? e.outbound_to : e.from) || i.templates.AnonymousParticipant();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "channelType", {
        get: function get() {
          return this.attributes.channelType || this.taskChannelUniqueName;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "incomingTransferObject", {
        get: function get() {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "outgoingTransferObject", {
        get: function get() {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "conference", {
        get: function get() {
          var e = r.FlexModule.state.conferences.states.get(this.taskSid);
          return e ? e.source : void 0;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    t.InsightsTask = a;

    var s = function () {
      function e(e) {
        this._source = e;
      }

      return Object.defineProperty(e.prototype, "source", {
        get: function get() {
          return this._source;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sid", {
        get: function get() {
          return this.source.worker_sid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "name", {
        get: function get() {
          return this.source.friendly_name;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "fullName", {
        get: function get() {
          return this.source.attributes.full_name || this.name;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "activityName", {
        get: function get() {
          return this.source.activity_name;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "attributes", {
        get: function get() {
          return this.source.attributes;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dateUpdated", {
        get: function get() {
          return new Date(this.source.date_updated);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "activityDuration", {
        get: function get() {
          return o.Utils.formatTimeDuration(Math.max(Date.now() - new Date(this.source.date_activity_changed).getTime(), 0), "short");
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "isAvailable", {
        get: function get() {
          return this.findAvailabilityByActivityName();
        },
        enumerable: !0,
        configurable: !0
      }), e.ensureAvailabilityCache = function () {
        var e = this;
        this.availabilityByNameCache.size || r.FlexModule.workerClient && r.FlexModule.workerClient.activities.size && r.FlexModule.workerClient.activities.forEach(function (t) {
          e.availabilityByNameCache.set(t.name, t.available);
        });
      }, e.prototype.findAvailabilityByActivityName = function () {
        return e.ensureAvailabilityCache(), !!e.availabilityByNameCache.has(this.activityName) && e.availabilityByNameCache.get(this.activityName);
      }, e.availabilityByNameCache = new Map(), e;
    }();

    t.InsightsWorker = s;

    var c = function () {
      function e(e) {
        this._source = e;
      }

      return Object.defineProperty(e.prototype, "source", {
        get: function get() {
          return this._source;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sid", {
        get: function get() {
          return this.source.queue_sid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "name", {
        get: function get() {
          return this.source.queue_name;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dateUpdated", {
        get: function get() {
          return new Date(this.source.date_updated);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "workspaceSid", {
        get: function get() {
          return this.source.workspace_sid;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    t.InsightsQueue = c;
  }, function (e, t) {
    e.exports = require("query-string");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(117),
        o = n(27),
        i = n(3),
        a = function () {
      function e() {}

      return e.isEnabled = function (e) {
        var t = r.featureFlagsSelector(i.FlexModule.state);
        return t[e] ? t[e].enabled : void 0;
      }, e.set = function (e, t) {
        o.Actions.overrideFeatureFlag({
          id: e,
          enabled: t
        });
      }, e;
    }();

    t.FeatureFlags = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(258),
        o = n(259);
    t.Strings = o.Strings;
    var i = {
      default: r.default
    };
    t.languages = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e.Error = "ERROR", e.Ready = "READY", e.Initializing = "INITIALIZING";
    }(t.InsightsServiceStatus || (t.InsightsServiceStatus = {}));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(131);
    t.InsightsService = r.InsightsService;
    var o = n(44);
    t.InsightsServiceStatus = o.InsightsServiceStatus;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(138);
    t.TaskDetailsPanel = r.TaskDetailsPanel;
    var o = n(269);
    t.TaskDetailsPanelProps = o.TaskDetailsPanelProps;
    var i = n(47);
    t.IconContainerWithStyle = i.IconContainerWithStyle;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u,
        p,
        d,
        f = n(0),
        h = n(2);
    t.IconContainer = h.default("div")(o || (o = r(["\n    margin-bottom: 15px;\n"], ["\n    margin-bottom: 15px;\n"]))), t.IconContainerWithStyle = h.default("div")(i || (i = r(["\n    border-radius: 50%;\n    width: 72px;\n    height: 72px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    ", ";\n    background: ", ";\n"], ["\n    border-radius: 50%;\n    width: 72px;\n    height: 72px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    ", ";\n    background: ", ";\n"])), function (e) {
      return e.theme.TaskDetailsPanel.IconContainer;
    }, function (e) {
      return e.background;
    }), t.SecondLineContainer = h.default("div")(a || (a = r(["\n    font-size: 12px;\n    margin-bottom: 0px;\n    margin-top: 0px;\n    ", "\n"], ["\n    font-size: 12px;\n    margin-bottom: 0px;\n    margin-top: 0px;\n    ", "\n"])), function (e) {
      return e.theme.TaskDetailsPanel.SecondLine;
    }), t.FirstLineContainer = h.default("div")(s || (s = r(["\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 2px;\n    margin-left: 4px;\n    margin-right: 4px;\n"], ["\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 2px;\n    margin-left: 4px;\n    margin-right: 4px;\n"]))), t.TitleLineContainer = h.default("div")(c || (c = r(["\n    font-size: 12px;\n    margin-bottom: 15px;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n"], ["\n    font-size: 12px;\n    margin-bottom: 15px;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n"]))), t.InfoContainer = h.default("div")(l || (l = r(["\n    margin: auto;\n    text-align: center;\n"], ["\n    margin: auto;\n    text-align: center;\n"]))), t.ContentContainer = h.default(f.FlexBoxColumn)(u || (u = r(["\n    flex-grow: 1;\n    overflow: hidden;\n"], ["\n    flex-grow: 1;\n    overflow: hidden;\n"]))), t.ButtonContainer = h.default("div")(p || (p = r(["\n    width: 100%;\n    display: flex;\n    margin-top: 24px;\n    margin-bottom: 24px;\n    justify-content: center;\n\n    button {\n        width: 44px;\n        height: 44px;\n        margin-left: 6px;\n        margin-right: 6px;\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    margin-top: 24px;\n    margin-bottom: 24px;\n    justify-content: center;\n\n    button {\n        width: 44px;\n        height: 44px;\n        margin-left: 6px;\n        margin-right: 6px;\n    }\n"]))), t.Container = h.default(f.FlexBoxColumn)(d || (d = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.TaskDetailsPanel.Container;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(3),
        a = n(75),
        s = n(0),
        c = n(22),
        l = n(7),
        u = n(49),
        p = function () {
      function e() {}

      return e.registerActions = function () {
        s.Actions.registerAction("ToggleMute", e.toggleMute), s.Actions.registerAction("HangupCall", e.hangupCall, this.updateVoiceActionPayload), s.Actions.registerAction("HoldCall", e.holdCall, this.updateVoiceActionPayload), s.Actions.registerAction("UnholdCall", e.unholdCall, this.updateVoiceActionPayload);
      }, e.toggleMute = function () {
        return r(this, void 0, Promise, function () {
          var e;
          return o(this, function (t) {
            if (!i.FlexModule.state.phone.connection) throw Error("Cannot call mute with no live connection!");
            return (e = i.FlexModule.state.phone.connection.source).mute(!e.isMuted()), [2];
          });
        });
      }, e.holdCall = function (e) {
        var t = e.task;
        return l.TaskHelper.canHold(t) ? (l.TaskHelper.isRegularConferenceCall(t) || a.Actions.oldHoldConnection(), t.hold().catch(function (e) {
          throw new Error("Error holding call! " + e.message);
        })) : Promise.reject(Error("Cannot hold call!"));
      }, e.unholdCall = function (e) {
        var t = e.task;
        return l.TaskHelper.canHold(t) ? (l.TaskHelper.isRegularConferenceCall(t) || a.Actions.oldUnHoldConnection(), t.unhold().catch(function (e) {
          throw new Error("Error unholding call! " + e.message);
        })) : Promise.reject(Error("Cannot unhold call!"));
      }, e.hangupCall = function (e) {
        return r(this, void 0, Promise, function () {
          var t;
          return o(this, function (n) {
            if (!e.task) throw Error("no task in payload");
            if (!(t = c.StateHelper.getCurrentPhoneCallState())) throw Error("no active call");
            return t.source.disconnect(), [2];
          });
        });
      }, e.updateVoiceActionPayload = function (e) {
        return e || (e = {}), e.task && (e.sid = e.task.sid), e.sid && !e.task && (e.task = l.TaskHelper.getTaskByTaskSid(e.sid)), e;
      }, e;
    }();

    t.VoiceActions = p, t.isValidVoiceActionPayload = function (e) {
      return u.isValidTaskPayload(e);
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a,
        s = n(15),
        c = n(41),
        l = n(3),
        u = n(7),
        p = n(22),
        d = n(0),
        f = n(29),
        h = n(26),
        m = n(17),
        g = n(10),
        y = n(34),
        v = n(72),
        b = n(6),
        C = n(8),
        _ = n(5),
        k = n(16),
        w = function () {
      function e() {}

      return e.registerActions = function () {
        d.Actions.registerAction("AcceptTask", this.acceptTask, this.updateAcceptTaskPayload), d.Actions.registerAction("RejectTask", this.rejectTask, this.updateWorkerActionPayload), d.Actions.registerAction("CompleteTask", this.completeTask, this.updateWorkerActionPayload), d.Actions.registerAction("WrapupTask", this.wrapupTask, this.updateWorkerActionPayload), d.Actions.registerAction("SelectTask", this.selectTask, this.updateWorkerActionPayload), d.Actions.registerAction("SetActivity", this.setActivity, this.updateWorkerSetActivityPayload), d.Actions.registerAction("SetWorkerActivity", this.setWorkerActivity, this.updateWorkerSetWorkerActivityPayload), d.Actions.registerAction("TransferTask", this.transferTask, this.updateWorkerActionPayload), d.Actions.registerAction("KickParticipant", this.kickParticipant, this.updateWorkerParticipantActionPayload), d.Actions.registerAction("CancelTransfer", this.cancelTransfer, this.updateWorkerActionPayload), d.Actions.registerAction("Logout", this.logout), d.Actions.registerAction("HoldParticipant", this.holdParticipant, this.updateWorkerParticipantActionPayload), d.Actions.registerAction("UnholdParticipant", this.unholdParticipant, this.updateWorkerParticipantActionPayload), d.Actions.registerAction("ToggleDTMFDialpad", this.toggleDTMFDialpad, this.updateWorkerActionPayload), d.Actions.registerAction("SetDTMFDialpadDigits", this.setDTMFDialpadDigits, this.updateWorkerActionPayload), d.Actions.registerAction("SendDTMFDigits", this.sendDTMFDigitsToCall, this.updateWorkerActionPayload);
      }, e.blockActionUntilReservationEvent = function (e, t, n) {
        d.Actions.blockAction(e, t);

        var r = ["accepted", "rejected", "timeout", "canceled", "rescinded", "completed", "wrapup"],
            o = function o() {
          d.Actions.unblockAction(e, t), r.forEach(function (e) {
            n.removeListener(e, o);
          });
        };

        r.forEach(function (e) {
          n.addListener(e, o);
        });
      }, e.acceptTask = function (t) {
        return o(this, void 0, Promise, function () {
          var n, r, o, s, c, f, h;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                if (n = t.task, r = !1, !(o = p.StateHelper.getReservation(n.sid))) throw new Error("Reservation not found for task " + n.sid);
                if ("pending" !== n.status) throw new Error("Reservation is not in pending state " + n.sid);
                if (!u.TaskHelper.isCallTask(n)) return [3, 5];
                if (a && clearTimeout(a), s = l.FlexModule.state.supervisor.callMonitoring.status !== k.CallMonitoringStatus.none, c = /^client:/, f = l.FlexModule.state.worker.attributes.contact_uri, (r = Boolean(p.StateHelper.getCurrentPhoneCallState())) && !s && _.log.error("'Stuck task' scenario 1 flavour 2 intercepted: a ghost voice connection was active while agent tried to accept a call task."), l.FlexModule.state.config.disableBrowserVoice && (c.test(f) || !f && c.test(t.conferenceOptions.to))) throw m.Notifications.showNotification(m.NotificationIds.BrowserVoiceDisabled), new Error("Browser voice disabled");
                e.blockActionUntilReservationEvent("AcceptTask", t, o), i.label = 1;

              case 1:
                return i.trys.push([1, 3,, 4]), [4, o.conference(t.conferenceOptions)];

              case 2:
                return i.sent(), a = setTimeout(function () {
                  !p.StateHelper.getCurrentPhoneCallState() || !n || "pending" !== n.status || r || n.attributes && "outbound" === n.attributes.direction || _.log.error("'Stuck task' scenario 1 flavour 1 intercepted: a call task is still pending after 5 seconds, but its voice connection is up.");
                }, 5e3), [3, 4];

              case 3:
                throw h = i.sent(), d.Actions.unblockAction("AcceptTask", t), h;

              case 4:
                return [2, o];

              case 5:
                return [4, o.accept()];

              case 6:
                return i.sent(), [2, o];
            }
          });
        });
      }, e.rejectTask = function (e) {
        return o(this, void 0, Promise, function () {
          var t, n;
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                if (t = e.task, !(n = p.StateHelper.getReservation(t.sid))) throw new Error("Reservation not found for task " + t.sid);
                if ("pending" !== t.status) throw new Error("Reservation is not in pending state " + t.sid);
                return [4, n.reject(void 0)];

              case 1:
                return r.sent(), [2, n];
            }
          });
        });
      }, e.completeTask = function (e) {
        return o(this, void 0, Promise, function () {
          var t;
          return i(this, function (n) {
            switch (n.label) {
              case 0:
                if ("completed" === (t = e.task).status) throw new Error("Reservation is in completed state " + t.sid);
                return [4, v.ChatOrchestrator.orchestrateCompleteTask(t)];

              case 1:
                return n.sent(), [4, t.complete()];

              case 2:
                return n.sent(), [2, t];
            }
          });
        });
      }, e.wrapupTask = function (e) {
        return o(this, void 0, Promise, function () {
          var t;
          return i(this, function (n) {
            switch (n.label) {
              case 0:
                if ("accepted" !== (t = e.task).status) throw new Error("Reservation is not in accepted state " + t.sid);
                return [4, v.ChatOrchestrator.orchestrateWrapupTask(t)];

              case 1:
                return n.sent(), [4, t.wrapUp()];

              case 2:
                return n.sent(), [2, t];
            }
          });
        });
      }, e.selectTask = function (e) {
        return o(this, void 0, void 0, function () {
          var t;
          return i(this, function (n) {
            return f.Actions.selectTask(e.sid), t = e.sid || "", b.tryInvokeAction("HistoryPush", "/agent-desktop/" + t), [2];
          });
        });
      }, e.setActivity = function (e) {
        var t = e.activitySid,
            n = l.FlexModule.state.worker.activities.get(t),
            o = e.options && e.options.rejectPendingReservations,
            i = !n.available && o,
            a = r(r({}, e.options), {
          rejectPendingReservations: i
        });
        return n.setAsCurrent(a).catch(function (e) {
          var t = !!e.response && e.response.statusText;
          if (!t || !t.match(/Worker WK.* cannot have its activity updated while it has .* pending reservations/)) throw e;
          m.Notifications.showNotification(m.NotificationIds.PendingReservationsOnActivityStateChange);
        });
      }, e.setWorkerActivity = function (e) {
        var t = e.workerSid,
            n = e.activitySid,
            r = l.FlexModule.state.worker.activities.get(n),
            o = e.options && e.options.rejectPendingReservations,
            i = !r.available && o,
            a = C.getFlexServiceUrl(l.FlexModule.state.config),
            u = {
          Sid: t,
          WorkspaceSid: g.Manager.getInstance().serviceConfiguration.taskrouter_workspace_sid,
          ActivitySid: n,
          RejectPendingReservations: i
        },
            p = {
          auth: {
            username: "token",
            password: l.FlexModule.state.session.ssoTokenPayload.token
          },
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        };
        return s.default.post(a + "/Worker/Instance", c.stringify(u), p).then(function () {
          _.log.debug("worker activity updated", n);
        }).catch(function (e) {
          m.Notifications.showNotification(m.NotificationIds.CannotChangeOtherWorkerActivity), _.log.error("failed to update worker activity", e);
        });
      }, e.transferTask = function (e) {
        return u.TaskHelper.canTransfer(e.task) ? e.task.transfer(e.targetSid, e.options) : (m.Notifications.showNotification(m.NotificationIds.TaskCannotBeTransferred), Promise.reject(new Error("cannot transfer this task!")));
      }, e.cancelTransfer = function (e) {
        return e.task.outgoingTransferObject ? e.task.cancelTransfer() : Promise.reject(new Error("there are no outgoing transfer to cancel"));
      }, e.kickParticipant = function (e) {
        return e.task.kick(e.targetSid);
      }, e.holdParticipant = function (e) {
        var t = e.task;
        return u.TaskHelper.canHold(t) ? t.holdParticipant(e.targetSid) : Promise.reject(new Error("Cannot hold participant!"));
      }, e.unholdParticipant = function (e) {
        var t = e.task;
        return u.TaskHelper.canHold(t) || e.targetSid === l.FlexModule.state.worker.worker.sid ? t.unholdParticipant(e.targetSid) : Promise.reject(new Error("Cannot unhold participant!"));
      }, e.toggleDTMFDialpad = function (t) {
        return o(this, void 0, Promise, function () {
          var n;
          return i(this, function (o) {
            return u.TaskHelper.isCallTask(t.task) ? (n = "CallCanvasDialpad" + t.task.sid, Object.prototype.hasOwnProperty.call(t, "open") ? t.open ? [2, f.Actions.setComponentState(n, {
              digits: ""
            })] : [2, f.Actions.deleteComponentState(n)] : [2, e.toggleDTMFDialpad(r(r({}, t), {
              open: !l.FlexModule.state.view.componentViewStates[n]
            }))]) : [2, Promise.reject(new Error("Cannot toggle DTMF dialpad for non call task"))];
          });
        });
      }, e.sendDTMFDigitsToCall = function (e) {
        return o(this, void 0, Promise, function () {
          var t, n, r;
          return i(this, function (o) {
            if (!u.TaskHelper.isLiveCall(e.task)) throw Error("Cannot send digits to a non live call");
            if (!(t = p.StateHelper.getCurrentPhoneCallState())) throw Error("no active call");
            return n = l.FlexModule.state.view.componentViewStates["CallCanvasDialpad" + e.task.sid], r = n ? n.digits : "", d.Actions.invokeAction("SetDTMFDialpadDigits", {
              task: e.task,
              digits: r + e.digits
            }), t.source.sendDigits(e.digits), [2];
          });
        });
      }, e.setDTMFDialpadDigits = function (e) {
        return o(this, void 0, Promise, function () {
          return i(this, function (t) {
            return u.TaskHelper.isLiveCall(e.task) ? [2, f.Actions.setComponentState("CallCanvasDialpad" + e.task.sid, {
              digits: e.digits
            })] : [2, Promise.reject(new Error("Cannot set digits for non live call"))];
          });
        });
      }, e.updateWorkerActionPayload = function (e) {
        var t = r({}, e);
        return t.task && (t.sid = t.task.sid), t.sid && !t.task && (t.task = u.TaskHelper.getTaskByTaskSid(t.sid)), t;
      }, e.updateWorkerParticipantActionPayload = function (t) {
        var n = e.updateWorkerActionPayload(t);

        if (n.participant && (n.targetSid = n.participant.sid), n.targetSid && !n.participant && n.task) {
          var r = l.FlexModule.state.conferences.states.get(n.task.taskSid);
          r && (n.participant = r.source.participants.find(function (e) {
            return e.workerSid === n.targetSid;
          }));
        }

        return n;
      }, e.updateAcceptTaskPayload = function (t) {
        var n = (t = e.updateWorkerActionPayload(t)).task.conference;
        t.conferenceOptions = t.conferenceOptions || {}, t.conferenceOptions.endConferenceOnExit = !n || 0 === n.liveWorkerCount, t.conferenceOptions.endConferenceOnCustomerExit = !0;
        var r = !!g.Manager.getInstance() && g.Manager.getInstance().serviceConfiguration;

        if (t.conferenceOptions.conferenceRecord = !!r.call_recording_enabled, t.conferenceOptions.conferenceRecord) {
          var o = {
            accountSid: r.account_sid,
            workspaceSid: r.taskrouter_workspace_sid,
            taskSid: t.task.sourceObject.task.sid
          },
              i = C.getCallRecordingCallbackUrl(r);
          Object.keys(o).forEach(function (e) {
            i = i.replace("{" + e + "}", o[e]);
          }), t.conferenceOptions.conferenceRecordingStatusCallback = i, t.conferenceOptions.conferenceRecordingStatusCallbackMethod = "POST";
        }

        return t;
      }, e.updateWorkerSetActivityPayload = function (e) {
        if (e.activityName && !e.activitySid) {
          var t = Array.from(l.FlexModule.state.worker.activities).find(function (t) {
            t[0];
            return t[1].name === e.activityName;
          });
          e.activitySid = t && t[0];
        }

        return e.activitySid && (e.activityName = l.FlexModule.state.worker.activities.get(e.activitySid).name, e.activityAvailable = l.FlexModule.state.worker.activities.get(e.activitySid).available), e.options || (e.options = {}), void 0 === e.options.rejectPendingReservations && (e.options.rejectPendingReservations = l.FlexModule.state.config.rejectPendingReservations), e;
      }, e.updateWorkerSetWorkerActivityPayload = function (e) {
        if (e.activityName && !e.activitySid) {
          var t = Array.from(l.FlexModule.state.worker.activities).find(function (t) {
            t[0];
            return t[1].name === e.activityName;
          });
          e.activitySid = t && t[0];
        }

        return e.activitySid && (e.activityName = l.FlexModule.state.worker.activities.get(e.activitySid).name, e.activityAvailable = l.FlexModule.state.worker.activities.get(e.activitySid).available), e.options || (e.options = {}), void 0 === e.options.rejectPendingReservations && (e.options.rejectPendingReservations = l.FlexModule.state.config.rejectPendingReservations), e;
      }, e.logout = function (e) {
        return y.clearStoredConfig(), h.Actions.logout(e).catch(function (e) {
          var t = !!e.response && e.response.statusText;
          if (!t || !t.match(/Worker WK.* cannot have its activity updated while it has .* pending reservations/)) throw e;
          m.Notifications.showNotification(m.NotificationIds.PendingReservationsOnLogout);
        }).then(function (e) {
          return e;
        });
      }, e;
    }();

    t.WorkerActions = w, t.isValidTaskPayload = function (e) {
      return function (t) {
        return e && t && t.task && t.task.sid === e.sid;
      };
    }, t.isValidWorkerActionPayload = function (e) {
      return t.isValidTaskPayload(e);
    }, t.isValidWorkerParticipantActionPayload = function (e, n) {
      return function (r) {
        return t.isValidWorkerActionPayload(e)(r) && n === r.targetSid;
      };
    };
  }, function (e, t) {
    e.exports = require("@material-ui/core/MenuItem");
  }, function (e, t) {
    e.exports = require("@material-ui/core/Select");
  }, function (e, t, n) {
    "use strict";

    var _r7,
        o = this && this.__extends || (_r7 = function r(e, t) {
      return (_r7 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r7(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(14),
        u = n(339),
        p = n(342),
        d = n(2),
        f = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      var r;
      return o(n, e), r = n, n.prototype.render = function () {
        return s.createElement(t.Connected, i({}, this.props));
      }, n.displayName = "TaskCanvasHeader", n.Content = new c.DynamicContentStore(r.displayName), n.defaultProps = {
        content: r.Content,
        ActionsComponent: u.EndTaskButton,
        titleTemplateContext: {}
      }, n = r = a([c.withDefaultPropsUpdate], n);
    }(s.PureComponent);

    t.TaskCanvasHeader = f, t.Connected = d.withTheme(l.withTaskContext(p.TaskCanvasHeaderImpl));
  }, function (e, t, n) {
    "use strict";

    var _r8,
        o = this && this.__extends || (_r8 = function r(e, t) {
      return (_r8 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r8(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(36),
        c = n(0),
        l = n(3),
        u = n(92),
        p = n(359),
        d = n(360),
        f = n(54),
        h = p.createGenerateClassName({
      productionPrefix: "flex-md-"
    }),
        m = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e,
            n = this.props.themeConf,
            r = u.ThemeColorsDefinitionCreator.getPredefined(this.props.themeConf.baseName);
        n.colors && (r.colors = i(i({}, r.colors), n.colors)), n.light && (r.lightTheme = n.light), e = f.createTheme(r.colors, r.lightTheme);
        var o = t.getMergedTheme(e, this.props.themeConf.overrides);
        o.name = this.props.themeConf.baseName;
        var c = p.createMuiTheme(o);
        return a.createElement(d.JssProvider, {
          generateClassName: h
        }, a.createElement(p.MuiThemeProvider, {
          theme: c
        }, a.createElement(s.ThemeProvider, {
          theme: o
        }, this.props.children)));
      }, t.getMergedTheme = function (e, t) {
        return t ? c.Utils.merge(e, t) : e;
      }, t;
    }(a.PureComponent);

    t.StorelessThemeProvider = m, t.ThemeProvider = l.connect(function (e) {
      return {
        themeConf: e.config.colorTheme
      };
    })(m);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0),
        i = n(57),
        a = r(r({}, o.BaseTheme.colors), i.commonColors);

    t.createTheme = function (e, t) {
      var n = o.createTheme(e, t),
          i = t ? e.darkTextColor : e.lightTextColor;
      return r(r({}, n), {
        colors: e,
        UserActivityControls: {
          Item: {
            color: i,
            lightHover: !1
          },
          Items: {
            background: e.base2
          },
          Divider: {
            background: e.base4
          }
        },
        LoginFormView: {
          Container: {
            backgroundColor: e.base2,
            borderColor: e.base4,
            color: i
          },
          LoginButton: {
            background: e.defaultButtonColor,
            lightHover: !0
          }
        },
        LoginView: {
          Container: {
            background: e.base2,
            color: i
          },
          LoginButton: {
            background: e.defaultButtonColor,
            color: e.lightTextColor
          },
          Logo: {
            color: e.base11
          }
        },
        RuntimeLoginView: {
          Container: {
            background: e.base2,
            color: i
          },
          LoginButton: {
            background: e.defaultButtonColor,
            lightHover: !0
          }
        },
        RootContainer: {},
        AgentDesktopView: {
          Panel1: {
            background: e.base2
          },
          Panel2: {
            background: e.base2
          },
          ContentSplitter: {
            background: e.base2,
            borderColor: e.base4,
            color: e.base10
          }
        },
        MainHeader: {
          Container: {
            background: t ? e.base9 : e.base3,
            color: e.lightTextColor,
            borderColor: e.base4
          },
          Button: {
            color: e.lightTextColor,
            lightHover: !0
          }
        },
        MainContainer: {},
        SideNav: {
          Container: {
            background: t ? e.base8 : e.base3,
            borderColor: e.base4
          },
          Button: {
            color: e.lightTextColor,
            background: t ? e.base8 : e.base3,
            lightHover: !0
          },
          Icon: {
            color: e.lightTextColor
          }
        },
        TaskDetailsPanel: {
          Container: {
            color: i
          },
          IconContainer: {
            color: e.lightTextColor,
            border: "1px solid " + e.base6
          },
          SecondLine: {
            color: e.base8
          }
        },
        IncomingTaskCanvas: {
          AcceptTaskButton: {
            color: e.acceptTextColor,
            background: e.acceptColor
          },
          RejectTaskButton: {
            color: e.declineTextColor,
            background: e.declineColor
          }
        },
        ConnectingOutboundCallCanvas: {
          CancelCallButton: {
            color: e.declineTextColor,
            background: e.declineColor
          }
        },
        TaskInfoPanel: {
          Container: {
            color: i
          }
        },
        CallCanvas: {
          Button: {
            background: e.base3,
            color: e.base11
          },
          HangUpButton: {
            background: e.declineColor,
            color: e.declineTextColor
          }
        },
        TaskCanvas: {
          Container: {
            background: e.base1
          }
        },
        TaskCanvasHeader: {
          Container: {
            background: e.base1,
            color: i
          },
          WrapupTaskButton: {
            background: e.declineColor,
            color: e.declineTextColor
          },
          EndTaskButton: {
            background: e.completeTaskColor,
            color: e.declineTextColor
          }
        },
        TaskList: {
          Filter: {
            Container: {
              background: e.base2,
              borderColor: e.base4
            },
            EntryButton: {
              color: i
            },
            Menu: {
              Item: {
                color: i,
                lightHover: !t
              },
              Items: {}
            }
          },
          Item: {
            Container: {
              color: i,
              borderColor: e.base4,
              background: e.base2,
              lightHover: !t
            },
            Icon: {
              color: e.lightTextColor
            },
            SelectedContainer: {
              background: e.base1,
              color: i,
              lightHover: !t
            },
            Buttons: {
              DefaultButton: {
                color: e.base11,
                background: e.base3,
                lightHover: !t
              },
              AcceptButton: {
                color: e.acceptTextColor,
                background: e.acceptColor
              },
              RejectButton: {
                color: e.declineTextColor,
                background: e.declineColor
              }
            }
          }
        },
        TaskCard: {
          Container: {
            Default: {
              borderColor: e.base4,
              lightHover: !t
            },
            Selected: {
              borderColor: e.base11
            },
            Hover: {
              borderColor: e.base11
            }
          },
          IconArea: {
            Default: {
              color: e.lightTextColor
            }
          },
          ContentArea: {
            Default: {
              color: i,
              backgroundColor: e.base1
            },
            Inactive: {
              color: i,
              backgroundColor: e.base2
            }
          }
        },
        TaskCardPlaceholder: {
          borderColor: e.base4
        },
        NoTasksCanvas: {
          Container: {
            color: i,
            background: e.base2
          },
          Hint: {
            color: e.base8
          }
        },
        CRMContainer: {
          Container: {
            borderColor: e.base4
          },
          Placeholder: {
            Container: {
              color: i,
              background: e.base1
            },
            Icon: {
              color: e.base11
            },
            Button: {
              background: e.defaultButtonColor,
              color: e.lightTextColor
            },
            Hint: {
              color: e.base8
            }
          }
        },
        Supervisor: {
          Container: {
            background: e.base1
          },
          TaskCanvas: {
            HeaderButton: {
              color: e.base11,
              lightHover: !t
            },
            Container: {
              borderColor: e.base4,
              background: e.base1
            },
            MonitorActiveButton: {
              background: e.flexBlueColor,
              color: e.lightTextColor
            },
            Button: {
              background: e.base3,
              color: e.base11
            },
            Header: {
              borderColor: e.base4,
              color: i
            }
          },
          WorkerCanvas: {
            Container: {
              borderColor: e.base4,
              color: i
            },
            Header: {
              color: i
            },
            SectionCaption: {
              borderColor: e.base4,
              color: i
            }
          },
          FilterButton: {
            borderColor: e.base4,
            color: i,
            lightHover: !0
          },
          Search: {
            Container: {
              color: i
            },
            Button: {
              background: e.defaultButtonColor,
              color: e.lightTextColor,
              lightHover: !1
            }
          }
        },
        WorkerDirectory: {
          Container: {
            boxShadow: "-2px 0 10px 0 rgba(0, 0, 0, 0.2)",
            background: e.base2,
            color: i
          },
          Header: {
            Button: {
              color: e.base11,
              background: e.base3,
              lightHover: !t
            },
            Container: {}
          },
          ItemsContainer: {
            borderColor: e.base4
          },
          Item: {
            borderColor: e.base4,
            background: e.base2,
            lightHover: !t
          },
          ItemActionButton: {
            color: e.base11,
            background: e.base3,
            lightHover: !t
          },
          QueueItem: {
            Avatar: {
              background: e.base3
            }
          }
        },
        WorkerSkills: {
          SaveButton: {
            background: e.flexBlueColor,
            color: e.lightTextColor
          },
          CancelButton: {
            background: e.disabledColor,
            color: e.darkTextColor
          },
          DeleteButton: {
            borderColor: e.base4,
            lightHover: !t
          }
        },
        LoadingView: {
          Container: {
            backgroundColor: e.base2,
            color: i
          }
        },
        ParticipantsCanvas: {
          ParticipantCanvas: {
            Container: {
              color: i
            },
            Avatar: {
              background: e.flexBlueColor,
              color: e.lightTextColor,
              borderColor: e.base5
            },
            StateHover: {
              background: e.buttonHoverColor,
              color: e.lightTextColor
            },
            ConnectingAnimation: {
              color: e.lightTextColor
            },
            Button: {
              background: e.base3,
              color: e.base11
            },
            HangUpButton: {
              background: e.declineColor,
              color: e.declineTextColor
            }
          },
          Notification: {
            Container: {
              background: e.holdColor,
              color: t ? e.base1 : e.base11
            }
          }
        },
        QueueStats: {
          Container: {
            backgroundColor: e.base1,
            color: i
          },
          TableContainer: {},
          TilesGrid: {}
        },
        QueuesStats: {
          Container: {
            backgroundColor: e.base1,
            color: i
          },
          TableContainer: {},
          TilesGrid: {}
        },
        ToggleLoggingPanel: {
          IconButton: {},
          Panel: {
            backgroundColor: e.base2
          },
          Button: {
            backgroundImage: "linear-gradient(\n                    to top,\n                    " + e.defaultButtonColor + ",\n                    " + e.defaultButtonColor + "\n                )"
          }
        },
        OutboundDialerPanel: {
          Container: {
            background: e.base1,
            borderColor: e.base4,
            color: i,
            disabled: {
              color: e.disabledColor
            }
          },
          Header: {
            background: e.base1,
            color: i
          },
          HeaderButton: {
            lightHover: !t
          }
        },
        TranscriptPlayer: {
          Sidepanel: {
            backgroundColor: e.base1
          }
        }
      });
    };

    var s = {
      colors: a,
      lightTheme: !0
    };
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(508);
    t.SideLink = r.SideLink;
    var o = n(511);
    t.SideLinkProps = o.SideLinkProps;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(223);
    t.Supervisor = o;
    var i = n(90);
    t.QueuesStats = i;
    var a = n(161);
    t.Insights = a, r(n(0)), r(n(9)), r(n(334)), r(n(165)), r(n(170)), r(n(387)), r(n(101));
    var s = n(192);
    t.WorkersDataTable = s.WorkersDataTable, t.AgentsDataTable = s.WorkersDataTable, t.ColumnDataCreationContext = s.ColumnDataCreationContext;
    var c = n(205);
    t.TaskCard = c.TaskCard;
    var l = n(205);
    t.TaskCardList = l.TaskCardList;
    var u = n(206);
    t.RootContainer = u.RootContainer, t.RootContainerChildrenProps = u.RootContainerChildrenProps;
    var p = n(184);
    t.CRMContainer = p.CRMContainer, t.CRMContainerProps = p.CRMContainerProps;
    var d = n(207);
    t.MainContainer = d.MainContainer, t.MainContainerProps = d.MainContainerProps, t.MainContainerChildrenProps = d.MainContainerChildrenProps;
    var f = n(86);
    t.MuteButton = f.MuteButton, t.MuteButtonProps = f.MuteButtonProps;
    var h = n(208);
    t.SideNav = h.SideNav, t.SideNavProps = h.SideNavProps, t.SideNavChildrenProps = h.SideNavChildrenProps, t.SideLink = h.SideLink, t.SideLinkProps = h.SideLinkProps;
    var m = n(177);
    t.TaskListButtons = m.TaskListButtons;
    var g = n(181);
    t.TaskListContainer = g.TaskListContainer;
    var y = n(215);
    t.ViewCollection = y.ViewCollection, t.ViewCollectionProps = y.ViewCollectionProps, t.View = y.View, t.ViewProps = y.ViewProps, t.ViewCollectionChildrenProps = y.ViewCollectionChildrenProps;
    var v = n(182);
    t.WorkerDirectory = v.WorkerDirectory;
    var b = n(198);
    t.WorkerProfile = b.WorkerProfile;
    var C = n(199);
    t.WorkerSkills = C.WorkerSkills;

    var _ = n(197);

    t.WorkerCanvas = _.WorkerCanvas;
    var k = n(212);
    t.LiveCommsBar = k.LiveCommsBar, t.LiveCommsBarChildrenProps = k.LiveCommsBarChildrenProps, t.LiveCommsBarItem = k.LiveCommsBarItem, t.LiveCommsBarItemAction = k.LiveCommsBarItemAction, t.LiveCommsBarItemActions = k.LiveCommsBarItemActions, t.LiveCommsBarItemActionsProps = k.LiveCommsBarItemActionsProps;
    var w = n(571);
    t.OutboundDialerPanel = w.OutboundDialerPanel;
    var T = n(2);
    t.PropsWithTheme = T.PropsWithTheme, t.withTheme = T.withTheme, t.Theme = T.Theme, t.ThemeProps = T.ThemeProps;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.commonColors = {
      holdColor: "#ea6c00",
      declineColor: "#d32f2f",
      acceptColor: "#07874a",
      declineTextColor: "#ffffff",
      acceptTextColor: "#ffffff",
      completeTaskColor: "#1976d2",
      flexBlueColor: "#1976D2",
      agentAvailableColor: "#62c158",
      agentBusyColor: "#f1a33e",
      agentUnavailableColor: "#dd392b",
      agentOfflineColor: "#606471"
    }, t.defaultChannelColors = {
      inactive: "#a0a8bd",
      call: "#1976D2",
      video: "#1976D2",
      chat: "#057D9E",
      sms: "#D81B60",
      facebook: "#4266B2",
      line: "#3ACE01",
      whatsapp: "#2BB826",
      custom: "#a0a8bd"
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(3),
        i = n(5),
        a = n(7),
        s = n(25),
        c = n(71),
        l = n(134),
        u = n(136),
        p = n(84),
        d = {
      states: new Map()
    };

    t.reduce = function (e, t) {
      switch (void 0 === e && (e = d), t.type) {
        case "CONFERENCE_INIT":
          return r(r({}, d), t.payload);

        case "CONFERENCE_MULTIPLE_UPDATE":
          var n = t.payload,
              o = new Map(e.states);
          return n.conferences.forEach(function (e) {
            o.set(e.sid, {
              source: e
            });
          }), r(r({}, e), {
            states: o
          });

        default:
          return e;
      }
    };

    var f = function () {
      function e() {}

      return e.dispatchAction = function (e, t) {
        o.FlexModule.dispatch({
          type: e,
          payload: t
        });
      }, e.assignInsights = function (e) {
        this.dispatchAction("CONFERENCE_INIT", {
          client: e
        }), l.ConferenceListenerManager.initialize(this.handleConferenceUpdate.bind(this));
      }, e.handleConferenceUpdateImpl = function () {
        if (i.log.debug("ConferencesState handleConferenceUpdateImpl " + this.handleConferenceUpdateCalls.size), 0 !== this.handleConferenceUpdateCalls.size) {
          var e = new Set();
          this.handleConferenceUpdateCalls.forEach(function (t) {
            if (i.log.debug("ConferencesState handleConferenceUpdateImpl " + t.sid), 0 !== t.children.length) {
              var n = t.sid,
                  r = new u.Conference(n);

              if (t.children.forEach(function (e) {
                if ("conf_status" === e.key) {
                  var t = e.value;
                  r.status = t.status, r.conferenceSid = t.conference_sid;
                } else {
                  var n = new p.ConferenceParticipant(e.value, e.key);
                  "supervisor" !== n.participantType && r.participants.push(n);
                }
              }), i.log.debug("ConferencesState handleConferenceUpdateImpl raw participants: " + r.participants.length), t.outboundTransfer && "initialized" !== t.outboundTransfer.status) {
                i.log.debug("ConferencesState handleConferenceUpdateImpl adding fake outbound participant");
                var a = {
                  worker_sid: t.outboundTransfer.sid,
                  status: t.outboundTransfer.status,
                  participant_type: "transfer",
                  connecting: "recently_left" !== t.outboundTransfer.status
                },
                    c = new p.ConferenceParticipant(a);
                r.participants.push(c);
              }

              var l = [];
              r.participants.forEach(function (e) {
                "left" !== e.status ? l.push(e) : l.find(function (t) {
                  return t.uniqueId === e.uniqueId;
                }) || r.participants.find(function (t) {
                  return t.uniqueId === e.uniqueId && "left" !== t.status;
                }) || l.push(e);
              }), r.participants = l, i.log.debug("ConferencesState handleConferenceUpdateImpl filtered participants: " + r.participants.length);
              var d = o.FlexModule.state.conferences.states.get(n);
              d && (r.participants = r.participants.map(function (e) {
                if ("left" === e.status) {
                  var n = d.source.participants.find(function (t) {
                    return t.uniqueId === e.uniqueId;
                  });

                  if (n) {
                    if ("joined" === n.status) return t.triggerDelayedStateUpdate(5e3), new p.ConferenceParticipant(e.source, e.callSid, new Date().getTime());
                    if (n.participantLeftTimestamp && new Date().getTime() - n.participantLeftTimestamp < 5e3) return n;
                  }
                }

                return e;
              })), i.log.debug("ConferencesState handleConferenceUpdateImpl final participants: " + r.participants.length);
              var f = r.participants.map(function (e) {
                return e.workerSid;
              });
              s.InsightsEntityCache.refreshInfoForEntities(f), r.source = t, e.add(r);
            }
          }), this.dispatchAction("CONFERENCE_MULTIPLE_UPDATE", {
            conferences: e
          }), e.forEach(function (e) {
            var t = Array.from(o.FlexModule.state.worker.tasks.values()).find(function (t) {
              return t.taskSid === e.sid && a.TaskHelper.isLiveCall(t);
            });
            t && c.Actions.updateEndConferenceOnExitForTask(t);
          });
        }
      }, e.handleConferenceUpdate = function (e) {
        var t = this;

        if (e) {
          if (i.log.debug("ConferencesState handleConferenceUpdate " + e.sid), this.handleConferenceUpdateThrottler) return void this.handleConferenceUpdateCalls.add(e);
          this.handleConferenceUpdateCalls = new Set(), this.handleConferenceUpdateCalls.add(e), this.handleConferenceUpdateImpl(), this.handleConferenceUpdateCalls = new Set(), this.handleConferenceUpdateThrottler = setTimeout(function () {
            t.handleConferenceUpdateImpl(), clearTimeout(t.handleConferenceUpdateThrottler), t.handleConferenceUpdateThrottler = null;
          }, 500);
        }
      }, e.updateConferencesWithParticipant = function (e) {
        var t = [];
        o.FlexModule.state.conferences.states.forEach(function (n, r) {
          n.source.participants.find(function (t) {
            return t.workerSid === e;
          }) && t.push(n.source);
        }), t.length > 0 && this.dispatchAction("CONFERENCE_MULTIPLE_UPDATE", {
          conferences: t
        });
      }, e.shutdown = function () {
        this.dispatchAction("CONFERENCE_INIT", {});
      }, e;
    }();

    t.Actions = f;
  }, function (e, t) {
    e.exports = require("react-router-redux");
  }, function (e, t, n) {
    "use strict";

    var _r9,
        o = this && this.__extends || (_r9 = function r(e, t) {
      return (_r9 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r9(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(3),
        u = n(14),
        p = n(146),
        d = n(2),
        f = n(19),
        h = n(27),
        m = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(g, i({}, this.props));
      }, t.displayName = p.displayName, t.Content = p.contentStore, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.TaskCanvasTabs = m;
    var g = l.connect(function (e) {
      var t = e.view.componentViewStates.AgentTaskCanvasTabs,
          n = h.featureFlagsSelector(e)[f.FeatureFlag.MarkdownSupport];
      return {
        selectedTabName: !!t && t.selectedTabName,
        uniqueName: "AgentTaskCanvasTabs",
        hasMarkdownSupport: n && n.enabled
      };
    })(u.withTaskContext(d.withTheme(p.TaskCanvasTabsImpl)));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.INSIGHTS_PLAYER_PLAY = "InsightsPlayer:play", t.INSIGHTS_PLAYER_SHOW = "InsightsPlayer:show", t.INSIGHTS_PLAYER_HIDE = "InsightsPlayer:hide", t.INSIGHTS_PLAYER_INITIALIZED = "InsightsPlayer:initialized", t.ENDPOINT_SEGMENT_ID = "${mediaApiUrl}/segmentId/${accountSid}/${taskSid}";
  }, function (e, t, n) {
    "use strict";

    var _r10,
        o = this && this.__extends || (_r10 = function r(e, t) {
      return (_r10 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r10(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        a = n(66),
        s = n(53),
        c = n(78),
        l = n(5);
    t.FlexContext = i.createContext(void 0);

    var u = function u(e) {
      return e.store === c.getDefaultStore() || e.legacy ? i.createElement(a.Provider, {
        store: e.store
      }, e.children) : e.children;
    },
        p = function (e) {
      function n(t) {
        var n = e.call(this, t) || this;
        return t.manager ? (t.manager.loadInitialData().then(function () {
          return l.log.info("All data has been loaded...");
        }), n) : (l.log.error("manager missing in the props of ContextProvider"), n);
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props.manager;
        return i.createElement(t.FlexContext.Provider, {
          value: this.props
        }, i.createElement(u, {
          store: e.store,
          legacy: this.props.legacy
        }, i.createElement(s.ThemeProvider, null, this.props.children)));
      }, n;
    }(i.PureComponent);

    t.ContextProvider = p;
  }, function (e, t) {
    e.exports = require("react-router");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u,
        p,
        d,
        f,
        h,
        m,
        g = n(2),
        y = n(0),
        v = n(65);
    t.CallButton = g.default(y.IconButton)(o || (o = r(["\n    margin-right: 8px;\n"], ["\n    margin-right: 8px;\n"]))), t.ItemInnerContainer = g.default(y.FlexBox)(i || (i = r(["\n    display: flex;\n    padding-left: 0px;\n    padding-right: 12px;\n    color: inherit;\n    outline: none;\n    height: 44px;\n    background: none;\n    border: none;\n    border-style: solid;\n    border-width: 0px 0px 1px 0px;\n    ", "\n    &:hover {\n        & .Twilio-WorkerDirectory-ButtonContainer {\n            display: flex;\n        }\n        ", "\n        & .Twilio-WorkerDirectory-QueueAvatar {\n            ", "\n        }\n    }\n"], ["\n    display: flex;\n    padding-left: 0px;\n    padding-right: 12px;\n    color: inherit;\n    outline: none;\n    height: 44px;\n    background: none;\n    border: none;\n    border-style: solid;\n    border-width: 0px 0px 1px 0px;\n    ", "\n    &:hover {\n        & .Twilio-WorkerDirectory-ButtonContainer {\n            display: flex;\n        }\n        ", "\n        & .Twilio-WorkerDirectory-QueueAvatar {\n            ", "\n        }\n    }\n"])), function (e) {
      return e.theme.WorkerDirectory.Item;
    }, function (e) {
      return y.getBackgroundWithHoverCSS(e.theme.WorkerDirectory.Item.background, e.theme.WorkerDirectory.Item.lightHover, !0);
    }, function (e) {
      return y.getBackgroundWithHoverCSS(e.theme.WorkerDirectory.QueueItem.Avatar.background, e.theme.WorkerDirectory.Item.lightHover, !0);
    }), t.ButtonContainer = g.default("div")(a || (a = r(["\n    display: none;\n"], ["\n    display: none;\n"]))), t.PopupContainer = g.default("div")(s || (s = r(["\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    width: 275px;\n    height: 100%;\n    right: 0px;\n    z-index: 100;\n    ", "\n"], ["\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    width: 275px;\n    height: 100%;\n    right: 0px;\n    z-index: 100;\n    ", "\n"])), function (e) {
      return y.Animations.FadeInOutTransition(e.isOpen);
    }), t.HeaderPanel = g.default(y.FlexBox)(c || (c = r(["\n    height: 44px;\n    padding-left: 12px;\n    padding-right: 40px;\n    ", "\n"], ["\n    height: 44px;\n    padding-left: 12px;\n    padding-right: 40px;\n    ", "\n"])), function (e) {
      return e.theme.WorkerDirectory.Header.Container;
    }), t.LabelContainer = g.default(y.FlexBox)(l || (l = r(["\n    margin: auto;\n"], ["\n    margin: auto;\n"]))), t.Label = g.default("div")(u || (u = r(["\n    width: 100%;\n    text-align: center;\n    font-size: 12px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: 1px;\n    text-align: center;\n"], ["\n    width: 100%;\n    text-align: center;\n    font-size: 12px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: 1px;\n    text-align: center;\n"]))), t.ItemContainer = g.default(y.FlexBox)(p || (p = r(["\n    flex-grow: 1;\n    overflow-y: auto;\n    border-style: solid;\n    border-width: 1px 0 0 0;\n    ", "\n"], ["\n    flex-grow: 1;\n    overflow-y: auto;\n    border-style: solid;\n    border-width: 1px 0 0 0;\n    ", "\n"])), function (e) {
      return e.theme.WorkerDirectory.ItemsContainer;
    }), t.Container = g.default(y.FlexBox)(d || (d = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.WorkerDirectory.Container;
    }), t.StyledInput = g.default(v.default)(f || (f = r(["\n    margin-left: 12px;\n    margin-top: 10px;\n    width: calc(100% - 24px);\n"], ["\n    margin-left: 12px;\n    margin-top: 10px;\n    width: calc(100% - 24px);\n"]))), t.InputContainer = g.default("div")(h || (h = r(["\n    flex: 0 0 56px;\n"], ["\n    flex: 0 0 56px;\n"]))), t.TabContainer = g.default(y.FlexBoxColumn)(m || (m = r(["\n    overflow-x: hidden;\n"], ["\n    overflow-x: hidden;\n"])));
  }, function (e, t) {
    e.exports = require("@material-ui/core/Input");
  }, function (e, t) {
    e.exports = require("react-redux");
  }, function (e, t) {
    e.exports = require("lodash.debounce");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(30),
        o = n(57),
        i = {
      Pending: "TaskReserved",
      Accepted: "TaskAssigned",
      Wrapping: "TaskWrapup",
      Completed: "TaskCompleted",
      Canceled: "TaskCanceled",
      Reserved: "TaskReserved",
      Assigned: "TaskAssigned"
    },
        a = {
      Accepted: "SupervisorTaskLive",
      Pending: "SupervisorTaskLive",
      Wrapping: "SupervisorTaskWrapUp",
      Completed: "SupervisorTaskCompleted",
      Canceled: "SupervisorTaskCompleted",
      Reserved: "SupervisorTaskLive",
      Assigned: "SupervisorTaskLive"
    },
        s = o.defaultChannelColors.inactive;

    function c(e, t, n, c, l) {
      return void 0 === n && (n = "GenericTask"), void 0 === c && (c = "GenericTaskBold"), void 0 === l && (l = o.defaultChannelColors.custom), {
        name: e,
        isApplicable: t,
        capabilities: new Set([r.TaskChannelCapability.Info]),
        charLimit: 32768,
        colors: {
          main: {
            Reserved: l,
            Assigned: l,
            Accepted: l,
            Pending: l,
            Canceled: s,
            Wrapping: s,
            Completed: s
          }
        },
        icons: {
          list: {
            Reserved: c,
            Assigned: c,
            Accepted: c,
            Pending: c,
            Canceled: n,
            Wrapping: n,
            Completed: n
          },
          active: c,
          main: n
        },
        templates: {
          CallCanvas: {
            titleLine: "TaskLineTitle",
            firstLine: "TaskHeaderLine",
            secondLine: i
          },
          IncomingTaskCanvas: {
            titleLine: "TaskLineTitle",
            firstLine: "TaskHeaderLine",
            secondLine: i
          },
          ConnectingOutboundCallCanvas: {
            titleLine: "TaskLineOutboundCallTitle",
            firstLine: "TaskLineOutboundCallHeader",
            secondLine: "TaskLineOutboundCallDetail"
          },
          TaskListItem: {
            firstLine: "TaskHeaderLine",
            secondLine: i,
            extraInfo: "TaskExtraInfo"
          },
          TaskCanvasHeader: {
            title: "TaskHeaderLine",
            secondLine: i,
            endButton: {
              Assigned: "TaskHeaderComplete",
              Accepted: "TaskHeaderComplete",
              Reserved: void 0,
              Wrapping: "TaskHeaderWrapup",
              Completed: void 0,
              Canceled: void 0,
              Pending: void 0
            }
          },
          TaskCard: {
            firstLine: "SupervisorTaskCardHeader",
            secondLine: a
          },
          TaskInfoPanel: {
            content: "TaskInfoPanelContent"
          },
          Supervisor: {
            TaskCanvasHeader: {
              title: "SupervisorTaskHeaderLine",
              secondLine: i
            },
            TaskInfoPanel: {
              content: "SupervisorTaskInfoPanelContent"
            },
            TaskOverviewCanvas: {
              firstLine: "SupervisorTaskViewContentHeader",
              secondLine: a
            }
          }
        },
        componentProps: {},
        notifications: {
          override: {}
        }
      };
    }

    t.createDefaultTaskChannel = c, t.Default = c("default", function () {
      return !0;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(7),
        o = function () {
      function e(e) {
        this.appState = e;
      }

      return e.prototype.getUnconsumedMessagesCount = function () {
        var e = this;
        return Array.from(this.appState.worker.tasks.values()).reduce(function (t, n) {
          return t + e.getUnconsumedMessagesCountForTask(n);
        }, 0);
      }, e.prototype.getPendingTasks = function () {
        return Array.from(this.appState.worker.tasks.values()).filter(function (e) {
          return r.TaskHelper.isPending(e);
        }).length;
      }, e.prototype.getUnconsumedMessagesCountForTask = function (e) {
        if (!r.TaskHelper.isTaskAccepted(e) || !r.TaskHelper.isChatBasedTask(e)) return 0;
        var t = r.TaskHelper.getTaskChatChannelSid(e);
        return t && this.appState.chat.channels[t] ? this.appState.chat.channels[t].unconsumedMessages.length : 0;
      }, e.prototype.isAgentView = function () {
        return Boolean(this.appState.router && this.appState.router.location && this.appState.router.location.pathname && this.appState.router.location.pathname.match(/agent-desktop/));
      }, e;
    }();

    t.AppStateHelper = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(0),
        o = n(3),
        i = n(7),
        a = n(5);

    function s(e) {
      var t = i.TaskHelper.getTaskChatChannelSid(e);

      if (t) {
        var n = o.FlexModule.state.chat.channels[t];
        if (n && n.source) a.log.debug("chat channel state exists already", t);else {
          a.log.debug("initializing chat for channel", t);

          try {
            r.ChatChannelState.Actions.initWithChannelSid(t);
          } catch (e) {
            a.log.debug("Unable to init chat for channel", t, e);
          }
        }
      }
    }

    t.loadTaskChatChannel = s, t.loadChatChannelsForTasks = function () {
      a.log.debug("Loading chat channels for all tasks"), o.FlexModule.state.worker.tasks.forEach(function (e) {
        i.TaskHelper.isChatBasedTask(e) && s(e);
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(3),
        i = n(5),
        a = n(115),
        s = n(72),
        c = n(26),
        l = n(264),
        u = n(7),
        p = n(0),
        d = n(12),
        f = n(70),
        h = n(6),
        m = n(17),
        g = n(83),
        y = {
      tasks: new Map(),
      listener: void 0,
      activities: new Map(),
      activity: void 0,
      attributes: {},
      source: void 0,
      worker: void 0
    };

    t.reduce = function (e, t) {
      switch (void 0 === e && (e = y), t.type) {
        case "WORKER_INIT":
          var n = t.payload;
          return r(r(r({}, y), t.payload), {
            worker: new l.TaskRouterWorker(n.source)
          });

        case c.ACTION_LOGGED_OUT:
          return y;

        case "WORKER_UPDATE":
          return r(r({}, e), t.payload);

        case "WORKER_ADD_RESERVATION":
        case "WORKER_UPDATE_RESERVATION":
          var o = t.payload,
              i = new Map(e.tasks),
              a = new l.TaskRouterTask(o);
          return i.set(a.sid, a), r(r({}, e), {
            tasks: i
          });

        case "WORKER_DELETE_RESERVATION":
          o = t.payload;
          var s = new Map(e.tasks);
          return s.delete(o.sid), r(r({}, e), {
            tasks: s
          });
      }

      return e;
    };

    var v = function () {
      function e() {}

      return e.dispatchWorkerAction = function (e, t) {
        o.FlexModule.dispatch({
          type: e,
          payload: t
        });
      }, e.init = function (e) {
        var t = o.FlexModule.state.worker.listener;
        t || (t = new _(e)), t.start();
      }, e.addReservation = function (e) {
        this.dispatchWorkerAction("WORKER_ADD_RESERVATION", e);
      }, e.setCurrentActivity = function (e) {
        var t = o.FlexModule.state.worker.activities.get(e);
        return t ? t.isCurrent ? Promise.resolve() : t.setAsCurrent() : Promise.reject("Activity not found: " + e);
      }, e.setCurrentActivityByName = function (e) {
        var t;
        return o.FlexModule.state.worker.activities.forEach(function (n) {
          n.name === e && (t = n);
        }), t ? t.isCurrent ? Promise.resolve() : t.setAsCurrent() : Promise.reject("Activity not found: " + e);
      }, e.updateEndConferenceOnExitForTask = function (e, t) {
        var n = t || e.conference;

        if (n && u.TaskHelper.isLiveCall(e) && "started" === n.status) {
          var r = n.participants.find(function (e) {
            return e.isMyself && "joined" === e.status;
          }),
              o = n.liveParticipantCount <= 2,
              a = this.previousEndConferenceOnExits.get(e.sid);
          i.log.info("Updating endConferenceOnExit for task " + e.sid + ". imLivePerConference: " + r + ", oldValue: " + a + ", newValue: " + o), r && a !== o && (i.log.info("Updating endConferenceOnExit done"), this.previousEndConferenceOnExits.set(e.sid, o), e.sourceObject.updateParticipant({
            endConferenceOnExit: o
          }));
        }
      }, e.shutdown = function () {
        i.log.debug("Worker state logout");
        var e = o.FlexModule.state.worker.source;
        if (e) try {
          e.disconnect();
        } catch (e) {
          i.log.error("Error on worker disconnect", e);
        }
        var t = o.FlexModule.state.worker.listener;
        t && t.stop();
      }, e.previousEndConferenceOnExits = new Map(), e;
    }();

    t.Actions = v;
    var b = {};

    function C(e, t) {
      return function (e, t) {
        return b[e] && !!b[e][t];
      }(e, t) ? (i.log.debug("duplicate reservation event", t, e), !1) : (b[e] = b[e] || {}, b[e][t] = !0, !0);
    }

    var _ = function () {
      function e(e) {
        var t = this;
        this.handleActivityUpdated = function () {
          t.dispatchAction("WORKER_UPDATE", {
            activity: t._worker.activity,
            activities: t._worker.activities
          });
        }, this.handleAttributesUpdated = function () {
          t.dispatchAction("WORKER_UPDATE", {
            attributes: t._worker.attributes
          });
        }, this.handleWorkerReady = function () {
          t.initAndLoadReservations();
        }, this.handleReservationCreated = function (e) {
          if (i.log.debug("reservationCreated event, sid: " + e.sid, e), t.initReservationListeners(e), v.addReservation(e), C(e.sid, "reservationCreated")) {
            var n = new l.TaskRouterTask(e);
            t.playSound(n), u.TaskHelper.isCallTask(n) && a.ConferenceListenerManager.startListening(n, "worker" + n.sid), u.TaskHelper.isInitialOutboundAttemptTask(n) ? (h.tryInvokeAction("AcceptTask", {
              task: n
            }), h.tryInvokeAction("SelectTask", {
              task: n
            })) : m.Notifications.showNotification(m.NotificationIds.IncomingTask, {
              task: n
            });
          }
        }, this.handleOutboundReservationCanceled = function (e) {
          g.OutboundCalling.handleOutboundTaskCancelledEvent(e);
        }, this.handleReservationUpdated = function (e, n) {
          if (i.log.info("Event, reservation updated", e, n), C(n.sid, e)) {
            var r = m.Notifications.activeNotifications.find(function (e) {
              return e.id === m.NotificationIds.IncomingTask && e.context.task.sid === n.sid;
            });
            r && m.Notifications.dismissNotification(r);
            var o = new l.TaskRouterTask(n);

            switch (s.ChatOrchestrator.handleReservationEvent(e, o).catch(function (e) {
              return i.log.error(e);
            }), e) {
              case "wrapup":
                t.dispatchAction("WORKER_UPDATE_RESERVATION", n);
                break;

              case "accepted":
                t.dispatchAction("WORKER_UPDATE_RESERVATION", n), t.stopSound(o), u.TaskHelper.isLiveCall(o) && v.updateEndConferenceOnExitForTask(o), u.TaskHelper.isCallTask(o) && o.incomingTransferObject && "COLD" === o.incomingTransferObject.mode && h.tryInvokeAction("UnholdCall", {
                  task: o
                }), u.TaskHelper.isChatBasedTask(o) && f.loadTaskChatChannel(o);
                break;

              case "completed":
              case "rejected":
              case "timeout":
              case "canceled":
              case "rescinded":
                "canceled" === e && u.TaskHelper.isOutboundCallTask(o) && t.handleOutboundReservationCanceled(n), t.stopReservationListeners(n), a.ConferenceListenerManager.stopListening(n.task.sid, "worker" + n.sid), t.stopSound(o), t.dispatchAction("WORKER_DELETE_RESERVATION", n), delete b[n.sid], a.ConferenceListenerManager.unInitOutboundTransferForTask(n.task.sid);
            }
          }
        }, this.handleTaskUpdated = function (e, n) {
          i.log.info("Task updated", e, n.task), ["completed", "rejected", "timeout", "canceled", "rescinded"].indexOf(n.status) > -1 || t.dispatchAction("WORKER_UPDATE_RESERVATION", n);
        }, this._reservationListeners = new Map(), this._worker = e, this.currentMediaIds = {}, this.initAndLoadReservations(), this.start();
      }

      return e.prototype.start = function () {
        this._listening || (i.log.debug("Adding worker listeners"), this._worker.addListener("reservationCreated", this.handleReservationCreated), this._worker.addListener("activityUpdated", this.handleActivityUpdated), this._worker.addListener("attributesUpdated", this.handleAttributesUpdated), this._worker.addListener("ready", this.handleWorkerReady), this._listening = !0);
      }, e.prototype.stop = function () {
        this._listening && (i.log.debug("Removing worker listeners"), this._worker.removeListener("reservationCreated", this.handleReservationCreated), this._worker.removeListener("activityUpdated", this.handleActivityUpdated), this._worker.removeListener("attributesUpdated", this.handleAttributesUpdated), this._worker.removeListener("ready", this.handleWorkerReady), this._listening = !1);
      }, e.prototype.initAndLoadReservations = function () {
        var e = this;
        this.stopAllReservationListeners();
        var t = new Map(o.FlexModule.state.worker.tasks);
        this._worker.reservations.forEach(function (n) {
          var r = new l.TaskRouterTask(n);
          t.set(n.sid, r), e.initReservationListeners(n), u.TaskHelper.isCallTask(r) && a.ConferenceListenerManager.startListening(r, "worker" + n.sid), u.TaskHelper.isChatBasedTask(r) && f.loadTaskChatChannel(r);
        }), this.dispatchAction("WORKER_INIT", {
          listener: this,
          source: this._worker,
          activity: this._worker.activity,
          activities: this._worker.activities,
          attributes: this._worker.attributes,
          tasks: t
        });
      }, e.prototype.stopAllReservationListeners = function () {
        var e = this;
        b = {}, Array.from(this._reservationListeners.keys()).forEach(function (t) {
          return e.stopReservationListeners(t);
        });
      }, e.prototype.dispatchAction = function (e, t) {
        v.dispatchWorkerAction(e, t);
      }, e.prototype.stopReservationListeners = function (e) {
        var t = this._reservationListeners.get(e);

        t && (t.resListeners.forEach(function (t) {
          e.removeListener(t.event, t.callback);
        }), t.taskListeners.forEach(function (t) {
          e.task.removeListener(t.event, t.callback);
        }), this._reservationListeners.delete(e));
      }, e.prototype.initReservationListeners = function (e) {
        var t = this;
        this.stopReservationListeners(e);
        var n = [],
            r = [];
        ["accepted", "rejected", "timeout", "canceled", "rescinded", "completed", "wrapup"].forEach(function (r) {
          var o = function o() {
            return t.handleReservationUpdated(r, e);
          };

          e.addListener(r, o), n.push({
            callback: o,
            event: r
          });
        });
        ["updated", "wrapup", "completed", "canceled"].forEach(function (n) {
          var o = function o() {
            return t.handleTaskUpdated(n, e);
          };

          e.task.addListener(n, o), r.push({
            callback: o,
            event: n
          });
        });

        var o = function o(e) {
          a.ConferenceListenerManager.initOutboundTransfer(e);
        };

        e.task.addListener("transferInitiated", o), r.push({
          event: "transferInitiated",
          callback: o
        }), this._reservationListeners.set(e, {
          resListeners: n,
          taskListeners: r
        });
      }, e.prototype.playSound = function (e) {
        var t = this,
            n = d.TaskChannels.getForTask(e);
        n.sounds && (this.currentMediaIds[e.taskSid] = p.AudioPlayerManager.play({
          url: n.sounds.Pending.url,
          repeatable: n.sounds.Pending.repeatable
        }, function (e) {
          t.handlePlayError(e);
        }));
      }, e.prototype.handlePlayError = function (e) {
        var t;
        t = e.code === p.ErrorCode.NotAllowed ? m.NotificationIds.AudioPlayerDeniedErrorNotificationId : e.code === p.ErrorCode.InvalidMedia ? m.NotificationIds.AudioPlayerInvalidMediaErrorNotificationId : m.NotificationIds.AudioPlayerGenericErrorNotificationId, m.Notifications.showNotification(t);
      }, e.prototype.stopSound = function (e) {
        this.currentMediaIds[e.taskSid] && p.AudioPlayerManager.stop(this.currentMediaIds[e.taskSid]);
      }, e.prototype.isListening = function () {
        return this._listening;
      }, e;
    }();

    t.WorkerListener = _;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a,
        s = n(15),
        c = n(41),
        l = n(0),
        u = n(5),
        p = n(17),
        d = n(18),
        f = n(7),
        h = n(3),
        m = n(22),
        g = n(8);
    !function (e) {
      e.AddToChatChannel = "AddToChatChannel", e.DeactivateChatChannel = "DeactivateChatChannel", e.LeaveChatChannel = "LeaveChatChannel";
    }(a = t.ChatOrchestration || (t.ChatOrchestration = {}));

    var y = {
      accepted: new Set([a.AddToChatChannel]),
      wrapup: new Set([a.DeactivateChatChannel]),
      completed: new Set([a.DeactivateChatChannel, a.LeaveChatChannel])
    },
        v = function () {
      function e() {
        var e;
        this.events = r({}, y), this.mapEventToFunc = ((e = {})[a.AddToChatChannel] = this.addWorkerToChatChannelInternal, e[a.DeactivateChatChannel] = this.deactivateChatChannelInternal, e[a.LeaveChatChannel] = this.leaveAgentFromChatInternal, e);
      }

      return e.prototype.getOrchestrations = function (e) {
        var t = this.events[e];
        return this.isChatOrchestrationsCallbackType(t) ? t : Array.from(t);
      }, e.prototype.setOrchestrations = function (e, t) {
        if (this.isChatOrchestrationsCallbackType(t)) return u.log.debug("ChatOrchestrator setOrchestrations, event: " + e + ", orchestrations: callback"), void (this.events[e] = t);
        var n = this.getOrchestrationsSet(e, t);
        this.events[e] = n;
        var r = Array.from(n).join(", ");
        u.log.debug("ChatOrchestrator setOrchestrations, event: " + e + ", orchestrations: [" + r + "]");
      }, e.prototype.clearAllOrchestrations = function () {
        var e = this;
        u.log.debug("ChatOrchestrator clearAllOrchestrations"), Object.keys(this.events).forEach(function (t) {
          e.events[t] = new Set();
        });
      }, e.prototype.orchestrateWrapupTask = function (e) {
        return u.log.debug("ChatOrchestrator orchestrateWrapupTask"), this.handleReservationEvent("wrapup", e);
      }, e.prototype.orchestrateCompleteTask = function (e) {
        return u.log.debug("ChatOrchestrator orchestrateCompleteTask"), this.handleReservationEvent("completed", e);
      }, e.prototype.handleReservationEvent = function (e, t) {
        return o(this, void 0, Promise, function () {
          var n, r, o, a, s, c, l;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                if (!f.TaskHelper.isChatBasedTask(t)) return [2, !1];
                if (n = this.events[e], this.isChatOrchestrationsCallbackType(n) && (r = n(t), n = this.getOrchestrationsSet(e, r)), !n) return [2, !1];
                if (!(o = Array.from(n.values())).length) return u.log.debug("ChatOrchestrator no events to handle for " + e + " in " + t.sid), [2, !1];
                a = Array.from(o).join(", "), u.log.debug("ChatOrchestrator handleReservationEvent event: " + e + " for " + t.sid + ", orchestrations: [" + a + "]"), s = !1, c = 0, i.label = 1;

              case 1:
                return c < o.length ? (l = o[c], [4, (0, this.mapEventToFunc[l])(t)]) : [3, 4];

              case 2:
                s = i.sent() || s, i.label = 3;

              case 3:
                return c++, [3, 1];

              case 4:
                return [2, s];
            }
          });
        });
      }, e.prototype.addWorkerToChatChannelInternal = function (e) {
        return o(this, void 0, void 0, function () {
          var t, n, r, o, a;
          return i(this, function (i) {
            return h.FlexModule.chatClient ? (t = m.StateHelper.getChatChannelStateForTask(e)) && t.source && "joined" === t.source.status ? (u.log.debug("ChatOrchestrator addAgentToChatChannel - chat channel state exists already"), [2, !1]) : (n = f.TaskHelper.getTaskChatChannelSid(e)) ? (u.log.debug("ChatOrchestrator addAgentToChatChannel for " + e.sid), r = g.getChatOrchestrationServiceUrl(h.FlexModule.state.config), o = c.stringify({
              Identity: h.FlexModule.chatClient.user.identity,
              ChatChannelSid: n
            }), a = {
              auth: {
                username: "token",
                password: h.FlexModule.chatClient.token
              },
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            }, u.log.debug("requesting to join channel for task", n, e.sid), [2, s.default.post(r + "/Users", o, a).then(function () {
              return u.log.debug("Request to join channel successfully sent", n, e.sid), !0;
            }).catch(function (t) {
              return 409 === t.response.status ? (u.log.warn("Agent is already in the chat channel", n, e.sid), !0) : (p.Notifications.showNotification(d.ChatOrchestrationAddToChatChannelFailed), u.log.error("Failed to join channel", n, e.sid, t), !1);
            })]) : (u.log.warn("ChatOrchestrator addAgentToChatChannel - No chat channel sid in task", e), [2, !1]) : (u.log.debug("chat client not ready yet, loading channel later"), [2, !1]);
          });
        });
      }, e.prototype.deactivateChatChannelInternal = function (e) {
        return o(this, void 0, void 0, function () {
          var t, n, o, a, s;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                if (!(t = m.StateHelper.getChatChannelStateForTask(e))) return [3, 5];
                if (!(n = t.source)) throw p.Notifications.showNotification(d.ChatOrchestrationDeactivateChatChannelFailed), a = f.TaskHelper.getTaskChatChannelSid(e), new Error("ChatOrchestrator DeactivateChatChannel failed for task " + e.sid + " channelSid: " + a + ". Chat channel is not loaded.");
                if (n.attributes[l.FrameConstants.CHANNEL_STATUS_ATTRIBUTE] === l.FrameConstants.CHANNEL_STATUS_INACTIVE) return u.log.trace("ChatOrchestrator DeactivateChatChannel channel already inactive " + e.sid), [2, !1];
                u.log.debug("ChatOrchestrator DeactivateChatChannel for " + e.sid), i.label = 1;

              case 1:
                return i.trys.push([1, 3,, 4]), [4, t.source.updateAttributes(r(r({}, t.source.attributes), (s = {}, s[l.FrameConstants.CHANNEL_STATUS_ATTRIBUTE] = l.FrameConstants.CHANNEL_STATUS_INACTIVE, s)))];

              case 2:
                return i.sent(), u.log.debug("ChatOrchestrator DeactivateChatChannel for " + e.sid + " done"), [3, 4];

              case 3:
                throw o = i.sent(), p.Notifications.showNotification(d.ChatOrchestrationDeactivateChatChannelFailed), a = f.TaskHelper.getTaskChatChannelSid(e), u.log.error("ChatOrchestrator DeactivateChatChannel for " + e.sid + " error, channelSid: " + a, o), o;

              case 4:
                return [2, !0];

              case 5:
                return u.log.debug("ChatOrchestrator DeactivateChatChannel chat channel not found for " + e.sid), [2, !1];
            }
          });
        });
      }, e.prototype.leaveAgentFromChatInternal = function (e) {
        return o(this, void 0, void 0, function () {
          var t, n;
          return i(this, function (r) {
            return u.log.debug("ChatOrchestrator leaveAgentFromChat for " + e.sid), (t = f.TaskHelper.getTaskChatChannelSid(e)) ? (n = m.StateHelper.getChatChannelStateForTask(e)) ? [2, n.source.leave().then(function () {
              return u.log.debug("ChatOrchestrator leaveAgentFromChat for " + e.sid + " done"), !0;
            }).catch(function (e) {
              throw p.Notifications.showNotification(d.ChatOrchestrationLeaveChatChannelFailed), u.log.error("Failed to leave chat channel", t, e), e;
            })] : (u.log.trace("No chat channel state for task", e), [2, !1]) : (u.log.trace("chat channel sid for task does not exist", e), [2, !1]);
          });
        });
      }, e.prototype.isChatOrchestrationsCallbackType = function (e) {
        return "function" == typeof e;
      }, e.prototype.getOrchestrationsSet = function (e, t) {
        if (!Array.isArray(t)) return new Set();
        var n = new Set(t);
        return this.validateOrchestrations(e, n), n;
      }, e.prototype.validateOrchestrations = function (e, t) {
        var n = this;
        if (t.forEach(function (e) {
          if (!n.mapEventToFunc[e]) throw new Error("Unknown orchestration: " + e);
        }), "accepted" === e && (t.has(a.DeactivateChatChannel) || t.has(a.LeaveChatChannel))) throw new Error("DeactivateChatChannel and LeaveChatChannel are not valid orchestrations for 'accept'");
      }, e;
    }();

    t.ChatOrchestrationManager = v, t.ChatOrchestrator = new v();
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(241);
    t.QueueStatsConnectionStatusInfo = r.QueueStatsConnectionStatusInfo;
    var o = n(243);
    t.QueueStatsConnectionStatusInfoText = o.QueueStatsConnectionStatusInfoText;
  }, function (e, t) {
    e.exports = require("@twilio/flex-insights-player");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(106),
        i = n(3),
        a = n(5),
        s = n(17),
        c = n(0),
        l = n(42),
        u = n(19),
        p = {
      listener: void 0,
      connection: void 0,
      connections: []
    };

    t.reduce = function (e, t) {
      switch (void 0 === e && (e = p), t.type) {
        case "PHONE_INIT":
          var n = t.payload;
          return r(r({}, p), {
            listener: n.listener
          });

        case "PHONE_UNINIT":
          return p;

        case "PHONE_TOGGLE_MUTE":
          var o = e.connection && e.connection.oldHold || !1,
              i = h(t.payload, o);
          return r(r({}, e), {
            connection: i,
            connections: [i]
          });

        case "PHONE_UNHOLD_CONNECTION":
        case "PHONE_ADD_CONNECTION":
          i = h(t.payload, !1);
          return r(r({}, e), {
            connection: i,
            connections: [i]
          });

        case "PHONE_HOLD_CONNECTION":
          i = h(t.payload, !0);
          return r(r({}, e), {
            connection: i,
            connections: [i]
          });

        case "PHONE_REMOVE_CONNECTION":
          return r(r({}, e), {
            connection: void 0,
            connections: []
          });

        default:
          return e;
      }
    };

    var d = function () {
      function e() {}

      return e.dispatchPhoneAction = function (e, t) {
        i.FlexModule.dispatch({
          type: e,
          payload: t
        });
      }, e.init = function (e, t) {
        this.listener = new f(e, t), this.dispatchPhoneAction("PHONE_INIT", {
          listener: this.listener
        });
      }, e.oldHoldConnection = function () {
        i.FlexModule.state.phone.connection && e.dispatchPhoneAction("PHONE_HOLD_CONNECTION", i.FlexModule.state.phone.connection.source);
      }, e.oldUnHoldConnection = function () {
        i.FlexModule.state.phone.connection && e.dispatchPhoneAction("PHONE_UNHOLD_CONNECTION", i.FlexModule.state.phone.connection.source);
      }, e.shutdown = function () {
        a.log.info("PhoneState: shutdown");
        var e = i.FlexModule.state.phone.listener;
        e && e.stop(), o.Device.destroy(), this.dispatchPhoneAction("PHONE_UNINIT", null);
      }, e;
    }();

    t.Actions = d;

    var f = function () {
      function e(e, t) {
        var n = this;
        this.handleDeviceChange = function () {
          a.log.info("PhoneState: handleDeviceChange");
          var e = Array.from(o.Device.audio.availableInputDevices.keys());
          e.length > 0 ? (n.microphoneID = e.find(function (e) {
            return "default" === e;
          }) || e[0], a.log.info("PhoneState: input device: " + n.microphoneID)) : (n.microphoneID = void 0, a.log.warn("PhoneState: no input devices"), c.Notifications.showNotification(s.NotificationIds.NoInputDevice));
        }, this.handleDeviceReady = function (e) {
          a.log.info("PhoneState: handleDeviceReady", n, e), n.tryInitialDeviceCheck();
        }, this.handleDeviceError = function (e) {
          31201 === e.code && c.Notifications.showNotification(s.NotificationIds.MicTaken), a.log.error("PhoneState: device error", e);
        }, this.handleDeviceConnect = function (e) {
          a.log.info("PhoneState: connection connected", e), e.on("mute", n.handleConnectionMute), d.dispatchPhoneAction("PHONE_ADD_CONNECTION", e);
        }, this.handleDeviceDisconnect = function (e) {
          a.log.info("PhoneState: connection disconnected", e), e.removeListener("mute", n.handleConnectionMute), d.dispatchPhoneAction("PHONE_REMOVE_CONNECTION", void 0), l.FeatureFlags.isEnabled(u.FeatureFlag.InitialAudioDeviceCheck) && i.FlexModule.state.config.initialDeviceCheck && o.Device.audio.unsetInputDevice();
        }, this.handleDeviceIncoming = function (e) {
          if (a.log.info("PhoneState: connection incoming", e), l.FeatureFlags.isEnabled(u.FeatureFlag.InitialAudioDeviceCheck) && i.FlexModule.state.config.initialDeviceCheck) {
            if (!n.microphoneID) return a.log.error("PhoneState: no input device, rejecting connection"), c.Notifications.showNotification(s.NotificationIds.NoInputDevice), void e.reject();
            o.Device.audio.setInputDevice(n.microphoneID).then(function () {
              return e.accept();
            }).catch(function (t) {
              a.log.error("PhoneState: Error setting the input device", t), c.Notifications.showNotification(s.NotificationIds.NoInputDevice), e.reject();
            });
          } else e.accept();
        }, this.handleDeviceCancel = function (e) {
          a.log.info("PhoneState: connection was cancelled", e);
        }, this.handleConnectionMute = function (e) {
          a.log.info("PhoneState: connection was " + (e ? "muted" : "unmuted")), d.dispatchPhoneAction("PHONE_TOGGLE_MUTE", i.FlexModule.state.phone.connection.source);
        }, o.Device.setup(e, t), this.start();
      }

      return e.prototype.start = function () {
        this._listening || (o.Device.on("ready", this.handleDeviceReady), o.Device.on("connect", this.handleDeviceConnect), o.Device.on("disconnect", this.handleDeviceDisconnect), o.Device.on("error", this.handleDeviceError), o.Device.on("incoming", this.handleDeviceIncoming), o.Device.on("cancel", this.handleDeviceCancel), this._listening = !0);
      }, e.prototype.stop = function () {
        this._listening && (o.Device.removeListener("ready", this.handleDeviceReady), o.Device.removeListener("connect", this.handleDeviceConnect), o.Device.removeListener("disconnect", this.handleDeviceDisconnect), o.Device.removeListener("error", this.handleDeviceError), o.Device.removeListener("incoming", this.handleDeviceIncoming), o.Device.removeListener("cancel", this.handleDeviceCancel), o.Device.audio.removeListener("deviceChange", this.handleDeviceChange), this._listening = !1);
      }, e.prototype.isListening = function () {
        return this._listening;
      }, e.prototype.tryInitialDeviceCheck = function () {
        var e = this;
        l.FeatureFlags.isEnabled(u.FeatureFlag.InitialAudioDeviceCheck) && i.FlexModule.state.config.initialDeviceCheck && (o.Device.audio.on("deviceChange", this.handleDeviceChange), navigator.mediaDevices.getUserMedia({
          audio: !0
        }).then(function (t) {
          try {
            e.handleDeviceChange();
          } finally {
            t.getTracks().forEach(function (e) {
              return e.stop();
            });
          }
        }).catch(function (e) {
          a.log.error("PhoneState: error in getUserMedia", e);
        }));
      }, e;
    }();

    function h(e, t) {
      return {
        oldHold: t,
        source: e
      };
    }

    t.DeviceListener = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(41),
        o = /^\/?(login\/)?([^/]*)\/?/;

    function i() {
      var e = window.location.search || "";
      if (!e) return "/";
      var t = r.parse(e),
          n = Array.isArray(t.path) ? t.path[0] : t.path;
      return n ? (n.endsWith("/") || (n += "/"), n.startsWith("/") || (n = "/" + n), n) : "/";
    }

    function a() {
      var e = r.parse(window.location.search);
      return Array.isArray(e.path) ? e.path.shift() : "string" == typeof e.path && delete e.path, r.stringify(e);
    }

    t.RUNTIME_DOMAIN_REGEXP = /^([a-z]+-[a-z]+-\d+)$/, t.parseRuntimeDomainFromPathName = function () {
      var e = window.location.pathname.match(o),
          n = e && e[2],
          r = e && !!e[1];
      if (!n) return "";
      if (r) return n;
      var i = n.match(t.RUNTIME_DOMAIN_REGEXP);
      return i && i[1] ? i[1] : "";
    }, t.parseDestinationPathFromSearch = i, t.getUserParamsFromSearch = a, t.getDestinationURLFromLocation = function () {
      var e = i();
      "/" === e && ((e = window.location.pathname).endsWith("/") || (e += "/"));
      var t = a();
      return t && (t = "?" + t), "" + window.location.origin + e + t;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e.file = "file";
    }(t.LoggerType || (t.LoggerType = {}));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(79),
        a = n(121),
        s = n(125),
        c = n(5);

    t.getDefaultStore = function () {
      return o;
    };

    var l,
        u = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      actionSanitizer: function actionSanitizer(e) {
        return e;
      },
      stateSanitizer: function stateSanitizer(e) {
        return e.flex.config ? r(r({}, e), {
          flex: r(r({}, e.flex), {
            chat: "<<CUT FOR DEV>>",
            insights: "<<CUT FOR DEV>>",
            supervisor: "<<CUT FOR DEV>>"
          })
        }) : e;
      }
    }) || i.compose;
    t.flexStoreEnhancer = function (e) {
      return function (t, n, o) {
        l = t;
        var i = r(r({}, e(t, n, o)), {
          addReducer: function addReducer(e, t) {
            if ("flex" !== e) {
              var n = l,
                  o = function o(_o, i) {
                var a;
                void 0 === _o && (_o = {});
                var s,
                    c = r({}, _o);
                c && c[e] && (s = c[e], delete c[e]);
                var l = n(c, i),
                    u = t(s, i);
                return c === l && s === u ? _o : r(r({}, l), ((a = {})[e] = u, a));
              };

              l = o, i.replaceReducer(o);
            } else c.log.debug("Cannot add reducer with name `flex`");
          }
        });
        return i;
      };
    }, t.createDefaultStore = function (e) {
      if (o) return c.log.error("default store already exists"), null;
      var n = i.combineReducers({
        flex: a.FlexReducer
      });
      return o = i.createStore(n, u(s.applyFlexMiddleware(e.history), t.flexStoreEnhancer));
    };
  }, function (e, t) {
    e.exports = require("redux");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(59);
    t.FLEX_LOCATION_CHANGE = "@@flex/LOCATION_CHANGE", t.createReducer = function (e) {
      return function (n, i) {
        var a = i.type === t.FLEX_LOCATION_CHANGE,
            s = i.type === o.LOCATION_CHANGE,
            c = e && e.router && e.router.isolate,
            l = i;
        return s && c ? n : (a && (l = r(r({}, i), {
          type: o.LOCATION_CHANGE
        })), o.routerReducer.call(null, n, l));
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(15),
        s = n(10),
        c = n(3),
        l = n(5);
    t.initialState = {
      queuesList: {},
      aggregatedData: {
        activeTasks: 0,
        waitingTasks: 0,
        agentByActivity: {},
        longestWaitQueue: {}
      },
      hasFetchedList: !1
    }, t.UPDATE_QUEUES = "FLEX_UPDATE_QUEUES", t.NO_QUEUE_FOUND = "FLEX_NO_QUEUE_FOUND", t.reduce = function (e, n) {
      switch (void 0 === e && (e = t.initialState), n.type) {
        case t.UPDATE_QUEUES:
          var o = r(r({}, e.queuesList), n.payload.queues),
              i = r(r({}, e.aggregatedData), p.getWorkspaceRealtimeStats(n.payload.workspaceStats, n.payload.queues));
          return r(r({}, e), {
            queuesList: o,
            aggregatedData: i,
            hasFetchedList: !0
          });

        case t.NO_QUEUE_FOUND:
          return r(r({}, e), {
            hasFetchedList: !0
          });

        default:
          return e;
      }
    };

    var u = function () {
      function e() {}

      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return this._dispatcher || c.FlexModule.dispatch;
        },
        set: function set(e) {
          this._dispatcher = e;
        },
        enumerable: !0,
        configurable: !0
      }), e.startPolling = function () {
        return o(this, void 0, void 0, function () {
          var e, t, n;
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                return e = s.Manager.getInstance(), t = e.serviceConfiguration, n = e.configuration.queuesStats, this.workspaceSid = t.taskrouter_workspace_sid, this.accountSid = t.account_sid, this.pollingInterval = Math.max(n.pollInterval, 1e3), this.baseUrl = n.baseApiUrl, this.isPollingData = !0, this.activities || (this.activities = c.FlexModule.workerClient.activities), [4, this.handleFetchedQueues()];

              case 1:
                return r.sent(), [2];
            }
          });
        });
      }, e.handleFetchedQueues = function () {
        return o(this, void 0, void 0, function () {
          var e,
              n,
              r,
              o,
              a,
              s,
              c = this;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                if (!this.isPollingData) return [2];
                if (this.fetchedQueuesList) return [3, 4];
                i.label = 1;

              case 1:
                return i.trys.push([1, 3,, 4]), [4, this.fetchTaskQueuesList()];

              case 2:
                return e = i.sent().data, this.fetchedQueuesList = e, [3, 4];

              case 3:
                return n = i.sent(), setTimeout(function () {
                  return c.handleFetchedQueues();
                }, this.pollingInterval), l.log.error(n), [2];

              case 4:
                return this.fetchedQueuesList && this.fetchedQueuesList.task_queues.length ? [4, Promise.all([this.fetchWorkspace()].concat(this.fetchedQueuesList.task_queues.map(function (e) {
                  return c.fetchTaskQueue(e.sid, e.friendly_name);
                })))] : (this.dispatcher({
                  type: t.NO_QUEUE_FOUND
                }), [2]);

              case 5:
                return r = i.sent(), o = r[0], a = r.slice(1), o.activity_statistics = o.activity_statistics.map(function (e) {
                  return c.getActivityDetails(e);
                }), s = a.reduce(function (e, t) {
                  return t && (e[t.task_queue_sid] = c.setQueueActivitiesDetails(t)), e;
                }, {}), this.dispatcher({
                  type: t.UPDATE_QUEUES,
                  payload: {
                    queues: s,
                    workspaceStats: o
                  }
                }), setTimeout(function () {
                  return c.handleFetchedQueues();
                }, this.pollingInterval), [2];
            }
          });
        });
      }, e.stopPolling = function () {
        this.isPollingData = !1;
      }, e.fetchTaskQueuesList = function () {
        return this.makeAuthenticatedGetCall("" + this.baseUrl + this.workspaceSid + "/TaskQueues/");
      }, e.fetchTaskQueueRealTimeStats = function (e) {
        return this.makeAuthenticatedGetCall("" + this.baseUrl + this.workspaceSid + "/TaskQueues/" + e + "/RealTimeStatistics/");
      }, e.fetchWorkspaceRealTimeStats = function () {
        return this.makeAuthenticatedGetCall("" + this.baseUrl + this.workspaceSid + "/RealTimeStatistics/");
      }, e.fetchTaskQueue = function (e, t) {
        return o(this, void 0, void 0, function () {
          var n, o;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return i.trys.push([0, 2,, 3]), [4, this.fetchTaskQueueRealTimeStats(e)];

              case 1:
                return n = i.sent(), [2, r({
                  friendly_name: t
                }, n.data)];

              case 2:
                return o = i.sent(), l.log.error("Failed to load stats for queue " + e + ".", o), [2, {}];

              case 3:
                return [2];
            }
          });
        });
      }, e.fetchWorkspace = function () {
        return o(this, void 0, void 0, function () {
          var e;
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return t.trys.push([0, 2,, 3]), [4, this.fetchWorkspaceRealTimeStats()];

              case 1:
                return [2, t.sent().data];

              case 2:
                return e = t.sent(), l.log.error("Failed to load realtime stats for workspace", e), [2, {}];

              case 3:
                return [2];
            }
          });
        });
      }, e.makeAuthenticatedGetCall = function (e) {
        var t = c.FlexModule.state.session.ssoTokenPayload.token;
        return a.default.get(e, {
          auth: {
            username: "token",
            password: t
          }
        });
      }, e.setQueueActivitiesDetails = function (e) {
        var t = this,
            n = e.activity_statistics.map(function (e) {
          return t.getActivityDetails(e);
        });
        return r(r({}, e), {
          activity_statistics: n
        });
      }, e.getActivityDetails = function (e) {
        return r(r({}, e), {
          available: this.activities.get(e.sid).available
        });
      }, e;
    }();

    t.Actions = u;

    var p = function () {
      function e() {}

      return e.getWorkspaceRealtimeStats = function (e, t) {
        var n = e.tasks_by_status;
        return {
          activeTasks: n.assigned + n.wrapping,
          waitingTasks: n.reserved + n.pending,
          longestWaitQueue: {
            friendlyName: this.getLongestQueueWaitFriendlyName(t),
            time: e.longest_task_waiting_age
          },
          agentByActivity: this.getWorkspaceAgentsByActivity(e)
        };
      }, e.getLongestQueueWaitFriendlyName = function (e) {
        return Object.keys(e).map(function (t) {
          return e[t];
        }).reduce(function (e, t) {
          return t.longest_task_waiting_age > e.longest_task_waiting_age ? t : e;
        }).friendly_name;
      }, e.getQueueAgentsByActivity = function (e, t) {
        var n = this,
            r = function r(e, _r11) {
          return t.activity_statistics.filter(function (t) {
            return t.available === e && n.isOfflineActivity(t) === _r11;
          }).reduce(function (e, t) {
            return e + t.workers;
          }, 0);
        };

        return {
          availableAgents: r(!0, !1) + (e.availableAgents || 0),
          offlineAgents: r(!1, !0) + (e.offlineAgents || 0),
          unavailableAgents: r(!1, !1) + (e.unavailableAgents || 0)
        };
      }, e.getWorkspaceAgentsByActivity = function (e) {
        var t = this,
            n = function n(_n, r) {
          return e.activity_statistics.filter(function (e) {
            return e.available === _n && t.isOfflineActivity(e) === r;
          }).reduce(function (e, t) {
            return e + t.workers;
          }, 0);
        };

        return {
          availableAgents: n(!0, !1),
          offlineAgents: n(!1, !0),
          unavailableAgents: n(!1, !1)
        };
      }, e.isOfflineActivity = function (e) {
        var t = s.Manager.getInstance().serviceConfiguration.taskrouter_offline_activity_sid;
        return t && t === e.sid || "Offline" === e.friendly_name;
      }, e;
    }();

    t.AggregatedDataHelpers = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r,
        o = n(256),
        i = n(5);

    function a(e) {
      return "browser" === e || "memory" === e;
    }

    t.isHistory = function (e) {
      var t = e;
      return !!(t && t.length && t.location && t.listen && t.action && t.push && t.replace && t.go && t.goBack && t.goForward);
    }, t.isHistoryType = a, t.isHistoryParams = function (e) {
      var t = e;
      return t && ("string" == typeof t.type || "boolean" == typeof t.isolate || "object" == typeof t.history);
    }, t.default = function (e) {
      if (void 0 === e && (e = {
        type: "browser"
      }), !r) {
        var t = e.isolate ? "memory" : e.type;

        r = function (e) {
          return "memory" === e ? o.createMemoryHistory : (a(e) || i.log.error("History type '" + e + "' is not supported. Use 'browser' or 'memory' type for router configuration."), o.createBrowserHistory);
        }(t)(e.history);
      }

      return r;
    }, t.setHistory = function (e) {
      r = e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a,
        s = n(1),
        c = n(0),
        l = n(6),
        u = n(5),
        p = n(34),
        d = n(10),
        f = n(3),
        h = n(29),
        m = n(18);
    !function (e) {
      e.missingDestination = "missing destination", e.missingQueue = "missing queue", e.missingCallerId = "missing caller id", e.generic = "generic error", e.invalidDestination = "invalid destination";
    }(a = t.OutboundCallingErrors || (t.OutboundCallingErrors = {}));

    var g = function () {
      function e() {}

      return e.initialize = function () {
        this.registerActions(), this.registerNotifications(), this.fetchCountriesAndFlags();
      }, e.handleOutboundTaskCancelledEvent = function (e) {
        if (u.log.debug("Outbound call " + e.sid + " canceled with reason: " + e.canceledReasonCode + " (https://www.twilio.com/docs/api/errors/" + e.canceledReasonCode + ")"), e.canceledReasonCode) switch (e.canceledReasonCode) {
          case 13223:
            c.Notifications.showNotification(m.OutboundCallCanceledInvalidNumber);
            break;

          case 45305:
            c.Notifications.showNotification(m.OutboundCallCanceledNoAnswer);
            break;

          case 45303:
            c.Notifications.showNotification(m.OutboundCallCanceledBusy);
            break;

          case 45302:
          case 45306:
          case 45307:
            break;

          default:
            c.Notifications.showNotification(m.OutboundCallCanceledGeneric, {
              reasonCode: e.canceledReasonCode
            });
        }
      }, e.registerActions = function () {
        c.Actions.registerAction("StartOutboundCall", this.startOutboundCall), c.Actions.registerAction("ToggleOutboundDialer", this.toggleOutboundDialer);
      }, e.registerNotifications = function () {
        var e = this,
            t = {
          id: m.OutboundCallCanceledGeneric,
          content: "OutboundCallFailedNotificationTitle",
          type: c.NotificationType.warning,
          timeout: 0
        };
        c.Notifications.registerNotification(t);
        var n = {
          id: m.OutboundCallCanceledBusy,
          content: "OutboundCallFailedNotificationTitleBusy",
          type: c.NotificationType.warning,
          timeout: 0,
          actions: [s.createElement(c.NotificationBar.Action, {
            label: "OutboundCallFailedNotificationAction",
            onClick: function onClick(t, n) {
              c.Notifications.dismissNotification(n), l.tryInvokeAction("StartOutboundCall", e.lastOutboundCallActionPayload);
            }
          })]
        };
        c.Notifications.registerNotification(n);
        var r = {
          id: m.OutboundCallCanceledNoAnswer,
          content: "OutboundCallFailedNotificationTitleNoAnswer",
          type: c.NotificationType.warning,
          timeout: 0,
          actions: [s.createElement(c.NotificationBar.Action, {
            label: "OutboundCallFailedNotificationAction",
            onClick: function onClick(t, n) {
              c.Notifications.dismissNotification(n), l.tryInvokeAction("StartOutboundCall", e.lastOutboundCallActionPayload);
            }
          })]
        };
        c.Notifications.registerNotification(r);
        var o = {
          id: m.OutboundCallCanceledInvalidNumber,
          content: "OutboundCallFailedNotificationTitleInvalidNumber",
          type: c.NotificationType.warning,
          timeout: 0
        };
        c.Notifications.registerNotification(o);
      }, e.fetchCountriesAndFlags = function () {
        c.CountryManager.getAllCountries(), c.CountryManager.getAllCountriesFlagPositions();
      }, e.startOutboundCall = function (t) {
        return o(this, void 0, Promise, function () {
          var n, o, s, l, u, h, g, y, v, b, C, _, k, w;

          return i(this, function (i) {
            switch (i.label) {
              case 0:
                if (c.Notifications.dismissNotificationById(m.OutboundCallCanceledBusy), c.Notifications.dismissNotificationById(m.OutboundCallCanceledGeneric), c.Notifications.dismissNotificationById(m.OutboundCallCanceledNoAnswer), c.Notifications.dismissNotificationById(m.OutboundCallCanceledInvalidNumber), !p.isOutboundCallingEnabled()) throw new Error("outbound calling disabled");
                if (f.FlexModule.state.phone.connection) throw new Error("voice connection already live");
                if (n = d.Manager.getInstance().serviceConfiguration, o = n.outbound_call_flows, s = n.taskrouter_offline_activity_sid, f.FlexModule.state.worker.activity.sid === s) throw new Error("cannot do outbound calls when offline");
                if (l = t.queueSid, u = t.callerId, h = t.destination, o && o.default && (l = l || o.default.queue_sid, u = u || o.default.caller_id), !h) throw new Error(a.missingDestination);
                if (!l) throw new Error(a.missingQueue);
                if (!u) throw new Error(a.missingCallerId);
                if (h.match(/client:/) && !f.FlexModule.state.config.enableClientCalling) throw new Error(a.invalidDestination);
                e.lastOutboundCallActionPayload = t, h.match(/client:/) || (y = !!o.default && o.default.location, h = c.CountryManager.formatPhoneNumberWithCountryCode(h, y)), v = [], b = [], C = function C(e) {
                  v.push(e.task.sid);
                }, _ = function _(e) {
                  b.push(e.task.sid);
                }, f.FlexModule.workerClient.addListener("reservationCreated", C), f.FlexModule.workerClient.addListener("reservationFailed", _), i.label = 1;

              case 1:
                return i.trys.push([1, 3, 4, 5]), [4, f.FlexModule.workerClient.createTask(h, u, o.default.workflow_sid, l, {
                  attributes: r(r({}, t.taskAttributes), {
                    direction: "outbound"
                  }),
                  taskChannelUniqueName: "voice"
                })];

              case 2:
                return g = i.sent(), [3, 5];

              case 3:
                throw k = i.sent(), w = "Unknown error", k.response && k.response.statusText ? w = k.response.statusText : k.message && (w = k.message), new Error(w);

              case 4:
                return f.FlexModule.workerClient.removeListener("reservationCreated", C), f.FlexModule.workerClient.removeListener("reservationFailed", _), [7];

              case 5:
                return i.trys.push([5, 7,, 8]), [4, new Promise(function (e, t) {
                  var n = function n(t) {
                    t.task.sid === g && (f.FlexModule.workerClient.removeListener("reservationCreated", n), f.FlexModule.workerClient.removeListener("reservationFailed", r), e());
                  },
                      r = function r(e) {
                    e.task.sid === g && (f.FlexModule.workerClient.removeListener("reservationCreated", n), f.FlexModule.workerClient.removeListener("reservationFailed", r), t());
                  };

                  v.indexOf(g) > -1 ? e() : b.indexOf(g) > -1 ? t() : (f.FlexModule.workerClient.addListener("reservationCreated", n), f.FlexModule.workerClient.addListener("reservationFailed", r));
                })];

              case 6:
                return i.sent(), [3, 8];

              case 7:
                throw i.sent(), new Error(a.generic);

              case 8:
                return [2];
            }
          });
        });
      }, e.toggleOutboundDialer = function () {
        return o(this, void 0, Promise, function () {
          return i(this, function (e) {
            if (!p.isOutboundCallingEnabled()) throw new Error("outbound calling disabled");
            if (f.FlexModule.state.phone.connection && !f.FlexModule.state.view.isOutboundDialerOpen) throw new Error("voice connection already live");
            return [2, h.Actions.toggleOutboundDialer()];
          });
        });
      }, e;
    }();

    t.OutboundCalling = g;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(25),
        o = n(5),
        i = n(3),
        a = function () {
      function e(e, t, n) {
        e && (this._source = e, this._callSid = t, this.participantLeftTimestamp = n);
      }

      return Object.defineProperty(e.prototype, "source", {
        get: function get() {
          return this._source;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "worker", {
        get: function get() {
          return r.InsightsEntityCache.getWorker(this.workerSid);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "queue", {
        get: function get() {
          return r.InsightsEntityCache.getQueue(this.workerSid);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "onHold", {
        get: function get() {
          return this._source && this._source.hold;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "muted", {
        get: function get() {
          return this._source && this._source.muted;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "connecting", {
        get: function get() {
          return this._source && this._source.connecting;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "participantType", {
        get: function get() {
          return this._source && this._source.participant_type;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "reservationSid", {
        get: function get() {
          return this._source && this._source.reservation_sid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "workerSid", {
        get: function get() {
          return this._source && this._source.worker_sid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "status", {
        get: function get() {
          return this.participantLeftTimestamp ? "recently_left" : this._source && this._source.status;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "uniqueId", {
        get: function get() {
          var e = this.callSid || "";
          return "" + this.workerSid + this.participantType + e;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sid", {
        get: function get() {
          return o.log.warn("Participant.sid is deprecated, use uniqueId instead!"), this.uniqueId;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "isMyself", {
        get: function get() {
          return this._source.worker_sid === i.FlexModule.state.worker.worker.sid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "callSid", {
        get: function get() {
          return this._callSid;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    t.ConferenceParticipant = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(277);
    t.TaskCanvasTabs = r.TaskCanvasTabs;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(289);
    t.MuteButton = r.MuteButton, t.MuteButtonProps = r.MuteButtonProps;
  }, function (e, t, n) {
    "use strict";

    var _r12,
        o = this && this.__extends || (_r12 = function r(e, t) {
      return (_r12 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r12(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(14),
        u = n(298),
        p = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      var n;
      return o(t, e), n = t, t.prototype.render = function () {
        return s.createElement(d, i({}, this.props));
      }, t.displayName = "TaskInfoPanel", t.Content = new c.DynamicContentStore(n.displayName), t.defaultProps = {
        content: n.Content
      }, t = n = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.TaskInfoPanel = p;
    var d = l.withTaskContext(u.TaskInfoPanelImpl);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(300);
    t.ConnectingOutboundCallCanvas = r.ConnectingOutboundCallCanvas;
    var o = n(304);
    t.ConnectingOutboundCallCanvasProps = o.ConnectingOutboundCallCanvasProps;
    var i = n(154);
    t.ConnectingOutboundCallCanvasActions = i.ConnectingOutboundCallCanvasActions;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(308);
    t.TaskCanvasHeader = r.TaskCanvasHeader;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(313);
    t.AggregatedQueuesDataTilesProps = r.AggregatedQueuesDataTilesProps, t.AggregatedQueuesDataTiles = r.AggregatedQueuesDataTiles;
    var o = n(329);
    t.QueuesDataTableProps = o.QueuesDataTableProps, t.QueuesDataTable = o.QueuesDataTable;
    var i = n(20);
    t.ActivityStatistic = i.ActivityStatistic, t.WorkerQueue = i.WorkerQueue, t.WorkspaceStats = i.WorkspaceStats;
    var a = n(20);

    t.setFilter = function (e) {
      return a.Actions.setFilter(e);
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u = n(2),
        p = n(0);
    t.Container = u.default("div")(o || (o = r(["\n    max-width: 200px;\n    ", "\n"], ["\n    max-width: 200px;\n    ", "\n"])), function (e) {
      return e.large && {
        minWidth: "120px;",
        maxWidth: "180px;"
      };
    }), t.UserActivityControls = u.default(p.Menu)(i || (i = r(["\n    white-space: nowrap;\n    min-width: 200px;\n    box-shadow: -1px 1px 3px 0 rgba(0, 0, 0, 0.4);\n"], ["\n    white-space: nowrap;\n    min-width: 200px;\n    box-shadow: -1px 1px 3px 0 rgba(0, 0, 0, 0.4);\n"]))), t.AccountMenuItem = u.default(p.MenuItem)(a || (a = r(["\n    font-weight: normal;\n    letter-spacing: initial;\n    font-weight: ", ";\n"], ["\n    font-weight: normal;\n    letter-spacing: initial;\n    font-weight: ", ";\n"])), function (e) {
      return e.selected && "bold";
    }), t.AccountMenuItemLogout = u.default(p.MenuItem)(s || (s = r(["\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 12px;\n    font-size: 12px;\n    letter-spacing: initial;\n\n    & > span {\n        margin-top: auto;\n        margin-bottom: auto;\n    }\n"], ["\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 12px;\n    font-size: 12px;\n    letter-spacing: initial;\n\n    & > span {\n        margin-top: auto;\n        margin-bottom: auto;\n    }\n"]))), t.AccountMenuDivider = u.default("li")(c || (c = r(["\n    height: 1px;\n    ", "\n"], ["\n    height: 1px;\n    ", "\n"])), function (e) {
      return e.theme.UserActivityControls.Divider;
    }), t.AccountMenuTitle = u.default("li")(l || (l = r(["\n    font-size: 12px;\n    font-weight: bold;\n    padding-top: 4px;\n    padding-bottom: 3px;\n    padding-left: 12px;\n    padding-right: 12px;\n    ", "\n"], ["\n    font-size: 12px;\n    font-weight: bold;\n    padding-top: 4px;\n    padding-bottom: 3px;\n    padding-left: 12px;\n    padding-right: 12px;\n    ", "\n"])), function (e) {
      return e.theme.UserActivityControls.Item;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    },
        i = this && this.__metadata || function (e, t) {
      if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(355),
        s = n(356),
        c = n(357),
        l = n(358),
        u = n(128),
        p = function () {
      function e() {}

      return e.getPredefined = function (e) {
        var t = {
          MediumTheme: a.default,
          DarkTheme: s.default,
          BlueMediumTheme: l.default,
          BlueDarkTheme: c.default
        },
            n = r(r({}, t), {
          GreyDark: s.GreyDark,
          GreyLight: a.GreyLight,
          FlexDark: c.FlexDark,
          FlexLight: l.FlexLight
        })[e];
        return n || (n = l.FlexLight), n;
      }, e;
    }();

    t.ThemeColorsDefinitionCreator = p;

    var d = function () {
      function e() {}

      return e.getPredefinedTheme = function (e) {
        return p.getPredefined(e);
      }, o([u.deprecatedMethod("ThemeColorsDefinitionCreator.getPredefined"), i("design:type", Function), i("design:paramtypes", [String]), i("design:returntype", Object)], e, "getPredefinedTheme", null), e;
    }();

    t.ThemeDefCreator = d;
  }, function (e, t) {
    e.exports = require("lodash.isequal");
  }, function (e, t, n) {
    "use strict";

    var _r13,
        o = this && this.__extends || (_r13 = function r(e, t) {
      return (_r13 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r13(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(1),
        c = n(0),
        l = n(7),
        u = n(171),
        p = n(171);
    t.TaskListContext = p.TaskListContext;

    var d = function d(e, t) {
      var n = l.TaskHelper.isPending(e),
          r = l.TaskHelper.isPending(t);
      return n !== r ? r ? 1 : -1 : n && r ? t.dateUpdated.getTime() - e.dateUpdated.getTime() : t.dateCreated.getTime() - e.dateCreated.getTime();
    },
        f = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.updateAll = function () {}, t.prototype.render = function () {
        return s.createElement(u.TaskListImpl, i({}, this.props));
      }, t.displayName = u.displayName, t.Content = u.contentStore, t.IncludeAllFilter = {
        callback: function callback() {
          return !0;
        }
      }, t.defaultProps = {
        compareFunction: d
      }, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.TaskList = f;
  }, function (e, t, n) {
    "use strict";

    var _r14,
        o = this && this.__extends || (_r14 = function r(e, t) {
      return (_r14 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r14(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(394),
        c = n(2),
        l = n(14),
        u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return a.createElement(p, i({}, this.props));
      }, t.friendlyName = s.displayName, t.displayName = s.displayName, t.Content = s.contentStore, t;
    }(a.PureComponent);

    t.WorkerDirectoryTabs = u;
    var p = c.withTheme(l.withTaskContext(s.WorkerDirectoryTabsImpl));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(187);
    t.LoginFormView = r.LoginFormView, t.LoginFormViewProps = r.LoginFormViewProps;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(3);
    t.SupervisorStateHelper = {
      getTaskBySid: function getTaskBySid(e) {
        var t = function (e) {
          var t = r.FlexModule.state.supervisor.stickyWorker;

          if (t) {
            var n = t.tasks.find(function (t) {
              return t.sid === e;
            });
            if (n) return n;
          }
        }(e);

        if (t) return t;

        for (var n = r.FlexModule.state.supervisor.workers, o = 0; o < n.length; o += 1) {
          if (t = n[o].tasks.find(function (t) {
            return t.sid === e;
          })) return t;
        }
      },
      getTaskByTaskSid: function getTaskByTaskSid(e) {
        var t = function (e) {
          var t = r.FlexModule.state.supervisor.stickyWorker;

          if (t) {
            var n = t.tasks.find(function (t) {
              return t.taskSid === e;
            });
            if (n) return n;
          }
        }(e);

        if (t) return t;

        for (var n = r.FlexModule.state.supervisor.workers, o = 0; o < n.length; o += 1) {
          if (t = n[o].tasks.find(function (t) {
            return t.taskSid === e;
          })) return t;
        }
      },
      getWorkerBySid: function getWorkerBySid(e) {
        var t = r.FlexModule.state.supervisor,
            n = t.workers,
            o = t.stickyWorker;
        if (o && o.worker.sid === e) return o.worker;
        var i = n.find(function (t) {
          return t.worker.sid === e;
        });
        return Boolean(i) ? i.worker : void 0;
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(433);
    t.TaskCardPlaceholder = r.TaskCardPlaceholder;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u,
        p,
        d,
        f,
        h = n(65),
        m = n(448),
        g = n(0),
        y = n(2);
    t.Container = y.default(g.FlexBox)(o || (o = r(["\n    padding-top: 12px;\n    padding-bottom: 12px;\n"], ["\n    padding-top: 12px;\n    padding-bottom: 12px;\n"]))), t.SkillsContainer = y.default(g.FlexBox)(i || (i = r(["\n    padding-left: 12px;\n    padding-right: 12px;\n    overflow-x: hidden;\n    overflow-y: auto;\n"], ["\n    padding-left: 12px;\n    padding-right: 12px;\n    overflow-x: hidden;\n    overflow-y: auto;\n"]))), t.NoSkillsContainer = y.default(g.FlexBox)(a || (a = r(["\n    margin-top: 16px;\n    & > * {\n        margin: auto;\n    }\n"], ["\n    margin-top: 16px;\n    & > * {\n        margin: auto;\n    }\n"]))), t.NotificationTextContainer = y.default(g.FlexBox)(s || (s = r(["\n    margin-top: 12px;\n    font-size: 10px;\n    & > * {\n        margin: auto;\n    }\n"], ["\n    margin-top: 12px;\n    font-size: 10px;\n    & > * {\n        margin: auto;\n    }\n"]))), t.ButtonsContainer = y.default(g.FlexBox)(c || (c = r(["\n    margin-top: 32px;\n    padding-left: 12px;\n    padding-right: 12px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    justify-content: center;\n    & > * {\n        margin-left: 6px;\n        margin-right: 6px;\n        min-width: 100px;\n    }\n"], ["\n    margin-top: 32px;\n    padding-left: 12px;\n    padding-right: 12px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    justify-content: center;\n    & > * {\n        margin-left: 6px;\n        margin-right: 6px;\n        min-width: 100px;\n    }\n"]))), t.AddPanelContainer = y.default(g.FlexBox)(l || (l = r(["\n    padding-left: 12px;\n    padding-right: 12px;\n    min-height: 48px;\n"], ["\n    padding-left: 12px;\n    padding-right: 12px;\n    min-height: 48px;\n"]))), t.StyledFormControlLabel = y.default(m.default)(u || (u = r(["\n    flex: 1 1 auto;\n    overflow: hidden;\n    margin-bottom: auto;\n"], ["\n    flex: 1 1 auto;\n    overflow: hidden;\n    margin-bottom: auto;\n"]))), t.StyledSkillLevelInput = y.default(h.default)(p || (p = r(["\n    flex: 0 0 56px;\n    height: 32px;\n    width: 56px;\n"], ["\n    flex: 0 0 56px;\n    height: 32px;\n    width: 56px;\n"]))), t.RightButtonContainer = y.default("div")(d || (d = r(["\n    display: flex;\n    flex: 0 0 28px;\n    margin-left: 12px;\n    & > * {\n        margin: auto;\n    }\n"], ["\n    display: flex;\n    flex: 0 0 28px;\n    margin-left: 12px;\n    & > * {\n        margin: auto;\n    }\n"]))), t.LevelInputAndButtonContainer = y.default(g.FlexBox)(f || (f = r(["\n    flex-basis: 0;\n"], ["\n    flex-basis: 0;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.isSkillLevelOk = function (e) {
      return !e.multivalue || e.level >= e.minimum && e.level <= e.maximum;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r(n(479)), r(n(494));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(61),
        a = n(6),
        s = n(8),
        c = n(10),
        l = n(32);
    t.getSegmentByTaskSid = function (e, t) {
      return r(this, void 0, void 0, function () {
        var n, r, l, u, p;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              if (n = t.axios, r = c.Manager.getInstance().serviceConfiguration.account_sid, l = s.getFlexInsightsPlayerConfig(c.Manager.getInstance().configuration).mediaApiUrl, !n) throw new Error("Axios not found in identity object");
              if (!r) throw new Error("account_sid not found in serviceConfiguration object");
              o.label = 1;

            case 1:
              return o.trys.push([1, 3,, 4]), [4, n.get(a.templateStr(i.ENDPOINT_SEGMENT_ID, {
                mediaApiUrl: l,
                accountSid: r,
                taskSid: e
              }))];

            case 2:
              if (200 !== (u = o.sent()).status) throw new Error("failed to get segmentId");
              return [2, u.data.segmentId];

            case 3:
              return p = o.sent(), [2, Promise.reject(p)];

            case 4:
              return [2];
          }
        });
      });
    }, t.getTitleForLink = function (e) {
      if (e.title) return e.title;
      if (e.type === l.InsightsPlayerMediaLinkType.VoiceRecording) return "Voice Recording";
      if (e.type === l.InsightsPlayerMediaLinkType.ChatTranscript) return "Chat Transcript";

      try {
        return new URL(e.url).host;
      } catch (t) {
        return e.url;
      }
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r(n(56)), r(n(13));
    var o = n(43);
    t.languages = o.languages, t.Strings = o.Strings, r(n(572)), r(n(168));
    var i = n(72);
    t.ChatOrchestrator = i.ChatOrchestrator, t.ChatOrchestratorEvent = i.ChatOrchestration, r(n(121)), r(n(125)), r(n(22));
    var a = n(78);
    t.FlexState = a.FlexState, t.flexStoreEnhancer = a.flexStoreEnhancer, r(n(7)), r(n(30)), r(n(11));
    var s = n(12);
    t.DefaultTaskChannels = s.DefaultTaskChannels, t.TaskChannels = s.TaskChannels;
    var c = n(573),
        l = n(17);
    c.registerActions(), l.registerToNotifications();
    var u = n(17);
    t.NotificationIds = u.NotificationIds, t.Notifications = u.Notifications, t.NotificationType = u.NotificationType, t.NotificationEvent = u.NotificationEvent;
    var p = n(31);
    t.VERSION = p.VERSION, n(129), r(n(92));
    var d = n(92);
    t.ThemeColorsDefinition = d.ThemeColorsDefinition, t.ThemeDef = d.ThemeDef;
    var f = n(56);
    t.Theme = f.Theme, t.ThemeProps = f.ThemeProps, r(n(577)), n(581).initialize();
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(105);
    t.TaskOverviewCanvas = r.TaskOverviewCanvas, t.TaskOverviewCanvasProps = r.TaskOverviewCanvasProps;
  }, function (e, t, n) {
    "use strict";

    var _r15,
        o = this && this.__extends || (_r15 = function r(e, t) {
      return (_r15 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r15(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(224),
        u = n(267),
        p = n(46),
        d = n(11),
        f = n(9),
        h = n(2),
        m = n(140),
        g = n(7),
        y = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      var n;
      return o(t, e), n = t, t.prototype.render = function () {
        var e,
            t = this.props,
            r = t.firstLine,
            o = t.secondLine,
            a = t.task,
            c = t.channelDefinition;
        return t.conference && g.TaskHelper.isLiveCall(a) && (e = s.createElement(m.ParticipantsCanvas, {
          includeMyself: !0,
          hideActions: !0
        })), s.createElement(p.TaskDetailsPanel, i({
          content: n.Content,
          IconComponent: u.TaskOverviewIcon,
          ActionsComponent: l.SupervisorTaskOverviewActions,
          contentComponent: e,
          firstLine: r || d.TaskChannelHelper.getTemplateForStatus(a, c.templates.Supervisor.TaskOverviewCanvas.firstLine, n),
          secondLine: o
        }, this.props));
      }, t.friendlyName = "TaskOverviewCanvas", t.displayName = n.friendlyName, t.Content = new c.DynamicContentStore(n.friendlyName), t = n = a([h.withTheme, f.withTaskContext], t);
    }(s.PureComponent);

    t.TaskOverviewCanvas = y;
  }, function (e, t) {
    e.exports = require("twilio-client");
  }, function (e, t) {
    e.exports = require("events");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(109);
    t.Spy = o.Spy, t.PredefinedSpies = o.PredefinedSpies, t.NotifyCallback = o.NotifyCallback;
    var i = n(231);
    t.Formatter = i.Formatter, t.PredefinedFormatters = i.PredefinedFormatters;
    var a = n(233);
    t.Storage = a.Storage, t.PredefinedStorages = a.PredefinedStorages;
    var s,
        c = n(235);
    t.Transport = c.Transport, t.PredefinedTransports = c.PredefinedTransports, function (e) {
      e.isLogging = "isLogging", e.ready = "ready";
    }(s || (s = {}));

    var l = function () {
      function e(t) {
        var n = this,
            s = t.identifier;
        this.config = r(r(r({}, e.defaults), {
          identifier: s
        }), t), this.storage = "function" == typeof this.config.storage ? this.config.storage() : a.getStorage(r({
          identifier: this.config.identifier
        }, this.config.storage));
        var l = this.storage ? function (e) {
          return n.storage.add(e);
        } : function (e) {
          return n.flush([e]);
        };
        this.spies = this.config.spies.map(function (e) {
          return "function" == typeof e ? e({
            trigger: l
          }) : o.getSpy(r({
            trigger: l
          }, e));
        }).filter(function (e) {
          return e;
        }), this.formatter = "function" == typeof this.config.formatter ? this.config.formatter() : i.getFormatter(this.config.formatter), this.transport = "function" == typeof this.config.transport ? this.config.transport() : c.getTransport(this.config.transport), this.start = this.start.bind(this);
      }

      return e.prototype.start = function () {
        this.isReady() && (this.setState(s.isLogging, !0), this.spies.forEach(function (e) {
          return e.start();
        }));
      }, e.prototype.stop = function () {
        this.spies.forEach(function (e) {
          return e.stop();
        }), this.storage.clear(), this.setState(s.ready, !1), this.setState(s.isLogging, !1);
      }, e.prototype.flush = function (e) {
        e = void 0 === e && this.storage ? this.storage.get() : e;
        var t = this.formatter(e);
        return this.transport.flush(t);
      }, e.prototype.isReady = function () {
        return this.getState(s.ready);
      }, e.prototype.isLogging = function () {
        return !!this.getState(s.isLogging);
      }, e.prototype.prepare = function () {
        var e = this;
        return new Promise(function (t) {
          e.setState(s.ready, !0), t();
        });
      }, e.prototype.setState = function (t, n) {
        var o,
            i = JSON.parse(window.localStorage.getItem(e.persistKey)) || {};
        i[this.config.identifier] = r(r({}, i[this.config.identifier]), ((o = {})[t] = n, o)), window.localStorage.setItem(e.persistKey, JSON.stringify(i));
      }, e.prototype.getState = function (t) {
        var n = (JSON.parse(window.localStorage.getItem(e.persistKey)) || {})[this.config.identifier] || {};
        return t ? n[t] : n;
      }, e.persistKey = "FLEX_LOG_STATE", e.defaults = {
        spies: [],
        storage: {
          type: a.PredefinedStorages.LocalStorage
        },
        transport: {
          type: c.PredefinedTransports.File
        },
        formatter: {
          type: i.PredefinedFormatters.String
        }
      }, e;
    }();

    t.LogManager = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__rest || function (e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(39);
    t.Spy = o.Spy, t.NotifyCallback = o.NotifyCallback, t.OnStartCallback = o.OnStartCallback;
    var i,
        a = n(227),
        s = n(228),
        c = n(229),
        l = n(230);
    !function (e) {
      e.ClassProxy = "ClassProxy", e.EventEmitter = "EventEmitter", e.DOMEvents = "DOMEvents", e.Loglevel = "Loglevel";
    }(i = t.PredefinedSpies || (t.PredefinedSpies = {})), t.getSpy = function (e) {
      var t = e.type,
          n = r(e, ["type"]);

      switch (e.type) {
        case i.ClassProxy:
          return new a.ClassProxySpy(n);

        case i.EventEmitter:
          return new s.EventEmitterSpy(n);

        case i.DOMEvents:
          return new c.DOMEventsSpy(n);

        case i.Loglevel:
          return new l.LoglevelSpy(n);

        default:
          console.error("invalid spy type: " + t);
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = function o(e) {
      return void 0 === e && (e = 0), function (t) {
        var n = r({}, t);
        return Object.getOwnPropertyNames(n).forEach(function (t) {
          var r = n[t];
          "object" != typeof r || Array.isArray(r) || null === r || (n[t] = e >= 1 ? "<Object>" : o(e + 1)(r));
        }), n;
      };
    };

    t.stringify = function (e) {
      return JSON.stringify(e, function (e, t) {
        return "function" == typeof t ? "<Function>" : "object" != typeof t || null === t || Array.isArray(t) ? t : o()(t);
      });
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function r() {
      this.add = this.add.bind(this), this.get = this.get.bind(this), this.clear = this.clear.bind(this);
    };

    t.Storage = r;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function r() {};

    t.Transport = r;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r,
        o,
        i,
        a = n(0),
        s = n(68),
        c = n(30),
        l = n(7),
        u = n(57),
        p = n(6),
        d = n(114),
        f = function f(e, t) {
      if (e.incomingTransferObject && "pending" === e.status) return "WORKER" === e.incomingTransferObject.type ? t === o ? "TaskLineCallTransferWorkerDetail" : "TaskLineCallTransferWorker" : t === o ? "TaskLineCallTransferQueueDetail" : "TaskLineCallTransferQueue";
      if (l.TaskHelper.isInitialOutboundAttemptTask(e)) return "TaskLineOutboundCallConnecting";

      switch (e.status) {
        case "pending":
          return t === o ? "TaskLineQueue" : "TaskLineCallReserved";

        case "accepted":
          return e.conference && e.conference.liveParticipantCount > 2 ? "TaskLineGroupCallAssigned" : "TaskLineCallAssigned";

        case "wrapping":
          if (t === r) return;
          return "TaskLineCallWrapup";

        default:
          return "";
      }
    },
        h = function h(e, t) {
      switch (e.status) {
        case "accepted":
          return e.conference && e.conference.liveParticipantCount > 2 ? "TaskHeaderLeaveCall" : "TaskHeaderEndCall";

        case "wrapping":
          return "TaskHeaderComplete";

        default:
          return "";
      }
    },
        m = function m(e, t) {
      switch (e.status) {
        case "accepted":
          return e.conference && e.conference.liveParticipantCount > 2 ? "SupervisorTaskGroupCall" : "SupervisorTaskLive";

        case "pending":
          return "SupervisorTaskLive";

        case "wrapping":
          return "SupervisorTaskWrapUp";

        default:
          return "SupervisorTaskCompleted";
      }
    },
        g = function g(e, t) {
      if (e.incomingTransferObject && "pending" === e.status) return "TaskLineCallTransferTitle";

      switch (e.status) {
        case "pending":
          return "TaskLineCallIncomingTitle";

        case "wrapping":
          return "TaskLineCallEndedTitle";

        default:
          return "";
      }
    },
        y = function y(e, t) {
      switch (e.status) {
        case "pending":
          return "TaskHeaderStatusPending";

        case "accepted":
          return e.conference && e.conference.liveParticipantCount > 2 ? "TaskHeaderGroupCallAccepted" : "TaskHeaderStatusAccepted";

        case "wrapping":
          return "TaskHeaderStatusWrapup";

        case "completed":
          return "TaskHeaderStatusCompleted";

        default:
          return "";
      }
    },
        v = function v(e, t) {
      return l.TaskHelper.isOutboundCallTask(e) ? "TaskLineOutboundCallHeader" : "TaskHeaderLine";
    },
        b = {
      IncomingTask: function IncomingTask(e, t) {
        var n = e.context.task,
            r = "IncomingCallNotificationTitle",
            o = "IncomingCallBrowserNotificationTitle",
            i = "IncomingCallBrowserNotificationBody";
        n && n.incomingTransferObject && (r = "IncomingCallTransferNotificationTitle", o = "IncomingCallTransferBrowserNotificationTitle", i = "WORKER" === n.incomingTransferObject.type ? "IncomingCallTransferWorkerBrowserNotificationBody" : "IncomingCallTransferQueueBrowserNotificationBody"), e.content = r, e.timeout = 0, e.icon = "IncomingCallBold", e.actions = d.incomingTaskNotificationActions, e.options || (e.options = {}), e.options.browser = {
          title: o,
          body: i,
          onClick: function onClick(e, t) {
            p.tryInvokeAction("SelectTask", {
              task: e.context.task
            });
          },
          options: {
            requireInteraction: !0
          }
        };
      }
    };

    function C(e, t) {
      return a.Utils.merge(s.Default, {
        name: e,
        isApplicable: t,
        capabilities: new Set([c.TaskChannelCapability.Call, c.TaskChannelCapability.Info, c.TaskChannelCapability.Wrapup]),
        colors: {
          main: w
        },
        icons: {
          list: _,
          active: k,
          main: "Call"
        },
        notifications: {
          override: b
        },
        templates: {
          CallCanvas: {
            secondLine: f,
            titleLine: g
          },
          IncomingTaskCanvas: {
            secondLine: f,
            titleLine: g
          },
          TaskListItem: {
            firstLine: v,
            secondLine: f
          },
          TaskCanvasHeader: {
            title: v,
            secondLine: y,
            endButton: h
          },
          TaskCard: {
            secondLine: m
          },
          Supervisor: {
            TaskCanvasHeader: {
              secondLine: y
            }
          },
          TaskCanvasTabs: {
            contentTabHeader: "TaskTabHeaderCall"
          }
        },
        componentProps: {}
      });
    }

    function _(e, t, n) {
      void 0 === n && (n = !1);
      var r = "Call";
      return i.has(t) && (r = "IncomingCall", l.TaskHelper.isInitialOutboundAttemptTask(e) ? r = "OutboundCall" : e.incomingTransferObject && "pending" === e.status ? r = "IncomingTransfer" : l.TaskHelper.isRegularConferenceCall(e) && l.TaskHelper.isGroupCall(e) && !l.TaskHelper.isInWrapupMode(e) && !l.TaskHelper.isCompleted(e) ? r = "GroupCall" : l.TaskHelper.isCallOnHold(e) ? r = "Hold" : l.TaskHelper.isLiveCall(e) ? r = l.TaskHelper.isOutboundCallTask(e) ? "OutboundCall" : "Call" : (l.TaskHelper.isInWrapupMode(e) || l.TaskHelper.isCompleted(e)) && (r = "Hangup")), n && (r += "Bold"), r;
    }

    function k(e, t, n) {
      return _(e, t, !0);
    }

    function w(e, t) {
      return l.TaskHelper.isCallOnHold(e) && !l.TaskHelper.isGroupCall(e) ? u.commonColors.holdColor : l.TaskHelper.isLiveCall(e) || l.TaskHelper.isIncomingCall(e) || l.TaskHelper.isInitialOutboundAttemptTask(e) ? u.defaultChannelColors.call : u.defaultChannelColors.inactive;
    }

    t.createCallTaskChannel = C, t.Call = C("call", function (e) {
      return "voice" === e.taskChannelUniqueName;
    }), t.init = function (e) {
      i || (i = new Set([e.CallCanvas, e.IncomingTaskCanvas, e.TaskCard, e.TaskOverviewCanvas, e.TaskListBaseItem, e.ConnectingOutboundCallCanvas]), r = e.CallCanvas, o = e.IncomingTaskCanvas);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(1),
        o = n(0);
    t.incomingTaskNotificationActions = [r.createElement(o.NotificationBar.Action, {
      label: "IncomingNotificationAccept",
      onClick: function onClick(e, t) {
        o.Actions.invokeAction("AcceptTask", {
          task: t.context.task
        }), o.Actions.invokeAction("SelectTask", {
          task: t.context.task
        });
      }
    }), r.createElement(o.NotificationBar.Action, {
      label: "IncomingNotificationReject",
      onClick: function onClick(e, t) {
        o.Actions.invokeAction("RejectTask", {
          task: t.context.task
        });
      }
    })];
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(116);
    t.ParticipantType = r.ParticipantType, t.ParticipantStatus = r.ParticipantStatus, t.ConferenceStatus = r.ConferenceStatus, t.OutboundTransfer = r.OutboundTransfer;
    var o = n(58);
    t.reduce = o.reduce, t.Actions = o.Actions, t.UpdateConferencePayload = o.UpdateConferencePayload, t.UpdateMultipleConferencePayload = o.UpdateMultipleConferencePayload, t.ConferencesState = o.ConferencesState, t.ConferenceState = o.ConferenceState;
    var i = n(134);
    t.ConferenceListenerManager = i.ConferenceListenerManager;
    var a = n(135);
    t.ConferenceListener = a.ConferenceListener;
    var s = n(136);
    t.Conference = s.Conference;
    var c = n(84);
    t.ConferenceParticipant = c.ConferenceParticipant;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e.initializing = "initializing", e.initialized = "initialized", e.destroying = "destroying";
    }(t.ConferenceListenerState || (t.ConferenceListenerState = {}));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(247),
        o = n(118);
    t.featureFlagsSelector = o.createSelector(function (e) {
      return e.featureFlags.features;
    }, function (e) {
      return e.featureFlags.localOverrides;
    }, function (e, t) {
      return r({}, e, t);
    });
  }, function (e, t) {
    e.exports = require("reselect");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(3),
        i = n(5),
        a = n(25),
        s = n(32),
        c = {
      client: void 0,
      playerMediaLinks: [],
      selectedMediaLink: void 0
    };

    t.reduce = function (e, t) {
      switch (void 0 === e && (e = c), t.type) {
        case "FLEX_ACTION_INIT_INSIGHTS":
          return r(r({}, c), {
            client: t.payload
          });

        case s.INSIGHTS_PLAYER_SET_MEDIA_LINKS:
          return r(r({}, e), {
            playerMediaLinks: t.payload || [],
            selectedMediaLink: t.payload && t.payload.length ? 0 : void 0
          });

        case s.INSIGHTS_PLAYER_MEDIA_SELECT:
          return r(r({}, e), {
            selectedMediaLink: t.payload
          });

        default:
          return e;
      }
    };

    var l = function () {
      function e() {}

      return e.dispatchAction = function (e, t) {
        o.FlexModule.dispatch({
          type: e,
          payload: t
        });
      }, e.init = function (e) {
        this.dispatchAction("FLEX_ACTION_INIT_INSIGHTS", e);
      }, e.shutdown = function () {
        i.log.info("Insights shutdown"), a.InsightsEntityCache.destroy();
        var e = o.FlexModule.state.insights.client;
        if (e) try {
          e.shutdown();
        } catch (e) {
          i.log.error("Error on Insights shutdown", e);
        }
        this.dispatchAction("FLEX_ACTION_INIT_INSIGHTS", null);
      }, e;
    }();

    t.Actions = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0),
        i = n(3),
        a = n(5);

    t.reduce = function (e, t) {
      switch (void 0 === e && (e = {}), t.type) {
        case "LOAD_CC_CONFIG":
          return r({
            sso: {}
          }, t.payload);

        default:
          return e;
      }
    };

    var s = function () {
      function e() {}

      return e.initConfig = function (e) {
        i.FlexModule.dispatch({
          type: "LOAD_CC_CONFIG",
          payload: e
        }), e.logLevel && a.log.setLevel(e.logLevel), o.ChatConfig.setConfig({
          language: e.language,
          logLevel: e.logLevel
        });
      }, e;
    }();

    t.Actions = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(120),
        o = n(26),
        i = n(71),
        a = n(75),
        s = n(29),
        c = n(119),
        l = n(16),
        u = n(80),
        p = n(58),
        d = n(20),
        f = n(81),
        h = n(123),
        m = n(27),
        g = n(0),
        y = {};

    t.FlexReducer = function (e, t) {
      return void 0 === e && (e = y), {
        config: r.reduce(e.config, t),
        session: o.reduce(e.session, t),
        chat: g.chatReducer(e.chat, t),
        worker: i.reduce(e.worker, t),
        phone: a.reduce(e.phone, t),
        view: s.reduce(e.view, t),
        insights: c.reduce(e.insights, t),
        supervisor: l.reduce(e.supervisor, t),
        router: u.createReducer(e.config)(e.router, t),
        connectionStatus: h.reduce(e.connectionStatus, t),
        conferences: p.reduce(e.conferences, t),
        realtimeQueues: d.reduce(e.realtimeQueues, t),
        queues: f.reduce(e.queues, t),
        featureFlags: m.reduce(e.featureFlags, t)
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SET_QUEUES = "FLEX_SET_QUEUES", t.ADD_QUEUE = "FLEX_ADD_QUEUE", t.UPDATE_QUEUE = "FLEX_UPDATE_QUEUE", t.REMOVE_QUEUE = "FLEX_REMOVE_QUEUE", t.SET_WORKSPACE_STATS = "FLEX_SET_WORKSPACE_STATS", t.UPDATE_FILTER = "FLEX_UPDATE_QUEUES_FILTER", t.QUEUES_ERROR = "FLEX_QUEUES_ERROR";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(253);
    t.reduce = r.reduce, t.ConnectionStatusState = r.ConnectionStatusState;
    var o = n(124);
    t.CONNECTION_STATUS_CHANGE = o.CONNECTION_STATUS_CHANGE, t.ConnectionStatus = o.ConnectionStatus, t.ConnectionStatusActionTypes = o.ConnectionStatusActionTypes;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CONNECTION_STATUS_CHANGE = "FLEX_CONNECTION_STATUS_CHANGE";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(79),
        o = n(254),
        i = n(255),
        a = n(59),
        s = n(5),
        c = n(82);

    t.applyFlexMiddleware = function (e) {
      var t;
      c.isHistory(e) ? (t = e, c.setHistory(t)) : t = c.isHistoryParams(e) ? c.default(e) : c.isHistoryType(e) ? c.default({
        type: e
      }) : c.default();
      var n = [a.routerMiddleware(t), i.default()];
      return s.log.getLevel() <= 1 && n.push(o.createLogger()), r.applyMiddleware.apply(void 0, n);
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a,
        s = n(15),
        c = n(5),
        l = n(31),
        u = n(3),
        p = n(127),
        d = n(8);
    !function (e) {
      e.NotStarted = "NotStarted", e.Loaded = "Loaded", e.Initialising = "Initialising", e.Initialized = "Initialized", e.Failed = "Failed";
    }(a = t.PluginState || (t.PluginState = {}));

    var f = function () {
      function e() {
        var e = this;
        this._plugins = [], this._phase = 0, this._listeners = [], this.doInit = function (t, n) {
          c.log.debug("loading plugin", t), e.updatePluginState(n, a.Initialising);
          var r = new t();
          return Promise.resolve(r.init(e._flexComponents, e._manager, e._plugins)).then(function () {
            c.log.debug("successfully loaded plugin", r.name), e.updatePluginState(n, a.Initialized);
          }).catch(function (r) {
            c.log.error("failed to load plugin", t, r), e.updatePluginState(n, a.Failed);
          });
        }, this.incrementPhase = function () {
          e._phase = e._phase + 1, e.notifyListeners();
        }, this.notifyListeners = function () {
          e._listeners.forEach(function (e) {
            return e.callback();
          });
        }, this.createListener = function (t) {
          var n = p.v4(),
              r = {
            uuid: n,
            callback: t
          };
          return e._listeners.push(r), function () {
            var t = e._listeners.findIndex(function (e) {
              return e.uuid === n;
            });

            -1 !== t && e._listeners.splice(t, 1);
          };
        };
      }

      return Object.defineProperty(e.prototype, "plugins", {
        get: function get() {
          return this._plugins;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "phase", {
        get: function get() {
          return this._phase;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "listeners", {
        get: function get() {
          return this._listeners;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.setup = function (e, t) {
        this._flexComponents = e, this._manager = t;
      }, e.prototype.init = function (e) {
        var n = this,
            r = document.currentScript.getAttribute("uuid");
        t.Plugins.updatePluginState(r, a.Loaded);
        var o = this.createListener(function () {
          n.canInitPlugin(r) && (o(), n.doInit(e, r));
        });
        this.canInitPlugin(r) && (o(), this.doInit(e, r));
      }, e.prototype.storePluginDefinition = function (e) {
        if (0 !== this._plugins.length) throw new Error("Plugins can only be set once");
        this._plugins = e;
      }, e.prototype.updatePluginState = function (e, t) {
        var n = this._plugins.find(function (t) {
          return t.uuid === e;
        });

        n && (n.state = t, t !== a.Failed && t !== a.Initialized || this.notifyListeners());
      }, e.prototype.canInitPlugin = function (e) {
        var t = this,
            n = this._plugins.slice(),
            r = n.filter(function (e) {
          return e.phase === t._phase;
        }),
            o = r.filter(function (e) {
          return e.state === a.NotStarted || e.state === a.Loaded;
        }),
            i = n.filter(function (t) {
          return t.uuid === e;
        })[0];

        if (!i) return c.log.warn("Could not find a loaded plugin"), !1;
        if (i.state === a.Initialized || i.state === a.Failed) return c.log.warn("Attempting to re-initialize an already initialized plugin"), !1;
        if (0 === r.length || 0 === o.length) return this.incrementPhase(), !1;
        if (!i || i.phase !== this._phase) return !1;
        if (1 === r.length) return !0;
        var s = r.findIndex(function (t) {
          return t.uuid === e;
        });
        return -1 !== s && r.slice().splice(0, s).every(function (e) {
          return e.state === a.Initialized || e.state === a.Failed;
        });
      }, e;
    }();

    t.PluginManager = f, t.Plugins = new f(), t.loadPlugins = function (e, n) {
      var f = this,
          h = n.configuration.pluginService;
      return h && h.enabled ? (c.log.debug("loading plugins ..."), t.Plugins.setup(e, n), new Promise(function (e, h) {
        return o(f, void 0, Promise, function () {
          var o, f, m, g;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return i.trys.push([0, 3,, 4]), o = d.getPluginServiceUrl(n.configuration), [4, s.default.get(o, {
                  withCredentials: !0,
                  headers: {
                    "X-Flex-JWE": u.FlexModule.state.session.ssoTokenPayload.token,
                    "X-Flex-Version": l.VERSION
                  }
                }).then(function (e) {
                  return e.data;
                }).catch(function (e) {
                  c.log.error("failed to reach plugin service at " + o + " " + e);
                })];

              case 1:
                return f = i.sent(), Array.isArray(f) && 0 !== f.length ? (m = f.map(function (e) {
                  return r(r({
                    phase: 3
                  }, e), {
                    uuid: p.v4(),
                    state: a.NotStarted
                  });
                }), t.Plugins.storePluginDefinition(m), [4, Promise.all(m.map(function (e) {
                  return new Promise(function (n) {
                    c.log.debug("downloading plugin: " + e.name + " version: " + e.version);
                    var r = document.createElement("script");
                    r.setAttribute("uuid", e.uuid), r.src = e.src, r.async = !0, r.onload = function () {
                      c.log.debug("plugin " + e.name + " downloaded"), n();
                    }, r.onerror = function (r) {
                      c.log.warn("failed to download plugin: " + e.name, r), t.Plugins.updatePluginState(e.uuid, a.Failed), n();
                    }, document.body.appendChild(r);
                  });
                }))]) : (c.log.debug("no plugins loaded"), e(), [2]);

              case 2:
                return i.sent(), u.FlexModule.events.emitPluginsLoaded(), e(), [3, 4];

              case 3:
                return g = i.sent(), c.log.warn("failed to fetch plugin configuration", g), h(), [3, 4];

              case 4:
                return [2];
            }
          });
        });
      })) : (c.log.debug("plugin service not configured"), Promise.resolve());
    };
  }, function (e, t) {
    e.exports = require("uuid");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.deprecatedGetter = function (e) {
      var t = this;
      return function (n, r, o) {
        var i = o.get;
        return o.get = function () {
          return console.warn("Warning! Getter '" + r + "' has been deprecated, please use '" + e + "' instead!"), i.call(t);
        }, o;
      };
    }, t.deprecatedSetter = function (e) {
      var t = this;
      return function (n, r, o) {
        var i = o.set;
        return o.set = function (n) {
          return console.warn("Warning! Setter '" + r + "' has been deprecated, please use '" + e + "' instead!"), i.call(t, n);
        }, o;
      };
    }, t.deprecatedMethod = function (e) {
      var t = this;
      return function (n, r, o) {
        var i = o.value;
        return o.value = function () {
          for (var n = [], o = 0; o < arguments.length; o++) {
            n[o] = arguments[o];
          }

          return console.warn("Warning! Method '" + r + "' has been deprecated, please use '" + e + "' instead!"), i.apply(t, n);
        }, o;
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(103);
    t.Flex = r;
    var o = n(1),
        i = n(130),
        a = n(79),
        s = n(66),
        c = n(5);
    window.Twilio = window.Twilio || {
      Flex: r
    }, window.Twilio.Flex || (window.Twilio.Flex = r);
    var l = {
      React: o,
      ReactDOM: i,
      Redux: a,
      ReactRedux: s
    };
    t.isConflictingDependency = function (e, t) {
      var n = window[e],
          r = t[e],
          o = r && r.version,
          i = n && n.version;
      return !!n && n !== r && (!i || i !== o);
    }, Object.keys(l).forEach(function (e) {
      t.isConflictingDependency(e, l) && c.log.warn("Cannot define global `" + e + "` variable for the module because the variable has been set by some other script. This may cause inconsistency."), window[e] = l[e];
    });
  }, function (e, t) {
    e.exports = require("react-dom");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(15),
        a = n(261),
        s = n(0),
        c = n(262),
        l = n(10),
        u = n(8),
        p = n(26),
        d = n(44),
        f = n(5),
        h = n(18),
        m = function () {
      function e() {
        this.isLoggedIn = !1, this.axios = i.default.create(), this.manager = l.Manager.getInstance(), this.initializeClient();
      }

      return e.init = function () {
        return e.getInstance().login();
      }, e.destroy = function () {
        return r(this, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return e.getInstance().isLoggedIn ? [4, e.getInstance().logout()] : [3, 2];

              case 1:
                t.sent(), e.getInstance().isLoggedIn = !1, t.label = 2;

              case 2:
                return [2];
            }
          });
        });
      }, e.getInstance = function () {
        return e.instance || (e.instance = new e()), e.instance;
      }, e.hasPermission = function (t) {
        return e.getInstance().isLoggedIn && e.getInstance().identityClient.isLoggedIn && e.getInstance().identityClient.hasPermission(t);
      }, e.prototype.initializeClient = function () {
        var e = u.getFlexInsightsSSOUrl(this.manager.configuration),
            t = new URL(u.getFlexInsightsIdentityUrl(this.manager.configuration));
        this.identityClient = new a.default({
          url: t.href,
          baseUrl: t.origin,
          axios: this.axios,
          ssoLoginUrl: e
        }), this.identityClient.initialize();
      }, e.prototype.login = function () {
        return r(this, void 0, void 0, function () {
          var e, t, n, r, i, a;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                if (o.trys.push([0, 2,, 3]), e = this.manager.store.getState().flex, t = e.session.ssoTokenPayload, n = t.identity, r = t.token, i = this.manager.serviceConfiguration.account_sid, !n || !r || !i) throw new Error("Missing one of SSO params: identity, token, accountSid");
                return [4, this.identityClient.ssoLogin({
                  identity: n,
                  token: r,
                  account_sid: i
                })];

              case 1:
                if (o.sent(), !this.identityClient.isLoggedIn) throw new Error("Login failed");
                return p.Actions.updateInsightsServiceStatus(d.InsightsServiceStatus.Ready), this.isLoggedIn = !0, [3, 3];

              case 2:
                return "Request failed with status code 400" === (a = o.sent()).message ? f.log.debug("Flex Insights Service authentication failed: " + (a.message || a) + ".") : (f.log.error("Flex Insights Service authentication failed: " + (a.message || a) + "."), s.Notifications.showNotification(h.FlexInsightsLoginFailed)), p.Actions.updateInsightsServiceStatus(d.InsightsServiceStatus.Error), [3, 3];

              case 3:
                return [2];
            }
          });
        });
      }, e.prototype.logout = function () {
        return Promise.all([this.identityClient.logout(), this.logoutYtica()]);
      }, e.prototype.logoutYtica = function () {
        return Promise.all([this.openYticaLogoutIframe(u.getFlexInsightsQuestionnairesUrl(l.Manager.getInstance().configuration) + "/logout-flex.html", "Twilio-AssessmentYticaLogout").catch(function (e) {
          return f.log.warn(e);
        }), this.openYticaLogoutIframe(u.getFlexInsightsBaseUrl(l.Manager.getInstance().configuration) + "/static/logout-flex.html", "Twilio-AppYticaLogout").catch(function (e) {
          return f.log.warn(e);
        })]);
      }, e.prototype.openYticaLogoutIframe = function (e, t) {
        return new Promise(function (n, r) {
          var o = document.createElement("iframe"),
              i = function i(e) {
            e.source === o.contentWindow && "object" == typeof e.data && "com.twilio.flex.insights.logout" === e.data.name && (window.removeEventListener("message", i), document.body.removeChild(o), n());
          };

          window.addEventListener("message", i), o.src = e, o.id = t, o.style.cssText = "position:absolute;top:0;left:0;display:none;opacity:0;", document.body.appendChild(o), setTimeout(function () {
            r(new Error(t + " has not logged out in time"));
          }, 1e4);
        });
      }, e.prototype.loginGoodData = function () {
        return r(this, void 0, Promise, function () {
          var e, t, n, r, a;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                if (!this.identityClient.isLoggedIn) throw new Error("Identity Client not logged in!");
                return [4, this.identityClient.getServiceSsoUrl("dashboards", "/")];

              case 1:
                return e = o.sent(), t = new URL(e), n = t.searchParams.get("sessionId") || "", r = t.origin, a = new URLSearchParams({
                  targetUrl: "/gdc/account/profile/current",
                  ssoProvider: "ytica",
                  encryptedClaims: n
                }), [4, i.default.create().post(r + "/gdc/account/customerlogin", a, {
                  withCredentials: !0,
                  headers: {
                    "Content-type": "application/x-www-form-urlencoded"
                  }
                })];

              case 2:
                return o.sent(), this.sdk = c.factory({
                  domain: r
                }), [2];
            }
          });
        });
      }, e;
    }();

    t.InsightsService = m;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(15),
        a = n(28),
        s = n(8),
        c = n(5),
        l = {
      untrustedDomain: {
        code: 70002,
        status: 400
      },
      invalidCertificate: {
        code: 70251,
        status: 403
      }
    };

    function u(e) {
      return e.replace(/((Token|Expiration|Identity|Roles)=[^&]+[&]?)/g, "").replace(/[&?]$/, "");
    }

    t.sanitizeSSOParams = u, t.getDefaultLoginWindowFeatures = function () {
      return {
        toolbar: "no",
        location: "no",
        menubar: "no",
        scrollbars: "no",
        resizable: "no",
        copyhistory: "no",
        width: 600,
        height: 800
      };
    }, t.stringifyLoginWindowFeatures = function (e) {
      return e ? Object.keys(e).map(function (t) {
        return t + "=" + e[t];
      }).join(", ") : "";
    };

    var p = function p(e, t) {
      var n = e.code,
          r = e.status;
      return n === t.code && r === t.status;
    },
        d = function () {
      function e() {
        throw Error("Instance of this class can't be created");
      }

      return e.fetchRedirectURL = function (e, t) {
        return r(this, void 0, Promise, function () {
          var n, r, l;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return n = s.getSSOLoginUrl(t, e), r = {
                  products: (p = t).products,
                  resource: u(p.redirectUrl)
                }, [4, i.default.post(n, r)];

              case 1:
                if (!(l = o.sent().data).location) throw c.log.error("No redirect location from /authenticate request, data: ", l), new a.InternalError("Invalid response from /authenticate endpoint");
                return [2, l.location];
            }

            var p;
          });
        });
      }, e.get = function (t, n) {
        return r(this, void 0, Promise, function () {
          var r, i, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                if (e.accountSid === t) return [3, 4];
                e.resetCache(), e.accountSid = t, o.label = 1;

              case 1:
                return o.trys.push([1, 3,, 4]), r = e, [4, e.fetchRedirectURL(t, n)];

              case 2:
                return r.idpUrl = o.sent(), [3, 4];

              case 3:
                if (!(i = o.sent()).isAxiosError) throw e.resetCache(), i;
                return s = i.response, p(s.data, l[a.ValidationErrorKeys.untrustedDomain]) ? e.error = new a.ValidationError(a.ValidationErrorKeys.untrustedDomain, i) : p(s.data, l[a.ValidationErrorKeys.invalidCertificate]) ? e.error = new a.ValidationError(a.ValidationErrorKeys.invalidCertificate, i) : e.error = new a.ValidationError(a.ValidationErrorKeys.sso, i), [3, 4];

              case 4:
                if (e.error) throw e.error;
                return [2, e.idpUrl];
            }
          });
        });
      }, e.resetCache = function () {
        e.accountSid = void 0, e.idpUrl = void 0, e.error = void 0;
      }, e;
    }();

    t.IdpUrl = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(25),
        o = function () {
      function e(e) {
        e && (this.mode = e.mode, this.type = e.type, this.workerSid = e.workerSid, this.to = e.to, this.sid = e.sid, this.source = e);
      }

      return Object.defineProperty(e.prototype, "worker", {
        get: function get() {
          return r.InsightsEntityCache.getWorker(this.workerSid);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "status", {
        get: function get() {
          return this.source ? this.source.status : "";
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "queue", {
        get: function get() {
          return r.InsightsEntityCache.getQueue(this.to);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.cancel = function () {
        return this.source.cancel ? this.source.cancel() : Promise.reject();
      }, e;
    }();

    t.TaskTransfer = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(5),
        o = n(22),
        i = n(7),
        a = n(25),
        s = n(135),
        c = function () {
      function e() {}

      return e.initialize = function (e) {
        var t = this;
        r.log.debug("ConferenceListenerManager initialize"), this.initialized = !0, this.conferenceWrappers = new Map(), this.requestedSids.forEach(function (e, n) {
          t.startListening(o.StateHelper.getTaskByTaskrouterTaskSid(n), e);
        }), this.conferenceListenerCallback = e;
      }, e.startListening = function (e, t) {
        if (e && (r.log.debug("ConferenceListenerManager startListening " + e.taskSid + " " + t), i.TaskHelper.isCallTask(e))) if (this.initialized) {
          e.incomingTransferObject && a.InsightsEntityCache.refreshInfoForEntities([e.incomingTransferObject.workerSid, e.incomingTransferObject.to]), e.outgoingTransferObject && a.InsightsEntityCache.refreshInfoForEntities([e.outgoingTransferObject.workerSid, e.outgoingTransferObject.to]);
          var n = this.conferenceWrappers.get(e.taskSid);
          if (n) -1 === n.consumers.indexOf(t) && (r.log.debug("ConferenceListenerManager new Consumer to listener"), n.consumers.push(t));else {
            r.log.debug("ConferenceListenerManager new Listener");
            var o = new s.ConferenceListener(e.taskSid, this.conferenceListenerCallback);
            this.conferenceWrappers.set(e.taskSid, {
              listener: o,
              consumers: [t]
            });
          }
        } else this.requestedSids.set(e.taskSid, t);
      }, e.stopListening = function (e, t) {
        r.log.debug("ConferenceListenerManager stopListening " + e + " " + t);
        var n = this.conferenceWrappers.get(e);

        if (n) {
          var o = n.consumers.indexOf(t);
          o > -1 && n.consumers.splice(o, 1), 0 === n.consumers.length && (n.listener.stop(), this.conferenceWrappers.delete(e));
        }
      }, e.initOutboundTransfer = function (e) {
        var t = e.taskSid,
            n = e.to;
        r.log.debug("ConferenceListenerManager initOutboundTransfer " + t + " " + n);
        var o = this.conferenceWrappers.get(t);
        o && o.listener.initOutboundTransfer(e);
      }, e.unInitOutboundTransferForTask = function (e) {
        r.log.debug("ConferenceListenerManager unInitOutboundTransfer " + e);
        var t = this.conferenceWrappers.get(e);
        t && t.listener.unInitOutboundTransfer();
      }, e.requestedSids = new Map(), e.initialized = !1, e;
    }();

    t.ConferenceListenerManager = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(116),
        a = n(5),
        s = n(3),
        c = n(265),
        l = function () {
      function e(e, t) {
        var n = this;
        this.stateUpdateTimers = [], this.updateOutboundTransfer = function (e) {
          if (n.outboundTransfer) {
            switch (e.status) {
              case "complete":
              case "canceled":
                n.stopOutgoingTransferListeners(), n.outboundTransfer = void 0;
                break;

              case "failed":
                n.failedTransferRemoveTimer = window.setTimeout(function () {
                  n.updateOutboundTransfer({
                    status: "complete"
                  }), n.failedTransferRemoveTimer = 0;
                }, 5e3), n.outboundTransfer.status = "recently_left";
            }

            n.emitCallback();
          }
        }, this.itemAdded = function (e) {
          a.log.debug("ConferenceListener itemAdded " + n.children.length), n.children.push(e.item), n.emitCallback();
        }, this.itemUpdated = function (e) {
          a.log.debug("ConferenceListener itemUpdated " + n.children.length), n.emitCallback();
        }, this.itemRemoved = function (e) {
          a.log.debug("ConferenceListener itemRemoved " + n.children.length), n.children.splice(n.children.indexOf(e.item), 1), n.emitCallback();
        }, this.lifeCycle = i.ConferenceListenerState.initializing, this.sid = e, this.updateCallback = t, this.initialize(e);
      }

      return e.prototype.triggerDelayedStateUpdate = function (e) {
        var t = this;
        this.stateUpdateTimers.push(window.setTimeout(function () {
          t.emitCallback();
        }, e));
      }, e.prototype.stop = function () {
        a.log.debug("ConferenceListener stop " + this.sid), this.lifeCycle === i.ConferenceListenerState.initialized ? (this.map.removeListener("itemAdded", this.itemAdded), this.map.removeListener("itemUpdated", this.itemUpdated), this.map.removeListener("itemRemoved", this.itemRemoved), this.map.close(), this.failedTransferRemoveTimer && window.clearTimeout(this.failedTransferRemoveTimer), this.stateUpdateTimers.forEach(function (e) {
          return window.clearTimeout(e);
        })) : (this.lifeCycle = i.ConferenceListenerState.destroying, a.log.debug("ConferenceListener canceling initialization"));
      }, e.prototype.initOutgoingTransferListeners = function () {
        this.outboundTransfer.source.addListener("attemptFailed", this.updateOutboundTransfer), this.outboundTransfer.source.addListener("completed", this.updateOutboundTransfer), this.outboundTransfer.source.addListener("failed", this.updateOutboundTransfer), this.outboundTransfer.source.addListener("canceled", this.updateOutboundTransfer);
      }, e.prototype.stopOutgoingTransferListeners = function () {
        this.outboundTransfer.source.removeListener("attemptFailed", this.updateOutboundTransfer), this.outboundTransfer.source.removeListener("completed", this.updateOutboundTransfer), this.outboundTransfer.source.removeListener("failed", this.updateOutboundTransfer), this.outboundTransfer.source.removeListener("canceled", this.updateOutboundTransfer);
      }, e.prototype.initOutboundTransfer = function (e) {
        this.outboundTransfer = {
          sid: e.to,
          status: "joined",
          source: e
        }, this.initOutgoingTransferListeners(), this.emitCallback();
      }, e.prototype.unInitOutboundTransfer = function () {
        this.updateOutboundTransfer({
          status: "complete"
        }), this.failedTransferRemoveTimer = 0;
      }, e.prototype.initialize = function (t) {
        return r(this, void 0, void 0, function () {
          var n, r;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a.log.debug("ConferenceListener initialize " + t + " started. " + e.mapQuerySemaphore.nrWaiting() + " waiting on lock"), [4, e.mapQuerySemaphore.acquire()];

              case 1:
                o.sent(), a.log.debug("Lock aquired for " + t + "."), o.label = 2;

              case 2:
                return o.trys.push([2,, 5, 6]), n = this, [4, s.FlexModule.insightsClient.map({
                  id: t + ".CS",
                  mode: "open_existing"
                })];

              case 3:
                return n.map = o.sent(), [4, this.map.getItems()];

              case 4:
                return r = o.sent(), this.children = r.items, this.map.on("itemAdded", this.itemAdded), this.map.on("itemUpdated", this.itemUpdated), this.map.on("itemRemoved", this.itemRemoved), [3, 6];

              case 5:
                return e.mapQuerySemaphore.release(), a.log.debug("Lock released for " + t + "."), [7];

              case 6:
                return this.lifeCycle === i.ConferenceListenerState.destroying ? (a.log.debug("ConferenceListener initialize " + t + " canceled"), this.lifeCycle = i.ConferenceListenerState.initialized, this.stop(), [2]) : (this.lifeCycle = i.ConferenceListenerState.initialized, a.log.debug("ConferenceListener initialize " + t + " finished"), this.emitCallback(), [2]);
            }
          });
        });
      }, e.prototype.emitCallback = function () {
        this.updateCallback && this.updateCallback(this);
      }, e.mapQuerySemaphore = new c.Sema(20), e;
    }();

    t.ConferenceListener = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function () {
      function e(e) {
        this.participants = [], this.sid = e;
      }

      return Object.defineProperty(e.prototype, "liveParticipantCount", {
        get: function get() {
          return this.participants.filter(function (e) {
            return "joined" === e.status && "transfer" !== e.participantType;
          }).length;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "liveWorkerCount", {
        get: function get() {
          return this.liveWorkers.length;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "liveWorkers", {
        get: function get() {
          return this.participants.filter(function (e) {
            return "joined" === e.status && "worker" === e.participantType;
          });
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    t.Conference = r;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(266),
        i = n(40),
        a = n(127);
    t.maxWorkersNumberFromInitialLoad = 200;

    var s = function () {
      function e(e) {
        var t = this;
        this.workerListeners = [], this.onWorkerTasksChanged = function () {
          t.updateCurrentWorkers();
        }, this.insightsClient = e;
      }

      return e.create = function (t, n) {
        return e.Actions = n, new e(t);
      }, e.prototype.getActiveFilterQuery = function () {
        return this.activeFilterQuery;
      }, e.prototype.setActiveFilterQuery = function (e, t) {
        this.activeFilterQuery = e, this.taskFilter = t, this.initInsights();
      }, e.prototype.setStickyWorkerSid = function (t, n) {
        t === this.stickyWorkerSid && n === this.stickyTaskSid || (this.stickyWorkerSid = t, this.stickyTaskSid = n, t ? this.initStickyWorker() : (e.Actions.updateStateStickyWorker(null), this.unInitStickyWorker()));
      }, e.prototype.initInsights = function () {
        var t = this;
        this.unInit();
        var n = this.activeFilterQuery || "";
        e.Actions.startLoadingWorkers(), this.insightsClient.liveQuery("tr-worker", n).then(function (e) {
          t.workersLiveQuery = e, t.loadInitialWorkers(e.getItems()), e.on("itemUpdated", function (e) {
            t.onWorkerItemUpdated(e);
          }), e.on("itemRemoved", function (e) {
            t.onWorkerItemRemoved(e);
          });
        });
      }, e.prototype.unInit = function () {
        this.workersLiveQuery && (this.workersLiveQuery.removeAllListeners(), this.workersLiveQuery.close());
      }, e.prototype.updateCurrentWorkers = function () {
        var t = this.workerListeners.map(function (e) {
          return e.state;
        });
        e.Actions.updateStateWorkers(t);
      }, e.prototype.loadInitialWorkers = function (e) {
        var t = this,
            n = Object.keys(e).map(function (t) {
          return new i.InsightsWorker(e[t]);
        });
        this.workerListeners = this.workerListeners.reduce(function (e, t) {
          var r = n.findIndex(function (e) {
            return e.sid === t.state.worker.sid;
          });
          return r >= 0 ? (t.updateWorker(n[r]), n.splice(r, 1), e.push(t)) : t.unInit(), e;
        }, []), n.forEach(function (e) {
          var n = new o.WorkerListener(e, t.insightsClient, t.onWorkerTasksChanged, t.taskFilter);
          t.workerListeners.push(n);
        }), this.updateCurrentWorkers();
      }, e.prototype.onWorkerItemUpdated = function (e) {
        var n = new i.InsightsWorker(e.value),
            r = this.workerListeners.findIndex(function (e) {
          return e.state.worker.sid === n.sid;
        });
        if (r >= 0) this.workerListeners[r].updateWorker(n);else {
          if (!(this.workerListeners.length < t.maxWorkersNumberFromInitialLoad)) return;
          var a = new o.WorkerListener(n, this.insightsClient, this.onWorkerTasksChanged, this.taskFilter);
          this.workerListeners.push(a);
        }
        this.stickyWorker && n.sid === this.stickyWorker.state.worker.sid && (this.stickyWorker.state.worker = n), this.updateCurrentWorkers();
      }, e.prototype.onWorkerItemRemoved = function (e) {
        var t = this.workerListeners.findIndex(function (t) {
          return t.state.worker.sid === e.key;
        });
        t < 0 || (this.workerListeners[t].unInit(), this.workerListeners.splice(t, 1), this.updateCurrentWorkers());
      }, e.prototype.initStickyWorker = function () {
        var e = this;
        this.unInitStickyWorker();
        var t = a.v4();
        this.lastStickyWorkerQueryUUID = t, this.insightsClient.liveQuery("tr-worker", 'data.worker_sid == "' + this.stickyWorkerSid + '"').then(function (n) {
          e.lastStickyWorkerQueryUUID === t && (e.stickyWorkerLiveQuery = n, e.loadInitialStickyWorker(n.getItems()), n.on("itemUpdated", function (t) {
            e.onStickyWorkerUpdate(t);
          }), n.on("itemRemoved", function () {
            e.onStickyWorkerRemoved();
          }));
        });
      }, e.prototype.unInitStickyWorker = function () {
        this.lastStickyWorkerQueryUUID = "", this.stickyWorkerLiveQuery && (this.stickyWorkerLiveQuery.removeAllListeners(), this.stickyWorkerLiveQuery.close()), this.stickyWorker && (this.stickyWorker.unInit(), this.stickyWorker = null);
      }, e.prototype.loadInitialStickyWorker = function (t) {
        var n = this,
            r = Object.keys(t)[0];

        if (!r && this.stickyWorker && (this.stickyWorker.unInit(), this.stickyWorker = null), r) {
          var a = new i.InsightsWorker(t[r]),
              s = this.taskFilter;
          this.stickyTaskSid && (s = s ? this.taskFilter + ' OR data.reservation_sid=="' + this.stickyTaskSid + '"' : 'data.reservation_sid=="' + this.stickyTaskSid + '"'), this.stickyWorker = a && new o.WorkerListener(a, this.insightsClient, function () {
            return e.Actions.updateStateStickyWorker(n.stickyWorker.state);
          }, s);
        }

        e.Actions.updateStateStickyWorker(this.stickyWorker ? this.stickyWorker.state : null);
      }, e.prototype.onStickyWorkerUpdate = function (t) {
        var n = new i.InsightsWorker(t.value);
        e.Actions.updateStateStickyWorker(r(r({}, this.stickyWorker.state), {
          worker: n
        }));
      }, e.prototype.onStickyWorkerRemoved = function () {
        this.stickyWorker && this.stickyWorker.unInit(), this.stickyWorker = null, e.Actions.updateStateStickyWorker(null);
      }, e;
    }();

    t.SupervisorWorkersListener = s;
  }, function (e, t, n) {
    "use strict";

    var _r16,
        o = this && this.__extends || (_r16 = function r(e, t) {
      return (_r16 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r16(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    },
        s = this && this.__rest || function (e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var c = n(1),
        l = n(0),
        u = n(47),
        p = n(7),
        d = n(3),
        f = n(2),
        h = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.refreshTimer = void 0, t.renderContainer = function () {
          var e = t.props,
              n = e.IconComponent,
              r = (e.ActionsComponent, e.titleLine),
              o = e.firstLine,
              a = e.secondLine,
              f = e.task,
              h = (e.conference, e.contentComponent),
              m = s(e, ["IconComponent", "ActionsComponent", "titleLine", "firstLine", "secondLine", "task", "conference", "contentComponent"]);
          if (h) return h;
          var g = new p.TaskHelper(f),
              y = d.FlexModule.state.supervisor.workers.find(function (e) {
            return e.worker.sid === t.props.task.workerSid;
          });
          !y && d.FlexModule.state.supervisor.stickyWorker && t.props.task.workerSid === d.FlexModule.state.supervisor.stickyWorker.worker.sid && (y = d.FlexModule.state.supervisor.stickyWorker);
          var v = !!y && y.worker;
          return c.createElement(u.InfoContainer, {
            key: "info-container",
            className: "Twilio-TaskDetailsPanel-Info"
          }, !!r && c.createElement(u.TitleLineContainer, {
            className: "Twilio-TaskDetailsPanel-TitleLine"
          }, c.createElement(l.Template, {
            code: r,
            task: f,
            helper: g,
            worker: v
          })), !!n && c.createElement(u.IconContainer, {
            className: "Twilio-TaskDetailsPanel-Icon"
          }, c.createElement(n, i({
            task: f
          }, m))), !!o && c.createElement(u.FirstLineContainer, {
            className: "Twilio-TaskDetailsPanel-FirstLine"
          }, c.createElement(l.Template, {
            code: o,
            task: f,
            helper: g,
            worker: v
          })), !!a && c.createElement(u.SecondLineContainer, {
            className: "Twilio-TaskDetailsPanel-SecondLine"
          }, c.createElement(l.Template, {
            code: a,
            task: f,
            helper: g,
            worker: v
          })));
        }, t;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        var e = this;
        this.refreshTimer = window.setInterval(function () {
          return e.forceUpdate();
        }, 1e3);
      }, t.prototype.componentWillUnmount = function () {
        void 0 !== this.refreshTimer && window.clearInterval(this.refreshTimer);
      }, t.prototype.render = function () {
        var e = this.props,
            t = e.content,
            n = e.ActionsComponent,
            r = e.task,
            o = s(e, ["content", "ActionsComponent", "task"]);
        return c.createElement(l.DynamicComponent, {
          contentStore: t,
          childProps: this.props,
          name: t.name,
          customChildren: this.props.children,
          vertical: !0
        }, c.createElement(u.Container, {
          className: "Twilio-TaskDetailsPanel-Container"
        }, c.createElement(u.ContentContainer, {
          className: "Twilio-TaskDetailsPanel-Content",
          key: "container"
        }, this.renderContainer()), c.createElement(u.ButtonContainer, {
          key: "button-container",
          className: "Twilio-TaskDetailsPanel-Buttons"
        }, !!n && c.createElement(n, i({
          task: r
        }, o)))));
      }, t = a([f.withTheme], t);
    }(c.PureComponent);

    t.TaskDetailsPanel = h;
  }, function (e, t) {
    e.exports = require("hoist-non-react-statics");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(141);
    t.ParticipantsCanvas = r.ParticipantsCanvas;
    var o = n(276);
    t.ParticipantsCanvasProps = o.ParticipantsCanvasProps;
  }, function (e, t, n) {
    "use strict";

    var _r17,
        o = this && this.__extends || (_r17 = function r(e, t) {
      return (_r17 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r17(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(14),
        c = n(271),
        l = n(2),
        u = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return a.createElement(t.Connected, i({}, this.props));
      }, n.displayName = c.displayName, n.Content = c.contentStore, n;
    }(a.PureComponent);

    t.ParticipantsCanvas = u, t.Connected = l.withTheme(s.withTaskContext(c.ParticipantsCanvasImpl));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(273);
    t.ParticipantCanvas = r.ParticipantCanvas;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(144);
    t.TaskCanvas = r.TaskCanvas, t.TaskCanvasChildrenProps = r.TaskCanvasChildrenProps, t.TaskCanvasThemeProps = r.TaskCanvasThemeProps;
    var o = n(85);
    t.TaskCanvasTabs = o.TaskCanvasTabs;
    var i = n(155);
    t.TaskInfoPanel = i.TaskInfoPanel;
    var a = n(89);
    t.TaskCanvasHeader = a.TaskCanvasHeader;
  }, function (e, t, n) {
    "use strict";

    var _r18,
        o = this && this.__extends || (_r18 = function r(e, t) {
      return (_r18 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r18(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(9),
        c = n(85),
        l = n(89),
        u = n(311),
        p = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return a.createElement(t.Connected, i({}, this.props));
      }, n.displayName = u.displayName, n.Content = u.contentStore, n.Header = l.TaskCanvasHeader, n.Tabs = c.TaskCanvasTabs, n;
    }(a.PureComponent);

    t.TaskCanvas = p, t.Connected = s.withTaskContext(u.TaskCanvasImpl);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(60);
    t.TaskCanvasTabs = r.TaskCanvasTabs;
    var o = n(305);
    t.TaskCanvasTabsChildrenProps = o.TaskCanvasTabsChildrenProps;
    var i = n(146);
    t.getThemeForChat = i.getThemeForChat;
  }, function (e, t, n) {
    "use strict";

    var _r19,
        o = this && this.__extends || (_r19 = function r(e, t) {
      return (_r19 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r19(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        a = n(12),
        s = n(7),
        c = n(0),
        l = n(4),
        u = n(147),
        p = n(151),
        d = n(87),
        f = n(36),
        h = n(60),
        m = n(6),
        g = n(88);
    t.displayName = "TaskCanvasTabs", t.contentStore = new c.DynamicContentStore(t.displayName);

    var y = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleTabSelection = function (e) {
          m.tryInvokeAction("SetComponentState", {
            name: "AgentTaskCanvasTabs",
            state: {
              selectedTabName: e
            }
          });
        }, t;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props,
            n = e.task,
            r = e.selectedTabName,
            o = a.TaskChannels.getForTask(n),
            f = s.TaskHelper.isPending(n),
            m = s.TaskHelper.isInitialOutboundAttemptTask(n),
            y = o.templates.TaskCanvasTabs && o.templates.TaskCanvasTabs.contentTabHeader || "";
        return i.createElement(c.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0,
          vertical: !0
        }, i.createElement(c.Tabs, {
          className: "Twilio-TaskCanvasTabs",
          selectedTabName: r,
          onTabSelected: this.handleTabSelection
        }, i.createElement(c.Tab, {
          key: "outbound",
          uniqueName: "outbound",
          label: i.createElement(c.Template, {
            code: a.TaskChannelHelper.getTemplateForStatus(n, y, h.TaskCanvasTabs)
          }),
          hidden: !f || !m
        }, i.createElement(g.ConnectingOutboundCallCanvas, null)), i.createElement(c.Tab, {
          key: "incoming",
          uniqueName: "incoming",
          label: i.createElement(c.Template, {
            source: l.templates.TaskTabAgentIncomingLabel
          }),
          hidden: !f || m
        }, i.createElement(u.IncomingTaskCanvas, null)), i.createElement(c.Tab, {
          key: "call",
          uniqueName: "call",
          label: i.createElement(c.Template, {
            code: a.TaskChannelHelper.getTemplateForStatus(n, y, h.TaskCanvasTabs)
          }),
          hidden: !s.TaskHelper.isCallTask(n) || f
        }, i.createElement(p.CallCanvas, null)), i.createElement(c.Tab, {
          key: "chat",
          uniqueName: "chat",
          label: i.createElement(c.Template, {
            code: a.TaskChannelHelper.getTemplateForStatus(n, y, h.TaskCanvasTabs)
          }),
          hidden: !s.TaskHelper.isChatBasedTask(n) || f
        }, !!this.props.task && this.renderChat(a.TaskChannelHelper.getColor(n, o.colors.main, h.TaskCanvasTabs))), i.createElement(c.Tab, {
          key: "info",
          uniqueName: "info",
          label: i.createElement(c.Template, {
            source: l.templates.TaskTabAgentInfoLabel
          })
        }, i.createElement(d.TaskInfoPanel, null))));
      }, n.prototype.renderChat = function (e) {
        var t = this.props.task,
            n = this.props,
            r = n.channelDefinition,
            o = r.charLimit,
            a = r.componentProps,
            u = n.hasMarkdownSupport,
            p = v(e);
        return i.createElement(f.ThemeProvider, {
          theme: p
        }, i.createElement(c.MessagingCanvas, {
          sid: s.TaskHelper.getTaskChatChannelSid(t),
          charLimit: o,
          inputDisabledReason: s.TaskHelper.isCompleted(t) || s.TaskHelper.isInWrapupMode(t) ? l.templates.ChatInputDisabledText() : void 0,
          welcomeMessageText: l.templates.ChatWelcomeText,
          predefinedMessage: a.MessagingCanvas && a.MessagingCanvas.predefinedMessage,
          hasMarkdownSupport: u
        }));
      }, n;
    }(i.PureComponent);

    function v(e) {
      return function (t) {
        return e ? c.Utils.merge(t, {
          Chat: {
            MessageInput: {
              Button: {
                background: e
              }
            },
            MessageListItem: {
              FromMe: {
                Bubble: {
                  background: e
                }
              }
            },
            WelcomeMessage: {
              Icon: {
                color: e
              }
            }
          }
        }) : t;
      };
    }

    t.TaskCanvasTabsImpl = y, t.getThemeForChat = v;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(148);
    t.IncomingTaskCanvas = r.IncomingTaskCanvas;
    var o = n(282);
    t.IncomingTaskCanvasProps = o.IncomingTaskCanvasProps;
    var i = n(150);
    t.IncomingTaskIcon = i.IncomingTaskIcon;
    var a = n(149);
    t.IncomingTaskCanvasActions = a.IncomingTaskCanvasActions;
  }, function (e, t, n) {
    "use strict";

    var _r20,
        o = this && this.__extends || (_r20 = function r(e, t) {
      return (_r20 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r20(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(9),
        c = n(279),
        l = n(2),
        u = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return a.createElement(t.Connected, i({}, this.props));
      }, n.friendlyName = c.displayName, n.displayName = c.displayName, n.Content = c.contentStore, n;
    }(a.PureComponent);

    t.IncomingTaskCanvas = u, t.Connected = l.withTheme(s.withTaskContext(c.IncomingTaskCanvasImpl));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(280);
    t.IncomingTaskCanvasActions = r.IncomingTaskCanvasActions;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(281);
    t.IncomingTaskIcon = r.IncomingTaskIcon;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(152);
    t.CallCanvas = r.CallCanvas;
    var o = n(297);
    t.CallCanvasChildrenProps = o.CallCanvasChildrenProps, function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(153));
  }, function (e, t, n) {
    "use strict";

    var _r21,
        o = this && this.__extends || (_r21 = function r(e, t) {
      return (_r21 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r21(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(14),
        c = n(283),
        l = n(2),
        u = n(3),
        p = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return a.createElement(t.Connected, i({}, this.props));
      }, n.friendlyName = c.displayName, n.displayName = c.displayName, n.Content = c.contentStore, n;
    }(a.PureComponent);

    t.CallCanvas = p, t.Connected = s.withTaskContext(u.connect(function (e, t) {
      return {
        dialpadState: e.view.componentViewStates["CallCanvasDialpad" + t.task.sid]
      };
    })(l.withTheme(c.CallCanvasImpl)));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(287);
    t.CallCanvasActions = r.CallCanvasActions;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(302);
    t.ConnectingOutboundCallCanvasActions = r.ConnectingOutboundCallCanvasActions;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(306);
    t.TaskInfoPanel = r.TaskInfoPanel;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(87);
    t.TaskInfoPanel = r.TaskInfoPanel;
    var o = n(307);
    t.TaskInfoPanelProps = o.TaskInfoPanelProps;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(312);
    t.TeamFiltersPanel = r.TeamFiltersPanel, t.TeamFiltersPanelProps = r.TeamFiltersPanelProps, t.FilterData = r.FilterData;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getTaskWaitingAgeFromTimestamp = function (e) {
      return e ? Date.now() - new Date(e).getTime() : 0;
    };
  }, function (e, t, n) {
    "use strict";

    var _r22,
        o = this && this.__extends || (_r22 = function r(e, t) {
      return (_r22 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r22(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(160),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.tick = function () {
          t.forceUpdate();
        }, t;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        a.addTickListener(this.tick);
      }, t.prototype.componentWillUnmount = function () {
        a.removeTickListener(this.tick);
      }, t.prototype.render = function () {
        return this.props.children();
      }, t;
    }(i.Component);

    t.Ticker = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = new (n(328))();
    window.setInterval(function () {
      return r.emit("tick");
    }, 1e3), t.addTickListener = function (e) {
      return r.on.call(r, "tick", e);
    }, t.removeTickListener = function (e) {
      return r.off.call(r, "tick", e);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(162);
    t.Controller = r.InsightsController;
    var o = n(44);
    t.ServiceStatus = o.InsightsServiceStatus;
    var i = n(333);
    t.Player = i;
  }, function (e, t, n) {
    "use strict";

    var _r23,
        o = this && this.__extends || (_r23 = function r(e, t) {
      return (_r23 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r23(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(3),
        s = n(45),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return this.props.children({
          status: this.props.status,
          client: s.InsightsService.getInstance().identityClient
        });
      }, t;
    }(i.PureComponent);

    t.InsightsControllerComponent = c, t.InsightsController = a.connect(function (e) {
      return {
        status: e.session.insightsServiceStatus
      };
    })(c);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(335);
    t.NoTasksCanvas = r.NoTasksCanvas;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(338);
    t.TaskCanvas = r.TaskCanvas;
    var o = n(346);
    t.TaskCanvasChildrenProps = o.TaskCanvasChildrenProps;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(166);
    t.UserControls = r.UserControls, t.UserControlsImplProps = r.UserControlsImplProps;
    var o = n(353);
    t.MainHeader = o.MainHeader;
    var i = n(366);
    t.MainHeaderProps = i.MainHeaderProps, t.MainHeaderChildrenProps = i.MainHeaderChildrenProps, function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(169));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(349);
    t.UserControls = r.UserControls, t.UserControlsChildrenProps = r.UserControlsChildrenProps, t.UserControlsImplProps = r.UserControlsChildrenProps;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c = n(0),
        l = n(2);
    t.Container = l.default("div")(o || (o = r(["\n    padding-left: 8px;\n    height: 44px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex: 0 0 auto;\n    border-style: solid;\n    border-width: 0 0 1px 0;\n    overflow: hidden;\n    ", "\n"], ["\n    padding-left: 8px;\n    height: 44px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex: 0 0 auto;\n    border-style: solid;\n    border-width: 0 0 1px 0;\n    overflow: hidden;\n    ", "\n"])), function (e) {
      return e.theme.MainHeader.Container;
    }), t.HeaderLogoImage = l.default("img")(i || (i = r(["\n    margin-left: 12px;\n    margin-top: auto;\n    margin-bottom: auto;\n    display: block;\n    max-width: 240px;\n    max-height: 36px;\n    width: auto;\n    height: auto;\n"], ["\n    margin-left: 12px;\n    margin-top: auto;\n    margin-bottom: auto;\n    display: block;\n    max-width: 240px;\n    max-height: 36px;\n    width: auto;\n    height: auto;\n"]))), t.StyledIconContainer = l.default("div")(a || (a = r(["\n    display: flex;\n    align-items: center;\n    position: relative;\n    background: ", ";\n    &:hover {\n        // Hack to change outer circle color on hover\n        & .Twilio-Main-Header-IconButton,\n        & .Twilio-Badge-OuterCircle {\n            cursor: pointer;\n            ", "\n        }\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    position: relative;\n    background: ", ";\n    &:hover {\n        // Hack to change outer circle color on hover\n        & .Twilio-Main-Header-IconButton,\n        & .Twilio-Badge-OuterCircle {\n            cursor: pointer;\n            ", "\n        }\n    }\n"])), function (e) {
      return e.theme.MainHeader.Container.background;
    }, function (e) {
      return c.getBackgroundWithHoverCSS(e.theme.MainHeader.Container.background, e.theme.MainHeader.Button.lightHover, !0);
    }), t.StyledIconButton = l.default(c.IconButton)(s || (s = r(["\n    margin-right: 8px;\n"], ["\n    margin-right: 8px;\n"])));
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r(n(77)), r(n(363));
    var o = n(84);
    t.ConferenceParticipant = o.ConferenceParticipant;
    var i = n(80);
    t.FLEX_LOCATION_CHANGE = i.FLEX_LOCATION_CHANGE;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(364));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(94);
    t.TaskList = r.TaskList, t.TaskListProps = r.TaskListProps;
    var o = n(174);
    t.TaskListBaseItem = o.TaskListBaseItem;
    var i = n(172);
    t.TaskListFilter = i.TaskListFilter, t.TaskListFilterProps = i.TaskListFilterProps;
    var a = n(173);
    t.TaskListItem = a.TaskListItem, t.TaskListItemProps = a.TaskListItemProps;
  }, function (e, t, n) {
    "use strict";

    var _r24,
        o = this && this.__extends || (_r24 = function r(e, t) {
      return (_r24 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r24(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    },
        s = this && this.__metadata || function (e, t) {
      if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var c = n(2),
        l = n(1),
        u = n(0),
        p = n(172),
        d = n(372),
        f = n(9),
        h = n(173),
        m = n(94),
        g = {
      from: {
        transform: "translateY(-45px)"
      },
      to: {
        transform: ""
      }
    };
    t.displayName = "TaskList", t.contentStore = new u.DynamicContentStore(t.displayName), t.TaskListContext = l.createContext(void 0);

    var y = function (e) {
      function n(t) {
        var n = e.call(this, t) || this;
        return n._isFilterChanging = !1, n.handleFilterChange = function (e) {
          n._isFilterChanging = !0, n.setState({
            selectedFilter: e
          }, function () {
            n._isFilterChanging = !1;
          }), n.props.onFilterChange && n.props.onFilterChange(e);
        }, n.state = i(i({}, t), {
          onFilterChange: n.handleFilterChange,
          selectedFilter: t.filters && t.filters.length > 0 && t.filters[0] || null
        }), n;
      }

      var r;
      return o(n, e), n.getDerivedStateFromProps = function (e, t) {
        return i(i({}, t), e);
      }, n.prototype.render = function () {
        var e = this,
            n = this.props,
            r = n.tasks,
            o = n.staticFilter,
            i = this.state,
            a = i.compareFunction,
            s = i.selectedFilter,
            c = Array.from(r.values()),
            f = o ? c.filter(function (e) {
          return o(e);
        }).sort(function (e, t) {
          return a(e, t);
        }).map(function (t) {
          return e.createTaskListItem(t);
        }) : [],
            h = c.filter(function (e) {
          return s.callback(e) && !o(e);
        }).sort(function (e, t) {
          return a(e, t);
        }).map(function (t) {
          return e.createTaskListItem(t);
        }),
            m = f.concat(l.createElement(p.TaskListFilter, {
          key: "TaskListFilter",
          filters: this.state.filters,
          value: this.state.selectedFilter
        })).concat(h);
        return l.createElement(t.TaskListContext.Provider, {
          value: this.state
        }, l.createElement(u.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.state,
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, l.createElement(u.FlexBox, {
          vertical: !0,
          noShrink: !0
        }, l.createElement(d.default, {
          key: "contents",
          easing: "ease-in",
          disableAllAnimations: this._isFilterChanging,
          duration: 300,
          appearAnimation: "fade",
          enterAnimation: g,
          leaveAnimation: "none"
        }, m))));
      }, n.prototype.createTaskListItem = function (e) {
        return l.createElement(f.TaskContextSource, {
          key: e.sid,
          taskSid: e.sid
        }, l.createElement(h.TaskListItem, {
          selectedTaskSid: this.state.selectedTaskSid,
          onSelected: this.props.onTaskSelected
        }));
      }, n = a([c.withTheme, s("design:paramtypes", ["function" == typeof (r = void 0 !== m.TaskListProps && m.TaskListProps) ? r : Object])], n);
    }(l.PureComponent);

    t.TaskListImpl = y;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(367);
    t.TaskListFilterProps = r.TaskListFilterProps, t.TaskListFilter = r.TaskListFilter;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(373);
    t.TaskListItem = r.TaskListItem;
    var o = n(386);
    t.TaskListItemChildrenProps = o.TaskListItemChildrenProps, t.TaskListItemProps = o.TaskListItemProps;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(175);
    t.TaskListBaseItem = r.TaskListBaseItem;
  }, function (e, t, n) {
    "use strict";

    var _r25,
        o = this && this.__extends || (_r25 = function r(e, t) {
      return (_r25 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r25(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(9),
        c = n(375);
    !function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(176));

    var l = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return a.createElement(t.Connected, i({}, this.props));
      }, n.displayName = "TaskListBaseItem", n;
    }(a.PureComponent);

    t.TaskListBaseItem = l, t.Connected = s.withTaskContext(c.TaskListBaseItemImpl);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u,
        p,
        d,
        f,
        h = n(0),
        m = n(2);
    t.TaskListIcon = m.default(h.Icon)(o || (o = r(["\n    flex: 0 0 44px;\n    ", "\n"], ["\n    flex: 0 0 44px;\n    ", "\n"])), function (e) {
      return e.theme.TaskList.Item.Icon;
    }), t.Container = m.default("div")(i || (i = r(["\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: ", ";\n    user-select: none;\n    height: 44px;\n    border-style: solid;\n    border-width: 0 0 1px 0;\n    overflow-y: hidden;\n    cursor: pointer;\n    height: ", ";\n\n    ", "\n    ", "\n    ", "\n    ", "\n    & .Twilio-TaskListBaseItem-IconAreaContainer {\n        background: ", ";\n    };\n    &:hover {\n        // Hack to change outer circle color on hover\n        & .Twilio-TaskListBaseItem-IconAreaContainer, & .Twilio-Badge-OuterCircle {\n            ", ";\n            }\n        }"], ["\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: ", ";\n    user-select: none;\n    height: 44px;\n    border-style: solid;\n    border-width: 0 0 1px 0;\n    overflow-y: hidden;\n    cursor: pointer;\n    height: ", ";\n\n    ", "\n    ", "\n    ", "\n    ", "\n    & .Twilio-TaskListBaseItem-IconAreaContainer {\n        background: ", ";\n    };\n    &:hover {\n        // Hack to change outer circle color on hover\n        & .Twilio-TaskListBaseItem-IconAreaContainer, & .Twilio-Badge-OuterCircle {\n            ", ";\n            }\n        }"])), function (e) {
      return e.vertical ? "column" : "row";
    }, function (e) {
      return e.large ? "200px" : "44px";
    }, function (e) {
      return e.theme.TaskList.Item.Container;
    }, function (e) {
      return e.selected ? e.theme.TaskList.Item.SelectedContainer : {};
    }, function (e) {
      return h.getBackgroundWithHoverCSS(e.theme.TaskList.Item.Container.background, e.theme.TaskList.Item.Container.lightHover);
    }, function (e) {
      return e.selected ? h.getBackgroundWithHoverCSS(e.theme.TaskList.Item.SelectedContainer.background, e.theme.TaskList.Item.SelectedContainer.lightHover) : {};
    }, function (e) {
      return e.iconColor;
    }, function (e) {
      return e.iconColor && h.getBackgroundWithHoverCSS(e.iconColor, !1, !0);
    }), t.UpperArea = m.default("div")(a || (a = r(["\n    height: 44px;\n    display: flex;\n    flex: auto 0 0;\n"], ["\n    height: 44px;\n    display: flex;\n    flex: auto 0 0;\n"]))), t.Content = m.default("div")(s || (s = r(["\n    flex: 1 1 auto;\n    overflow: hidden;\n"], ["\n    flex: 1 1 auto;\n    overflow: hidden;\n"]))), t.LowerArea = m.default("div")(c || (c = r(["\n    display: flex;\n    height: 156px;\n\n    p {\n        overflow-y: hidden;\n        text-overflow: ellipsis;\n    }\n\n    div {\n        width: 100%;\n        height: 100%;\n    }\n\n    iframe {\n        width: 100%;\n        height: 100%;\n    }\n"], ["\n    display: flex;\n    height: 156px;\n\n    p {\n        overflow-y: hidden;\n        text-overflow: ellipsis;\n    }\n\n    div {\n        width: 100%;\n        height: 100%;\n    }\n\n    iframe {\n        width: 100%;\n        height: 100%;\n    }\n"]))), t.ActionsContainer = m.default("div")(l || (l = r(["\n    height: 44px;\n    flex: 0 0 auto;\n    display: flex;\n    margin-right: 8px;\n\n    button {\n        margin-left: 4px;\n        margin-right: 4px;\n    }\n"], ["\n    height: 44px;\n    flex: 0 0 auto;\n    display: flex;\n    margin-right: 8px;\n\n    button {\n        margin-left: 4px;\n        margin-right: 4px;\n    }\n"]))), t.SecondLineContainer = m.default("div")(u || (u = r(["\n    font-size: 10px;\n    margin: 1px 4px 4px 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"], ["\n    font-size: 10px;\n    margin: 1px 4px 4px 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"]))), t.SecondLineStyledTemplate = m.default(h.Template)(p || (p = r(["\n    display: inline-flex;\n    align-items: center;\n    .Twilio-Template-Icon {\n        margin-right: 4px;\n    }\n"], ["\n    display: inline-flex;\n    align-items: center;\n    .Twilio-Template-Icon {\n        margin-right: 4px;\n    }\n"]))), t.FirstLineContainer = m.default("div")(d || (d = r(["\n    font-size: 12px;\n    font-weight: bold;\n    margin: 4px 4px 0px 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"], ["\n    font-size: 12px;\n    font-weight: bold;\n    margin: 4px 4px 0px 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"]))), t.IconAreaContainer = m.default("div")(f || (f = r(["\n    position: relative;\n    flex: 0 0 44px;\n    display: flex;\n"], ["\n    position: relative;\n    flex: 0 0 44px;\n    display: flex;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(376);
    t.TaskListButtons = r.TaskListButtons;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(388);
    t.AgentDesktopView = r.AgentDesktopView, t.AgentDesktopViewProps = r.AgentDesktopViewProps, t.AgentDesktopViewChildrenProps = r.AgentDesktopViewChildrenProps;
    var o = n(180);
    t.SplitterOrientation = o.SplitterOrientation;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(180);
    t.Panel1 = r.Panel1;
  }, function (e, t, n) {
    "use strict";

    var _r26,
        o = this && this.__extends || (_r26 = function r(e, t) {
      return (_r26 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r26(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s,
        c = n(1),
        l = n(0),
        u = n(3),
        p = n(24),
        d = n(181),
        f = n(164),
        h = n(163),
        m = n(182),
        g = n(401),
        y = n(404),
        v = n(6);
    !function (e) {
      e.auto = "auto", e.vertical = "vertical", e.horizontal = "horizontal";
    }(s = t.SplitterOrientation || (t.SplitterOrientation = {}));

    var b = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleResize = function (e) {
          setTimeout(function () {
            t.forceUpdate();
          }, 0);
        }, t.handleParentSplitterChange = function () {
          setTimeout(function () {
            t.forceUpdate();
          }, 0);
        }, t.handleSelectedViewChanged = function (e, n) {
          n || setTimeout(function () {
            t.forceUpdate();
          }, 0);
        }, t.makeInnerRef = function (e) {
          t.container = e;
        }, t.handleTaskSelected = function (e) {
          v.tryInvokeAction("SelectTask", {
            sid: e
          });
        }, t;
      }

      var n;
      return o(t, e), n = t, t.prototype.componentDidMount = function () {
        var e = this;
        u.FlexModule.events.addListener(p.FlexEvent.flexSplitterResize, this.handleParentSplitterChange), u.FlexModule.events.addListener(p.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged), u.FlexModule.events.addListener(p.FlexEvent.viewResized, this.handleResize), setTimeout(function () {
          return e.forceUpdate();
        }, 1);
      }, t.prototype.componentWillUnmount = function () {
        u.FlexModule.events.removeListener(p.FlexEvent.flexSplitterResize, this.handleParentSplitterChange), u.FlexModule.events.removeListener(p.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged), u.FlexModule.events.removeListener(p.FlexEvent.viewResized, this.handleResize);
      }, t.prototype.render = function () {
        var e = !0;

        switch (this.props.splitterOrientation) {
          case s.auto:
            if (this.container) e = this.container.getBoundingClientRect().width < 552;
            break;

          default:
            e = this.props.splitterOrientation === s.vertical;
        }

        return c.createElement(l.DynamicComponent, {
          name: n.friendlyName,
          contentStore: n.Content,
          childProps: this.props,
          customChildren: this.props.children,
          vertical: !0
        }, c.createElement(y.LeftPanelRootContainer, i({}, this.props, {
          innerRef: this.makeInnerRef
        }), this.props.tasks.size > 0 ? c.createElement(g.ContentSplitter, {
          key: "splitter",
          vertical: e
        }, c.createElement(d.TaskListContainer, {
          tasks: this.props.tasks,
          selectedTaskSid: this.props.selectedTaskSid,
          onTaskSelected: this.handleTaskSelected
        }), c.createElement(f.TaskCanvas, {
          key: "taskCanvas"
        })) : c.createElement(h.NoTasksCanvas, {
          key: "no-tasks"
        }), c.createElement(m.WorkerDirectory, {
          key: "worker-directory"
        })));
      }, t.friendlyName = "AgentDesktopView.Panel1", t.displayName = n.friendlyName, t.Content = new l.DynamicContentStore(n.friendlyName), t.defaultProps = {
        splitterOrientation: s.auto
      }, t = n = a([l.withDefaultPropsUpdate], t);
    }(c.Component);

    t.Panel1 = b;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(389);
    t.TaskListContainer = r.TaskListContainer, t.TaskListContainerProps = r.TaskListContainerProps;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(392);
    t.WorkerDirectory = r.WorkerDirectory, t.WorkerDirectoryProps = r.WorkerDirectoryProps, t.WorkerDirectoryChildrenProps = r.WorkerDirectoryChildrenProps;
    var o = n(95);
    t.WorkerDirectoryTabs = o.WorkerDirectoryTabs, t.WorkerDirectoryTabsProps = o.WorkerDirectoryTabsProps;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(405);
    t.Panel2 = r.Panel2;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(406);
    t.CRMContainer = r.CRMContainer, t.CRMContainerProps = r.CRMContainerProps, t.CRMContainerChildrenProps = r.CRMContainerChildrenProps;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2);
    t.Container = i.default("div")(o || (o = r(["\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 auto;\n    border-style: solid;\n    border-width: 0 0 0 1px;\n    ", "\n\n    iframe {\n        border: none;\n        display: flex;\n        flex: 1 0 auto;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 auto;\n    border-style: solid;\n    border-width: 0 0 0 1px;\n    ", "\n\n    iframe {\n        border: none;\n        display: flex;\n        flex: 1 0 auto;\n    }\n"])), function (e) {
      return e.theme.CRMContainer.Container;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l = n(0),
        u = n(2);
    t.Container = u.default("div")(o || (o = r(["\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1 0 auto;\n    justify-content: center;\n    ", "\n"], ["\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1 0 auto;\n    justify-content: center;\n    ", "\n"])), function (e) {
      return e.theme.LoginView.Container;
    }), t.LogoContainer = u.default("div")(i || (i = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.LoginView.Logo;
    }), t.ControlsContainer = u.default("div")(a || (a = r(["\n    margin-top: 29px;\n    text-align: center;\n"], ["\n    margin-top: 29px;\n    text-align: center;\n"]))), t.LoginButton = u.default(l.Button)(s || (s = r(["\n    margin-top: 28px;\n    padding-left: 16px;\n    padding-right: 16px;\n"], ["\n    margin-top: 28px;\n    padding-left: 16px;\n    padding-right: 16px;\n"]))), t.LoadingContainer = u.default("div")(c || (c = r(["\n    margin-top: 34px;\n    font-size: 12px;\n    font-weight: 600;\n"], ["\n    margin-top: 34px;\n    font-size: 12px;\n    font-weight: 600;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r27,
        o = this && this.__extends || (_r27 = function r(e, t) {
      return (_r27 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r27(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(53),
        c = n(76),
        l = n(420),
        u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return a.createElement(s.StorelessThemeProvider, {
          themeConf: {
            baseName: "BlueDarkTheme"
          }
        }, a.createElement(l.LoginFormViewImpl, i({}, this.props)));
      }, t.defaultProps = {
        userConfig: {},
        initialRuntimeDomain: c.parseRuntimeDomainFromPathName() || "",
        userLoggedOut: !1
      }, t;
    }(a.Component);

    t.LoginFormView = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(422);
    t.LogoWithCircle = r.LogoWithCircle;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(423);
    t.LoginLogo = r.LoginLogo;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(191);
    t.TeamsView = r.TeamsView, t.FilterDefinitionFactory = r.FilterDefinitionFactory;
  }, function (e, t, n) {
    "use strict";

    var _r28,
        o = this && this.__extends || (_r28 = function r(e, t) {
      return (_r28 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r28(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s,
        c = n(1),
        l = n(63),
        u = n(3),
        p = n(16),
        d = n(2),
        f = n(426),
        h = n(0),
        m = n(27),
        g = n(19);
    !function (e) {
      e.search = "teams-view-search", e.filter = "teams-view-filter";
    }(s = t.FiltersType || (t.FiltersType = {}));

    var y = function (e) {
      function n() {
        var n = null !== e && e.apply(this, arguments) || this;
        return n.getBaseRoute = function () {
          return n.props.route.match && n.props.route.match.url.replace(/\/$/, "");
        }, n.renderChildrenFromRoute = function (e) {
          return c.createElement(t.Connected, i({}, n.props, {
            route: e
          }));
        }, n;
      }

      var r;
      return o(n, e), r = n, n.prototype.componentDidMount = function () {
        r.defaultProps.filtersEnabled && console.warn("`TeamsView.defaultProps.filtersEnabled` will be deprecated in flex-ui version 1.19. To toggle Advance Team View Filters on/off, please use the pilot flag on the feature page https://flex.twilio.com/admin/features");
      }, n.prototype.render = function () {
        var e = this.getBaseRoute();
        return c.createElement(l.Route, {
          path: e + "/:resource?/:sid?",
          children: this.renderChildrenFromRoute
        });
      }, n.displayName = f.displayName, n.Content = f.contentStore, n.activitiesFilter = function (e) {
        var t = Array.from(e.worker.activities).map(function (e) {
          return {
            value: e[1].name,
            label: e[1].name,
            default: !1
          };
        });
        return {
          id: "data.activity_name",
          fieldName: "activity_name",
          type: h.FiltersListItemType.multiValue,
          title: "Activities",
          options: t
        };
      }, n.defaultProps = {
        filters: [r.activitiesFilter]
      }, n = r = a([h.withDefaultPropsUpdate], n);
    }(c.PureComponent);

    t.TeamsView = y, t.Connected = u.connect(function (e, t) {
      var n;
      e.view.filters[s.search] ? n = e.view.filters[s.search] : e.view.filters[s.filter] && (n = e.view.filters[s.filter]);
      var r = m.featureFlagsSelector(e)[g.FeatureFlag.AdvancedTeamsViewFilters];
      return {
        appliedFilters: n,
        filtersEnabled: r && r.enabled || t.filtersEnabled,
        monitoredTaskSid: e.supervisor.callMonitoring.status === p.CallMonitoringStatus.monitoring ? e.supervisor.callMonitoring.task.taskSid : "",
        workers: e.supervisor.workers,
        stickyWorker: e.supervisor.stickyWorker,
        isLoadingWorkers: e.supervisor.isLoadingWorkers,
        filters: t.filters.map(function (n) {
          return "function" == typeof n ? n(e, t) : n;
        }).filter(function (e) {
          return !!e;
        })
      };
    })(d.withTheme(f.TeamsViewImpl));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(427);
    t.WorkersDataTable = r.WorkersDataTable, t.WorkersDataTableProps = r.WorkersDataTableProps, t.ColumnDataCreationContext = r.ColumnDataCreationContext, t.WorkerListFilter = r.WorkerListFilter, t.defaultCompareFunction = r.defaultCompareFunction;
  }, function (e, t, n) {
    "use strict";

    var _r29,
        o = this && this.__extends || (_r29 = function r(e, t) {
      return (_r29 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r29(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(194),
        c = n(98),
        l = n(196),
        u = function u(e, t) {
      var n = e.dateUpdated.getTime();
      return t.dateUpdated.getTime() - n;
    },
        p = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this,
            n = this.props,
            r = n.tasks,
            o = n.filter,
            u = n.compareFunction,
            p = Array.from(r).filter(function (e) {
          return !o || o(e);
        });
        return 0 === p.length ? i.createElement(c.TaskCardPlaceholder, null) : i.createElement(a.DynamicComponent, {
          contentStore: t.Content,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          subContainer: i.createElement(a.FlexBox, {
            allowWrap: !0
          })
        }, i.createElement(a.FlexBox, {
          className: "Twilio-TaskCardList-Container"
        }, p.sort(u).map(function (t) {
          return i.createElement(l.SupervisorTaskContextSource, {
            taskSid: t.sid,
            key: t.sid
          }, i.createElement(s.TaskCard, {
            selected: e.props.selectedTaskSid === t.sid,
            highlighted: e.props.highlightedTaskSid === t.taskSid,
            onClick: e.props.onCardSelected
          }));
        })));
      }, t.displayName = "TaskCardList", t.Content = new a.DynamicContentStore(t.displayName), t.defaultProps = {
        compareFunction: u
      }, t;
    }(i.Component);

    t.TaskCardList = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(195);
    t.TaskCard = r.TaskCard;
    var o = n(436);
    t.TaskCardProps = o.TaskCardProps, t.TaskCardChildrenProps = o.TaskCardChildrenProps;
  }, function (e, t, n) {
    "use strict";

    var _r30,
        o = this && this.__extends || (_r30 = function r(e, t) {
      return (_r30 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r30(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(9),
        c = n(432),
        l = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return a.createElement(t.Connected, i({}, this.props));
      }, n.displayName = c.displayName, n.Content = c.contentStore, n;
    }(a.PureComponent);

    t.TaskCard = l, t.Connected = s.withTaskContext(c.TaskCardImpl);
  }, function (e, t, n) {
    "use strict";

    var _r31,
        o = this && this.__extends || (_r31 = function r(e, t) {
      return (_r31 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r31(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    },
        a = this && this.__rest || function (e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(14),
        l = n(12),
        u = n(3),
        p = n(7),
        d = n(97),
        f = function f(e, t) {
      var n,
          r = d.SupervisorStateHelper.getTaskBySid(t.taskSid);
      return p.TaskHelper.isCallTask(r) && (n = e.conferences.states.get(r.taskSid)), {
        task: r,
        conference: n,
        chatChannel: r && p.TaskHelper.isChatBasedTask(r) ? e.chat.channels[p.TaskHelper.getTaskChatChannelSid(r)] : void 0
      };
    },
        h = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.children,
            n = a(e, ["children"]);
        return n.channelDefinition = n.task ? l.TaskChannels.getForTask(n.task) : void 0, s.createElement(c.TaskContext.Provider, {
          value: n
        }, t);
      }, t = i([u.connect(f)], t);
    }(s.PureComponent);

    t.SupervisorTaskContextSource = h;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(440);
    t.WorkerCanvas = r.WorkerCanvas, t.WorkerCanvasProps = r.WorkerCanvasProps;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(443);
    t.WorkerProfile = r.WorkerProfile;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(446);
    t.WorkerSkills = r.WorkerSkills;
  }, function (e, t) {
    e.exports = require("@material-ui/core/FormHelperText");
  }, function (e, t) {
    e.exports = require("@material-ui/core");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(203));
    var r = n(469);
    t.QueuesStatsView = r.FullscreenableQueuesStatsView;
  }, function (e, t, n) {
    "use strict";

    var _r32,
        o = this && this.__extends || (_r32 = function r(e, t) {
      return (_r32 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r32(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(90),
        c = n(465),
        l = n(3).connect(function (e) {
      var t = e.realtimeQueues,
          n = t.queuesList && !Object.keys(t.queuesList).length;
      return {
        isLoading: n && !t.hasFetchedList,
        hasNoData: n && t.hasFetchedList,
        error: t.error
      };
    })(c.QueuesStatsViewImpl),
        u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return a.createElement(l, i({}, this.props));
      }, t.displayName = c.displayName, t.Content = c.Content, t.Tiles = s.AggregatedQueuesDataTiles, t.Table = s.QueuesDataTable, t;
    }(a.PureComponent);

    t.QueuesStatsViewComponent = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(467));
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r(n(194)), r(n(98));
    var o = n(193);
    t.TaskCardList = o.TaskCardList, t.TaskCardListProps = o.TaskCardListProps;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(498);
    t.RootContainer = r.RootContainer;
    var o = n(570);
    t.RootContainerChildrenProps = o.RootContainerChildrenProps;
  }, function (e, t, n) {
    "use strict";

    var _r33,
        o = this && this.__extends || (_r33 = function r(e, t) {
      return (_r33 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r33(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(3),
        u = n(501),
        p = n(2),
        d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.updateAll = function () {}, t.prototype.render = function () {
        return s.createElement(f, i({}, this.props));
      }, t.displayName = u.displayName, t.Content = u.contentStore, t.defaultProps = {
        keepSideNavOpen: !1,
        showNotificationBar: !0,
        showLiveCommsBar: !0
      }, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.MainContainer = d;
    var f = l.connect(function (e) {
      return {
        activeView: e.view.activeView,
        showOutboundDialer: e.view.isOutboundDialerOpen
      };
    })(p.withTheme(u.MainContainerImpl));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(504);
    t.SideNav = r.SideNav, t.SideNavProps = r.SideNavProps, t.SideNavChildrenProps = r.SideNavChildrenProps;
    var o = n(55);
    t.SideLink = o.SideLink, t.SideLinkProps = o.SideLinkProps;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(507);
    t.SideLinkAgentDesktop = r.SideLinkAgentDesktop;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(512);
    t.SideLinkTeams = r.SideLinkTeams;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(513);
    t.SideLinkQueuesStats = r.SideLinkQueuesStats;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(534);
    t.LiveCommsBar = r.LiveCommsBar, t.LiveCommsBarChildrenProps = r.LiveCommsBarChildrenProps;
    var o = n(213);
    t.LiveCommsBarItem = o.LiveCommsBarItem;
    var i = n(214);
    t.LiveCommsBarItemAction = i.LiveCommsBarItemAction, t.LiveCommsBarItemActions = i.LiveCommsBarItemActions, t.LiveCommsBarItemActionsProps = i.LiveCommsBarItemActionsProps;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(537);
    t.LiveCommsBarItem = r.LiveCommsBarItem;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(542);
    t.LiveCommsBarItemAction = r.LiveCommsBarItemAction, t.LiveCommsBarItemActions = r.LiveCommsBarItemActions, t.LiveCommsBarItemActionsProps = r.LiveCommsBarItemActionsProps;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(544);
    t.ViewCollection = r.ViewCollection, t.ViewCollectionProps = r.ViewCollectionProps, t.ViewCollectionChildrenProps = r.ViewCollectionChildrenProps, t.ViewAdditionalProps = r.ViewAdditionalProps;
    var o = n(216);
    t.View = o.View, t.ViewProps = o.ViewProps, t.ViewMountRule = o.ViewMountRule;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(546);
    t.View = r.View, t.ViewFC = r.ViewFC, t.ViewProps = r.ViewProps, t.ViewMountRule = r.ViewMountRule;
    var o = n(547);
    t.ViewImpl = o.ViewImpl;
  }, function (e, t, n) {
    "use strict";

    var _r34,
        o = this && this.__extends || (_r34 = function r(e, t) {
      return (_r34 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r34(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(567),
        c = n(2),
        l = n(3),
        u = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return a.createElement(t.Connected, i({}, this.props));
      }, n.displayName = s.displayName, n.Content = s.contentStore, n;
    }(a.PureComponent);

    t.OutboundDialerPanel = u, t.Connected = c.withTheme(l.connect(function (e) {
      return {
        worker: e.worker
      };
    })(s.OutboundDialerPanelImpl));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u,
        p,
        d,
        f,
        h = n(1),
        m = n(51),
        g = n(0),
        y = n(2);
    t.StyledSidePanel = y.default(g.SidePanel)(o || (o = r(["\n    width: 276px;\n"], ["\n    width: 276px;\n"]))), t.Container = y.default("div")(i || (i = r(["\n    display: flex;\n    position: absolute;\n    height: 100%;\n    right: 0px;\n    z-index: 10;\n"], ["\n    display: flex;\n    position: absolute;\n    height: 100%;\n    right: 0px;\n    z-index: 10;\n"]))), t.DialerContainer = y.default("div")(a || (a = r(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 276px;\n    padding: 0 11px;\n    box-sizing: border-box;\n    ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 276px;\n    padding: 0 11px;\n    box-sizing: border-box;\n    ", ";\n"])), function (e) {
      var t = e.disabled,
          n = e.theme;
      return t && n.OutboundDialerPanel.Container.disabled;
    }), t.OfflineContainer = y.default("div")(s || (s = r(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 276px;\n    padding: 0 11px 80px;\n    box-sizing: border-box;\n    flex-grow: 1;\n    text-align: center;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 276px;\n    padding: 0 11px 80px;\n    box-sizing: border-box;\n    flex-grow: 1;\n    text-align: center;\n"]))), t.Caption = y.default("label")(c || (c = r(["\n    display: block;\n    text-transform: uppercase;\n    font-size: 10px;\n    line-height: 1.6;\n    letter-spacing: 2px;\n    margin-top: 16px;\n    margin-bottom: 8px;\n    width: 100%;\n"], ["\n    display: block;\n    text-transform: uppercase;\n    font-size: 10px;\n    line-height: 1.6;\n    letter-spacing: 2px;\n    margin-top: 16px;\n    margin-bottom: 8px;\n    width: 100%;\n"]))), t.CallButton = y.default(g.IconButton)(l || (l = r(["\n    box-sizing: content-box;\n    padding: 8px;\n    ", ";\n    ", ";\n    ", ";\n"], ["\n    box-sizing: content-box;\n    padding: 8px;\n    ", ";\n    ", ";\n    ", ";\n"])), function (e) {
      return e.theme.Dialer.CallButton;
    }, function (e) {
      return e.disabled && e.theme.Dialer.CallButton.disabled;
    }, function (e) {
      return g.getBackgroundWithHoverCSS(e.theme.Dialer.CallButton.backgroundColor, e.theme.Dialer.CallButton.lightHover, !1, e.disabled);
    }), t.StyledSelect = y.default(m.default)(u || (u = r(["\n    width: 252px;\n"], ["\n    width: 252px;\n"]))), t.CallControls = y.default("div")(p || (p = r(["\n    position: relative;\n    margin-top: 24px;\n"], ["\n    position: relative;\n    margin-top: 24px;\n"]))), t.CallAnimation = y.default("div")(d || (d = r(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n"]))), t.ErrorMessage = y.default("div")(f || (f = r(["\n    margin-top: 16px;\n    text-align: center;\n    ", "\n"], ["\n    margin-top: 16px;\n    text-align: center;\n    ", "\n"])), function (e) {
      return "color: " + e.theme.colors.errorColor + ";";
    }), t.ErrorIcon = function (e) {
      return h.createElement("svg", {
        width: "64px",
        height: "64px",
        viewBox: "0 0 64 64",
        version: "1.1"
      }, h.createElement("g", {
        id: "icn-nodialpad",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, h.createElement("g", {
        id: "Group",
        transform: "translate(13.000000, 10.000000)",
        fill: "currentcolor",
        fillRule: "nonzero"
      }, h.createElement("path", {
        d: "M40.2393529,0.577227648 C40.4217651,0.741472373 40.457097,1.0073275 40.3350858,1.20610476 L40.2819361,1.27717249 L1.46120874,44.3919581 C1.27951301,44.5937517 0.965860889,44.6075477 0.760647112,44.4227724 C0.578234866,44.2585276 0.542903019,43.9926725 0.664914216,43.7938952 L0.718063914,43.7228275 L39.5387913,0.608041884 C39.720487,0.406248337 40.0341391,0.392452334 40.2393529,0.577227648 Z M18.5,37 C19.8807119,37 21,38.1192881 21,39.5 C21,40.8254834 19.9684641,41.9100387 18.6643757,41.9946823 L18.5,42 C17.1192881,42 16,40.8807119 16,39.5 C16,38.1745166 17.0315359,37.0899613 18.3356243,37.0053177 L18.5,37 Z M18.5,38 C17.6715729,38 17,38.6715729 17,39.5 C17,40.3284271 17.6715729,41 18.5,41 C19.3284271,41 20,40.3284271 20,39.5 C20,38.6715729 19.3284271,38 18.5,38 Z M3.5,25 C4.88071187,25 6,26.1192881 6,27.5 C6,28.8254834 4.96846406,29.9100387 3.66437569,29.9946823 L3.5,30 C2.11928813,30 1,28.8807119 1,27.5 C1,26.1745166 2.03153594,25.0899613 3.33562431,25.0053177 L3.5,25 Z M21,27.5 C21,28.8254834 19.9684641,29.9100387 18.6643757,29.9946823 L18.5,30 C17.7272816,30 17.0364439,29.6494271 16.577861,29.0986556 L17.258901,28.3426832 C17.5288069,28.7394275 17.9839734,29 18.5,29 C19.3284271,29 20,28.3284271 20,27.5 C20,26.927513 19.6792876,26.4299325 19.2077278,26.1771232 L19.8890896,25.4211202 C20.5589691,25.8696169 21,26.6333043 21,27.5 Z M33.5,25 C34.8807119,25 36,26.1192881 36,27.5 C36,28.8254834 34.9684641,29.9100387 33.6643757,29.9946823 L33.5,30 C32.1192881,30 31,28.8807119 31,27.5 C31,26.1745166 32.0315359,25.0899613 33.3356243,25.0053177 L33.5,25 Z M3.5,26 C2.67157288,26 2,26.6715729 2,27.5 C2,28.3284271 2.67157288,29 3.5,29 C4.32842712,29 5,28.3284271 5,27.5 C5,26.6715729 4.32842712,26 3.5,26 Z M33.5,26 C32.6715729,26 32,26.6715729 32,27.5 C32,28.3284271 32.6715729,29 33.5,29 C34.3284271,29 35,28.3284271 35,27.5 C35,26.6715729 34.3284271,26 33.5,26 Z M3.5,14 C4.88071187,14 6,15.1192881 6,16.5 C6,17.8254834 4.96846406,18.9100387 3.66437569,18.9946823 L3.5,19 C2.11928813,19 1,17.8807119 1,16.5 C1,15.1745166 2.03153594,14.0899613 3.33562431,14.0053177 L3.5,14 Z M18.5,14 C19.8807119,14 21,15.1192881 21,16.5 C21,17.8254834 19.9684641,18.9100387 18.6643757,18.9946823 L18.5,19 C17.1192881,19 16,17.8807119 16,16.5 C16,15.1745166 17.0315359,14.0899613 18.3356243,14.0053177 L18.5,14 Z M33.5,14 C34.8807119,14 36,15.1192881 36,16.5 C36,17.8254834 34.9684641,18.9100387 33.6643757,18.9946823 L33.5,19 C32.1192881,19 31,17.8807119 31,16.5 C31,15.1745166 32.0315359,14.0899613 33.3356243,14.0053177 L33.5,14 Z M3.5,15 C2.67157288,15 2,15.6715729 2,16.5 C2,17.3284271 2.67157288,18 3.5,18 C4.32842712,18 5,17.3284271 5,16.5 C5,15.6715729 4.32842712,15 3.5,15 Z M18.5,15 C17.6715729,15 17,15.6715729 17,16.5 C17,17.3284271 17.6715729,18 18.5,18 C19.3284271,18 20,17.3284271 20,16.5 C20,15.6715729 19.3284271,15 18.5,15 Z M33.5,15 C32.6715729,15 32,15.6715729 32,16.5 C32,17.3284271 32.6715729,18 33.5,18 C34.3284271,18 35,17.3284271 35,16.5 C35,15.6715729 34.3284271,15 33.5,15 Z M3.5,2 C4.88071187,2 6,3.11928813 6,4.5 C6,5.8254834 4.96846406,6.91003867 3.66437569,6.99468232 L3.5,7 C2.11928813,7 1,5.88071187 1,4.5 C1,3.1745166 2.03153594,2.08996133 3.33562431,2.00531768 L3.5,2 Z M18.5,2 C19.8807119,2 21,3.11928813 21,4.5 C21,5.8254834 19.9684641,6.91003867 18.6643757,6.99468232 L18.5,7 C17.1192881,7 16,5.88071187 16,4.5 C16,3.1745166 17.0315359,2.08996133 18.3356243,2.00531768 L18.5,2 Z M33.5,2 C34.4672987,2 35.3062876,2.54935997 35.7219874,3.35310076 L34.9680567,4.19060837 C34.8254692,3.51062085 34.2223655,3 33.5,3 C32.6715729,3 32,3.67157288 32,4.5 C32,5.27624002 32.5896259,5.91476552 33.3454347,5.99213342 L32.5915533,6.82982407 C31.6599959,6.46632258 31,5.56023644 31,4.5 C31,3.1745166 32.0315359,2.08996133 33.3356243,2.00531768 L33.5,2 Z M3.5,3 C2.67157288,3 2,3.67157288 2,4.5 C2,5.32842712 2.67157288,6 3.5,6 C4.32842712,6 5,5.32842712 5,4.5 C5,3.67157288 4.32842712,3 3.5,3 Z M18.5,3 C17.6715729,3 17,3.67157288 17,4.5 C17,5.32842712 17.6715729,6 18.5,6 C19.3284271,6 20,5.32842712 20,4.5 C20,3.67157288 19.3284271,3 18.5,3 Z",
        id: "Combined-Shape"
      }))));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n(220), n(221), n(222), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(103));
  }, function (e, t) {
    e.exports = require("core-js/features/symbol");
  }, function (e, t) {
    e.exports = require("core-js/features/symbol/iterator");
  }, function (e, t) {
    e.exports = require("core-js/features/object/assign");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(104);
    t.TaskOverviewCanvas = r.TaskOverviewCanvas;
    var o = n(143);
    t.TaskCanvas = o.TaskCanvas, t.TaskInfoPanel = o.TaskInfoPanel, t.TaskCanvasTabs = o.TaskCanvasTabs, t.TaskCanvasHeader = o.TaskCanvasHeader, function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(157));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(225);
    t.SupervisorTaskOverviewActions = r.SupervisorTaskOverviewActions, t.SupervisorTaskOverviewActionsImplProps = r.SupervisorTaskOverviewActionsImplProps;
  }, function (e, t, n) {
    "use strict";

    var _r35,
        o = this && this.__extends || (_r35 = function r(e, t) {
      return (_r35 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r35(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(3),
        s = n(1),
        c = n(240),
        l = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return s.createElement(t.Connected, i({}, this.props));
      }, n;
    }(s.Component);

    t.SupervisorTaskOverviewActions = l, t.Connected = a.connect(function (e) {
      return {
        monitorStatus: e.supervisor.callMonitoring.status
      };
    })(c.SupervisorTaskOverviewActionsImpl);
  }, function (e, t) {
    e.exports = require("loglevel");
  }, function (e, t, n) {
    "use strict";

    var _r36,
        o = this && this.__extends || (_r36 = function r(e, t) {
      return (_r36 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r36(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.stopped = !1, n.methods = t.methods || [], n;
      }

      return o(t, e), t.prototype.start = function () {
        var e = this,
            t = this.trigger,
            n = this.methods,
            r = this.targetAlias,
            o = {
          get: function get(o, i) {
            var a = o[i];
            return e.stopped || n.length && n.indexOf(i) < 0 || "function" != typeof a ? a : function () {
              for (var e = [], n = 0; n < arguments.length; n++) {
                e[n] = arguments[n];
              }

              var s = a.apply(o, e);
              return t({
                target: o,
                args: e,
                result: s,
                targetAlias: r,
                subject: i,
                timestamp: Date.now()
              }), s;
            };
          }
        };
        this.onStart && this.onStart(new Proxy(this.target, o));
      }, t.prototype.stop = function () {
        this.stopped = !0;
      }, t;
    }(n(39).Spy);

    t.ClassProxySpy = i;
  }, function (e, t, n) {
    "use strict";

    var _r37,
        o = this && this.__extends || (_r37 = function r(e, t) {
      return (_r37 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r37(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        if (n.events = t.events, !n.events) throw Error("EventEmitterSpy requires some events to listen to.");
        return n;
      }

      return o(t, e), t.prototype.start = function () {
        var e = this;
        this.events.forEach(function (t) {
          e.target.addListener(t, e.trigger);
        }), this.onStart && this.onStart();
      }, t.prototype.stop = function () {
        var e = this;
        this.events.forEach(function (t) {
          e.target.removeListener(t, e.trigger);
        });
      }, t;
    }(n(39).Spy);

    t.EventEmitterSpy = i;
  }, function (e, t, n) {
    "use strict";

    var _r38,
        o = this && this.__extends || (_r38 = function r(e, t) {
      return (_r38 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r38(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        if (n.applyMiddleware = function (e) {
          n.trigger({
            targetAlias: n.targetAlias || "Window event listener",
            args: [e.message + " in " + e.filename + " at " + e.lineno + ":" + e.colno],
            subject: "Error Event",
            result: "",
            timestamp: Date.now()
          });
        }, n.events = t.events, !n.events) throw Error("DOMEventsSpy requires some events to listen to.");
        return n;
      }

      return o(t, e), t.prototype.start = function () {
        var e = this;
        this.events.forEach(function (t) {
          e.target.addEventListener(t, e.applyMiddleware);
        }), this.onStart && this.onStart();
      }, t.prototype.stop = function () {
        var e = this;
        this.events.forEach(function (t) {
          e.target.removeEventListener(t, e.applyMiddleware);
        });
      }, t;
    }(n(39).Spy);

    t.DOMEventsSpy = i;
  }, function (e, t, n) {
    "use strict";

    var _r39,
        o = this && this.__extends || (_r39 = function r(e, t) {
      return (_r39 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r39(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.stopped = !1, n.methods = t.methods || [], n;
      }

      return o(t, e), t.prototype.start = function () {
        var e = this,
            t = this.target,
            n = this.targetAlias,
            r = this.trigger,
            o = this.methods,
            i = t.methodFactory;
        t.methodFactory = function (a, s, c) {
          var l = i(a, s, c);
          return o.indexOf(a) < 0 ? l : function () {
            for (var o = [], i = 0; i < arguments.length; i++) {
              o[i] = arguments[i];
            }

            var s = l.apply(t, o);
            return e.stopped || r({
              target: t,
              args: o,
              result: s,
              targetAlias: n,
              subject: a,
              timestamp: Date.now()
            }), s;
          };
        }, t.setLevel(t.getLevel()), this.onStart && this.onStart(t);
      }, t.prototype.stop = function () {
        this.stopped = !0;
      }, t;
    }(n(39).Spy);

    t.LoglevelSpy = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r,
        o = n(232);
    !function (e) {
      e.String = "String";
    }(r = t.PredefinedFormatters || (t.PredefinedFormatters = {})), t.getFormatter = function (e) {
      if (e.type === r.String) return o.stringFormatter;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
        e += arguments[t].length;
      }

      var r = Array(e),
          o = 0;

      for (t = 0; t < n; t++) {
        for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) {
          r[o] = i[a];
        }
      }

      return r;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(110),
        a = function a(e) {
      var t,
          n = e.timestamp,
          r = e.targetAlias,
          o = e.subject,
          a = e.args,
          s = e.repeats;
      return [new Date(n).toLocaleString(), r, o, Array.isArray(a) ? function (e) {
        return e.map(function (e) {
          return "object" == typeof e ? i.stringify(e) : e.toString();
        });
      }(a).map((t = 100, function (e) {
        return e.length > t ? e.substring(0, 100) + " <CUT " + (e.length - t) + " characters>}" : e;
      })).join(" ") : a, s ? "(repeats " + s + " more " + (s > 1 ? "times" : "time") + ")" : ""].reduce(function (e, t) {
        return t ? e ? e + " | " + t : t : e;
      }, "");
    };

    t.stringFormatter = function (e) {
      var t, n;
      return e.reduce((t = function t(e, _t) {
        return e.subject === _t.subject && JSON.stringify(e.args) === JSON.stringify(_t.args);
      }, n = {}, function (e, i, a, s) {
        if (!e.length) return [i];
        var c = e,
            l = e.length - 1,
            u = e[l];
        return t(u, i) ? n[l] ? n[l]++ : n[l] = 1 : c = o(e, [i]), a === s.length - 1 && (c = c.map(function (e, t) {
          var o = n[t];
          return o ? r(r({}, e), {
            repeats: o
          }) : e;
        })), c;
      }), []).map(a).join("\n");
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r,
        o = n(234),
        i = n(111);
    t.Storage = i.Storage, function (e) {
      e.LocalStorage = "LocalStorage";
    }(r = t.PredefinedStorages || (t.PredefinedStorages = {})), t.getStorage = function (e) {
      if (e.type === r.LocalStorage) return new o.LocalStorage(e);
    };
  }, function (e, t, n) {
    "use strict";

    var _r40,
        o = this && this.__extends || (_r40 = function r(e, t) {
      return (_r40 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r40(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(111),
        a = n(110),
        s = n(67),
        c = function (e) {
      function t(t) {
        var n = e.call(this) || this;
        return n.maxLocalStorageSize = 4e3, n.cache = [], n.localStorageKey = "FLEX_LOG_CONTENT_" + t.identifier, n.cache = n.get(), n.set = s(n.set.bind(n), 1e3, {
          maxWait: 100
        }), n;
      }

      return o(t, e), t.calculateUsedSpace = function (e) {
        return Number((new Blob([e]).size / 1024).toFixed());
      }, t.prototype.set = function (e, n) {
        for (var r = a.stringify(this.cache), o = 0; t.calculateUsedSpace(r) >= this.getMaxLocalStorageSize() && o < 10;) {
          this.cache = this.truncate(this.cache), r = a.stringify(this.cache), o++;
        }

        t.calculateUsedSpace(r) >= this.getMaxLocalStorageSize() ? n(Error("The object you're trying to store is too big. The maximum allowed size is\n                    " + this.getMaxLocalStorageSize() / 1024 + "Mb")) : (window.localStorage.setItem(this.localStorageKey, r), e(this.get()));
      }, t.prototype.truncate = function (e) {
        var t = Math.floor(e.length / 2);
        return e.slice(t, e.length);
      }, t.prototype.setMaxLocalStorageSize = function (e) {
        this.maxLocalStorageSize = e;
      }, t.prototype.getMaxLocalStorageSize = function () {
        return this.maxLocalStorageSize;
      }, t.prototype.add = function (e) {
        return this.cache.push(e), new Promise(this.set);
      }, t.prototype.get = function () {
        var e = window.localStorage.getItem(this.localStorageKey) || "[]";
        return JSON.parse(e);
      }, t.prototype.clear = function () {
        return this.cache = [], new Promise(this.set);
      }, t;
    }(i.Storage);

    t.LocalStorage = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(112);
    t.Transport = r.Transport;
    var o,
        i = n(236);
    !function (e) {
      e.File = "File";
    }(o = t.PredefinedTransports || (t.PredefinedTransports = {})), t.getTransport = function (e) {
      if (e.type === o.File) return new i.DownloadableFile();
    };
  }, function (e, t, n) {
    "use strict";

    var _r41,
        o = this && this.__extends || (_r41 = function r(e, t) {
      return (_r41 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r41(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.flush = function (e) {
        var t = this.getAnchorTag(),
            n = new Blob([e], {
          type: "octet/stream"
        }),
            r = window.URL.createObjectURL(n);
        t.href = r, t.download = new Date().toISOString() + ".txt", t.click(), window.URL.revokeObjectURL(r);
      }, t.prototype.getAnchorTag = function () {
        return this.anchorElement ? this.anchorElement : (this.anchorElement = document.createElement("a"), document.body.appendChild(this.anchorElement), this.anchorElement.style.display = "none", this.anchorElement);
      }, t;
    }(n(112).Transport);

    t.DownloadableFile = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(0),
        o = n(5),
        i = n(7),
        a = n(70);

    function s(e) {
      r.ChatChannelState.Actions.unload(e.sid);
    }

    var c = function () {
      function e() {}

      return e.init = function (e) {
        e.addListener("channelJoined", this.handleChannelJoined), e.addListener("channelLeft", this.handleChannelLeft), e.addListener("channelRemoved", this.handleChannelRemoved);
      }, e.handleChannelJoined = function (e) {
        var t = i.TaskHelper.getTaskFromChannelSid(e.sid);
        t ? (o.log.debug("channel joined, loading", e.sid), a.loadTaskChatChannel(t)) : o.log.warn("Task for chat channel does not exist - not loading yet", e.sid);
      }, e.handleChannelLeft = function (e) {
        return o.log.debug("handleChannelLeft for channel", e.sid), s(e);
      }, e.handleChannelRemoved = function (e) {
        return o.log.debug("handleChannelRemoved for channel", e.sid), s(e);
      }, e;
    }();

    t.ChatListener = c;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(113);
    r(n(113)), r(n(239)), r(n(68)), t.initDefaultChannels = function (e) {
      o.init(e);
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0),
        i = n(68),
        a = n(30),
        s = n(57),
        c = n(69),
        l = n(6),
        u = n(114),
        p = {
      Pending: "TaskLineQueue",
      Accepted: "TaskLineChatAssigned",
      Wrapping: "TaskLineChatAssigned"
    };

    function d(e, t, n, d, f, h, m, g, y, v, b, C) {
      void 0 === n && (n = "Message"), void 0 === d && (d = "MessageBold"), void 0 === f && (f = s.defaultChannelColors.chat), void 0 === h && (h = "TaskLineChatReserved"), void 0 === m && (m = 32768), void 0 === g && (g = "TaskHeaderStatusAccepted"), void 0 === y && (y = "TaskLineChatAssigned"), void 0 === v && (v = "IncomingChatNotificationTitle"), void 0 === b && (b = "IncomingChatBrowserNotificationTitle"), void 0 === C && (C = "IncomingChatBrowserNotificationBody");
      var _ = {
        IncomingTask: {
          content: v,
          type: o.NotificationType.information,
          timeout: 0,
          icon: "Message",
          actions: u.incomingTaskNotificationActions,
          options: {
            browser: {
              title: b,
              body: C,
              onClick: function onClick(e, t) {
                l.tryInvokeAction("SelectTask", {
                  task: e.context.task
                });
              },
              options: {
                requireInteraction: !0
              }
            }
          }
        }
      },
          k = r(r({}, p), {
        Pending: h,
        Accepted: y
      });
      return o.Utils.merge(i.Default, {
        name: e,
        isApplicable: t,
        charLimit: m,
        capabilities: new Set([a.TaskChannelCapability.Chat, a.TaskChannelCapability.Info, a.TaskChannelCapability.Wrapup]),
        colors: {
          main: {
            Accepted: f,
            Pending: f,
            Reserved: f,
            Assigned: f
          }
        },
        icons: {
          list: {
            Pending: d,
            Accepted: d,
            Canceled: n,
            Wrapping: n,
            Completed: n,
            Reserved: d,
            Assigned: d
          },
          active: d,
          main: n
        },
        templates: {
          IncomingTaskCanvas: {
            secondLine: p,
            titleLine: {
              Pending: h
            }
          },
          TaskListItem: {
            secondLine: k
          },
          TaskCanvasHeader: {
            secondLine: {
              Pending: "TaskHeaderStatusPending",
              Accepted: g,
              Wrapping: "TaskHeaderStatusWrapup",
              Completed: "TaskHeaderStatusCompleted"
            },
            endButton: {
              Assigned: "TaskHeaderEndChat",
              Accepted: "TaskHeaderEndChat",
              Wrapping: "TaskHeaderComplete"
            }
          },
          TaskCanvasTabs: {
            contentTabHeader: "TaskTabHeaderChat"
          },
          Supervisor: {
            TaskCanvasHeader: {
              secondLine: {
                Pending: "TaskHeaderStatusPending",
                Accepted: g,
                Wrapping: "TaskHeaderStatusWrapup",
                Completed: "TaskHeaderStatusCompleted"
              }
            }
          }
        },
        componentProps: {
          TaskListItem: {
            Badge: {
              children: function children(e, t) {
                return new c.AppStateHelper(e).getUnconsumedMessagesCountForTask(t.task);
              }
            }
          }
        },
        notifications: {
          override: _
        }
      });
    }

    t.Chat = d("chat", function (e) {
      return "chat" === e.taskChannelUniqueName;
    }, "Message", "MessageBold", s.defaultChannelColors.chat, void 0, void 0, "TaskHeaderWebChatStatusAccepted", "TaskLineWebChatAssigned"), t.ChatMessenger = d("chat-messenger", function (e) {
      return t.Chat.isApplicable(e) && ("facebook" === e.channelType || "messenger" === e.channelType);
    }, "Facebook", "FacebookBold", s.defaultChannelColors.facebook, "TaskLineChatMessengerReserved", 4e3, void 0, void 0, "IncomingMessengerNotificationTitle", "IncomingMessengerBrowserNotificationTitle"), t.ChatMessenger.templates.TaskCanvasTabs.contentTabHeader = "TaskTabHeaderMessenger", t.ChatLine = d("chat-line", function (e) {
      return t.Chat.isApplicable(e) && "line" === e.channelType;
    }, "Line", "LineBold", s.defaultChannelColors.line, "TaskLineChatLineReserved", 4e3, void 0, void 0, "IncomingLineNotificationTitle", "IncomingLineBrowserNotificationTitle"), t.ChatMessenger.templates.TaskCanvasTabs.contentTabHeader = "TaskTabHeaderLine", t.ChatWhatsApp = d("chat-whatsapp", function (e) {
      return t.Chat.isApplicable(e) && "whatsapp" === e.channelType;
    }, "Whatsapp", "WhatsappBold", s.defaultChannelColors.whatsapp, "TaskLineChatWhatsAppReserved", 4e3, void 0, void 0, "IncomingWhatsAppNotificationTitle", "IncomingWhatsAppBrowserNotificationTitle"), t.ChatMessenger.templates.TaskCanvasTabs.contentTabHeader = "TaskTabHeaderWhatsApp", t.ChatSms = d("chat-sms", function (e) {
      return "sms" === e.taskChannelUniqueName || t.Chat.isApplicable(e) && "sms" === e.channelType;
    }, "Sms", "SmsBold", s.defaultChannelColors.sms, "TaskLineSmsReserved", 1600, void 0, void 0, "IncomingWhatsAppNotificationTitle", "IncomingWhatsAppBrowserNotificationTitle"), t.ChatMessenger.templates.TaskCanvasTabs.contentTabHeader = "TaskTabHeaderSMS", t.createChatTaskChannel = d;
  }, function (e, t, n) {
    "use strict";

    var _r42,
        o = this && this.__extends || (_r42 = function r(e, t) {
      return (_r42 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r42(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(0),
        c = n(7),
        l = n(3),
        u = n(16),
        p = n(4),
        d = n(2),
        f = n(6),
        h = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onMonitorClick = function () {
          t.props.monitorStatus === u.CallMonitoringStatus.none ? f.tryInvokeAction("MonitorCall", {
            task: t.props.task
          }) : t.props.monitorStatus === u.CallMonitoringStatus.monitoring && f.tryInvokeAction("StopMonitoringCall", {
            task: t.props.task
          });
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props.task;
        return c.TaskHelper.isLiveCall(e) ? e.workerSid === l.FlexModule.workerClient.sid ? null : e.conference ? a.createElement(s.IconButton, {
          className: "Twilio-SupervisorTaskOverviewActions-MonitorButton",
          icon: this.props.monitorStatus === u.CallMonitoringStatus.monitoring ? "MonitorOffLarge" : "MonitorBoldLarge",
          disabled: this.props.monitorStatus === u.CallMonitoringStatus.waiting,
          onClick: this.onMonitorClick,
          themeOverride: this.props.monitorStatus === u.CallMonitoringStatus.monitoring ? this.props.theme.Supervisor.TaskCanvas.MonitorActiveButton : this.props.theme.Supervisor.TaskCanvas.Button,
          title: p.templates.MonitorCallTooltip()
        }) : null : null;
      }, t = i([d.withTheme], t);
    }(a.Component);

    t.SupervisorTaskOverviewActionsImpl = h;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(3),
        o = n(242);
    t.QueueStatsConnectionStatusInfo = r.connect(function (e) {
      return {
        connectionState: e.connectionStatus.connectionState
      };
    })(o.QueueStatsConnectionStatusInfoImpl);
  }, function (e, t, n) {
    "use strict";

    var _r43,
        o = this && this.__extends || (_r43 = function r(e, t) {
      return (_r43 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r43(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(18),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        "connected" !== this.props.connectionState && a.Notifications.showNotification(s.QueuesStatsStale);
      }, t.prototype.componentDidUpdate = function (e) {
        e.connectionState !== this.props.connectionState && ("connected" === this.props.connectionState ? a.Notifications.dismissNotificationById(s.QueuesStatsStale) : a.Notifications.showNotification(s.QueuesStatsStale));
      }, t.prototype.componentWillUnmount = function () {
        a.Notifications.dismissNotificationById(s.QueuesStatsStale);
      }, t.prototype.render = function () {
        return null;
      }, t;
    }(i.PureComponent);

    t.QueueStatsConnectionStatusInfoImpl = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(3),
        o = n(244);
    t.QueueStatsConnectionStatusInfoText = r.connect(function (e) {
      return {
        timestampLastConnected: e.connectionStatus.timestampLastConnected
      };
    })(o.QueueStatsConnectionStatusInfoTextImpl);
  }, function (e, t, n) {
    "use strict";

    var _r44,
        o = this && this.__extends || (_r44 = function r(e, t) {
      return (_r44 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r44(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        var e = this;
        this.intervalHandle = window.setInterval(function () {
          return e.forceUpdate();
        }, 1e3);
      }, t.prototype.componentWillUnmount = function () {
        window.clearInterval(this.intervalHandle);
      }, t.prototype.render = function () {
        var e = a.Utils.formatTimeDuration(Date.now() - this.props.timestampLastConnected);
        return i.createElement("div", null, "You are currently experiencing connectivity issues. The data has not been updated for", " ", e, ".");
      }, t;
    }(i.PureComponent);

    t.QueueStatsConnectionStatusInfoTextImpl = s;
  }, function (e, t) {
    e.exports = require("twilio-chat");
  }, function (e, t) {
    e.exports = require("twilio-sync");
  }, function (e, t) {
    e.exports = require("lodash.merge");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(3),
        i = n(19);
    t.initialState = {
      localOverrides: {},
      features: {}
    }, t.reduce = function (e, n) {
      var o;

      switch (void 0 === e && (e = t.initialState), n.type) {
        case i.FEATURE_FLAGS_UPDATE:
          var a = n.payload.reduce(function (e, t) {
            return e[t.id] = t, e;
          }, {});
          return r(r({}, e), {
            features: r(r({}, e.features), a)
          });

        case i.FEATURE_FLAGS_OVERRIDES_UPDATE:
          return r(r({}, e), {
            localOverrides: n.payload
          });

        case i.FEATURE_FLAG_OVERRIDE:
          return n.payload.id ? r(r({}, e), {
            localOverrides: r(r({}, e.localOverrides), (o = {}, o[n.payload.id] = n.payload, o))
          }) : e;

        default:
          return e;
      }
    };

    var a = function () {
      function e() {}

      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return this._dispatcher || o.FlexModule.dispatch;
        },
        set: function set(e) {
          this._dispatcher = e;
        },
        enumerable: !0,
        configurable: !0
      }), e.setFeatures = function (t) {
        t && e.dispatcher({
          type: i.FEATURE_FLAGS_UPDATE,
          payload: t
        });
      }, e.setFeatureOverrides = function (t) {
        t && e.dispatcher({
          type: i.FEATURE_FLAGS_OVERRIDES_UPDATE,
          payload: t
        });
      }, e.overrideFeatureFlag = function (t) {
        t && e.dispatcher({
          type: i.FEATURE_FLAG_OVERRIDE,
          payload: t
        });
      }, e;
    }();

    t.Actions = a;
  }, function (e, t) {
    e.exports = require("twilio-taskrouter");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    },
        a = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
        e += arguments[t].length;
      }

      var r = Array(e),
          o = 0;

      for (t = 0; t < n; t++) {
        for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) {
          r[o] = i[a];
        }
      }

      return r;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(15),
        c = n(3),
        l = n(122),
        u = n(5),
        p = n(8);

    function d(e) {
      return r(r({}, e.value), {
        key: e.key
      });
    }

    t.WORKSPACE_KEY = "workspace", t.initialState = {
      queuesList: {},
      hasFetchedList: !1,
      workspaceStats: void 0,
      filter: void 0,
      error: void 0
    }, t.reduce = function (e, n) {
      var o;

      switch (void 0 === e && (e = t.initialState), n.type) {
        case l.SET_QUEUES:
          var i = n.payload.reduce(function (e, t) {
            return e[t.key] = t, e;
          }, {});
          return r(r({}, e), {
            queuesList: i,
            hasFetchedList: !0,
            error: void 0
          });

        case l.ADD_QUEUE:
        case l.UPDATE_QUEUE:
          return r(r({}, e), {
            queuesList: r(r({}, e.queuesList), (o = {}, o[n.payload.key] = n.payload, o))
          });

        case l.REMOVE_QUEUE:
          return delete (i = r({}, e.queuesList))[n.payload], r(r({}, e), {
            queuesList: i
          });

        case l.SET_WORKSPACE_STATS:
          return r(r({}, e), {
            workspaceStats: n.payload
          });

        case l.UPDATE_FILTER:
          return r(r({}, e), {
            filter: n.payload
          });

        case l.QUEUES_ERROR:
          return r(r({}, e), {
            error: n.payload
          });

        default:
          return e;
      }
    };

    var f = function () {
      function e() {}

      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return this._dispatcher || c.FlexModule.dispatch;
        },
        set: function set(e) {
          this._dispatcher = e;
        },
        enumerable: !0,
        configurable: !0
      }), e.init = function () {
        return o(this, void 0, void 0, function () {
          var e, t;
          return i(this, function (n) {
            switch (n.label) {
              case 0:
                return n.trys.push([0, 2,, 3]), e = this, [4, c.FlexModule.insightsClient.map({
                  id: "realtime_statistics_v1",
                  mode: "open_existing"
                })];

              case 1:
                return e._map = n.sent(), [2, this.fetchWorkerQueues()];

              case 2:
                return t = n.sent(), u.log.error(t), this.dispatcher({
                  type: l.QUEUES_ERROR,
                  payload: t
                }), [2, void 0];

              case 3:
                return [2];
            }
          });
        });
      }, e.close = function () {
        this._map && this._map.close();
      }, e.setFilter = function (e) {
        this.dispatcher({
          type: l.UPDATE_FILTER,
          payload: e
        });
      }, e.getQueueSids = function () {
        return o(this, void 0, Promise, function () {
          var e, t, n, r, o, l;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                e = c.FlexModule.state.session.ssoTokenPayload.token, t = p.getWorkspaceTaskQueuesUrl(c.FlexModule.workerClient.workspaceSid), n = [], i.label = 1;

              case 1:
                i.trys.push([1, 5,, 6]), i.label = 2;

              case 2:
                return t ? [4, s.default.get(t, {
                  auth: {
                    username: "token",
                    password: e
                  }
                })] : [3, 4];

              case 3:
                return r = i.sent(), t = r.data && r.data.meta && r.data.meta.next_page_url, o = r.data.task_queues.map(function (e) {
                  return e.sid;
                }), n = a(n, o), [3, 2];

              case 4:
                return [3, 6];

              case 5:
                throw l = i.sent(), new Error("Unable to fetch Task Queues for workspace: " + l);

              case 6:
                return [2, n];
            }
          });
        });
      }, e.fetchWorkerQueues = function () {
        return o(this, void 0, void 0, function () {
          var e, n, r, o;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return this._map ? [4, this._map.getItems()] : [3, 2];

              case 1:
                e = i.sent().items, n = e.map(function (e) {
                  return d(e);
                }), r = n.find(function (e) {
                  return e.key === t.WORKSPACE_KEY;
                }), o = n.filter(function (e) {
                  return e.key !== t.WORKSPACE_KEY;
                }), this.dispatcher({
                  type: l.SET_QUEUES,
                  payload: o
                }), r && this.dispatcher({
                  type: l.SET_WORKSPACE_STATS,
                  payload: r
                }), this.registerMapListeners(), i.label = 2;

              case 2:
                return [2];
            }
          });
        });
      }, e.registerMapListeners = function () {
        this._map && (this._map.on("itemAdded", this.handleItemAdded), this._map.on("itemUpdated", this.handleItemUpdated), this._map.on("itemRemoved", this.handleItemRemoved));
      }, e.handleItemAdded = function (t) {
        var n = t.item;
        e.dispatcher({
          type: l.ADD_QUEUE,
          payload: d(n)
        });
      }, e.handleItemUpdated = function (n) {
        var r = d(n.item);
        r.key === t.WORKSPACE_KEY ? e.dispatcher({
          type: l.SET_WORKSPACE_STATS,
          payload: r
        }) : e.dispatcher({
          type: l.UPDATE_QUEUE,
          payload: r
        });
      }, e.handleItemRemoved = function (t) {
        var n = t.key;
        e.dispatcher({
          type: l.REMOVE_QUEUE,
          payload: n
        });
      }, e;
    }();

    t.Actions = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(118);
    t.queuesListSelector = function (e) {
      return e.realtimeQueues.queuesList;
    }, t.queuesListFilterSelector = function (e) {
      return e.realtimeQueues.filter;
    }, t.workspaceStatsSelector = function (e) {
      return e.realtimeQueues.workspaceStats;
    }, t.queuesListArraySelector = r.createSelector(t.queuesListSelector, t.queuesListFilterSelector, function (e, t) {
      return void 0 === t && (t = function t() {
        return !0;
      }), Object.keys(e).map(function (t) {
        return e[t];
      }).filter(t).sort(function (e, t) {
        return e.friendly_name.localeCompare(t.friendly_name);
      });
    }), t.workspaceActiveTasksSelector = r.createSelector(t.queuesListArraySelector, function (e) {
      return e.reduce(function (e, t) {
        return e + t.tasks_by_status.assigned + t.tasks_by_status.wrapping;
      }, 0);
    }), t.workspaceWaitingTasksSelector = r.createSelector(t.queuesListArraySelector, function (e) {
      return e.reduce(function (e, t) {
        return e + t.tasks_by_status.reserved + t.tasks_by_status.pending;
      }, 0);
    }), t.workspaceLongestQueueSelector = r.createSelector(t.queuesListArraySelector, function (e) {
      return e.reduce(function (e, t) {
        var n = t.longest_task_waiting_from ? new Date(t.longest_task_waiting_from) : new Date();
        return n < e.timestamp ? {
          queue: t,
          timestamp: n
        } : e;
      }, {
        timestamp: new Date(),
        queue: null
      }).queue;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(10),
        o = n(3);

    function i(e, t, n) {
      return e.activity_statistics.filter(function (e) {
        return function (e) {
          var t = o.FlexModule.workerClient.activities.get(e.sid);
          return t ? t.available : void 0;
        }(e) === t && function (e) {
          var t = r.Manager.getInstance().serviceConfiguration.taskrouter_offline_activity_sid;
          return t && t === e.sid || "Offline" === e.friendly_name;
        }(e) === n;
      }).reduce(function (e, t) {
        return e + t.workers;
      }, 0);
    }

    t.getAvailableAgentsCount = function (e) {
      return e ? i(e, !0, !1) : 0;
    }, t.getUnavailableAgentsCount = function (e) {
      return e ? i(e, !1, !1) : 0;
    }, t.getOfflineAgentsCount = function (e) {
      return e ? i(e, !1, !0) : 0;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(67),
        o = n(3),
        i = n(124),
        a = {
      timestampLastConnected: Date.now(),
      connectionState: "connected"
    };

    t.reduce = function (e, t) {
      switch (void 0 === e && (e = a), t.type) {
        case i.CONNECTION_STATUS_CHANGE:
          if (t.payload !== e.connectionState) {
            var n = e.timestampLastConnected;
            return "connected" !== e.connectionState && "connected" !== t.payload || (n = Date.now()), {
              timestampLastConnected: n,
              connectionState: t.payload
            };
          }

          return e;

        default:
          return e;
      }
    };

    var s = function () {
      function e() {}

      return e.init = function (e, t) {
        void 0 === e && (e = o.FlexModule.insightsClient), void 0 === t && (t = o.FlexModule.dispatch), this.syncClient = e, this.dispatch = t, this.updateConnectionState(this.syncClient.connectionState), this.syncClient.on("connectionStateChanged", this.updateConnectionState);
      }, e.updateConnectionState = function (t) {
        e.dispatchUpdate(t), "connected" === t && e.dispatchUpdate.flush();
      }, e.dispatchUpdate = r(function (t) {
        e.dispatch({
          type: i.CONNECTION_STATUS_CHANGE,
          payload: t
        });
      }, 5e3), e;
    }();

    t.ConnectionStatusState = s;
  }, function (e, t) {
    e.exports = require("redux-logger");
  }, function (e, t) {
    e.exports = require("redux-promise-middleware");
  }, function (e, t) {
    e.exports = require("history");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    t.default = {
      language: "en-US",
      colorTheme: "BlueMediumTheme",
      pluginService: {
        enabled: !0
      },
      sdkOptions: {
        insights: {
          productId: "flex_insights"
        }
      },
      rejectPendingReservations: !0,
      initialDeviceCheck: !0,
      notifications: {
        browser: !1
      },
      enableClientCalling: !1
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0),
        i = '\n<h1>TASK CONTEXT</h1>\n<h2>Task type</h2>\n<p>{{task.channelType}}</p>\n<h2>Task created on</h2>\n<p>{{task.dateCreated}}</p>\n<h2>Task priority</h2>\n<p>{{task.priority}}</p>\n<h2>Task queue</h2>\n<p>{{task.queueName}}</p>\n<h2>Task Sid</h2>\n<p>{{task.taskSid}}</p>\n<h2>Reservation Sid</h2>\n<p>{{task.sid}}</p>\n<hr />\n<h1>CUSTOMER CONTEXT</h1>\n<h2>Customer name / phone number</h2>\n<p>{{task.defaultFrom}}</p>\n<h2>Country</h2>\n<p>{{task.attributes.caller_country}}</p>\n<hr />\n<h1>ADDONS</h1>\n<p>\n    No add-ons enabled.\n    To expand your experience, visit\n</p>\n<a href="https://www.twilio.com/marketplace/add-ons" target="blank">Twilio Marketplace</a>',
        a = r(r({}, o.languages.default), {
      SetYourStatus: "Set your status",
      LogOut: "Log out",
      SigningIn: "Signing in",
      SessionExpired: "Your session has expired. <a href='#' onClick='window.location.reload()'>Click here to log in again</a>",
      NoTasksTitle: "Status",
      NoTasks: "No active tasks",
      NoTasksHintNotAvailable: "Change activity state to start receiving tasks.",
      NoTasksHintAvailable: "You are ready to start receiving tasks.",
      NoCRMConfigured: "No CRM configured",
      NoCRMConfiguredAction: "HOW TO CONFIGURE",
      NoCRMTitle: "CRM config",
      NoCRMHint: "Our docs can help you get started.",
      LoginUsername: "User Name",
      LoginPassword: "Password",
      LoginLoading: "Loading ...",
      LoginWelcome: "Hi there, welcome to Flex!",
      LoginLogin: "LOGIN",
      LoginContinue: "Continue anyway",
      LoginAgain: "Login again",
      LoginLaunch: "Launch",
      LoginTitle: "Twilio Flex",
      LoginErrorDomain: "Oops! Your runtime domain is incorrect.",
      LoginErrorDomainDetails: "Find your runtime domain <a href='https://www.twilio.com/console/runtime/overview'>here</a>",
      LoginErrorSso: "Hmm, Single Sign-On has not been configured.",
      LoginErrorSsoDetails: "Find out how to configure Single Sign-On <a href='https://www.twilio.com/console/flex/users/single-sign-on'>here</a>",
      LoginErrorPopupBlocked: "Sorry, pop-ups are blocked.",
      LoginErrorPopupBlockedDetails: "<a href='https://support.google.com/chrome/answer/95472'>Find out how to enable pop-ups in your browser</a>",
      LoginErrorUntrustedDomain: "Trusted Login has not been enabled for this domain.",
      LoginErrorUntrustedDomainDetails: "Find out how to configure Single Sign-On <a href='https://www.twilio.com/docs/flex/configuring-single-sign-and-identity-provider-integration#how-do-i-login-to-a-self-hosted-domain' target='_blank'>here</a>",
      LoginErrorInvalidCertificate: "Invalid SSO Settings",
      LoginErrorInvalidCertificateDetails: "This may be caused by malformed urls or missing/invalid certificates.<br><br>Please reconfigure the <a href='https://www.twilio.com/docs/api/errors/70251' target='_blank'>SSO settings</a> and retry.",
      LoginErrorGeneric: "Oops! Well, that didn't work :( Please double check your configuration.",
      LoginIsAdmin: "Flex Admin?",
      LoginWithTwilio: "Login with Twilio.",
      TaskHeaderLeaveCall: "LEAVE CALL",
      TaskHeaderEndCall: "HANG UP",
      TaskHeaderWrapup: "WRAP UP",
      TaskHeaderComplete: "COMPLETE",
      TaskHeaderEndChat: "END CHAT",
      TaskHeaderStatusPending: "",
      TaskHeaderStatusAccepted: "Live | {{helper.durationSinceUpdate}}",
      TaskHeaderWebChatStatusAccepted: "{{#if helper.chat.isCustomerOnline}} {{{icon name='GreenIndicator'}}} {{else}} {{{icon name='GreyIndicator'}}} {{/if}} Live | {{helper.durationSinceUpdate}}",
      TaskHeaderGroupCallAccepted: "Live | {{helper.durationSinceUpdate}} | {{{icon name='Participant'}}} {{task.conference.liveParticipantCount}}",
      TaskHeaderStatusWrapup: "Wrap up | {{helper.durationSinceUpdate}}",
      TaskHeaderStatusCompleted: "Completed | {{helper.durationSinceUpdate}}",
      SideNavInsightsAgentsView: "Agents",
      SideNavInsightsAnalyzeView: "Analyze",
      SideNavInsightsDashboardsView: "Dashboards",
      SideNavInsightsInspectionsView: "Inspections",
      SideNavInsightsQuestionnairesView: "Questionnaires",
      SideNavInsightsSpeechSearchesView: "Speech Searches",
      SideNavTaskView: "Agent Desktop",
      SideNavTeamsView: "Teams",
      SideNavAgentDashboard: "Agent Dashboard",
      SideNavSupervisorInspections: "Supervisor Inspections",
      SideNavSupervisorDashboard: "Supervisor Dashboard",
      SideNavSupervisorReports: "Supervisor Reports",
      SideNavSettings: "Settings",
      SideNavQueuesStatsView: "Queues Stats",
      TaskHeaderLine: "{{task.defaultFrom}}",
      TaskExtraInfo: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      TaskLineCallIncomingTitle: "Incoming call",
      TaskLineCallTransferTitle: "Transfer request",
      TaskLineCallEndedTitle: "Call ended",
      TaskLineQueue: "Queue: {{task.queueName}}",
      TaskLineCallDuration: "{{helper.durationSinceUpdate}}",
      TaskLineCallReserved: "Incoming call from queue {{task.queueName}}",
      TaskLineCallAssigned: "Live | {{helper.durationSinceUpdate}}",
      TaskLineCallWrapup: "Wrap up | {{helper.durationSinceUpdate}}",
      TaskLineGroupCallAssigned: "Live | {{helper.durationSinceUpdate}} | {{{icon name='Participant'}}} {{task.conference.liveParticipantCount}}",
      TaskLineCallTransferWorker: "Request from {{task.incomingTransferObject.worker.fullName}} (direct)",
      TaskLineCallTransferWorkerDetail: "From: {{task.incomingTransferObject.worker.fullName}} (direct)<br />Queue: {{task.queueName}}",
      TaskLineCallTransferQueue: "Request from {{task.incomingTransferObject.worker.fullName}} ({{task.incomingTransferObject.queue.name}})",
      TaskLineCallTransferQueueDetail: "From: {{task.incomingTransferObject.worker.fullName}}<br />Queue: {{task.queueName}}",
      TaskLineOutboundCallTitle: "Connecting Call",
      TaskLineOutboundCallHeader: "{{task.attributes.outbound_to}}",
      TaskLineOutboundCallDetail: "Your caller ID: {{task.attributes.from}}<br />Queue: {{task.queueName}}",
      TaskLineChatReserved: "Incoming chat request",
      TaskLineChatLineReserved: "Incoming Line request",
      TaskLineChatMessengerReserved: "Incoming Messenger request",
      TaskLineChatWhatsAppReserved: "Incoming WhatsApp request",
      TaskLineSmsReserved: "Incoming SMS request",
      TaskLineChatAssigned: "{{helper.durationSinceUpdate}} | {{#if helper.chat.typers.length}} typing … {{else}} {{#if helper.chat.lastMessage}} {{helper.chat.lastMessage.authorName}}: {{helper.chat.lastMessage.body}}{{else}}No messages{{/if}}{{/if}}",
      TaskLineWebChatAssigned: "{{#if helper.chat.isCustomerOnline}} {{{icon name='GreenIndicator'}}} {{else}} {{{icon name='GreyIndicator'}}} {{/if}}{{helper.durationSinceUpdate}} | {{#if helper.chat.typers.length}} typing … {{else}} {{#if helper.chat.lastMessage}} {{helper.chat.lastMessage.authorName}}: {{helper.chat.lastMessage.body}}{{else}}No messages{{/if}}{{/if}}",
      TaskLineTitle: "",
      TaskReserved: "Reserved",
      TaskAssigned: "Assigned",
      TaskWrapup: "In wrap up",
      TaskCompleted: "Completed",
      TaskCanceled: "Canceled",
      TaskFilterAll: "ALL TASKS",
      TaskFilterActive: "ACTIVE TASKS",
      TaskFilterWrapping: "TASKS IN WRAP UP",
      TaskInfoPanelContent: i,
      ColumnHeaderAgent: "AGENT",
      ColumnHeaderCalls: "CALLS",
      ColumnHeaderTasks: "OTHER TASKS",
      SupervisorUserCardFirstLine: "{{worker.fullName}}",
      SupervisorUserCardSecondLine: "{{worker.activityName}} | {{worker.activityDuration}}",
      SupervisorTaskViewContentHeader: "{{worker.fullName}}, {{task.defaultFrom}}",
      SupervisorTaskHeaderLine: "{{task.defaultFrom}}",
      SupervisorTaskLive: "{{helper.durationSinceUpdateShort}}",
      SupervisorTaskGroupCall: "{{helper.durationSinceUpdateShort}} | ({{task.conference.liveParticipantCount}})",
      SupervisorTaskWrapUp: "Wrap up | {{helper.durationSinceUpdateShort}}",
      SupervisorTaskCompleted: "Completed | {{helper.durationSinceUpdateShort}}",
      SupervisorTaskCardHeader: "{{task.defaultFrom}}",
      SupervisorTaskInfoPanelContent: i,
      LiveCommsMonitoringMessage: "You are listening to a call with {{task.defaultFrom}} and {{worker.fullName}}",
      LiveCommsMonitoringMessageMoreWorkers: "You are listening to a call with {{task.defaultFrom}} and {{workers.length}} workers",
      LiveCommsMonitoringMessageNoWorkers: "You are listening to a call with {{task.defaultFrom}}",
      LiveCommsOngoingCallMessage: "You are on a call with {{task.defaultFrom}}",
      LiveCommsBarReturnToCall: "RETURN",
      LiveCommsBarStopListening: "STOP LISTENING",
      LiveCommsBarHold: "HOLD",
      LiveCommsBarUnHold: "UNHOLD",
      WorkerDirectoryTitle: "Transfer",
      WorkerDirectoryItemFirstLine: "{{worker.fullName}}",
      WorkerDirectoryItemSecondLine: "{{worker.activityName}}",
      WorkerDirectoryAgentsTabLabel: "AGENTS",
      WorkerDirectoryQueuesTabLabel: "QUEUES",
      WorkerDirectoryQueueItemText: "{{queue.name}}",
      WorkerDirectorySearchPlaceholder: "Search",
      ChatInputDisabledText: "Conversation ended",
      WorkerCanvasHeader: "Profile",
      WorkerCanvasDetailsHeader: "Agent Details",
      WorkerCanvasSkillsHeader: "Skills",
      WorkerSkillLevelInvalid: "Please select a skill level between {{min}} - {{max}}",
      WorkerSkillPleaseSelect: "Add skill",
      WorkerSkillsNoSkills: "No skills attributed",
      WorkerSkillsSchemaMismatch: "Worker skills schema mismatch",
      WorkerSkillsSaved: "Changes saved successfully",
      WorkerSkillsError: "Failed to save changes",
      WorkerSkillsReverted: "Changes reverted",
      ChatWelcomeText: "Conversation started with customer",
      UiVersionDeprecated: "{{message}}",
      RuntimeLoginLabel: "Runtime domain",
      RuntimeLoginPlaceholder: "Your Runtime Domain",
      RuntimeLoginLaunch: "Launch",
      RuntimeLoginWithTwilio: "Login with Twilio.",
      RuntimeLoginIsAdmin: "Flex Admin?",
      RuntimeLoginErrorDomain: "Oops! Well, that didn’t work :( Check your <b>domain</b>.",
      RuntimeLoginErrorSso: "Oops! Well, that didn’t work :( Check your <b>SSO</b> setup.",
      TransferFailedNotification: "Transfer failed: {{reason}}",
      TaskCannotBeTransferredNotification: "Task cannot be transferred",
      SupervisorTaskCanvasHeader: "TASK DETAILS",
      TaskTabAgentIncomingLabel: "Incoming",
      TaskTabAgentInfoLabel: "Info",
      TaskTabSupervisorOverviewLabel: "Overview",
      TaskTabSupervisorCallLabel: "Call",
      TaskTabSupervisorChatLabel: "Chat",
      TaskTabSupervisorInfoLabel: "Info",
      MicNotAvailableNotification: "Unable to access microphone, please check browser settings.",
      BrowserVoiceDisabledNotification: "Call cannot be accepted. Twilio Voice SDK has been disabled.",
      MessageSizeExceeded: "The entered character number exceeds the limit - {{currentCharCount}}/{{maxCharCount}}",
      UserControlWorkerSecondLine: "{{worker.activityName}} | {{worker.activityDuration}}",
      UserLoggedOutSuccess: "You have logged out successfully!",
      CannotChangeOtherWorkerActivity: "You cannot change an agent’s activity while they have a pending task/reservation.",
      CallCanvasWorkerOnHold: "You are on hold",
      CallCanvasUnholdWorker: "Unhold",
      CallParticipantStatusOnHold: "On Hold",
      CallParticipantStatusLive: "Live",
      CallParticipantStatusConnecting: "Calling...",
      CallParticipantStatusLeft: "Caller left",
      CallParticipantStatusTransferFailed: "No Answer",
      CallParticipantStatusKickConfirmation: "Remove from call?",
      LiveCommsIncomingDirectCallTransfer: "Request from {{task.incomingTransferObject.worker.fullName}} (direct)",
      LiveCommsIncomingQueueCallTransfer: "Request from {{task.incomingTransferObject.worker.fullName}} ({{task.incomingTransferObject.queue.name}})",
      CallParticipantCustomerName: "{{task.defaultFrom}}",
      MonitoringFailedNotification: "Monitoring attempt has failed",
      PredefinedChatMessageAuthorName: "Bot",
      PredefinedChatMessageBody: "Hi there! How can we help you today?",
      AgentStatusAvailable: "Available",
      AgentStatusBusy: "Busy",
      AgentStatusUnavailable: "Unavailable",
      AgentStatusOffline: "Offline",
      ActiveTasksTileTitle: "Active tasks",
      WaitingTasksTileTitle: "Waiting tasks",
      AgentsByActivityTileTitle: "Agents",
      LongestWaitTimeTileTitle: "Longest wait",
      QueuesNoDataHeading: "Queues",
      QueuesNoDataBodyForAdmin: "You have no Queues set up. Please configure your Queues.",
      QueuesNoDataBodyForSupervisor: "There are no Queues set up. Please contact your Administrator.",
      QueuesNoDataLinkLabelForAdmin: "Add Queue",
      PendingReservationsOnLogoutNotification: "You cannot logout while you have a pending task/reservation",
      PendingReservationsOnActivityStateChangeNotification: "You cannot update your activity while you have a pending task/reservation",
      AcceptTaskTooltip: "Accept",
      RejectTaskTooltip: "Reject",
      HangupCallTooltip: "Hang up",
      LeaveCallTooltip: "Leave",
      MuteCallTooltip: "Mute",
      HoldCustomerTooltip: "Hold Customer",
      UnholdCustomerTooltip: "Unhold Customer",
      HoldAgentTooltip: "Hold {{worker.fullName}}",
      UnholdAgentTooltip: "Unhold {{worker.fullName}}",
      CancelTransferTooltip: "Cancel Consult",
      KickAgentTooltip: "Hang up {{worker.fullName}}",
      ColdTransferTooltip: "Transfer",
      WarmTransferTooltip: "Consult",
      MonitorCallTooltip: "Monitor Call",
      LogToFileStartLoggingText: "<div>\n    <h2>Capture logs</h2>\n    <ul>\n        <li>When you enable logging, your browser will be refreshed and logs capturing will start.</li>\n        <li>Once you are ready to finish - stop logging. All captured logs will be saved to a text file.</li>\n    </ul>\n  </div>",
      LogToFileStartLoggingLabel: "Refresh and start",
      LogToFileStopLoggingText: "<div>\n    <h2>Logging is active</h2>\n    <p>\n    If you've repeated your actions and reproduced the issue, stop logging to download the file with captured logs.\n    </p>\n  </div>",
      LogToFileStopLoggingLabel: "Finish and download",
      ChatOrchestrationAddToChatChannelFailed: "Failed to add worker to the chat channel.",
      ChatOrchestrationDeactivateChatChannelFailed: "Failed to deactivate the chat channel.",
      ChatOrchestrationLeaveChatChannelFailed: "Failed to remove worker from the chat channel.",
      TeamsViewFilterAction: "Filter{{#if filterCount}} ({{filterCount}}){{/if}}",
      TeamsViewClearSearchAction: "Clear search result",
      TeamsViewClearSearchPlaceholder: "Search Agents",
      TeamsViewResultsSummaryNoWorkersDisplayed: "No agents matched your criteria. Refine results via search or filter.",
      TeamsViewResultsSummaryMaxWorkersDisplayed: "Showing maximum number of agents. Refine results via search or ",
      TeamsViewResultsSummaryFilterCTA: "filter",
      TeamFiltersPanelTitle: "Filters",
      TeamFiltersPanelSingularLabel: "Viewing <strong>{{number}}</strong> agent",
      TeamFiltersPanelPluralLabel: "Viewing <strong>{{number}}</strong> agents",
      TeamFiltersApply: "Apply",
      TeamFiltersReset: "Reset",
      OutboundDialerPanelTitle: "Call",
      OutboundDialerPanelPhoneInputCaption: "Enter a number",
      OutboundDialerPanelQueueSelectCaption: "Assign a queue",
      OutboundCallFailedNotificationTitle: "Unable to connect your call. Please try again or contact support. [{{reasonCode}}]",
      OutboundCallFailedNotificationTitleBusy: "This number is currently busy. Please try again.",
      OutboundCallFailedNotificationTitleNoAnswer: "No answer from this number. Please try again.",
      OutboundCallFailedNotificationTitleInvalidNumber: "Dialed number is invalid. Please check the number and try again.",
      OutboundCallFailedNotificationAction: "redial",
      AudioPlayerDeniedError: "Cannot play sound, because permissions for playback of media were not given or denied. To find out more about how to fix this error, go to <a href='https://www.twilio.com/docs/flex/audio-player' target='blank'>FlexDocs</a>.",
      AudioPlayerInvalidMediaError: "Cannot play sound, because provided media is invalid.",
      AudioPlayerGenericError: "Error playing media.",
      RequestBrowserNotificationPermissions: "We need your permission to <a href='#'>enable browser notifications</a>",
      IncomingCallBrowserNotificationTitle: "Incoming call",
      IncomingCallBrowserNotificationBody: "From: {{task.defaultFrom}}",
      IncomingCallNotificationTitle: "Incoming call from {{task.defaultFrom}}",
      IncomingCallTransferNotificationTitle: "Transfer request from {{task.defaultFrom}}",
      IncomingCallTransferBrowserNotificationTitle: "Transfer request",
      IncomingCallTransferWorkerBrowserNotificationBody: "From {{task.incomingTransferObject.worker.fullName}} (direct)",
      IncomingCallTransferQueueBrowserNotificationBody: "From {{task.incomingTransferObject.worker.fullName}} ({{task.incomingTransferObject.queue.name}})",
      IncomingNotificationAccept: "accept",
      IncomingNotificationReject: "reject",
      IncomingChatNotificationTitle: "Incoming chat request from {{task.defaultFrom}}",
      IncomingLineNotificationTitle: "Incoming Line request from {{task.defaultFrom}}",
      IncomingMessengerNotificationTitle: "Incoming Messenger request from {{task.defaultFrom}}",
      IncomingWhatsAppNotiticationTitle: "Incoming WhatsApp request from {{task.defaultFrom}}",
      IncomingSmsNotificationTitle: "Incoming SMS request from {{task.defaultFrom}}",
      IncomingChatBrowserNotificationTitle: "Incoming chat request",
      IncomingLineBrowserNotificationTitle: "Incoming Line request",
      IncomingMessengerBrowserNotificationTitle: "Incoming Messenger request",
      IncomingWhatsAppBrowserNotiticationTitle: "Incoming WhatsApp request",
      IncomingSmsBrowserNotificationTitle: "Incoming SMS request",
      IncomingChatBrowserNotificationBody: "From: {{task.defaultFrom}}",
      TaskTabHeaderChat: "Chat",
      TaskTabHeaderCall: "Call",
      TaskTabHeaderSMS: "SMS",
      TaskTabHeaderMessenger: "Messenger",
      TaskTabHeaderLine: "Line",
      TaskTabHeaderWhatsApp: "WhatsApp",
      QueuesStatsHeaderQueueName: "Queues",
      QueuesStatsHeaderActiveTasks: "Active tasks",
      QueuesStatsHeaderWaitingTasks: "Waiting tasks",
      QueuesStatsHeaderLongestWait: "Longest wait",
      QueuesStatsHeaderAgentsActivity: "Agents by activity",
      FlexInsightsLoginFailedNotificationTitle: "Flex Insights has been unable to load, please reload Flex to gain access",
      FlexInsightsPlayerLoadingSegmentFailed: "Failed to fetch conversation data",
      FlexInsightsLoginFailedNotificationAction: "Reload",
      InputDeviceErrorNotification: "Unable to find or initialize audio input device",
      AnonymousParticipant: "Anonymous",
      TaskLineOutboundCallConnecting: "Connecting call…",
      OutboundErrorGeneral: "Unable to connect your call. Please try again or contact support.",
      OutboundErrorMissingDestination: "Unable to connect your call. Please check the number and try again.",
      OutboundErrorMissingQueue: "Unable to connect your call. Please select a queue and try again.",
      NoOutboundCallingWhenOffline: "To make a call, please change your status from '{{offlineName}}'"
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(31),
        o = n(5),
        i = n(17),
        a = n(18);
    !function (e) {
      e.yes = "yes", e.no = "no", e.deprecated = "deprecated";
    }(t.CompatibilityOptions || (t.CompatibilityOptions = {})), t.isCompatible = function (e, t) {
      switch (void 0 === t && (t = void 0), e) {
        case "yes":
          return !0;

        case "deprecated":
          return i.Notifications.showNotification(a.FlexUiVersionDeprecated, {
            message: t
          }), o.log.warn("This version of Flex is deprecated and will not work with future version of back end services. Please contact your administrator. UI version", r.VERSION, t), !0;

        default:
          return o.log.error("This version of Flex is not compatible with back end services. UI version", r.VERSION, t), !1;
      }
    };
  }, function (e, t) {
    e.exports = require("@twilio/flex-insights-identity-client-js");
  }, function (e, t) {
    e.exports = require("@gooddata/gooddata-js");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(15),
        o = n(8),
        i = n(27),
        a = n(19),
        s = n(31),
        c = n(5),
        l = n(33);

    t.fetchFlexFeatures = function (e) {
      var t = l.SSOLoginHandler.getTokenInfo().token,
          n = o.getSessionUrl(e.configuration);
      return i.Actions.setFeatureOverrides(e.configuration.featureOverrides), r.default.get(n, {
        headers: {
          "X-Flex-Version": s.VERSION,
          "X-Flex-JWE": t
        }
      }).then(function (e) {
        try {
          var t = e.data,
              n = t.insightsActive,
              r = t.features;
          i.Actions.setFeatures(r), i.Actions.overrideFeatureFlag({
            id: a.FeatureFlag.FlexInsights,
            enabled: n,
            name: a.FeatureFlag.FlexInsights,
            description: "Whether Flex Insights is enabled",
            stage: a.FeatureStage.Private
          });
        } catch (e) {
          c.log.error("Failed to set feature flags configuration", e);
        }
      }).catch(function (e) {
        c.log.error("Failed to fetch feature flag config", e);
      });
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(133),
        o = n(5),
        i = n(0),
        a = n(18),
        s = n(3),
        c = n(4),
        l = function () {
      function e(e) {
        var t = this;
        this.transfer = function (e, n) {
          var r = function r(n) {
            o.log.debug("transfer of task " + t._task.sid + " to " + e + " unsuccessful", n);
            var r = n.response && n.response.statusText ? n.response.statusText : "Unknown error";
            throw i.Notifications.showNotification(a.TransferFailed, {
              reason: r
            }), n;
          };

          return n.mode && "COLD" === n.mode ? t._reservation.updateParticipant({
            endConferenceOnExit: !1
          }).then(function () {
            return t._task.transfer(e, n).catch(function (e) {
              throw t._reservation.updateParticipant({
                endConferenceOnExit: !0
              }), e;
            });
          }).then(function () {
            o.log.debug("transfer of task " + t._task.sid + " to " + e + " successful");
          }).catch(function (e) {
            r(e);
          }) : t._task.transfer(e, n).then(function () {
            o.log.debug("transfer of task " + t._task.sid + " to " + e + " successful");
          }).catch(function (e) {
            r(e);
          });
        }, this.setAttributes = function (e) {
          return t._task.setAttributes(e);
        }, this.wrapUp = function () {
          return t._reservation.wrap();
        }, this.complete = function () {
          return t._reservation.complete();
        }, this.hold = function () {
          return t._task.updateParticipant({
            hold: !0
          });
        }, this.unhold = function () {
          return t._task.updateParticipant({
            hold: !1
          });
        }, this.holdParticipant = function (e) {
          var n = t.conference.participants.find(function (t) {
            return t.workerSid === e;
          });
          return n && "worker" === n.participantType ? t._task.hold(n.workerSid, !0) : t.hold();
        }, this.unholdParticipant = function (e) {
          var n = t.conference.participants.find(function (t) {
            return t.workerSid === e;
          });
          return n && "worker" === n.participantType ? t._task.hold(n.workerSid, !1) : t.unhold();
        }, this.kick = function (e) {
          return t._task.kick(e);
        }, this.cancelTransfer = function () {
          return t._outgoingTransferObject.cancel();
        }, this._reservation = e, this._task = e.task, this._task.transfers && (this._task.transfers.incoming && (this._incomingTransferObject = new r.TaskTransfer(this._task.transfers.incoming)), this._task.transfers.outgoing && (this._outgoingTransferObject = new r.TaskTransfer(this._task.transfers.outgoing)));
      }

      return Object.defineProperty(e.prototype, "source", {
        get: function get() {
          return this._task;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sourceObject", {
        get: function get() {
          return this._reservation;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "addOns", {
        get: function get() {
          return this._task.addOns;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "age", {
        get: function get() {
          return this._task.age;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "attributes", {
        get: function get() {
          return this._task.attributes;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dateCreated", {
        get: function get() {
          return this._reservation.dateCreated;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dateUpdated", {
        get: function get() {
          return this._reservation.dateUpdated;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "priority", {
        get: function get() {
          return this._task.priority;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "queueName", {
        get: function get() {
          return this._task.queueName;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "queueSid", {
        get: function get() {
          return this._task.queueSid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "reason", {
        get: function get() {
          return this._task.reason;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sid", {
        get: function get() {
          return this._reservation.sid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "taskSid", {
        get: function get() {
          return this._task.sid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "status", {
        get: function get() {
          return this._reservation.status;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "taskStatus", {
        get: function get() {
          return this._task.status;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "taskChannelSid", {
        get: function get() {
          return this._task.taskChannelSid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "taskChannelUniqueName", {
        get: function get() {
          return this._task.taskChannelUniqueName;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "timeout", {
        get: function get() {
          return this._task.timeout;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "workflowName", {
        get: function get() {
          return this._task.workflowName;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "workflowSid", {
        get: function get() {
          return this._task.workflowSid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "workerSid", {
        get: function get() {
          return this._reservation.workerSid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "routingTarget", {
        get: function get() {
          return this._task.routingTarget;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "defaultFrom", {
        get: function get() {
          var e = this.attributes;
          return (e.name ? e.name : this.routingTarget && "outbound" === e.direction ? e.outbound_to : e.from) || c.templates.AnonymousParticipant();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "channelType", {
        get: function get() {
          return this.attributes.channelType || this.taskChannelUniqueName;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "incomingTransferObject", {
        get: function get() {
          return this._incomingTransferObject;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "outgoingTransferObject", {
        get: function get() {
          return this._outgoingTransferObject;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "conference", {
        get: function get() {
          var e = s.FlexModule.state.conferences.states.get(this.taskSid);
          return e ? e.source : void 0;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    t.TaskRouterTask = l;

    var u = function () {
      function e(e) {
        this._source = e;
      }

      return Object.defineProperty(e.prototype, "source", {
        get: function get() {
          return this._source;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sid", {
        get: function get() {
          return this.source.sid;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "name", {
        get: function get() {
          return this.source.name;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "fullName", {
        get: function get() {
          return this.source.attributes.full_name || this.name;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "activityName", {
        get: function get() {
          return this.source.activity.name;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "attributes", {
        get: function get() {
          return this.source.attributes;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dateUpdated", {
        get: function get() {
          return this.source.dateUpdated;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "isAvailable", {
        get: function get() {
          return this.source.activity && this.source.activity.available;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "activityDuration", {
        get: function get() {
          return this.source && this.source.dateStatusChanged ? i.Utils.formatTimeDuration(Math.max(Date.now() - new Date(this.source.dateStatusChanged).getTime(), 0), "short") : "";
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    t.TaskRouterWorker = u;
  }, function (e, t) {
    e.exports = require("async-sema");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
        e += arguments[t].length;
      }

      var r = Array(e),
          o = 0;

      for (t = 0; t < n; t++) {
        for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) {
          r[o] = i[a];
        }
      }

      return r;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = n(40),
        i = function () {
      function e(e, t, n, r) {
        this._state = void 0, this._state = {
          worker: e,
          tasks: []
        }, this.taskFilter = r, this.initInsightsQuery(t), this.onTasksUpdated = n;
      }

      return Object.defineProperty(e.prototype, "state", {
        get: function get() {
          return this._state;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.updateWorker = function (e) {
        this._state.worker = e;
      }, e.prototype.getTasksFromItems = function (e) {
        return Object.keys(e).map(function (t) {
          return new o.InsightsTask(e[t]);
        });
      }, e.prototype.updateTasksInState = function (e) {
        this._state = {
          tasks: e,
          worker: this.state.worker
        }, this.onTasksUpdated(this);
      }, e.prototype.onTasksItemsUpdated = function (e) {
        var t = this.getTasksFromItems(e);
        this.updateTasksInState(t);
      }, e.prototype.onTaskItemUpdated = function (e) {
        var t = new o.InsightsTask(e.value),
            n = r(this._state.tasks),
            i = n.findIndex(function (e) {
          return e.sid === t.sid;
        });
        i >= 0 ? n[i] = t : n.push(t), this.updateTasksInState(n);
      }, e.prototype.onTaskItemRemoved = function (e) {
        var t = this._state.tasks.filter(function (t) {
          return t.sid !== e.key;
        });

        this.updateTasksInState(t);
      }, e.prototype.initInsightsQuery = function (e) {
        var t = this,
            n = 'data.worker_sid == "' + this.state.worker.sid + '"';
        this.taskFilter && (n = n + " && (" + this.taskFilter + ")"), e.liveQuery("tr-reservation", n).then(function (e) {
          t.liveQuery = e, t.onTasksItemsUpdated(e.getItems()), e.on("itemUpdated", function (e) {
            t.onTaskItemUpdated(e);
          }), e.on("itemRemoved", function (e) {
            t.onTaskItemRemoved(e);
          });
        });
      }, e.prototype.unInit = function () {
        this.liveQuery && (this.liveQuery.removeAllListeners(), this.liveQuery.close());
      }, e;
    }();

    t.WorkerListener = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(268);
    t.TaskOverviewIcon = r.TaskOverviewIcon;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(1),
        o = n(12),
        i = n(105),
        a = n(46),
        s = n(270);

    t.TaskOverviewIcon = function (e) {
      var t = e.task,
          n = o.TaskChannels.getForTask(t),
          c = o.TaskChannelHelper.getIcon(t, n.icons.active, i.TaskOverviewCanvas),
          l = o.TaskChannelHelper.getColor(t, n.colors.main, i.TaskOverviewCanvas);
      return r.createElement(a.IconContainerWithStyle, {
        background: l
      }, r.createElement(s.StyledIcon, {
        icon: c,
        sizeMultiplier: 2
      }));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(0),
        a = n(2);
    t.StyledIcon = a.default(i.Icon)(o || (o = r(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (e) {
      return e.color;
    });
  }, function (e, t, n) {
    "use strict";

    var _r45,
        o = this && this.__extends || (_r45 = function r(e, t) {
      return (_r45 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r45(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        a = n(3),
        s = n(24),
        c = n(0),
        l = n(272),
        u = n(142),
        p = n(7),
        d = n(6),
        f = n(49);
    t.displayName = "ParticipantsCanvas", t.contentStore = new c.DynamicContentStore(t.displayName);

    var h = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          participantWidth: 50,
          listMode: !1
        }, t.handleSelectedViewChanged = function (e, n) {
          n || t.handleParticipantWidthNeedsUpdate();
        }, t.handleParticipantWidthNeedsUpdate = function () {
          if (t.container) {
            var e = t.container.offsetWidth,
                n = t.container.offsetHeight,
                r = 4;
            e <= 340 ? r = 1 : e <= 510 ? r = 2 : e <= 680 && (r = 3);
            var o = t.getParticipants();
            r = Math.min(r, o.length);
            var i = 190 * Math.ceil(o.length / r) > n;
            t.setState({
              listMode: i,
              participantWidth: 100 / r
            });
          }
        }, t.setContainerRef = function (e) {
          t.container = e;
        }, t.renderParticipants = function () {
          var e = t.props,
              n = e.task,
              r = e.hideActions;
          return t.getParticipants().map(function (e) {
            return i.createElement(u.ParticipantCanvas, {
              key: e.uniqueId,
              participant: e,
              participantWidth: t.state.participantWidth,
              task: n,
              hideActions: r,
              listMode: t.state.listMode
            });
          });
        }, t.unHoldMyself = function () {
          d.tryInvokeAction("UnholdParticipant", {
            task: t.props.task,
            targetSid: a.FlexModule.state.worker.worker.sid
          });
        }, t;
      }

      return o(n, e), n.prototype.componentDidMount = function () {
        var e = this;
        a.FlexModule.events.addListener(s.FlexEvent.flexSplitterResize, this.handleParticipantWidthNeedsUpdate), a.FlexModule.events.addListener(s.FlexEvent.viewResized, this.handleParticipantWidthNeedsUpdate), a.FlexModule.events.addListener(s.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged), setTimeout(function () {
          e.handleParticipantWidthNeedsUpdate();
        }, 0);
      }, n.prototype.componentWillUnmount = function () {
        a.FlexModule.events.removeListener(s.FlexEvent.flexSplitterResize, this.handleParticipantWidthNeedsUpdate), a.FlexModule.events.removeListener(s.FlexEvent.viewResized, this.handleParticipantWidthNeedsUpdate), a.FlexModule.events.removeListener(s.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged);
      }, n.prototype.render = function () {
        var e = this,
            n = this.props,
            r = n.task,
            o = (n.children, this.state.listMode ? l.ParticipantsContainerList : l.ParticipantsContainerNormal);
        return i.createElement(c.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0,
          rootContainerStyles: "display: flex;\n                        position: relative;"
        }, i.createElement(l.Container, {
          key: "container"
        }, p.TaskHelper.amIOnHold(r) && i.createElement(l.WorkerOnHoldContainer, {
          key: "onHold",
          className: "ParticipantsCanvas-Container-ImOnHold"
        }, i.createElement(c.Template, {
          code: "CallCanvasWorkerOnHold"
        }), i.createElement(c.ActionStateListener, {
          key: "onHoldAction",
          action: "UnholdParticipant",
          payload: f.isValidWorkerParticipantActionPayload(r, a.FlexModule.state.worker.worker.sid)
        }, function (t) {
          return i.createElement(l.ActionButton, {
            onClick: e.unHoldMyself,
            disabled: t.disabled
          }, i.createElement(c.Template, {
            code: "CallCanvasUnholdWorker"
          }));
        })), i.createElement(l.Scroll, {
          innerRef: this.setContainerRef,
          key: "participantsContainer",
          className: "ParticipantsCanvas-Container"
        }, i.createElement(o, null, this.renderParticipants()))));
      }, n.prototype.getParticipants = function () {
        var e = this.props.conference.source.participants;
        return this.props.includeMyself || (e = e.filter(function (e) {
          return !e.isMyself;
        })), e = e.filter(function (e) {
          return "left" !== e.status;
        });
      }, n;
    }(i.PureComponent);

    t.ParticipantsCanvasImpl = h;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(2),
        i = n(21);
    t.Container = o.default("div")(a || (a = r(["\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    flex-grow: 1;\n"], ["\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    flex-grow: 1;\n"]))), t.ParticipantsContainerNormal = o.default("div")(s || (s = r(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    flex: 1;\n    justify-content: center;\n    align-content: center;\n"], ["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    flex: 1;\n    justify-content: center;\n    align-content: center;\n"]))), t.ParticipantsContainerList = o.default("div")(c || (c = r(["\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    flex-grow: 1;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    flex-grow: 1;\n"]))), t.Scroll = o.default("div")(l || (l = r(["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-wrap: nowrap;\n    overflow-y: scroll;\n    overflow-x: hidden;\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-wrap: nowrap;\n    overflow-y: scroll;\n    overflow-x: hidden;\n"])));
    var a,
        s,
        c,
        l,
        u,
        p,
        d,
        f = i.keyframes(u || (u = r(["\n    from {\n        opacity: 0.3;\n        transform: translate3d(0, -30px, 0);\n    }\n\n    to {\n        opacity: 1;\n        transform: translate3d(0);\n    }\n"], ["\n    from {\n        opacity: 0.3;\n        transform: translate3d(0, -30px, 0);\n    }\n\n    to {\n        opacity: 1;\n        transform: translate3d(0);\n    }\n"])));
    t.WorkerOnHoldContainer = o.default("div")(p || (p = r(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 32px;\n    padding: 0 12px;\n    flex-shrink: 0;\n    animation: ", " 0.15s ease 1;\n    ", ";\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 32px;\n    padding: 0 12px;\n    flex-shrink: 0;\n    animation: ", " 0.15s ease 1;\n    ", ";\n"])), f, function (e) {
      return e.theme.ParticipantsCanvas.Notification.Container;
    }), t.ActionButton = o.default("button")(d || (d = r(["\n    padding: 0px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: normal;\n    background: inherit;\n    color: inherit;\n    border: none;\n    outline: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n"], ["\n    padding: 0px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: normal;\n    background: inherit;\n    color: inherit;\n    border: none;\n    outline: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r46,
        o = this && this.__extends || (_r46 = function r(e, t) {
      return (_r46 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r46(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(0),
        c = n(2),
        l = n(274),
        u = n(275),
        p = n(4),
        d = n(7),
        f = n(6),
        h = n(48),
        m = n(49),
        g = n(36),
        y = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          showKickConfirmation: !1
        }, t.getThemeForButtons = function () {
          return function (e) {
            return s.Utils.merge(e, {
              Button: e.ParticipantsCanvas.ParticipantCanvas.Button
            });
          };
        }, t.showKickConfirmation = function () {
          return t.setState({
            showKickConfirmation: !0
          });
        }, t.hideKickConfirmation = function () {
          return t.setState({
            showKickConfirmation: !1
          });
        }, t.onCancelTransferClick = function () {
          var e = t.props.task;
          f.tryInvokeAction("CancelTransfer", {
            task: e
          });
        }, t.onHoldParticipantClick = function () {
          var e = t.props,
              n = e.task,
              r = e.participant;
          "worker" === r.participantType ? f.tryInvokeAction(r.onHold ? "UnholdParticipant" : "HoldParticipant", {
            task: n,
            targetSid: r.workerSid
          }) : f.tryInvokeAction(r.onHold ? "UnholdCall" : "HoldCall", {
            task: n
          });
        }, t.onKickParticipantConfirmClick = function () {
          var e = t.props,
              n = e.task,
              r = e.participant;
          f.tryInvokeAction("KickParticipant", {
            task: n,
            targetSid: r.workerSid
          }), t.hideKickConfirmation();
        }, t;
      }

      var n;
      return o(t, e), n = t, t.prototype.render = function () {
        var e = this.props,
            t = e.task,
            n = e.participant,
            r = "recently_left" === n.status || d.TaskHelper.amIOnHold(t),
            o = "",
            i = "",
            s = p.templates.CallParticipantStatusLive;
        if ("customer" === this.props.participant.participantType) o = a.createElement(p.Template, {
          code: "CallParticipantCustomerName",
          task: t
        });else if ("worker" === n.participantType || "transfer" === n.participantType) {
          var c = n.worker;
          c ? (o = c.fullName, i = c.attributes.image_url) : n.queue && (o = n.queue.name);
        }
        return n.onHold && (s = p.templates.CallParticipantStatusOnHold), "recently_left" === n.status && (s = "transfer" === n.participantType ? p.templates.CallParticipantStatusTransferFailed : p.templates.CallParticipantStatusLeft), n.connecting && (s = p.templates.CallParticipantStatusConnecting), this.state.showKickConfirmation && (s = p.templates.CallParticipantStatusKickConfirmation), this.props.listMode ? this.renderContentList(r, o, i, s) : this.renderContent(r, o, i, s);
      }, t.prototype.renderContent = function (e, t, r, o) {
        var i = this.props,
            c = i.task,
            u = i.participant,
            f = i.theme,
            h = i.hideActions,
            m = f.ParticipantsCanvas.ParticipantCanvas.ConnectingAnimation.color,
            y = this.getThemeForButtons();
        return a.createElement(g.ThemeProvider, {
          theme: y
        }, a.createElement(s.DynamicComponent, {
          contentStore: n.Content,
          childProps: this.props,
          name: n.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, a.createElement(l.Container, {
          participantWidth: this.props.participantWidth,
          isDisabled: e
        }, a.createElement(l.StyledAvatar, {
          key: "avatar",
          className: "ParticipantCanvas-Avatar",
          imageUrl: r,
          large: !0,
          showAvailabilityIcon: !1,
          noStyling: !0,
          hold: u.onHold
        }), (u.onHold || u.connecting) && a.createElement(l.AvatarHover, {
          key: "avatar-hover",
          className: "ParticipantCanvas-Hover"
        }, u.connecting && a.createElement(s.ConnectingAnimation, {
          color: m,
          sizeMultiplier: 3
        }), u.onHold && a.createElement(s.Icon, {
          icon: "HoldBold",
          sizeMultiplier: 2
        })), a.createElement(l.Name, {
          key: "name",
          className: "ParticipantCanvas-Name"
        }, t, " "), a.createElement(l.Status, {
          key: "status",
          className: "ParticipantCanvas-Status"
        }, a.createElement(p.Template, {
          source: o
        })), !h && d.TaskHelper.isMyTask(c) && a.createElement(l.ActionsContainer, {
          key: "actions",
          className: "ParticipantCanvas-Actions"
        }, a.createElement(s.DynamicComponent, {
          contentStore: n.Actions.Content,
          childProps: this.props,
          name: n.Actions.displayName,
          noContainers: !0
        }, this.renderActions())))));
      }, t.prototype.renderContentList = function (e, t, r, o) {
        var i = this.props,
            c = i.task,
            l = i.participant,
            f = i.theme,
            h = i.hideActions,
            m = f.ParticipantsCanvas.ParticipantCanvas.ConnectingAnimation.color,
            y = this.getThemeForButtons();
        return a.createElement(g.ThemeProvider, {
          theme: y
        }, a.createElement(s.DynamicComponent, {
          contentStore: n.ListItem.Content,
          childProps: this.props,
          name: n.ListItem.displayName,
          customChildren: this.props.children,
          noContainers: !0
        }, a.createElement(u.Container, {
          isDisabled: e
        }, a.createElement(u.StyledAvatar, {
          key: "avatar",
          className: "ParticipantCanvas-Avatar",
          imageUrl: r,
          showAvailabilityIcon: !1,
          noStyling: !0,
          hold: l.onHold
        }), (l.onHold || l.connecting) && a.createElement(u.AvatarHover, {
          key: "avatar-hover",
          className: "ParticipantCanvas-Hover"
        }, l.connecting && a.createElement(s.ConnectingAnimation, {
          color: m
        }), l.onHold && a.createElement(s.Icon, {
          icon: "HoldBold",
          sizeMultiplier: 1
        })), a.createElement(u.StatusContainer, {
          key: "statusContainer"
        }, a.createElement(u.Name, {
          key: "name",
          className: "ParticipantCanvas-Name"
        }, t, " "), a.createElement(u.Status, {
          key: "status",
          className: "ParticipantCanvas-Status"
        }, a.createElement(p.Template, {
          source: o
        }))), !h && d.TaskHelper.isMyTask(c) && a.createElement(u.ActionsContainer, {
          key: "actions",
          className: "ParticipantCanvas-Actions"
        }, a.createElement(s.DynamicComponent, {
          contentStore: n.Actions.Content,
          childProps: this.props,
          name: n.Actions.displayName,
          noContainers: !0
        }, this.renderActions())))));
      }, t.prototype.renderActions = function () {
        var e = this;
        if (this.state.showKickConfirmation) return this.renderKickConfirmation();
        var t = this.props,
            n = t.participant,
            r = t.theme,
            o = t.task;
        if (n.connecting && "transfer" === n.participantType) return a.createElement(a.Fragment, null, a.createElement(s.ActionStateListener, {
          key: "cancel-transfer",
          action: "CancelTransfer",
          payload: m.isValidWorkerActionPayload(o)
        }, function (t) {
          return a.createElement(s.IconButton, {
            icon: "CloseLarge",
            className: "ParticipantCanvas-CancelButton",
            onClick: e.onCancelTransferClick,
            themeOverride: r.ParticipantsCanvas.ParticipantCanvas.HangUpButton,
            title: p.templates.CancelTransferTooltip(),
            disabled: t.disabled
          });
        }));
        var i = n.onHold ? p.templates.UnholdCustomerTooltip() : p.templates.HoldCustomerTooltip(),
            c = ["HoldCall", "UnholdCall"],
            l = h.isValidVoiceActionPayload(o);
        return "worker" === n.participantType && (i = n.onHold ? p.templates.UnholdAgentTooltip({
          worker: n.worker
        }) : p.templates.HoldAgentTooltip({
          worker: n.worker
        }), c = ["HoldParticipant", "UnholdParticipant"], l = m.isValidWorkerParticipantActionPayload(o, n.workerSid)), a.createElement(a.Fragment, null, a.createElement(s.ActionStateListener, {
          key: "hold",
          action: c,
          payload: l
        }, function (t) {
          return a.createElement(s.IconButton, {
            icon: n.onHold ? "HoldOff" : "Hold",
            className: "ParticipantCanvas-HoldButton",
            disabled: !d.TaskHelper.canHold(o) || "joined" !== n.status || t.disabled,
            onClick: e.onHoldParticipantClick,
            title: i
          });
        }), "worker" === n.participantType && a.createElement(s.ActionStateListener, {
          key: "kick",
          action: "KickParticipant",
          payload: m.isValidWorkerActionPayload(o)
        }, function (t) {
          return a.createElement(s.IconButton, {
            icon: "Hangup",
            className: "ParticipantCanvas-HangupButton",
            disabled: !d.TaskHelper.canKickWorkerParticipant(o, n) || t.disabled,
            onClick: e.showKickConfirmation,
            themeOverride: r.ParticipantsCanvas.ParticipantCanvas.HangUpButton,
            title: p.templates.KickAgentTooltip({
              worker: n.worker
            })
          });
        }));
      }, t.prototype.renderKickConfirmation = function () {
        return a.createElement(a.Fragment, null, a.createElement(s.IconButton, {
          key: "accept-kick",
          icon: "Accept",
          className: "ParticipantCanvas-AcceptAction",
          onClick: this.onKickParticipantConfirmClick
        }), a.createElement(s.IconButton, {
          key: "cancel-kick",
          icon: "Close",
          className: "ParticipantCanvas-DeclineAction",
          onClick: this.hideKickConfirmation
        }));
      }, t.displayName = "ParticipantCanvas", t.Content = new s.DynamicContentStore(n.displayName), t.ListItem = {
        displayName: "ParticipantCanvasListItem",
        Content: new s.DynamicContentStore("ParticipantCanvasListItem")
      }, t.Actions = {
        displayName: "ParticipantCanvasActions",
        Content: new s.DynamicContentStore("ParticipantCanvasActions")
      }, t = n = i([c.withTheme], t);
    }(a.Component);

    t.ParticipantCanvas = y;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u = n(0),
        p = n(2);
    t.Container = p.default("div")(o || (o = r(["\n    flex-grow: 0;\n    padding: 8px;\n    font-size: 30px;\n    text-align: center;\n    box-sizing: border-box;\n    min-width: 170px;\n    width: ", ";\n    opacity: ", ";\n    ", "\n"], ["\n    flex-grow: 0;\n    padding: 8px;\n    font-size: 30px;\n    text-align: center;\n    box-sizing: border-box;\n    min-width: 170px;\n    width: ", ";\n    opacity: ", ";\n    ", "\n"])), function (e) {
      return e.participantWidth + "%";
    }, function (e) {
      return e.isDisabled && .4;
    }, function (e) {
      return e.theme.ParticipantsCanvas.ParticipantCanvas.Container;
    }), t.Name = p.default("div")(i || (i = r(["\n    font-size: 14px;\n    font-weight: bold;\n    margin-top: 10px;\n    margin-bottom: 4px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    font-size: 14px;\n    font-weight: bold;\n    margin-top: 10px;\n    margin-bottom: 4px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"]))), t.Status = p.default("div")(a || (a = r(["\n    font-size: 12px;\n"], ["\n    font-size: 12px;\n"]))), t.StyledAvatar = p.default(u.Avatar)(s || (s = r(["\n    margin: 0 auto;\n    width: 72px;\n    height: 72px;\n    border-radius: 1000px;\n    position: relative;\n    border-style: solid;\n    border-width: 1px;\n    ", ";\n    background: ", ";\n"], ["\n    margin: 0 auto;\n    width: 72px;\n    height: 72px;\n    border-radius: 1000px;\n    position: relative;\n    border-style: solid;\n    border-width: 1px;\n    ", ";\n    background: ", ";\n"])), function (e) {
      return e.theme.ParticipantsCanvas.ParticipantCanvas.Avatar;
    }, function (e) {
      return e.hold && e.theme.colors.holdColor;
    }), t.AvatarHover = p.default(u.FlexBox)(c || (c = r(["\n    left: 50%;\n    transform: translateX(-50%);\n    margin: 1px auto;\n    border-radius: 1000px;\n    width: 72px;\n    height: 72px;\n    position: absolute;\n    justify-content: center;\n    ", "\n"], ["\n    left: 50%;\n    transform: translateX(-50%);\n    margin: 1px auto;\n    border-radius: 1000px;\n    width: 72px;\n    height: 72px;\n    position: absolute;\n    justify-content: center;\n    ", "\n"])), function (e) {
      return e.theme.ParticipantsCanvas.ParticipantCanvas.StateHover;
    }), t.ActionsContainer = p.default("div")(l || (l = r(["\n    margin-top: 10px;\n    button {\n        width: 30px;\n        height: 30px;\n        margin-left: 6px;\n        margin-right: 6px;\n    }\n"], ["\n    margin-top: 10px;\n    button {\n        width: 30px;\n        height: 30px;\n        margin-left: 6px;\n        margin-right: 6px;\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u,
        p = n(0),
        d = n(2);
    t.Container = d.default("div")(o || (o = r(["\n    flex-grow: 0;\n    overflow: hidden;\n    padding: 8px 16px 0px 16px;\n    font-size: 12px;\n    box-sizing: border-box;\n    opacity: ", ";\n    ", ";\n"], ["\n    flex-grow: 0;\n    overflow: hidden;\n    padding: 8px 16px 0px 16px;\n    font-size: 12px;\n    box-sizing: border-box;\n    opacity: ", ";\n    ", ";\n"])), function (e) {
      return e.isDisabled && .4;
    }, function (e) {
      return e.theme.ParticipantsCanvas.ParticipantCanvas.Container;
    }), t.Name = d.default("div")(i || (i = r(["\n    font-size: 12px;\n    font-weight: bold;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    font-size: 12px;\n    font-weight: bold;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"]))), t.StatusContainer = d.default(p.FlexBoxColumn)(a || (a = r(["\n    overflow: hidden;\n"], ["\n    overflow: hidden;\n"]))), t.Status = d.default("div")(s || (s = r(["\n    font-size: 10px;\n"], ["\n    font-size: 10px;\n"]))), t.StyledAvatar = d.default(p.Avatar)(c || (c = r(["\n    margin: 0 auto;\n    width: 30px;\n    height: 30px;\n    border-radius: 1000px;\n    position: relative;\n    border-style: solid;\n    border-width: 1px;\n    margin-right: 12px;\n    ", ";\n    background: ", ";\n"], ["\n    margin: 0 auto;\n    width: 30px;\n    height: 30px;\n    border-radius: 1000px;\n    position: relative;\n    border-style: solid;\n    border-width: 1px;\n    margin-right: 12px;\n    ", ";\n    background: ", ";\n"])), function (e) {
      return e.theme.ParticipantsCanvas.ParticipantCanvas.Avatar;
    }, function (e) {
      return e.hold && e.theme.colors.holdColor;
    }), t.AvatarHover = d.default(p.FlexBox)(l || (l = r(["\n    left: 17px;\n    border-radius: 1000px;\n    width: 30px;\n    height: 30px;\n    position: absolute;\n    justify-content: center;\n    ", "\n"], ["\n    left: 17px;\n    border-radius: 1000px;\n    width: 30px;\n    height: 30px;\n    position: absolute;\n    justify-content: center;\n    ", "\n"])), function (e) {
      return e.theme.ParticipantsCanvas.ParticipantCanvas.StateHover;
    }), t.ActionsContainer = d.default("div")(u || (u = r(["\n    display: flex;\n    flex-grow: 0;\n    button {\n        width: 32px;\n        height: 32px;\n        margin-left: 6px;\n        margin-right: 6px;\n    }\n"], ["\n    display: flex;\n    flex-grow: 0;\n    button {\n        width: 32px;\n        height: 32px;\n        margin-left: 6px;\n        margin-right: 6px;\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r47,
        o = this && this.__extends || (_r47 = function r(e, t) {
      return (_r47 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r47(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(278),
        u = n(3),
        p = n(14),
        d = n(2),
        f = n(27),
        h = n(19),
        m = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(g, i({}, this.props));
      }, t.displayName = l.displayName, t.Content = l.contentStore, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.TaskCanvasTabs = m;
    var g = u.connect(function (e) {
      var t = e.view.componentViewStates.SupervisorCanvasTabs,
          n = f.featureFlagsSelector(e)[h.FeatureFlag.MarkdownSupport];
      return {
        selectedTabName: !!t && t.selectedTabName,
        uniqueName: "SupervisorCanvasTabs",
        hasMarkdownSupport: n && n.enabled
      };
    })(p.withTaskContext(d.withTheme(l.TaskCanvasTabsImpl)));
  }, function (e, t, n) {
    "use strict";

    var _r48,
        o = this && this.__extends || (_r48 = function r(e, t) {
      return (_r48 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r48(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        a = n(0),
        s = n(145),
        c = n(4),
        l = n(104),
        u = n(155),
        p = n(7),
        d = n(12),
        f = n(11),
        h = n(36),
        m = n(6);
    t.displayName = "SupervisorTaskCanvasTabs", t.contentStore = new a.DynamicContentStore(t.displayName);

    var g = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleTabSelection = function (e) {
          m.tryInvokeAction("SetComponentState", {
            name: "SupervisorCanvasTabs",
            state: {
              selectedTabName: e
            }
          });
        }, t;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props,
            n = e.task,
            r = e.selectedTabName,
            o = c.templates.TaskTabSupervisorOverviewLabel;
        return p.TaskHelper.isCallTask(n) ? o = c.templates.TaskTabSupervisorCallLabel : p.TaskHelper.isChatBasedTask(n) && (o = c.templates.TaskTabSupervisorChatLabel), i.createElement(a.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0,
          vertical: !0
        }, i.createElement(a.Tabs, {
          className: "Twilio-TaskCanvasTabs",
          selectedTabName: r,
          onTabSelected: this.handleTabSelection
        }, i.createElement(a.Tab, {
          key: "overview",
          uniqueName: "overview",
          label: i.createElement(a.Template, {
            source: o
          })
        }, this.renderOverviewTab()), i.createElement(a.Tab, {
          key: "info",
          uniqueName: "info",
          label: i.createElement(a.Template, {
            source: c.templates.TaskTabSupervisorInfoLabel
          })
        }, i.createElement(u.TaskInfoPanel, {
          task: n
        }))));
      }, n.prototype.renderOverviewTab = function () {
        var e = this.props,
            t = e.task,
            r = e.hasMarkdownSupport;

        if (p.TaskHelper.isChatBasedTask(t)) {
          if (!this.props.chatChannel || this.props.chatChannel.isLoadingChannel) return null;
          if (this.props.chatChannel.errorWhileLoadingChannel) return i.createElement(l.TaskOverviewCanvas, {
            task: t
          });
          var o = d.TaskChannels.getForTask(t),
              u = f.TaskChannelHelper.getColor(t, o.colors.main, n),
              m = s.getThemeForChat(u);
          return i.createElement(h.ThemeProvider, {
            theme: m
          }, i.createElement(a.MessagingCanvas, {
            sid: p.TaskHelper.getTaskChatChannelSid(t),
            inputDisabledReason: p.TaskHelper.isCompleted(t) || p.TaskHelper.isInWrapupMode(t) ? c.templates.ChatInputDisabledText() : void 0,
            hasMarkdownSupport: r
          }));
        }

        return i.createElement(l.TaskOverviewCanvas, {
          task: t
        });
      }, n;
    }(i.PureComponent);

    t.TaskCanvasTabsImpl = g;
  }, function (e, t, n) {
    "use strict";

    var _r49,
        o = this && this.__extends || (_r49 = function r(e, t) {
      return (_r49 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r49(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(2),
        c = n(1),
        l = n(0),
        u = n(46),
        p = n(149),
        d = n(150),
        f = n(11);
    t.displayName = "IncomingTaskCanvas", t.contentStore = new l.DynamicContentStore(t.displayName);

    var h = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      var r;
      return o(n, e), r = n, n.prototype.render = function () {
        var e = this.props,
            n = e.firstLine,
            o = e.secondLine,
            a = e.channelDefinition,
            s = e.titleLine,
            l = this.props.task;
        return c.createElement(u.TaskDetailsPanel, i({
          content: t.contentStore,
          IconComponent: d.IncomingTaskIcon,
          ActionsComponent: p.IncomingTaskCanvasActions,
          titleLine: s || f.TaskChannelHelper.getTemplateForStatus(l, a.templates.IncomingTaskCanvas.titleLine, r),
          firstLine: n || f.TaskChannelHelper.getTemplateForStatus(l, a.templates.IncomingTaskCanvas.firstLine, r),
          secondLine: o || f.TaskChannelHelper.getTemplateForStatus(l, a.templates.IncomingTaskCanvas.secondLine, r)
        }, this.props));
      }, n = r = a([s.withTheme], n);
    }(c.PureComponent);

    t.IncomingTaskCanvasImpl = h;
  }, function (e, t, n) {
    "use strict";

    var _r50,
        o = this && this.__extends || (_r50 = function r(e, t) {
      return (_r50 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r50(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(2),
        s = n(1),
        c = n(0),
        l = n(4),
        u = n(6),
        p = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onAcceptClick = function () {
          u.tryInvokeAction("AcceptTask", {
            task: t.props.task
          });
        }, t.onDeclineClick = function () {
          u.tryInvokeAction("RejectTask", {
            task: t.props.task
          });
        }, t;
      }

      var n;
      return o(t, e), n = t, t.prototype.render = function () {
        var e = this;
        return s.createElement(c.DynamicComponent, {
          contentStore: n.Content,
          childProps: this.props,
          customChildren: this.props.children,
          name: n.displayName,
          noContainers: !0
        }, s.createElement(c.ContentFragment, null, s.createElement(c.ActionStateListener, {
          key: "Accept",
          action: ["AcceptTask", "RejectTask"]
        }, function (t) {
          return s.createElement(c.IconButton, {
            className: "Twilio-IncomingTask-Accept",
            icon: "AcceptLarge",
            themeOverride: e.props.theme.IncomingTaskCanvas.AcceptTaskButton,
            onClick: e.onAcceptClick,
            disabled: t.disabled,
            title: l.templates.AcceptTaskTooltip()
          });
        }), s.createElement(c.ActionStateListener, {
          key: "Reject",
          action: ["AcceptTask", "RejectTask"]
        }, function (t) {
          return s.createElement(c.IconButton, {
            className: "Twilio-IncomingTask-Reject",
            icon: "CloseLarge",
            themeOverride: e.props.theme.IncomingTaskCanvas.RejectTaskButton,
            onClick: e.onDeclineClick,
            disabled: t.disabled,
            title: l.templates.RejectTaskTooltip()
          });
        })));
      }, t.displayName = "IncomingTaskCanvasActions", t.Content = new c.DynamicContentStore(n.displayName), t = n = i([a.withTheme], t);
    }(s.Component);

    t.IncomingTaskCanvasActions = p;
  }, function (e, t, n) {
    "use strict";

    var _r51,
        o = this && this.__extends || (_r51 = function r(e, t) {
      return (_r51 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r51(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(2),
        s = n(1),
        c = n(9),
        l = n(47),
        u = n(11),
        p = n(148),
        d = n(0),
        f = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props.task;
        return s.createElement(c.TaskContext.Consumer, null, function (t) {
          return s.createElement(l.IconContainerWithStyle, {
            background: u.TaskChannelHelper.getColor(e, t.channelDefinition.colors.main, p.IncomingTaskCanvas)
          }, s.createElement(d.Icon, {
            icon: u.TaskChannelHelper.getIcon(e, t.channelDefinition.icons.active, p.IncomingTaskCanvas),
            sizeMultiplier: 2
          }));
        });
      }, t = i([a.withTheme], t);
    }(s.Component);

    t.IncomingTaskIcon = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r52,
        o = this && this.__extends || (_r52 = function r(e, t) {
      return (_r52 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r52(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(0),
        c = n(7),
        l = n(141),
        u = n(138),
        p = n(284),
        d = n(153),
        f = n(11),
        h = n(293),
        m = n(6);
    t.displayName = "CallCanvas", t.contentStore = new s.DynamicContentStore(t.displayName);

    var g = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.componentDidUpdate = function () {
        var e = this.props.task;
        this.props.dialpadState && !c.TaskHelper.isLiveCall(e) && m.tryInvokeAction("ToggleDTMFDialpad", {
          task: e,
          open: !1
        });
      }, n.prototype.render = function () {
        var e,
            r = this.props,
            o = r.task,
            s = r.channelDefinition,
            m = r.conference,
            g = r.dialpadState;
        return m && c.TaskHelper.isLiveCall(o) && (e = a.createElement(l.ParticipantsCanvas, null)), g && (e = a.createElement(h.CallCanvasDialpad, {
          dialpadState: g
        })), a.createElement(u.TaskDetailsPanel, i({
          content: t.contentStore,
          IconComponent: p.CallCanvasIcon,
          ActionsComponent: d.CallCanvasActions,
          contentComponent: e,
          titleLine: f.TaskChannelHelper.getTemplateForStatus(o, s.templates.CallCanvas.titleLine, n),
          firstLine: f.TaskChannelHelper.getTemplateForStatus(o, s.templates.CallCanvas.firstLine, n),
          secondLine: f.TaskChannelHelper.getTemplateForStatus(o, s.templates.CallCanvas.secondLine, n)
        }, this.props));
      }, n;
    }(a.PureComponent);

    t.CallCanvasImpl = g;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(285);
    t.CallCanvasIcon = r.CallCanvasIcon;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(1),
        o = n(12),
        i = n(152),
        a = n(47),
        s = n(286);

    t.CallCanvasIcon = function (e) {
      var t = e.task,
          n = o.TaskChannels.getForTask(t),
          c = o.TaskChannelHelper.getIcon(t, n.icons.active, i.CallCanvas),
          l = o.TaskChannelHelper.getColor(t, n.colors.main, i.CallCanvas);
      return r.createElement(a.IconContainerWithStyle, {
        background: l
      }, r.createElement(s.StyledIcon, {
        icon: c,
        sizeMultiplier: 2
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(0),
        a = n(2);
    t.StyledIcon = a.default(i.Icon)(o || (o = r(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (e) {
      return e.color;
    });
  }, function (e, t, n) {
    "use strict";

    var _r53,
        o = this && this.__extends || (_r53 = function r(e, t) {
      return (_r53 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r53(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(288),
        l = n(9),
        u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(c.CallCanvasActionsImpl, i({}, this.props));
      }, t.displayName = c.displayName, t.Content = c.contentStore, t = a([l.withTaskContext], t);
    }(s.Component);

    t.CallCanvasActions = u;
  }, function (e, t, n) {
    "use strict";

    var _r54,
        o = this && this.__extends || (_r54 = function r(e, t) {
      return (_r54 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r54(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(2),
        c = n(0),
        l = n(4),
        u = n(86),
        p = n(291),
        d = n(7),
        f = n(48),
        h = n(6),
        m = n(3),
        g = n(36);
    t.displayName = "CallCanvasActions", t.contentStore = new c.DynamicContentStore(t.displayName);

    var y = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onHoldClick = function () {
          var e = d.TaskHelper.isCallOnHold(t.props.task);
          h.tryInvokeAction(e ? "UnholdCall" : "HoldCall", {
            task: t.props.task
          });
        }, t.onHangupClick = function () {
          h.tryInvokeAction("HangupCall", {
            task: t.props.task
          });
        }, t.onDirectoryClick = function () {
          h.tryInvokeAction("ShowDirectory", {
            task: t.props.task
          });
        }, t.onDialpadClick = function () {
          var e = t.props.task;
          h.tryInvokeAction("ToggleDTMFDialpad", {
            task: e
          });
        }, t.getThemeForButtons = function () {
          return function (e) {
            return c.Utils.merge(e, {
              Button: e.CallCanvas.Button
            });
          };
        }, t;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this,
            n = this.props,
            r = n.task,
            o = n.theme,
            i = d.TaskHelper.isLiveCall(r),
            s = d.TaskHelper.isRegularConferenceCall(r),
            h = d.TaskHelper.isCallOnHold(r),
            y = d.TaskHelper.canHold(r),
            v = d.TaskHelper.canTransfer(r),
            b = f.isValidVoiceActionPayload(r),
            C = l.templates.HangupCallTooltip(),
            _ = "HangupLarge";
        r.conference && r.conference.liveParticipantCount > 2 && (_ = "LeaveCallLarge", C = l.templates.LeaveCallTooltip());
        var k = h ? l.templates.UnholdCustomerTooltip() : l.templates.HoldCustomerTooltip(),
            w = "CallCanvasDialpad" + this.props.task.sid,
            T = Boolean(m.FlexModule.state.view.componentViewStates[w]),
            O = this.getThemeForButtons();
        return a.createElement(g.ThemeProvider, {
          theme: O
        }, a.createElement(c.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          customChildren: this.props.children,
          name: t.displayName,
          noContainers: !0
        }, a.createElement(c.ContentFragment, null, !s && a.createElement(c.ActionStateListener, {
          key: "hold",
          action: ["HoldCall", "UnholdCall"],
          payload: b
        }, function (t) {
          return a.createElement(p.HoldButton, {
            className: "Twilio-CallCanvas-HoldButton",
            disabled: !i || !y || t.disabled,
            isOnHold: h,
            onClick: e.onHoldClick,
            title: k
          });
        }), a.createElement(c.ActionStateListener, {
          key: "toggleMute",
          action: "ToggleMute"
        }, function (e) {
          return a.createElement(u.MuteButton, {
            className: "Twilio-CallCanvas-MuteButton",
            disabled: !i || e.disabled,
            large: !0,
            title: l.templates.MuteCallTooltip()
          });
        }), a.createElement(c.IconButton, {
          className: "Twilio-CallCanvas-Directory",
          icon: "TransferLarge",
          key: "directory",
          disabled: !i || !v,
          onClick: this.onDirectoryClick
        }), a.createElement(c.IconButton, {
          className: "Twilio-CallCanvas-Dialpad",
          icon: T ? "CloseLarge" : "DialpadLarge",
          key: "dialpad",
          disabled: !i,
          onClick: this.onDialpadClick
        }), a.createElement(c.ActionStateListener, {
          key: "hangup",
          action: "HangupCall",
          payload: b
        }, function (t) {
          return a.createElement(c.IconButton, {
            className: "Twilio-CallCanvas-HangupButton",
            icon: _,
            disabled: !i || t.disabled,
            onClick: e.onHangupClick,
            themeOverride: o.CallCanvas.HangUpButton,
            title: C
          });
        }))));
      }, n = i([s.withTheme], n);
    }(a.PureComponent);

    t.CallCanvasActionsImpl = y;
  }, function (e, t, n) {
    "use strict";

    var _r55,
        o = this && this.__extends || (_r55 = function r(e, t) {
      return (_r55 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r55(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(3),
        c = n(290),
        l = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return a.createElement(u, i({}, this.props));
      }, t;
    }(a.PureComponent);

    t.MuteButton = l;
    var u = s.connect(function (e, t) {
      return {
        muted: !!e.phone.connection && e.phone.connection.source.isMuted(),
        disabled: !e.phone.connection || t.disabled
      };
    })(c.MuteButtonImpl);
  }, function (e, t, n) {
    "use strict";

    var _r56,
        o = this && this.__extends || (_r56 = function r(e, t) {
      return (_r56 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r56(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__rest || function (e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(21),
        u = n(4),
        p = n(6),
        d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onMuteClick = function () {
          p.tryInvokeAction("ToggleMute");
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.large,
            n = e.className,
            r = e.muted,
            o = (e.children, a(e, ["large", "className", "muted", "children"])),
            p = t ? "MuteLarge" : "Mute";
        return r && (p += "Bold"), s.createElement(c.IconButton, i({
          className: l.cx("Twilio-MuteButton", n),
          icon: p,
          onClick: this.onMuteClick,
          title: u.templates.MuteCallTooltip()
        }, o));
      }, t;
    }(s.PureComponent);

    t.MuteButtonImpl = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(292);
    t.HoldButton = r.HoldButton, t.HoldButtonProps = r.HoldButtonProps;
  }, function (e, t, n) {
    "use strict";

    var _r57,
        o = this && this.__extends || (_r57 = function r(e, t) {
      return (_r57 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r57(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__rest || function (e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(21),
        u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.className,
            n = e.isOnHold,
            r = e.onClick,
            o = a(e, ["className", "isOnHold", "onClick"]),
            u = n ? "HoldOffLarge" : "HoldLarge";
        return s.createElement(c.IconButton, i({
          className: l.cx("Twilio-HoldButton", t),
          icon: u,
          onClick: r
        }, o));
      }, t;
    }(s.PureComponent);

    t.HoldButton = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(294);
    t.CallCanvasDialpad = r.CallCanvasDialpad;
  }, function (e, t, n) {
    "use strict";

    var _r58,
        o = this && this.__extends || (_r58 = function r(e, t) {
      return (_r58 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r58(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(9),
        c = n(295),
        l = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return a.createElement(t.Connected, i({}, this.props));
      }, n.displayName = c.displayName, n.Content = c.contentStore, n;
    }(a.PureComponent);

    t.CallCanvasDialpad = l, t.Connected = s.withTaskContext(c.CallCanvasDialpadImpl);
  }, function (e, t, n) {
    "use strict";

    var _r59,
        o = this && this.__extends || (_r59 = function r(e, t) {
      return (_r59 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r59(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        a = n(0),
        s = n(6),
        c = n(296);
    t.displayName = "CallCanvasDialpad", t.contentStore = new a.DynamicContentStore(t.displayName);

    var l = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleKeyClick = function (e) {
          s.tryInvokeAction("SendDTMFDigits", {
            task: t.props.task,
            digits: e
          });
        }, t;
      }

      return o(n, e), n.prototype.render = function () {
        return i.createElement(a.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0
        }, i.createElement(c.Container, {
          className: "Twilio-CallCanvas-Dialpad"
        }, i.createElement(c.DigitsContainer, {
          key: "digits"
        }, i.createElement(c.Digits, null, this.props.dialpadState.digits)), i.createElement(a.Dialpad, {
          key: "dialpad",
          onClick: this.handleKeyClick
        })));
      }, n;
    }(i.PureComponent);

    t.CallCanvasDialpadImpl = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c = n(2),
        l = n(21).keyframes(o || (o = r(["\n    from {\n        opacity: 0.3;\n        transform: translate3d(0, 30px, 0);\n    }\n\n    to {\n        opacity: 1;\n        transform: translate3d(0);\n    }\n"], ["\n    from {\n        opacity: 0.3;\n        transform: translate3d(0, 30px, 0);\n    }\n\n    to {\n        opacity: 1;\n        transform: translate3d(0);\n    }\n"])));
    t.DigitsContainer = c.default("div")(i || (i = r(["\n    height: 44px;\n    display: flex;\n    overflow: hidden;\n    justify-content: center;\n    width: 100%;\n"], ["\n    height: 44px;\n    display: flex;\n    overflow: hidden;\n    justify-content: center;\n    width: 100%;\n"]))), t.Digits = c.default("span")(a || (a = r(["\n    font-size: 18px;\n    line-height: 1.33;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    font-size: 18px;\n    line-height: 1.33;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"]))), t.Container = c.default("div")(s || (s = r(["\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0 12px;\n    animation: ", " 0.15s ease 1;\n"], ["\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0 12px;\n    animation: ", " 0.15s ease 1;\n"])), l);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r60,
        o = this && this.__extends || (_r60 = function r(e, t) {
      return (_r60 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r60(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(7),
        s = n(0),
        c = n(299),
        l = n(11),
        u = n(87),
        p = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.task,
            n = e.content,
            r = e.templateCode,
            o = e.channelDefinition,
            p = new a.TaskHelper(t);
        return i.createElement(s.DynamicComponent, {
          contentStore: n,
          childProps: this.props,
          name: n.name,
          customChildren: this.props.children,
          vertical: !0
        }, i.createElement(c.Container, null, i.createElement(s.Template, {
          key: "content",
          code: r || l.TaskChannelHelper.getTemplateForStatus(t, o.templates.TaskInfoPanel.content, u.TaskInfoPanel),
          task: t,
          helper: p
        })));
      }, t;
    }(i.PureComponent);

    t.TaskInfoPanelImpl = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2);
    t.Container = i.default("div")(o || (o = r(["\n    display: flex;\n    flex: 1 1 auto;\n    overflow: auto;\n    padding-left: 12px;\n    padding-right: 12px;\n    padding-top: 6px;\n    padding-bottom: 6px;\n    ", "\n\n    hr {\n        border-color: ", ";\n    }\n"], ["\n    display: flex;\n    flex: 1 1 auto;\n    overflow: auto;\n    padding-left: 12px;\n    padding-right: 12px;\n    padding-top: 6px;\n    padding-bottom: 6px;\n    ", "\n\n    hr {\n        border-color: ", ";\n    }\n"])), function (e) {
      return e.theme.TaskInfoPanel.Container;
    }, function (e) {
      return e.theme.Tabs.LabelsContainer.borderColor;
    });
  }, function (e, t, n) {
    "use strict";

    var _r61,
        o = this && this.__extends || (_r61 = function r(e, t) {
      return (_r61 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r61(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(9),
        c = n(301),
        l = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return a.createElement(t.Connected, i({}, this.props));
      }, n.displayName = c.displayName, n.Content = c.contentStore, n;
    }(a.PureComponent);

    t.ConnectingOutboundCallCanvas = l, t.Connected = s.withTaskContext(c.ConnectingOutboundCallCanvasImpl);
  }, function (e, t, n) {
    "use strict";

    var _r62,
        o = this && this.__extends || (_r62 = function r(e, t) {
      return (_r62 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r62(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(0),
        c = n(46),
        l = n(154),
        u = n(303),
        p = n(11),
        d = n(7),
        f = n(22);
    t.displayName = "ConnectingOutboundCallCanvas", t.contentStore = new s.DynamicContentStore(t.displayName);

    var h = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        var e,
            r = this.props,
            o = r.firstLine,
            s = r.secondLine,
            h = r.channelDefinition,
            m = r.titleLine,
            g = r.task;
        return d.TaskHelper.isInitialOutboundAttemptTask(g) && f.StateHelper.getCurrentPhoneCallState() && (e = l.ConnectingOutboundCallCanvasActions), a.createElement(c.TaskDetailsPanel, i({
          content: t.contentStore,
          IconComponent: u.ConnectingOutboundCallIcon,
          ActionsComponent: e,
          titleLine: m || p.TaskChannelHelper.getTemplateForStatus(g, h.templates.ConnectingOutboundCallCanvas.titleLine, n),
          firstLine: o || p.TaskChannelHelper.getTemplateForStatus(g, h.templates.ConnectingOutboundCallCanvas.firstLine, n),
          secondLine: s || p.TaskChannelHelper.getTemplateForStatus(g, h.templates.ConnectingOutboundCallCanvas.secondLine, n)
        }, this.props));
      }, n;
    }(a.PureComponent);

    t.ConnectingOutboundCallCanvasImpl = h;
  }, function (e, t, n) {
    "use strict";

    var _r63,
        o = this && this.__extends || (_r63 = function r(e, t) {
      return (_r63 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r63(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(2),
        s = n(1),
        c = n(0),
        l = n(4),
        u = n(6),
        p = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onCancelCall = function () {
          u.tryInvokeAction("HangupCall", {
            task: t.props.task
          });
        }, t;
      }

      var n;
      return o(t, e), n = t, t.prototype.render = function () {
        var e = this;
        return s.createElement(c.DynamicComponent, {
          contentStore: n.Content,
          childProps: this.props,
          customChildren: this.props.children,
          name: n.displayName,
          noContainers: !0
        }, s.createElement(c.ContentFragment, null, s.createElement(c.ActionStateListener, {
          key: "Cancel",
          action: "HangupCall"
        }, function (t) {
          return s.createElement(c.IconButton, {
            className: "Twilio-OutboundCall-Cancel",
            icon: "HangupLarge",
            themeOverride: e.props.theme.ConnectingOutboundCallCanvas.CancelCallButton,
            onClick: e.onCancelCall,
            disabled: t.disabled,
            title: l.templates.HangupCallTooltip()
          });
        })));
      }, t.displayName = "ConnectingOutboundCallCanvasActions", t.Content = new c.DynamicContentStore(n.displayName), t = n = i([a.withTheme], t);
    }(s.Component);

    t.ConnectingOutboundCallCanvasActions = p;
  }, function (e, t, n) {
    "use strict";

    var _r64,
        o = this && this.__extends || (_r64 = function r(e, t) {
      return (_r64 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r64(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a,
        s,
        c = n(1),
        l = n(9),
        u = n(47),
        p = n(11),
        d = n(88),
        f = n(0),
        h = n(2),
        m = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props.task;
        return c.createElement(l.TaskContext.Consumer, null, function (n) {
          return c.createElement(u.IconContainerWithStyle, {
            background: p.TaskChannelHelper.getColor(e, n.channelDefinition.colors.main, d.ConnectingOutboundCallCanvas)
          }, c.createElement(t.StyledIcon, {
            icon: p.TaskChannelHelper.getIcon(e, n.channelDefinition.icons.active, d.ConnectingOutboundCallCanvas),
            sizeMultiplier: 2
          }), c.createElement(t.CallAnimation, null, c.createElement(f.ConnectingAnimation, {
            sizeMultiplier: 3
          })));
        });
      }, n;
    }(c.Component);

    t.ConnectingOutboundCallIcon = m, t.StyledIcon = h.default(f.Icon)(a || (a = i(["\n    opacity: 6 0%;\n"], ["\n    opacity: 6 0%;\n"]))), t.CallAnimation = h.default("div")(s || (s = i(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r65,
        o = this && this.__extends || (_r65 = function r(e, t) {
      return (_r65 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r65(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(156),
        u = n(9),
        p = n(11),
        d = n(144),
        f = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      var n;
      return o(t, e), n = t, t.prototype.render = function () {
        var e = this,
            t = this.props,
            r = t.templateCode,
            o = t.task;
        return s.createElement(u.TaskContext.Consumer, null, function (t) {
          return s.createElement(l.TaskInfoPanel, i({}, e.props, {
            templateCode: r || p.TaskChannelHelper.getTemplateForStatus(o, t.channelDefinition.templates.Supervisor.TaskInfoPanel.content, d.TaskCanvas),
            content: n.Content
          }));
        });
      }, t.displayName = "SupervisorTaskInfoPanel", t.Content = new c.DynamicContentStore(n.displayName), t.defaultProps = {}, t = n = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.TaskInfoPanel = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r66,
        o = this && this.__extends || (_r66 = function r(e, t) {
      return (_r66 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r66(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(9),
        c = n(309),
        l = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return a.createElement(t.Connected, i({}, this.props));
      }, n.displayName = c.displayName, n.Content = c.contentStore, n;
    }(a.PureComponent);

    t.TaskCanvasHeader = l, t.Connected = s.withTaskContext(c.TaskCanvasHeaderImpl);
  }, function (e, t, n) {
    "use strict";

    var _r67,
        o = this && this.__extends || (_r67 = function r(e, t) {
      return (_r67 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r67(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(0),
        c = n(2),
        l = n(310),
        u = n(7),
        p = n(11),
        d = n(6);
    t.displayName = "SupervisorTaskCanvasHeader", t.contentStore = new s.DynamicContentStore(t.displayName);

    var f = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.refreshTimer = void 0, t.handleCloseTask = function () {
          d.tryInvokeAction("SelectTaskInSupervisor", {
            task: void 0
          });
        }, t;
      }

      var r;
      return o(n, e), r = n, n.prototype.componentDidMount = function () {
        var e = this;
        this.refreshTimer = window.setInterval(function () {
          return e.forceUpdate();
        }, 1e3);
      }, n.prototype.componentWillUnmount = function () {
        void 0 !== this.refreshTimer && window.clearInterval(this.refreshTimer);
      }, n.prototype.render = function () {
        var e = this.props,
            n = e.task,
            o = e.channelDefinition,
            i = new u.TaskHelper(n);
        return a.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.contentStore.name,
          customChildren: this.props.children
        }, a.createElement(l.HeaderContainer, {
          noShrink: !0,
          noGrow: !0,
          className: "Twilio-SupervisorTaskCanvasHeader"
        }, a.createElement(l.HeaderCloseIconButton, {
          key: "close-button",
          icon: "Close",
          onClick: this.handleCloseTask,
          themeOverride: this.props.theme.Supervisor.TaskCanvas.HeaderButton
        }), a.createElement(l.HeaderContentContainer, {
          vertical: !0,
          key: "title",
          className: "Twilio-SupervisorTaskCanvasHeader-Content"
        }, a.createElement(l.TitleContainer, {
          className: "Twilio-SupervisorTaskCanvasHeader-Title"
        }, a.createElement(s.Template, {
          code: p.TaskChannelHelper.getTemplateForStatus(n, o.templates.Supervisor.TaskCanvasHeader.title, r),
          task: n
        })), a.createElement(l.ActivityStatusContainer, {
          key: "activity",
          className: "Twilio-SupervisorTaskCanvasHeader-Activity"
        }, a.createElement(s.Template, {
          code: p.TaskChannelHelper.getTemplateForStatus(n, o.templates.Supervisor.TaskCanvasHeader.secondLine, r),
          task: n,
          helper: i
        })))));
      }, n = r = i([c.withTheme], n);
    }(a.PureComponent);

    t.TaskCanvasHeaderImpl = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u = n(0),
        p = n(2);
    t.Text = p.default(u.FlexBox)(o || (o = r(["\n    align-items: center;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 3px;\n    justify-content: center;\n    padding-right: 44px;\n    text-transform: uppercase;\n"], ["\n    align-items: center;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 3px;\n    justify-content: center;\n    padding-right: 44px;\n    text-transform: uppercase;\n"]))), t.TitleContainer = p.default(u.FlexBox)(i || (i = r(["\n    overflow: hidden;\n    font-size: 14px;\n    font-weight: bold;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"], ["\n    overflow: hidden;\n    font-size: 14px;\n    font-weight: bold;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"]))), t.ActivityStatusContainer = p.default("div")(a || (a = r(["\n    font-size: 12px;\n    font-weight: normal;\n    margin-top: 2px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"], ["\n    font-size: 12px;\n    font-weight: normal;\n    margin-top: 2px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"]))), t.HeaderContainer = p.default(u.FlexBox)(s || (s = r(["\n    height: 56px;\n    padding-left: 11px;\n    padding-right: 11px;\n    align-items: center;\n    ", "\n"], ["\n    height: 56px;\n    padding-left: 11px;\n    padding-right: 11px;\n    align-items: center;\n    ", "\n"])), function (e) {
      return e.theme.Supervisor.TaskCanvas.Header;
    }), t.HeaderContentContainer = p.default(u.FlexBox)(c || (c = r(["\n    overflow: hidden;\n    margin: 0 40px 0 10px;\n    align-items: center;\n"], ["\n    overflow: hidden;\n    margin: 0 40px 0 10px;\n    align-items: center;\n"]))), t.HeaderCloseIconButton = p.default(u.IconButton)(l || (l = r(["\n    flex-shrink: 0;\n"], ["\n    flex-shrink: 0;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r68,
        o = this && this.__extends || (_r68 = function r(e, t) {
      return (_r68 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r68(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(0),
        c = n(85),
        l = n(4),
        u = n(2),
        p = n(89),
        d = n(6);
    t.displayName = "TaskCanvas", t.contentStore = new s.DynamicContentStore(t.displayName);

    var f = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleCloseTask = function () {
          d.tryInvokeAction("SelectTaskInSupervisor", {
            task: void 0
          });
        }, t;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props,
            n = (e.task, e.theme);
        return a.createElement(s.SidePanel, {
          contentStore: t.contentStore,
          displayName: t.displayName,
          handleCloseClick: this.handleCloseTask,
          title: a.createElement(s.Template, {
            source: l.templates.SupervisorTaskCanvasHeader
          }),
          themeOverride: n.Supervisor.TaskCanvas,
          HeaderComponent: a.createElement(p.TaskCanvasHeader, {
            key: "customHeader"
          })
        }, a.createElement(c.TaskCanvasTabs, {
          key: "tabs"
        }));
      }, n.displayName = t.displayName, n = i([u.withTheme], n);
    }(a.PureComponent);

    t.TaskCanvasImpl = f;
  }, function (e, t, n) {
    "use strict";

    var _r69,
        o = this && this.__extends || (_r69 = function r(e, t) {
      return (_r69 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r69(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(0),
        c = n(4);
    t.displayName = "TeamFiltersPanel", t.contentStore = new s.DynamicContentStore(t.displayName);

    var l = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props,
            n = e.workers,
            r = e.filters,
            o = e.isHidden,
            i = e.appliedFilters,
            l = e.isLoadingWorkers,
            u = e.handleApplyFilters,
            p = e.handleResetFilters,
            d = e.handleCloseClick,
            f = i && i.filters ? this.getSimplifiedFiltersMap(i.filters) : [];
        return a.createElement(s.SidePanel, {
          handleCloseClick: d,
          title: a.createElement(c.Template, {
            source: c.templates.TeamFiltersPanelTitle
          }),
          displayName: t.displayName,
          themeOverride: {},
          contentStore: t.contentStore,
          isHidden: o
        }, a.createElement(s.FiltersList, {
          key: "filter-list",
          headerLabel: a.createElement(c.Template, {
            source: 1 === n.length ? c.templates.TeamFiltersPanelSingularLabel : c.templates.TeamFiltersPanelPluralLabel,
            number: n.length
          }),
          applyLabel: a.createElement(c.Template, {
            source: c.templates.TeamFiltersApply
          }),
          resetLabel: a.createElement(c.Template, {
            source: c.templates.TeamFiltersReset
          }),
          filters: r,
          actionsDisabled: l,
          appliedFilters: f,
          handleApplyClick: u,
          handleResetClick: p
        }));
      }, n.prototype.getSimplifiedFiltersMap = function (e) {
        return e.reduce(function (e, t) {
          var n;
          return i(i({}, e), ((n = {})[t.name] = t.values, n));
        }, {});
      }, n.displayName = "TeamFiltersPanel", n.Content = new s.DynamicContentStore(n.displayName), n;
    }(a.PureComponent);

    t.TeamFiltersPanel = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(314));
  }, function (e, t, n) {
    "use strict";

    var _r70,
        o = this && this.__extends || (_r70 = function r(e, t) {
      return (_r70 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r70(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__rest || function (e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(0),
        c = n(315),
        l = n(316),
        u = n(319),
        p = n(322),
        d = n(325),
        f = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            n = e.children,
            r = i(e, ["children"]);
        return a.createElement(s.DynamicComponent, {
          name: t.displayName,
          contentStore: t.Content,
          customChildren: n,
          childProps: r,
          noContainers: !0
        }, a.createElement(c.Grid, {
          className: "Twilio-AggregatedQueuesDataTiles-Grid",
          key: "aggregated-data-view"
        }, a.createElement(l.ActiveTasksTile, {
          key: "active-tasks-tile"
        }), a.createElement(u.WaitingTasksTile, {
          key: "waiting-tasks-tile"
        }), a.createElement(d.LongestWaitTimeTile, {
          key: "longest-wait-time-tile"
        }), a.createElement(p.AgentsByActivityChartTile, {
          key: "agents-by-activity-chart-tile"
        })));
      }, t.displayName = "AggregatedQueuesDataTiles", t.Content = new s.DynamicContentStore(t.displayName), t;
    }(a.PureComponent);

    t.AggregatedQueuesDataTiles = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(35);
    t.Grid = i.default("div")(o || (o = r(["\n    display: flex;\n    padding-left: 56px;\n    padding-right: 56px;\n    width: 100%;\n    max-width: 1600px;\n    margin-top: 56px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 0;\n    height: auto;\n    box-sizing: border-box;\n    flex: 0 0 auto;\n\n    > * {\n        flex: 1 1 25%;\n    }\n\n    > * + * {\n        margin-left: 8px;\n    }\n\n    ", "\n"], ["\n    display: flex;\n    padding-left: 56px;\n    padding-right: 56px;\n    width: 100%;\n    max-width: 1600px;\n    margin-top: 56px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 0;\n    height: auto;\n    box-sizing: border-box;\n    flex: 0 0 auto;\n\n    > * {\n        flex: 1 1 25%;\n    }\n\n    > * + * {\n        margin-left: 8px;\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.QueuesStats.TilesGrid;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(317));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(318),
        o = n(3),
        i = n(20);
    t.ActiveTasksTile = o.connect(function (e) {
      return {
        activeTasks: i.workspaceActiveTasksSelector(e)
      };
    })(r.ActiveTasksTileImpl);
  }, function (e, t, n) {
    "use strict";

    var _r71,
        o = this && this.__extends || (_r71 = function r(e, t) {
      return (_r71 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r71(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(4),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return i.createElement(a.AggregatedDataTile, {
          title: i.createElement(s.Template, {
            source: s.templates.ActiveTasksTileTitle
          }),
          content: this.props.activeTasks.toString()
        });
      }, t;
    }(i.PureComponent);

    t.ActiveTasksTileImpl = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(320));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(321),
        o = n(3),
        i = n(20);
    t.WaitingTasksTile = o.connect(function (e) {
      return {
        waitingTasks: i.workspaceWaitingTasksSelector(e)
      };
    })(r.WaitingTasksTileImpl);
  }, function (e, t, n) {
    "use strict";

    var _r72,
        o = this && this.__extends || (_r72 = function r(e, t) {
      return (_r72 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r72(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(4),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return i.createElement(a.AggregatedDataTile, {
          title: i.createElement(s.Template, {
            source: s.templates.WaitingTasksTileTitle
          }),
          content: this.props.waitingTasks.toString()
        });
      }, t;
    }(i.PureComponent);

    t.WaitingTasksTileImpl = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(323));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(324),
        o = n(3),
        i = n(20);
    t.AgentsByActivityChartTile = o.connect(function (e) {
      var t = i.workspaceStatsSelector(e);
      return {
        availableAgents: i.getAvailableAgentsCount(t),
        unavailableAgents: i.getUnavailableAgentsCount(t),
        offlineAgents: i.getOfflineAgentsCount(t)
      };
    })(r.AgentsByActivityChartTileImpl);
  }, function (e, t, n) {
    "use strict";

    var _r73,
        o = this && this.__extends || (_r73 = function r(e, t) {
      return (_r73 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r73(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(0),
        c = n(4),
        l = n(2),
        u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.availableAgents,
            n = e.unavailableAgents,
            r = e.offlineAgents,
            o = e.theme,
            i = [{
          value: t,
          label: c.templates.AgentStatusAvailable ? c.templates.AgentStatusAvailable() : "",
          color: o ? o.colors.agentAvailableColor : ""
        }, {
          value: n,
          label: c.templates.AgentStatusUnavailable ? c.templates.AgentStatusUnavailable() : "",
          color: o ? o.colors.agentUnavailableColor : ""
        }, {
          value: r,
          label: c.templates.AgentStatusOffline ? c.templates.AgentStatusOffline() : "",
          color: o ? o.colors.agentOfflineColor : ""
        }];
        return a.createElement(s.AggregatedDataTile, {
          title: a.createElement(c.Template, {
            source: c.templates.AgentsByActivityTileTitle
          })
        }, a.createElement(s.StackedBarChart, {
          items: i
        }), a.createElement(s.Legend, {
          items: i,
          showLabels: !0
        }));
      }, t = i([l.withTheme], t);
    }(a.PureComponent);

    t.AgentsByActivityChartTileImpl = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(326));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(327),
        o = n(3),
        i = n(20);
    t.LongestWaitTimeTile = o.connect(function (e) {
      var t = i.workspaceLongestQueueSelector(e);
      return {
        waitFrom: t ? t.longest_task_waiting_from : null,
        queueName: t && t.friendly_name || ""
      };
    })(r.LongestWaitTimeTileImpl);
  }, function (e, t, n) {
    "use strict";

    var _r74,
        o = this && this.__extends || (_r74 = function r(e, t) {
      return (_r74 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r74(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(4),
        c = n(158),
        l = n(159),
        u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this;
        return this.props.waitFrom ? i.createElement(l.Ticker, null, function () {
          return i.createElement(a.AggregatedDataTile, {
            title: i.createElement(s.Template, {
              source: s.templates.LongestWaitTimeTileTitle
            }),
            content: a.Utils.formatTimeDuration(c.getTaskWaitingAgeFromTimestamp(e.props.waitFrom), "short"),
            description: e.props.queueName
          });
        }) : i.createElement(a.AggregatedDataTile, {
          title: i.createElement(s.Template, {
            source: s.templates.LongestWaitTimeTileTitle
          }),
          content: "0",
          description: this.props.queueName
        });
      }, t;
    }(i.PureComponent);

    t.LongestWaitTimeTileImpl = u;
  }, function (e, t) {
    e.exports = require("eventemitter3");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(330);
    t.QueuesDataTableProps = r.QueuesDataTableProps, t.QueuesDataTable = r.QueuesDataTable;
  }, function (e, t, n) {
    "use strict";

    var _r75,
        o = this && this.__extends || (_r75 = function r(e, t) {
      return (_r75 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r75(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(3),
        c = n(331),
        l = n(20),
        u = s.connect(function (e) {
      return {
        queuesList: l.queuesListArraySelector(e)
      };
    })(c.QueuesDataTableImpl),
        p = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), Object.defineProperty(t, "sortable", {
        get: function get() {
          return t.isSortable;
        },
        set: function set(e) {
          t.isSortable = e, t.instance && t.instance.forceUpdate();
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.componentDidMount = function () {
        t.instance = this;
      }, t.prototype.componentWillUnmount = function () {
        t.instance = void 0;
      }, t.prototype.render = function () {
        return a.createElement(u, i({
          sortable: t.isSortable
        }, this.props));
      }, t.friendlyName = c.displayName, t.displayName = c.displayName, t.Content = c.Content, t.isSortable = !0, t;
    }(a.PureComponent);

    t.QueuesDataTable = p;
  }, function (e, t, n) {
    "use strict";

    var _r76,
        o = this && this.__extends || (_r76 = function r(e, t) {
      return (_r76 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r76(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(2),
        c = n(0),
        l = n(332),
        u = n(20),
        p = n(4),
        d = n(158),
        f = n(159);
    t.displayName = "QueuesDataTable", t.Content = new c.DynamicContentStore(t.displayName);

    var h = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return this.props.renderContent(this.props.item);
      }, t;
    }(a.PureComponent);

    function m(e) {
      return function (t) {
        return a.createElement(h, {
          item: t,
          renderContent: e
        });
      };
    }

    var g = c.DataTable;

    function y(e) {
      return function (t, n) {
        return e(t) - e(n);
      };
    }

    var v = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.getTaskQueueSid = function (e) {
          return e.key;
        }, t.renderFriendlyName = m(function (e) {
          return a.createElement(l.FirstCellContent, null, e.friendly_name);
        }), t.renderActiveTasks = m(function (e) {
          var t = e.tasks_by_status,
              n = t.assigned,
              r = t.wrapping;
          return a.createElement("span", null, n + r);
        }), t.renderWaitingTasks = m(function (e) {
          var t = e.tasks_by_status,
              n = t.pending,
              r = t.reserved;
          return a.createElement("span", null, n + r);
        }), t.renderLongestWaitingTime = m(function (e) {
          return e.longest_task_waiting_from ? a.createElement(f.Ticker, null, function () {
            return a.createElement("span", null, c.Utils.formatTimeDuration(d.getTaskWaitingAgeFromTimestamp(e.longest_task_waiting_from), "short"));
          }) : a.createElement("span", null, "0");
        }), t.renderAgents = m(function (e) {
          var n = [{
            label: p.templates.AgentStatusAvailable ? p.templates.AgentStatusAvailable() : "",
            value: u.getAvailableAgentsCount(e),
            color: t.props.theme.colors.agentAvailableColor
          }, {
            label: p.templates.AgentStatusUnavailable ? p.templates.AgentStatusUnavailable() : "",
            value: u.getUnavailableAgentsCount(e),
            color: t.props.theme.colors.agentUnavailableColor
          }, {
            label: p.templates.AgentStatusOffline ? p.templates.AgentStatusOffline() : "",
            value: u.getOfflineAgentsCount(e),
            color: t.props.theme.colors.agentOfflineColor
          }];
          return a.createElement(c.Legend, {
            items: n,
            showLabels: !1
          });
        }), t;
      }

      return o(n, e), n.prototype.render = function () {
        var e,
            n = this.props,
            r = n.queuesList,
            o = n.sortable;
        return a.createElement(l.TableContainer, {
          className: "Twilio-QueuesDataTable"
        }, a.createElement(c.DynamicComponent, {
          childProps: this.props,
          contentStore: t.Content,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0
        }, a.createElement(g, {
          items: r,
          itemKey: this.getTaskQueueSid,
          columnDataCreationContext: {},
          hasHoverStyle: !1
        }, a.createElement(c.ColumnDefinition, {
          key: "friendly-name",
          header: a.createElement(c.Template, {
            source: p.templates.QueuesStatsHeaderQueueName
          }),
          content: this.renderFriendlyName,
          sortingFn: o ? (e = function e(_e) {
            return _e.friendly_name;
          }, function (t, n) {
            return e(t).localeCompare(e(n));
          }) : void 0
        }), a.createElement(c.ColumnDefinition, {
          key: "active-tasks",
          header: a.createElement(c.Template, {
            source: p.templates.QueuesStatsHeaderActiveTasks
          }),
          content: this.renderActiveTasks,
          sortingFn: o ? y(function (e) {
            return e.tasks_by_status.assigned + e.tasks_by_status.wrapping;
          }) : void 0
        }), a.createElement(c.ColumnDefinition, {
          key: "waiting-tasks",
          header: a.createElement(c.Template, {
            source: p.templates.QueuesStatsHeaderWaitingTasks
          }),
          content: this.renderWaitingTasks,
          sortingFn: o ? y(function (e) {
            return e.tasks_by_status.pending + e.tasks_by_status.reserved;
          }) : void 0
        }), a.createElement(c.ColumnDefinition, {
          key: "longest-wait-time",
          header: a.createElement(c.Template, {
            source: p.templates.QueuesStatsHeaderLongestWait
          }),
          content: this.renderLongestWaitingTime,
          sortingFn: o ? y(function (e) {
            return d.getTaskWaitingAgeFromTimestamp(e.longest_task_waiting_from);
          }) : void 0
        }), a.createElement(c.ColumnDefinition, {
          key: "agents",
          header: a.createElement(c.Template, {
            source: p.templates.QueuesStatsHeaderAgentsActivity
          }),
          content: this.renderAgents
        }))));
      }, n = i([s.withTheme], n);
    }(a.PureComponent);

    t.QueuesDataTableImpl = v;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(35);
    t.FirstCellContent = a.default("span")(o || (o = r(["\n    padding-left: 6px;\n"], ["\n    padding-left: 6px;\n"]))), t.TableContainer = a.default("div")(i || (i = r(["\n    overflow-y: auto;\n    padding-left: 56px;\n    padding-right: 56px;\n    width: 100%;\n    max-width: 1600px;\n    margin: 48px auto 0;\n    box-sizing: border-box;\n\n    td {\n        font-size: 12px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    ", "\n"], ["\n    overflow-y: auto;\n    padding-left: 56px;\n    padding-right: 56px;\n    width: 100%;\n    max-width: 1600px;\n    margin: 48px auto 0;\n    box-sizing: border-box;\n\n    td {\n        font-size: 12px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.QueuesStats.TableContainer;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(32);
    t.InsightsPlayerPlayActionPayload = r.InsightsPlayerPlayActionPayload;
    var o = n(61);
    t.Action = {
      INSIGHTS_PLAYER_PLAY: o.INSIGHTS_PLAYER_PLAY,
      INSIGHTS_PLAYER_SHOW: o.INSIGHTS_PLAYER_SHOW,
      INSIGHTS_PLAYER_HIDE: o.INSIGHTS_PLAYER_HIDE,
      INSIGHTS_PLAYER_INITIALIZED: o.INSIGHTS_PLAYER_INITIALIZED
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(147);
    t.IncomingTaskCanvas = r.IncomingTaskCanvas, t.IncomingTaskCanvasProps = r.IncomingTaskCanvasProps, t.IncomingTaskCanvasActions = r.IncomingTaskCanvasActions;
    var o = n(88);
    t.ConnectingOutboundCallCanvas = o.ConnectingOutboundCallCanvas, t.ConnectingOutboundCallCanvasProps = o.ConnectingOutboundCallCanvasProps, t.ConnectingOutboundCallCanvasActions = o.ConnectingOutboundCallCanvasActions;
    var i = n(163);
    t.NoTasksCanvas = i.NoTasksCanvas;
    var a = n(151);
    t.CallCanvas = a.CallCanvas, t.CallCanvasActions = a.CallCanvasActions;
    var s = n(164);
    t.TaskCanvas = s.TaskCanvas, t.TaskCanvasChildrenProps = s.TaskCanvasChildrenProps;
    var c = n(347);
    t.TaskCanvasHeader = c.TaskCanvasHeader;
    var l = n(145);
    t.TaskCanvasTabs = l.TaskCanvasTabs, t.TaskCanvasTabsChildrenProps = l.TaskCanvasTabsChildrenProps;
    var u = n(46);
    t.TaskDetailsPanel = u.TaskDetailsPanel;
    var p = n(156);
    t.TaskInfoPanel = p.TaskInfoPanel;
    var d = n(142);
    t.ParticipantCanvas = d.ParticipantCanvas;
    var f = n(140);
    t.ParticipantsCanvas = f.ParticipantsCanvas;
  }, function (e, t, n) {
    "use strict";

    var _r77,
        o = this && this.__extends || (_r77 = function r(e, t) {
      return (_r77 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r77(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(3),
        c = n(336),
        l = n(2),
        u = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return a.createElement(t.Connected, i({}, this.props));
      }, n.friendlyName = c.displayName, n.displayName = c.displayName, n.Content = c.contentStore, n;
    }(a.PureComponent);

    t.NoTasksCanvas = u, t.Connected = s.connect(function (e) {
      return {
        worker: e.worker
      };
    })(l.withTheme(c.NoTasksCanvasImpl));
  }, function (e, t, n) {
    "use strict";

    var _r78,
        o = this && this.__extends || (_r78 = function r(e, t) {
      return (_r78 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r78(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        a = n(0),
        s = n(4),
        c = n(50),
        l = n(5),
        u = n(337);
    t.displayName = "NoTasksCanvas", t.contentStore = new a.DynamicContentStore(t.displayName);

    var p = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleChange = function (e) {
          a.Actions.invokeAction("SetActivity", {
            activitySid: e.target.value
          }).then(function () {
            l.log.debug("activity updated");
          }).catch(function (e) {
            l.log.error("failed to update activity:", e);
          });
        }, t;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props.worker,
            n = Array.from(this.props.worker.activities.values()).filter(function (e) {
          return "Reserved" !== e.name;
        }),
            r = this.props.worker.activity && this.props.worker.activity.sid,
            o = !!e && !!e.activity && e.activity.available,
            l = !!e && e.attributes.full_name || !!e && e.source && e.source.name || "",
            p = !!e && e.attributes.image_url;
        return i.createElement(a.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0,
          vertical: !0
        }, i.createElement(u.Container, null, i.createElement(u.FirstLineContainer, {
          key: "first-line"
        }, i.createElement(u.FirstLine, null, i.createElement(a.Template, {
          source: s.templates.NoTasksTitle
        }))), i.createElement(u.SecondLine, {
          key: "second-line"
        }, " ", i.createElement(a.Template, {
          source: s.templates.NoTasks
        }), " "), i.createElement(u.HintLine, {
          key: "hint"
        }, " ", i.createElement(a.Template, {
          source: o ? s.templates.NoTasksHintAvailable : s.templates.NoTasksHintNotAvailable
        }), " "), i.createElement(u.StyledWorkerAvatar, {
          key: "avatar",
          imageUrl: p,
          available: o,
          large: !0
        }), i.createElement(u.NameLine, {
          key: "name"
        }, l), i.createElement(u.StyledSelect, {
          key: "availability",
          className: "Twilio-NoTasks-WorkerActivity",
          value: r,
          onChange: this.handleChange
        }, n.map(function (e) {
          return i.createElement(c.default, {
            key: e.sid,
            value: e.sid
          }, e.name);
        }))));
      }, n;
    }(i.PureComponent);

    t.NoTasksCanvasImpl = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u,
        p,
        d = n(2),
        f = n(0),
        h = n(51);
    t.Container = d.default("div")(o || (o = r(["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    ", "\n"], ["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    ", "\n"])), function (e) {
      return e.theme.NoTasksCanvas.Container;
    }), t.StyledWorkerAvatar = d.default(f.Avatar)(i || (i = r(["\n    width: 60px;\n    height: 60px;\n"], ["\n    width: 60px;\n    height: 60px;\n"]))), t.FirstLineContainer = d.default("div")(a || (a = r(["\n    border-style: solid;\n    border-width: 0px 0px 4px 0px;\n    border-color: ", ";\n"], ["\n    border-style: solid;\n    border-width: 0px 0px 4px 0px;\n    border-color: ", ";\n"])), function (e) {
      return e.theme.colors.flexBlueColor;
    }), t.FirstLine = d.default("div")(s || (s = r(["\n    font-size: 10px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    margin: 0px 12px 4px 12px;\n"], ["\n    font-size: 10px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    margin: 0px 12px 4px 12px;\n"]))), t.SecondLine = d.default("div")(c || (c = r(["\n    font-size: 24px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    text-align: center;\n    margin: 34px 20px 0px 20px;\n"], ["\n    font-size: 24px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    text-align: center;\n    margin: 34px 20px 0px 20px;\n"]))), t.HintLine = d.default("div")(l || (l = r(["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 16px 20px;\n    ", "\n"], ["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 16px 20px;\n    ", "\n"])), function (e) {
      return e.theme.NoTasksCanvas.Hint;
    }), t.NameLine = d.default("div")(u || (u = r(["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 0px 20px;\n"], ["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 0px 20px;\n"]))), t.StyledSelect = d.default(h.default)(p || (p = r(["\n    margin-top: 20px;\n    width: 140px;\n"], ["\n    margin-top: 20px;\n    width: 140px;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r79,
        o = this && this.__extends || (_r79 = function r(e, t) {
      return (_r79 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r79(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(14),
        c = n(52),
        l = n(60),
        u = n(344),
        p = n(2),
        d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return a.createElement(f, i({}, this.props));
      }, t.displayName = u.displayName, t.Content = u.contentStore, t.Header = c.TaskCanvasHeader, t.Tabs = l.TaskCanvasTabs, t;
    }(a.PureComponent);

    t.TaskCanvas = d;
    var f = p.withTheme(s.withTaskContext(u.TaskCanvasImpl));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(340);
    t.EndTaskButton = r.EndTaskButton, t.EndTaskButtonProps = r.EndTaskButtonProps;
  }, function (e, t, n) {
    "use strict";

    var _r80,
        o = this && this.__extends || (_r80 = function r(e, t) {
      return (_r80 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r80(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(2),
        s = n(1),
        c = n(7),
        l = n(0),
        u = n(49),
        p = n(9),
        d = n(11),
        f = n(52),
        h = n(12),
        m = n(22),
        g = n(341),
        y = n(6),
        v = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onCompleteTaskButtonClick = function () {
          if (t.props.task) {
            var e = t.props.task,
                n = {
              task: e,
              reason: "Completed manually from button"
            },
                r = m.StateHelper.getCurrentPhoneCallState();
            c.TaskHelper.isLiveCall(e) && r ? y.tryInvokeAction("HangupCall", {
              task: e
            }) : c.TaskHelper.isInWrapupMode(e) ? y.tryInvokeAction("CompleteTask", n) : h.TaskChannels.getForTask(e).capabilities.has(h.TaskChannelCapability.Wrapup) ? y.tryInvokeAction("WrapupTask", n) : y.tryInvokeAction("CompleteTask", n);
          }
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this,
            t = this.props,
            n = t.task,
            r = t.templateCode;
        return c.TaskHelper.isPending(n) || c.TaskHelper.isCompleted(n) ? null : s.createElement(l.ActionStateListener, {
          action: ["HangupCall", "CompleteTask", "WrapupTask"],
          payload: u.isValidTaskPayload(n)
        }, function (t) {
          return s.createElement(g.EndTaskButtonContainer, {
            className: "Twilio-TaskCanvasHeader-EndButton",
            themeOverride: e.getEndTaskButtonStyle(),
            onClick: e.onCompleteTaskButtonClick,
            disabled: t.disabled
          }, s.createElement(p.TaskContext.Consumer, null, function (e) {
            return s.createElement(l.Template, {
              task: n,
              code: r || d.TaskChannelHelper.getTemplateForStatus(n, e.channelDefinition.templates.TaskCanvasHeader.endButton, f.TaskCanvasHeader)
            });
          }));
        });
      }, t.prototype.getEndTaskButtonStyle = function () {
        var e = this.props.task;
        return c.TaskHelper.isInWrapupMode(e) ? this.props.theme.TaskCanvasHeader.EndTaskButton : h.TaskChannels.getForTask(e).capabilities.has(h.TaskChannelCapability.Wrapup) ? this.props.theme.TaskCanvasHeader.WrapupTaskButton : this.props.theme.TaskCanvasHeader.EndTaskButton;
      }, t = i([a.withTheme], t);
    }(s.Component);

    t.EndTaskButton = v;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2),
        a = n(0);
    t.EndTaskButtonContainer = i.default(a.Button)(o || (o = r([""], [""])));
  }, function (e, t, n) {
    "use strict";

    var _r81,
        o = this && this.__extends || (_r81 = function r(e, t) {
      return (_r81 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r81(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(0),
        c = n(343),
        l = n(7),
        u = n(11),
        p = n(52),
        d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.refreshTimer = void 0, t;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        var e = this;
        this.refreshTimer = window.setInterval(function () {
          return e.forceUpdate();
        }, 1e3);
      }, t.prototype.componentWillUnmount = function () {
        void 0 !== this.refreshTimer && window.clearInterval(this.refreshTimer);
      }, t.prototype.render = function () {
        var e = this.props,
            t = e.ActionsComponent,
            n = e.content,
            r = e.icon,
            o = e.titleTemplateCode,
            d = e.titleTemplateContext,
            f = e.task,
            h = e.secondLineTemplateCode,
            m = e.secondLineTemplateContext,
            g = new l.TaskHelper(f);
        return a.createElement(s.DynamicComponent, {
          contentStore: n,
          childProps: this.props,
          name: n.name,
          customChildren: this.props.children
        }, a.createElement(c.Container, {
          icon: r
        }, !!r && a.createElement(c.IconContainer, {
          key: "icon",
          className: "Twilio-TaskCanvasHeader-Icon"
        }, a.createElement(s.Icon, {
          icon: r
        })), a.createElement(c.ContentContainer, {
          vertical: !0,
          key: "header"
        }, a.createElement(c.TitleContainer, {
          key: "header-title",
          className: "Twilio-TaskCanvasHeader-Name"
        }, a.createElement(s.Template, i({
          code: o || u.TaskChannelHelper.getTemplateForStatus(this.props.task, this.props.channelDefinition.templates.TaskCanvasHeader.title, p.TaskCanvasHeader),
          task: f
        }, d))), a.createElement(c.ActivityStatusContainer, {
          key: "header-activity",
          className: "Twilio-TaskCanvasHeader-Activity"
        }, a.createElement(c.ActivityStatusStyledTemplate, i({
          code: h || u.TaskChannelHelper.getTemplateForStatus(this.props.task, this.props.channelDefinition.templates.TaskCanvasHeader.secondLine, p.TaskCanvasHeader),
          task: f,
          helper: g
        }, m)))), a.createElement(t, {
          key: "actions",
          task: f
        })));
      }, t;
    }(a.PureComponent);

    t.TaskCanvasHeaderImpl = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u = n(0),
        p = n(2);
    t.TitleContainer = p.default("div")(o || (o = r(["\n    overflow: hidden;\n    margin-left: 0px;\n    margin-right: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 14px;\n    font-weight: bold;\n"], ["\n    overflow: hidden;\n    margin-left: 0px;\n    margin-right: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 14px;\n    font-weight: bold;\n"]))), t.IconContainer = p.default("div")(i || (i = r(["\n    display: flex;\n    flex: 0 0 auto;\n    width: 36px;\n\n    .Twilio-Icon {\n        margin: auto;\n    }\n"], ["\n    display: flex;\n    flex: 0 0 auto;\n    width: 36px;\n\n    .Twilio-Icon {\n        margin: auto;\n    }\n"]))), t.Container = p.default("div")(a || (a = r(["\n    display: flex;\n    flex: 0 0 auto;\n    padding-top: 2px;\n    padding-bottom: 2px;\n    padding-left: ", ";\n    padding-right: 12px;\n    height: 56px;\n    ", "\n"], ["\n    display: flex;\n    flex: 0 0 auto;\n    padding-top: 2px;\n    padding-bottom: 2px;\n    padding-left: ", ";\n    padding-right: 12px;\n    height: 56px;\n    ", "\n"])), function (e) {
      return e.icon ? "2px" : "12px";
    }, function (e) {
      return e.theme.TaskCanvasHeader.Container;
    }), t.ContentContainer = p.default(u.FlexBox)(s || (s = r(["\n    justify-content: center;\n    overflow: hidden;\n"], ["\n    justify-content: center;\n    overflow: hidden;\n"]))), t.ActivityStatusContainer = p.default("div")(c || (c = r(["\n    font-size: 12px;\n    font-weight: normal;\n    margin-top: 2px;\n    overflow: hidden;\n    margin-left: 0px;\n    margin-right: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"], ["\n    font-size: 12px;\n    font-weight: normal;\n    margin-top: 2px;\n    overflow: hidden;\n    margin-left: 0px;\n    margin-right: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"]))), t.ActivityStatusStyledTemplate = p.default(u.Template)(l || (l = r(["\n    display: inline-flex;\n    align-items: center;\n    .Twilio-Template-Icon {\n        margin-right: 4px;\n    }\n"], ["\n    display: inline-flex;\n    align-items: center;\n    .Twilio-Template-Icon {\n        margin-right: 4px;\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r82,
        o = this && this.__extends || (_r82 = function r(e, t) {
      return (_r82 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r82(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        a = n(0),
        s = n(345),
        c = n(52),
        l = n(60);
    t.displayName = "TaskCanvas", t.contentStore = new a.DynamicContentStore(t.displayName);

    var u = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props.task;
        return e ? i.createElement(a.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, i.createElement(s.Container, {
          vertical: !0,
          overflow: "hidden"
        }, i.createElement(c.TaskCanvasHeader, {
          key: "header",
          task: e
        }), i.createElement(l.TaskCanvasTabs, {
          key: "tabs"
        }))) : null;
      }, n;
    }(i.PureComponent);

    t.TaskCanvasImpl = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2),
        a = n(0);
    t.Container = i.default(a.FlexBox)(o || (o = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.TaskCanvas.Container;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(52);
    t.TaskCanvasHeader = r.TaskCanvasHeader;
    var o = n(348);
    t.TaskCanvasHeaderProps = o.TaskCanvasHeaderProps;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r83,
        o = this && this.__extends || (_r83 = function r(e, t) {
      return (_r83 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r83(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(3),
        c = n(350);
    !function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(91));

    var l = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return a.createElement(t.Connected, i({}, this.props));
      }, n;
    }(a.PureComponent);

    t.UserControls = l, t.Connected = s.connect(function (e) {
      return {
        worker: e.worker
      };
    })(c.UserControlsImpl);
  }, function (e, t, n) {
    "use strict";

    var _r84,
        o = this && this.__extends || (_r84 = function r(e, t) {
      return (_r84 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r84(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(0),
        c = n(2),
        l = n(351),
        u = n(91),
        p = n(4),
        d = n(5),
        f = n(6),
        h = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleWindowResize = function () {
          t.forceUpdate();
        }, t.onLogoutClick = function () {
          f.tryInvokeAction("Logout", {
            forceLogout: !1
          }), t.modalPopup.hide();
        }, t.setModalPopupRef = function (e) {
          t.modalPopup = e;
        }, t;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.handleWindowResize);
      }, t.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.handleWindowResize);
      }, t.prototype.render = function () {
        var e = this;
        return a.createElement(s.ModalPopupWithEntryControl, {
          className: "Twilio-UserControls",
          alignRight: !0,
          autoClose: !0,
          entryControl: a.createElement(l.UserControlsUserCard, {
            className: "Twilio-UserControlsUserCard-AccountButton",
            large: window.innerWidth > 552,
            worker: this.props.worker
          }),
          ref: this.setModalPopupRef
        }, a.createElement(u.UserActivityControls, {
          className: "Twilio-UserControls-AccountMenu",
          styleOverride: this.props.theme.UserActivityControls
        }, a.createElement(u.AccountMenuTitle, {
          className: "Twilio-AccountMenu-Title"
        }, a.createElement(s.Template, {
          source: p.templates.SetYourStatus
        })), Array.from(this.props.worker.activities.values()).filter(function (e) {
          return "Reserved" !== e.name;
        }).map(function (t) {
          return a.createElement(u.AccountMenuItem, {
            className: "Twilio-AccountMenu-Item",
            key: t.sid,
            selected: e.props.worker.activity && t.sid === e.props.worker.activity.sid,
            onClick: function onClick() {
              return e.onActivityClick(t.sid);
            },
            styleOverride: e.props.theme.UserActivityControls
          }, t.name);
        }), a.createElement(u.AccountMenuDivider, null), a.createElement(u.AccountMenuItemLogout, {
          onClick: this.onLogoutClick,
          styleOverride: this.props.theme.UserActivityControls
        }, a.createElement(s.Template, {
          source: p.templates.LogOut
        }), a.createElement(s.Icon, {
          icon: "Logout"
        }))));
      }, t.prototype.onActivityClick = function (e) {
        this.modalPopup.hide(), s.Actions.invokeAction("SetActivity", {
          activitySid: e
        }).then(function () {
          d.log.debug("activity updated");
        }).catch(function (e) {
          d.log.error("failed to update activity:", e);
        });
      }, t.displayName = "UserControls", t = i([c.withTheme], t);
    }(a.PureComponent);

    t.UserControlsImpl = h;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(352);
    t.UserControlsUserCard = r.UserControlsUserCard, t.UserControlsUserCardProps = r.UserControlsUserCardProps;
  }, function (e, t, n) {
    "use strict";

    var _r85,
        o = this && this.__extends || (_r85 = function r(e, t) {
      return (_r85 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r85(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__rest || function (e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(4),
        u = n(91),
        p = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        var e = this;
        this.interval = window.setInterval(function () {
          return e.forceUpdate();
        }, 1e3);
      }, t.prototype.componentWillUnmount = function () {
        clearInterval(this.interval);
      }, t.prototype.render = function () {
        var e = this.props,
            t = (e.className, e.innerRef, e.worker),
            n = e.large,
            r = e.onClick,
            o = a(e, ["className", "innerRef", "worker", "large", "onClick"]),
            p = t.worker;
        return s.createElement(u.Container, {
          large: n
        }, s.createElement(c.UserCard, i({
          className: "Twilio-UserControls-UserCard",
          large: n,
          firstLine: p.fullName,
          secondLine: s.createElement(c.Template, {
            source: l.templates.UserControlWorkerSecondLine,
            workerActivityName: p.activityName,
            worker: p
          }),
          imageUrl: p.attributes.image_url,
          isAvailable: p.isAvailable,
          onClick: r,
          lightHover: !0
        }, o)));
      }, t;
    }(s.PureComponent);

    t.UserControlsUserCard = p;
  }, function (e, t, n) {
    "use strict";

    var _r86,
        o = this && this.__extends || (_r86 = function r(e, t) {
      return (_r86 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r86(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(1),
        c = n(0),
        l = n(3),
        u = n(7),
        p = n(354),
        d = n(69);
    !function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(167));

    var f = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      var n;
      return o(t, e), n = t, t.updateAll = function () {}, t.prototype.render = function () {
        return s.createElement(h, i({}, this.props));
      }, t.getBadgeChildren = function (e) {
        var t = new d.AppStateHelper(e);
        return t.isAgentView() ? 0 : t.getPendingTasks() + t.getUnconsumedMessagesCount();
      }, t.displayName = p.displayName, t.Content = p.contentStore, t.defaultProps = {
        logoUrl: void 0,
        Badge: {
          children: n.getBadgeChildren,
          variant: c.Badge.variants.dot,
          position: {
            right: "10px",
            top: "5px"
          }
        }
      }, t = n = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.MainHeader = f;
    var h = l.connect(function (e, t) {
      var n = t.Badge && t.Badge.children;
      return {
        incomingTasks: !!Array.from(e.worker.tasks.values()).find(function (e) {
          return u.TaskHelper.isPending(e);
        }),
        isLiveVoiceConnection: !!e.phone.connection,
        Badge: i(i({}, t.Badge), {
          children: "function" == typeof n ? n(e, t) : n
        })
      };
    })(p.MainHeaderImpl);
  }, function (e, t, n) {
    "use strict";

    var _r87,
        o = this && this.__extends || (_r87 = function r(e, t) {
      return (_r87 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r87(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(1),
        c = n(2),
        l = n(13),
        u = n(0),
        p = n(167),
        d = n(361),
        f = n(168),
        h = n(169),
        m = n(86),
        g = n(166),
        y = n(6),
        v = n(34),
        b = n(93);
    t.displayName = "MainHeader", t.contentStore = new u.DynamicContentStore(t.displayName);

    var C = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onSidebarButtonClick = function () {
          y.tryInvokeAction("ToggleSidebar");
        }, t.onDialpadClick = function () {
          y.tryInvokeAction("ToggleOutboundDialer");
        }, t.onSidebarButtonBlur = function (e) {
          var t = document.getElementsByClassName("Twilio-SideNav-Container"),
              n = null;
          if (t.length > 0 && (n = t[0]), n) for (var r = e.relatedTarget; r;) {
            if (r === n) return;
            r = r.parentElement;
          }
          y.tryInvokeAction("ToggleSidebar", {
            open: !1
          });
        }, t;
      }

      return o(n, e), n.prototype.shouldComponentUpdate = function (e) {
        return !b(this.props, e);
      }, n.prototype.render = function () {
        var e = this.props,
            n = e.theme,
            r = e.logoUrl,
            o = e.Badge,
            a = e.isLiveVoiceConnection,
            c = l.Manager.getInstance().configuration.logger;
        return s.createElement(u.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children
        }, s.createElement(p.Container, null, s.createElement(u.ContentFragment, {
          align: "start"
        }, s.createElement(p.StyledIconContainer, {
          key: "sidenav-button"
        }, s.createElement(p.StyledIconButton, {
          themeOverride: n.MainHeader.Button,
          icon: "Hamburger",
          onClick: this.onSidebarButtonClick,
          onBlur: this.onSidebarButtonBlur,
          className: "Twilio-Main-Header-IconButton"
        }), o && s.createElement(u.Badge, i({
          key: "badge"
        }, o))), r ? s.createElement(p.HeaderLogoImage, {
          key: "logo",
          src: r
        }) : s.createElement(d.HeaderLogo, {
          key: "logo"
        })), s.createElement(u.ContentFragment, {
          align: "end"
        }, c && c.type === f.LoggerType.file && s.createElement(h.ToggleLoggingPanel, {
          key: "logging-button"
        }), v.isOutboundCallingEnabled() && s.createElement(u.IconButton, {
          key: "dialpad-button",
          themeOverride: n.MainHeader.Button,
          icon: "Dialpad",
          onClick: this.onDialpadClick,
          disabled: a
        }), s.createElement(m.MuteButton, {
          key: "mute-button",
          themeOverride: n.MainHeader.Button
        }), s.createElement(g.UserControls, {
          key: "user-controls"
        }))));
      }, n = a([c.withTheme], n);
    }(s.Component);

    t.MainHeaderImpl = C;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0),
        i = n(54),
        a = {
      colors: r(r({}, i.default.colors), o.GreyLight.colors),
      lightTheme: !0
    };
    t.GreyLight = a, t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0),
        i = n(54),
        a = {
      colors: r(r({}, i.default.colors), o.GreyDark.colors),
      lightTheme: !1
    };
    t.GreyDark = a, t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0),
        i = n(54),
        a = {
      colors: r(r({}, i.default.colors), o.FlexDark.colors),
      lightTheme: !1
    };
    t.FlexDark = a, t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0),
        i = n(54),
        a = {
      colors: r(r({}, i.default.colors), o.FlexLight.colors),
      lightTheme: !0
    };
    t.FlexLight = a, t.default = a;
  }, function (e, t) {
    e.exports = require("@material-ui/core/styles");
  }, function (e, t) {
    e.exports = require("react-jss");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(362);
    t.HeaderLogo = r.HeaderLogo;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(1);

    t.HeaderLogo = function (e) {
      return o.createElement("svg", r({
        viewBox: "0 0 150 32",
        width: "150px",
        height: "32px"
      }, e), o.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h150v32H0z"
      }), o.createElement("g", {
        fill: "currentColor"
      }, o.createElement("path", {
        d: "M42.524 11.83h-3.472V21h-1.05v-9.17H34.6v-.98h7.77l.154.98zm17.54-.98l-3.192 10.192h-.924l-3.052-8.722-3.038 8.722h-.896L45.798 10.99l1.064-.238 2.618 8.61 2.898-8.512h1.078l2.94 8.512 2.576-8.512h1.092zM65.438 21h-1.064V10.85h1.064V21zm10.302 0h-5.264V10.85h1.05v9.17h4.06l.154.98zm5.136 0h-1.064V10.85h1.064V21zm14.096-5.082c0 3.108-1.96 5.278-4.788 5.278-2.828 0-4.76-2.156-4.76-5.25 0-3.122 1.96-5.278 4.788-5.278 2.828 0 4.76 2.142 4.76 5.25zm-1.106.014c0-2.576-1.456-4.312-3.682-4.312-2.212 0-3.668 1.736-3.668 4.298 0 2.59 1.47 4.312 3.682 4.312 2.226 0 3.668-1.722 3.668-4.298zm16.516-4.102h-4.242v3.542h3.388l.154.966h-3.542V21h-1.05V10.85h5.292v.98zM119.76 21h-5.264V10.85h1.05v9.17h4.06l.154.98zm9.616 0h-5.642V10.85h5.488v.98h-4.438v3.374h3.514l.154.98h-3.668v3.85h4.592V21zm11.926-.14l-1.064.224-3.22-4.62L133.91 21h-1.162l3.668-5.278-3.304-4.718 1.05-.224 2.87 4.172 2.8-4.102h1.162l-3.36 4.844 3.668 5.166zM8.852 14.253l4.324 4.325a.499.499 0 0 1 .146.353v4.568a.5.5 0 0 1-.852.354l-4.324-4.326A.495.495 0 0 1 8 19.174v-4.568a.5.5 0 0 1 .852-.353zM8.503 8h10.673c.132 0 .26.052.352.146l4.325 4.325a.5.5 0 0 1-.353.852H13.321a.49.49 0 0 0 0 .978h3.306c.132 0 .26.052.353.145l4.324 4.326a.5.5 0 0 1-.353.852h-5.1a.503.503 0 0 1-.353-.146l-7.352-7.34A.495.495 0 0 1 8 11.785V8.503C8 8.225 8.226 8 8.503 8z"
      }))));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r88,
        o = this && this.__extends || (_r88 = function r(e, t) {
      return (_r88 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r88(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(5),
        s = n(0),
        c = n(365),
        l = n(4),
        u = n(21),
        p = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          isLogging: a.logManager.isLogging()
        }, t.handleClick = function () {
          a.logManager.isLogging() ? (t.modalPopup.hide(), window.removeEventListener("beforeunload", t.handlePageLeave), a.logManager.flush(), a.logManager.stop()) : a.logManager.prepare().then(function () {
            window.location.reload();
          }), t.setState({
            isLogging: a.logManager.isLogging()
          });
        }, t.renderTriggerButton = function (e) {
          var n = t.state.isLogging;
          return i.createElement(c.ButtonContainer, null, i.createElement(c.StyledIconButton, {
            isModalOpen: e,
            roundCorners: !1,
            className: u.cx("Twilio-ToggleLoggingPanel-IconButton"),
            icon: n ? "SupportabilityBold" : "Supportability"
          }));
        }, t.setModalPopupRef = function (e) {
          t.modalPopup = e;
        }, t;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        return a.logManager.isLogging() && window.addEventListener("beforeunload", this.handlePageLeave), this;
      }, t.prototype.handlePageLeave = function (e) {
        a.logManager.isLogging() && (e.preventDefault(), e.returnValue = !0);
      }, t.prototype.render = function () {
        var e = this.state.isLogging;
        return i.createElement(s.ModalPopupWithEntryControl, {
          className: "Twilio-ToggleLoggingPanel",
          autoClose: !0,
          alignRight: !0,
          ref: this.setModalPopupRef,
          entryControl: this.renderTriggerButton
        }, i.createElement(c.Panel, {
          className: u.cx("Twilio-ToggleLoggingPanel-Panel")
        }, i.createElement(l.Template, {
          source: e ? l.templates.LogToFileStopLoggingText : l.templates.LogToFileStartLoggingText
        }), i.createElement(c.StyledButton, {
          roundCorners: !1,
          className: u.cx("Twilio-ToggleLoggingPanel-IconButton"),
          onClick: this.handleClick
        }, i.createElement(l.Template, {
          source: e ? l.templates.LogToFileStopLoggingLabel : l.templates.LogToFileStartLoggingLabel
        }))));
      }, t;
    }(i.PureComponent);

    t.ToggleLoggingPanel = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c = n(2),
        l = n(0);
    t.Panel = c.default("div")(o || (o = r(["\n    width: 260px;\n    color: ", ";\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.4);\n    padding: 16px;\n\n    h2 {\n        font-size: 12px;\n        font-weight: bold;\n        margin-top: 0;\n        margin-bottom: 12px;\n        line-height: 16px;\n    }\n\n    ul {\n        list-style: disc;\n        padding-left: 20px;\n        margin: 0;\n    }\n\n    li,\n    p {\n        padding: 0;\n        margin-top: 0;\n        margin-bottom: 8px;\n        line-height: 16px;\n        color: ", ";\n    }\n\n    ", "\n"], ["\n    width: 260px;\n    color: ", ";\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.4);\n    padding: 16px;\n\n    h2 {\n        font-size: 12px;\n        font-weight: bold;\n        margin-top: 0;\n        margin-bottom: 12px;\n        line-height: 16px;\n    }\n\n    ul {\n        list-style: disc;\n        padding-left: 20px;\n        margin: 0;\n    }\n\n    li,\n    p {\n        padding: 0;\n        margin-top: 0;\n        margin-bottom: 8px;\n        line-height: 16px;\n        color: ", ";\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.calculated.textColor;
    }, function (e) {
      return e.theme.colors.base8;
    }, function (e) {
      return e.theme.ToggleLoggingPanel.Panel;
    }), t.ButtonContainer = c.default("div")(i || (i = r(["\n    height: 100%;\n    display: flex;\n    align-items: center;\n"], ["\n    height: 100%;\n    display: flex;\n    align-items: center;\n"]))), t.StyledIconButton = c.default(l.IconButton)(a || (a = r(["\n    height: 44px;\n    width: 44px;\n    border-radius: 0;\n    background-color: ", ";\n\n    &:hover {\n        background-color: rgba(255, 255, 255, 0.2);\n    }\n\n    ", "\n"], ["\n    height: 44px;\n    width: 44px;\n    border-radius: 0;\n    background-color: ", ";\n\n    &:hover {\n        background-color: rgba(255, 255, 255, 0.2);\n    }\n\n    ", "\n"])), function (e) {
      return e.isModalOpen ? "rgba(255, 255, 255, 0.2)" : "none";
    }, function (e) {
      return e.theme.ToggleLoggingPanel.IconButton;
    }), t.StyledButton = c.default(l.Button)(s || (s = r(["\n    .Twilio & {\n        margin-top: 16px;\n        color: #fff;\n        width: 100%;\n        text-transform: uppercase;\n\n        ", "\n    }\n"], ["\n    .Twilio & {\n        margin-top: 16px;\n        color: #fff;\n        width: 100%;\n        text-transform: uppercase;\n\n        ", "\n    }\n"])), function (e) {
      return e.theme.ToggleLoggingPanel.Button;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r89,
        o = this && this.__extends || (_r89 = function r(e, t) {
      return (_r89 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r89(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(4),
        c = n(0),
        l = n(368),
        u = n(369),
        p = n(94),
        d = n(2),
        f = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleModalChange = function () {
          t.forceUpdate();
        }, t.setModalPopupRef = function (e) {
          t.modalPopup = e;
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this,
            t = this.props.filters || [];
        return 0 === t.length ? null : a.createElement(p.TaskListContext.Consumer, null, function (n) {
          return a.createElement(l.StyledModalPopupWithEntryControl, {
            autoClose: !0,
            entryControl: a.createElement(u.TaskFilterButton, {
              className: "Twilio-TaskListFilter-TaskFilterButton",
              isOpen: e.isModalOpen(),
              content: e.getFilterText()
            }),
            innerRef: e.setModalPopupRef,
            onChange: e.handleModalChange
          }, a.createElement(l.StyledMenu, {
            className: "Twilio-TaskListFilter-Items",
            styleOverride: e.props.theme.TaskList.Filter.Menu
          }, t.map(function (t) {
            return a.createElement(c.MenuItem, {
              key: t.text,
              className: "Twilio-TaskListFilter-Item",
              onClick: function onClick() {
                return e.onFilterClick(t, n.onFilterChange);
              },
              selected: t === e.props.value,
              styleOverride: e.props.theme.TaskList.Filter.Menu
            }, e.getFilterText(t));
          })));
        });
      }, t.prototype.isModalOpen = function () {
        return !!this.modalPopup && this.modalPopup.isOpen;
      }, t.prototype.getFilterText = function (e) {
        return void 0 === e && (e = this.props.value), e.text in s.templates ? a.createElement(s.Template, {
          source: s.templates[e.text]
        }) : e.text;
      }, t.prototype.onFilterClick = function (e, t) {
        t(e), this.modalPopup.hide();
      }, t.displayName = "TaskListFilter", t = i([d.withTheme], t);
    }(a.PureComponent);

    t.TaskListFilter = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(2),
        s = n(0);
    t.StyledModalPopupWithEntryControl = a.default(s.ModalPopupWithEntryControl)(o || (o = r(["\n    border-style: solid;\n    border-width: 0 0 1px 0;\n    z-index: 1;\n    position: relative;\n    ", "\n"], ["\n    border-style: solid;\n    border-width: 0 0 1px 0;\n    z-index: 1;\n    position: relative;\n    ", "\n"])), function (e) {
      return e.theme.TaskList.Filter.Container;
    }), t.StyledMenu = a.default(s.Menu)(i || (i = r(["\n    box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.25);\n"], ["\n    box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.25);\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(370);
    t.TaskFilterButton = r.TaskFilterButton;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__rest || function (e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        a = n(371);

    t.TaskFilterButton = function (e) {
      var t = e.content,
          n = e.isOpen,
          s = o(e, ["content", "isOpen"]);
      return i.createElement(a.StyledEntryButton, r({}, s), t, i.createElement(a.StyledToggleIcon, {
        icon: n ? "FilterUp" : "Filter"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(2),
        s = n(0);
    t.StyledEntryButton = a.default("button")(o || (o = r(["\n    margin-top: auto;\n    margin-bottom: auto;\n    padding: 0px 12px;\n    width: 100%;\n    white-space: nowrap;\n    border: none;\n    background: none;\n    outline: none;\n    text-align: left;\n\n    font-size: 10px;\n    font-weight: bold;\n    letter-spacing: 2px;\n\n    margin-right: auto;\n    display: flex;\n    align-items: center;\n    width: auto;\n\n    :hover,\n    :focus {\n        background: initial;\n    }\n    ", "\n"], ["\n    margin-top: auto;\n    margin-bottom: auto;\n    padding: 0px 12px;\n    width: 100%;\n    white-space: nowrap;\n    border: none;\n    background: none;\n    outline: none;\n    text-align: left;\n\n    font-size: 10px;\n    font-weight: bold;\n    letter-spacing: 2px;\n\n    margin-right: auto;\n    display: flex;\n    align-items: center;\n    width: auto;\n\n    :hover,\n    :focus {\n        background: initial;\n    }\n    ", "\n"])), function (e) {
      return e.theme.TaskList.Filter.EntryButton;
    }), t.StyledToggleIcon = a.default(s.Icon)(i || (i = r(["\n    margin-left: 4px;\n    margin-top: auto;\n    margin-bottom: auto;\n"], ["\n    margin-left: 4px;\n    margin-top: auto;\n    margin-bottom: auto;\n"])));
  }, function (e, t) {
    e.exports = require("react-flip-move");
  }, function (e, t, n) {
    "use strict";

    var _r90,
        o = this && this.__extends || (_r90 = function r(e, t) {
      return (_r90 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r90(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(14),
        u = n(374),
        p = n(2),
        d = n(3),
        f = n(12),
        h = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.updateAll = function () {}, t.prototype.render = function () {
        return s.createElement(m, i({}, this.props));
      }, t.displayName = u.displayName, t.Content = u.contentStore, t.defaultProps = {
        itemSize: "Small"
      }, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.TaskListItem = h;
    var m = l.withTaskContext(d.connect(function (e, t) {
      var n = f.TaskChannels.getForTask(t.task),
          r = n && n.componentProps && n.componentProps.TaskListItem && n.componentProps.TaskListItem.Badge && n.componentProps.TaskListItem.Badge.children;
      return {
        Badge: {
          children: "function" == typeof r ? r(e, t) : r
        }
      };
    })(p.withTheme(u.TaskListItemImpl)));
  }, function (e, t, n) {
    "use strict";

    var _r91,
        o = this && this.__extends || (_r91 = function r(e, t) {
      return (_r91 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r91(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(0),
        c = n(174),
        l = n(93);
    t.displayName = "TaskListItem", t.contentStore = new s.DynamicContentStore(t.displayName);

    var u = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.shouldComponentUpdate = function (e) {
        return !l(this.props, e);
      }, n.prototype.render = function () {
        var e = void 0 !== this.props.selected ? this.props.selected : this.props.selectedTaskSid === (this.props.task && this.props.task.sid),
            n = "Large" === (e && "LargeSelected" === this.props.itemSize ? "Large" : this.props.itemSize),
            r = i(i({}, this.props), {
          selected: e,
          large: n
        });
        return a.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: r,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0,
          vertical: !0
        }, a.createElement(a.Fragment, null, a.createElement(s.DefaultContentFragment, null, a.createElement(c.TaskListBaseItem, i({}, r)))));
      }, n;
    }(a.Component);

    t.TaskListItemImpl = u;
  }, function (e, t, n) {
    "use strict";

    var _r92,
        o = this && this.__extends || (_r92 = function r(e, t) {
      return (_r92 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r92(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(7),
        s = n(176),
        c = n(11),
        l = n(0),
        u = n(177),
        p = n(175),
        d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.refreshTimer = void 0, t.handleContainerClick = function (e) {
          t.props.onSelected && t.props.onSelected(t.props.task.sid);
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        if (!this.props.visible) return null;
        var e = this.props,
            t = e.actions,
            n = e.firstLine,
            r = e.secondLine,
            o = e.extraInfo,
            d = e.selected,
            f = e.large,
            h = e.icon,
            m = e.iconColor,
            g = e.task,
            y = e.channelDefinition,
            v = new a.TaskHelper(g),
            b = d ? y.icons.active : y.icons.list;
        return i.createElement(s.Container, {
          className: "Twilio-TaskListBaseItem",
          iconColor: m || c.TaskChannelHelper.getColor(g, y.colors.main, p.TaskListBaseItem),
          onClick: this.handleContainerClick,
          selected: d,
          large: f,
          vertical: !0
        }, i.createElement(s.UpperArea, {
          className: "Twilio-TaskListBaseItem-UpperArea"
        }, i.createElement(s.IconAreaContainer, {
          className: "Twilio-TaskListBaseItem-IconAreaContainer"
        }, i.createElement(s.TaskListIcon, {
          className: "Twilio-TaskListBaseItem-IconArea",
          icon: h || c.TaskChannelHelper.getIcon(g, b, p.TaskListBaseItem),
          selected: d
        }), this.props.Badge && i.createElement(l.Badge, null, this.props.Badge.children)), i.createElement(s.Content, {
          className: "Twilio-TaskListBaseItem-Content"
        }, i.createElement(s.FirstLineContainer, {
          className: "Twilio-TaskListBaseItem-FirstLine"
        }, n || i.createElement(l.Template, {
          code: c.TaskChannelHelper.getTemplateForStatus(g, y.templates.TaskListItem.firstLine, p.TaskListBaseItem),
          task: g,
          helper: v
        })), i.createElement(s.SecondLineContainer, {
          className: "Twilio-TaskListBaseItem-SecondLine"
        }, r || i.createElement(s.SecondLineStyledTemplate, {
          code: c.TaskChannelHelper.getTemplateForStatus(g, y.templates.TaskListItem.secondLine, p.TaskListBaseItem),
          task: g,
          helper: v
        }))), i.createElement(s.ActionsContainer, {
          className: "Twilio-TaskListBaseItem-Actions"
        }, t || i.createElement(u.TaskListButtons, null))), f && i.createElement(s.LowerArea, {
          className: "Twilio-TaskListBaseItem-LowerArea"
        }, o || i.createElement(l.Template, {
          code: c.TaskChannelHelper.getTemplateForStatus(g, y.templates.TaskListItem.extraInfo, p.TaskListBaseItem),
          task: g,
          helper: v
        })));
      }, t.prototype.componentDidMount = function () {
        var e = this;
        this.refreshTimer = window.setInterval(function () {
          return e.forceUpdate();
        }, 1e3);
      }, t.prototype.componentWillUnmount = function () {
        void 0 !== this.refreshTimer && window.clearInterval(this.refreshTimer);
      }, t.defaultProps = {
        visible: !0
      }, t.displayName = "TaskListBaseItem", t;
    }(i.PureComponent);

    t.TaskListBaseItemImpl = d;
  }, function (e, t, n) {
    "use strict";

    var _r93,
        o = this && this.__extends || (_r93 = function r(e, t) {
      return (_r93 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r93(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(14),
        c = n(377),
        l = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return a.createElement(u, i({}, this.props));
      }, t.displayName = c.displayName, t.Content = c.contentStore, t;
    }(a.PureComponent);

    t.TaskListButtons = l;
    var u = s.withTaskContext(c.TaskListButtonsImpl);
  }, function (e, t, n) {
    "use strict";

    var _r94,
        o = this && this.__extends || (_r94 = function r(e, t) {
      return (_r94 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r94(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        a = n(0),
        s = n(7),
        c = n(378),
        l = n(380),
        u = n(382),
        p = n(384);
    t.displayName = "TaskListButtons", t.contentStore = new a.DynamicContentStore(t.displayName);

    var d = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props,
            n = e.call,
            r = e.task,
            o = !s.TaskHelper.isRegularConferenceCall(r) && !s.TaskHelper.isOutboundCallTask(r) || s.TaskHelper.isRegularConferenceCall(r) && 2 === r.conference.liveParticipantCount;
        return i.createElement(a.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0
        }, i.createElement(i.Fragment, null, s.TaskHelper.isPending(r) && !s.TaskHelper.isInitialOutboundAttemptTask(r) && i.createElement(a.ContentFragment, null, i.createElement(c.AcceptTaskButton, {
          key: "accept",
          task: r
        }), i.createElement(l.RejectTaskButton, {
          key: "reject",
          task: r
        })), !!n && i.createElement(a.ContentFragment, null, o && i.createElement(u.HoldCallTaskButton, {
          key: "hold",
          task: r
        }), i.createElement(p.HangupCallTaskButton, {
          key: "hangup",
          task: r
        }))));
      }, n;
    }(i.PureComponent);

    t.TaskListButtonsImpl = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(379);
    t.AcceptTaskButton = r.AcceptTaskButton;
  }, function (e, t, n) {
    "use strict";

    var _r95,
        o = this && this.__extends || (_r95 = function r(e, t) {
      return (_r95 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r95(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(2),
        s = n(1),
        c = n(0),
        l = n(4),
        u = n(6),
        p = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onClick = function (e) {
          u.tryInvokeAction("AcceptTask", {
            task: t.props.task
          }), e.preventDefault();
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this;
        return s.createElement(c.ActionStateListener, {
          action: ["AcceptTask", "RejectTask"]
        }, function (t) {
          return s.createElement(c.IconButton, {
            className: "Twilio-TaskButton-Accept",
            themeOverride: e.props.theme.TaskList.Item.Buttons.AcceptButton,
            onClick: e.onClick,
            icon: "Accept",
            disabled: t.disabled,
            title: l.templates.AcceptTaskTooltip()
          });
        });
      }, t = i([a.withTheme], t);
    }(s.PureComponent);

    t.AcceptTaskButton = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(381);
    t.RejectTaskButton = r.RejectTaskButton;
  }, function (e, t, n) {
    "use strict";

    var _r96,
        o = this && this.__extends || (_r96 = function r(e, t) {
      return (_r96 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r96(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(2),
        s = n(1),
        c = n(0),
        l = n(4),
        u = n(6),
        p = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onClick = function (e) {
          var n = t.props.task;
          u.tryInvokeAction("RejectTask", {
            task: n
          }), e.preventDefault();
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this,
            t = this.props.theme;
        return s.createElement(c.ActionStateListener, {
          action: ["AcceptTask", "RejectTask"]
        }, function (n) {
          return s.createElement(c.IconButton, {
            className: "Twilio-TaskButton-Reject",
            onClick: e.onClick,
            themeOverride: t.TaskList.Item.Buttons.RejectButton,
            icon: "Close",
            disabled: n.disabled,
            title: l.templates.RejectTaskTooltip()
          });
        });
      }, t = i([a.withTheme], t);
    }(s.PureComponent);

    t.RejectTaskButton = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(383);
    t.HoldCallTaskButton = r.HoldCallTaskButton;
  }, function (e, t, n) {
    "use strict";

    var _r97,
        o = this && this.__extends || (_r97 = function r(e, t) {
      return (_r97 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r97(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(2),
        s = n(1),
        c = n(0),
        l = n(4),
        u = n(7),
        p = n(48),
        d = n(6),
        f = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onClick = function (e) {
          var n = t.props.task;
          d.tryInvokeAction(t.isOnHold() ? "UnholdCall" : "HoldCall", {
            task: n
          }), e.preventDefault();
        }, t;
      }

      return o(t, e), t.prototype.isOnHold = function () {
        return u.TaskHelper.isCallOnHold(this.props.task);
      }, t.prototype.render = function () {
        var e = this,
            t = this.props,
            n = t.task,
            r = t.theme,
            o = this.isOnHold();
        return s.createElement(c.ActionStateListener, {
          action: ["HoldCall", "UnholdCall"],
          payload: p.isValidVoiceActionPayload(n)
        }, function (t) {
          return s.createElement(c.IconButton, {
            disabled: t.disabled || !u.TaskHelper.canHold(n),
            className: "Twilio-TaskButton-Hold",
            onClick: e.onClick,
            themeOverride: r.TaskList.Item.Buttons.DefaultButton,
            icon: o ? "HoldOff" : "Hold",
            title: o ? l.templates.UnholdCustomerTooltip() : l.templates.HoldCustomerTooltip()
          });
        });
      }, t = i([a.withTheme], t);
    }(s.Component);

    t.HoldCallTaskButton = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(385);
    t.HangupCallTaskButton = r.HangupCallTaskButton;
  }, function (e, t, n) {
    "use strict";

    var _r98,
        o = this && this.__extends || (_r98 = function r(e, t) {
      return (_r98 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r98(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(2),
        s = n(1),
        c = n(0),
        l = n(4),
        u = n(48),
        p = n(6),
        d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onClick = function (e) {
          var n = t.props.task;
          p.tryInvokeAction("HangupCall", {
            task: n
          }), e.preventDefault();
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this,
            t = this.props,
            n = t.task,
            r = t.theme,
            o = n.conference && n.conference.liveParticipantCount > 2 ? "LeaveCall" : "Hangup";
        return s.createElement(c.ActionStateListener, {
          action: "HangupCall",
          payload: u.isValidVoiceActionPayload(n)
        }, function (t) {
          return s.createElement(c.IconButton, {
            className: "Twilio-TaskButton-Hangup",
            onClick: e.onClick,
            icon: o,
            themeOverride: r.TaskList.Item.Buttons.RejectButton,
            disabled: t.disabled,
            title: l.templates.HangupCallTooltip()
          });
        });
      }, t = i([a.withTheme], t);
    }(s.Component);

    t.HangupCallTaskButton = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(178);
    t.AgentDesktopView = r.AgentDesktopView, t.AgentDesktopViewProps = r.AgentDesktopViewProps, t.AgentDesktopViewChildrenProps = r.AgentDesktopViewChildrenProps, t.SplitterOrientation = r.SplitterOrientation;
    var o = n(414);
    t.LoginView = o.LoginView, t.LoginViewProps = o.LoginViewProps;
    var i = n(96);
    t.LoginFormView = i.LoginFormView;
    var a = n(190);
    t.TeamsView = a.TeamsView;
    var s = n(202);
    t.QueuesStatsView = s.QueuesStatsView;
    var c = n(475);
    t.RuntimeLoginView = c.RuntimeLoginView, t.RuntimeLookupResponse = c.RuntimeLookupResponse;
  }, function (e, t, n) {
    "use strict";

    var _r99,
        o = this && this.__extends || (_r99 = function r(e, t) {
      return (_r99 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r99(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(63),
        l = n(0),
        u = n(3),
        p = n(179),
        d = n(183),
        f = n(412),
        h = function (e) {
      function n() {
        var n = null !== e && e.apply(this, arguments) || this;
        return n.getBaseRoute = function () {
          return n.props.route.match && n.props.route.match.url.replace(/\/$/, "");
        }, n.renderChildren = function (e) {
          return s.createElement(t.Connected, i({}, n.props, {
            route: e
          }));
        }, n;
      }

      return o(n, e), n.updateAll = function () {}, n.prototype.render = function () {
        var e = this.getBaseRoute();
        return s.createElement(c.Route, {
          path: e + "/:taskSid?",
          children: this.renderChildren
        });
      }, n.displayName = f.displayName, n.Content = f.contentStore, n.Panel1 = p.Panel1, n.Panel2 = d.Panel2, n.defaultProps = {
        showPanel2: !0,
        splitterOptions: void 0
      }, n = a([l.withDefaultPropsUpdate], n);
    }(s.PureComponent);

    t.AgentDesktopView = h, t.Connected = u.connect(function (e) {
      return {
        tasks: e.worker.tasks
      };
    })(f.AgentDesktopViewImpl);
  }, function (e, t, n) {
    "use strict";

    var _r100,
        o = this && this.__extends || (_r100 = function r(e, t) {
      return (_r100 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r100(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(7),
        u = n(390),
        p = function p(e) {
      return l.TaskHelper.isIncomingCall(e) || l.TaskHelper.isLiveCall(e);
    },
        d = [{
      text: "TaskFilterAll",
      callback: function callback(e) {
        return !p(e);
      }
    }, {
      text: "TaskFilterActive",
      callback: function callback(e) {
        return !p(e) && "accepted" === e.status;
      }
    }, {
      text: "TaskFilterWrapping",
      callback: function callback(e) {
        return !p(e) && "wrapping" === e.status;
      }
    }],
        f = function f(e) {
      return p(e);
    },
        h = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.updateAll = function () {}, t.prototype.render = function () {
        return s.createElement(u.TaskListContainerImpl, i({}, this.props));
      }, t.displayName = u.displayName, t.defaultTaskFilters = d, t.defaultStaticTaskFilter = f, t.Content = u.contentStore, t.defaultProps = {
        taskFilters: d,
        staticTaskFilter: f
      }, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.TaskListContainer = h;
  }, function (e, t, n) {
    "use strict";

    var _r101,
        o = this && this.__extends || (_r101 = function r(e, t) {
      return (_r101 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r101(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        a = n(0),
        s = n(170),
        c = n(391);
    t.displayName = "TaskListsContainer", t.contentStore = new a.DynamicContentStore(t.displayName);

    var l = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return i.createElement(a.DynamicComponent, {
          name: t.displayName,
          contentStore: t.contentStore,
          childProps: this.props,
          customChildren: this.props.children,
          vertical: !0
        }, i.createElement(c.Container, null, i.createElement(s.TaskList, {
          key: "tasklist",
          staticFilter: this.props.staticTaskFilter,
          filters: this.props.taskFilters,
          tasks: this.props.tasks,
          selectedTaskSid: this.props.selectedTaskSid,
          onTaskSelected: this.props.onTaskSelected
        })));
      }, n;
    }(i.PureComponent);

    t.TaskListContainerImpl = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(0),
        a = n(2);
    t.Container = a.default(i.FlexBoxColumn)(o || (o = r(["\n    overflow-y: auto;\n"], ["\n    overflow-y: auto;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r102,
        o = this && this.__extends || (_r102 = function r(e, t) {
      return (_r102 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r102(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(3),
        l = n(0),
        u = n(393),
        p = n(95),
        d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(f, i({}, this.props));
      }, t.friendlyName = u.displayName, t.displayName = u.displayName, t.Content = u.contentStore, t.Tabs = p.WorkerDirectoryTabs, t = a([l.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.WorkerDirectory = d, t.mapStateToProps = function (e) {
      return {
        task: e.worker.tasks.get(e.view.selectedTaskSid),
        isOpen: e.view.isDirectoryOpen,
        isWarmTransferEnabled: !!e.config.warmTransfers && e.config.warmTransfers.enabled
      };
    };
    var f = c.connect(t.mapStateToProps)(u.WorkerDirectoryImpl);
  }, function (e, t, n) {
    "use strict";

    var _r103,
        o = this && this.__extends || (_r103 = function r(e, t) {
      return (_r103 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r103(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(2),
        s = n(1),
        c = n(64),
        l = n(0),
        u = n(95);
    t.displayName = "WorkerDirectory", t.contentStore = new l.DynamicContentStore(t.displayName);

    var p = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onCloseClick = function () {
          l.Actions.invokeAction("HideDirectory");
        }, t;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props,
            n = e.isOpen,
            r = e.children,
            o = e.theme,
            i = e.isWarmTransferEnabled;
        return s.createElement(c.PopupContainer, {
          className: "Twilio-WorkerDirectory-Popup",
          isOpen: n
        }, s.createElement(l.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: r,
          vertical: !0,
          noContainers: !0
        }, s.createElement(c.Container, {
          className: "Twilio-WorkerDirectory",
          vertical: !0
        }, s.createElement(c.HeaderPanel, {
          key: "header",
          className: "Twilio-WorkerDirectory-Header",
          noGrow: !0,
          noShrink: !0
        }, s.createElement(l.IconButton, {
          icon: "Close",
          onClick: this.onCloseClick,
          themeOverride: o.WorkerDirectory.Header.Button
        }), s.createElement(c.LabelContainer, null, s.createElement(c.Label, null, s.createElement(l.Template, {
          source: l.templates.WorkerDirectoryTitle
        })))), this.props.isOpen ? s.createElement(u.WorkerDirectoryTabs, {
          key: "tabs",
          isWarmTransferEnabled: i
        }) : null)));
      }, n = i([a.withTheme], n);
    }(s.PureComponent);

    t.WorkerDirectoryImpl = p;
  }, function (e, t, n) {
    "use strict";

    var _r104,
        o = this && this.__extends || (_r104 = function r(e, t) {
      return (_r104 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r104(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        a = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(0),
        c = n(1),
        l = n(64),
        u = n(395),
        p = n(398),
        d = n(40),
        f = n(3),
        h = n(25),
        m = n(6);
    t.displayName = "WorkerDirectoryTabs", t.contentStore = new s.DynamicContentStore(t.displayName);

    var g = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.queueSearchInputElementRef = c.createRef(), t.workerSearchInputElementRef = c.createRef(), t.onTransferQueueClick = function (e) {
          return function (n) {
            m.tryInvokeAction("TransferTask", {
              task: t.props.task,
              targetSid: e.sid,
              options: n
            }), m.tryInvokeAction("HideDirectory");
          };
        }, t.onTransferClick = function (e) {
          return function (n) {
            m.tryInvokeAction("TransferTask", {
              task: t.props.task,
              targetSid: e.sid,
              options: n
            }), m.tryInvokeAction("HideDirectory");
          };
        }, t.onWorkerSearchInputChange = function () {
          t.workersSearch && !t.workerSearchTimer && (t.workerSearchTimer = window.setTimeout(function () {
            if (null != t.workerSearchInputElementRef.current) {
              var e = t.workerSearchInputElementRef.current,
                  n = e.value ? 'data.attributes.full_name contains "' + e.value + '"' : "";
              t.workersSearch.search(n), t.workerSearchTimer = null;
            }
          }, 300));
        }, t.onQueueSearchInputChange = function () {
          t.queuesSearch && !t.queueSearchTimer && (t.queueSearchTimer = window.setTimeout(function () {
            if (null != t.queueSearchInputElementRef.current) {
              var e = t.queueSearchInputElementRef.current,
                  n = e.value ? 'data.queue_name contains "' + e.value + '"' : "";
              t.queuesSearch.search(n), t.queueSearchTimer = null;
            }
          }, 300));
        }, t.state = {
          workers: [],
          queues: []
        }, t;
      }

      return o(n, e), n.prototype.componentDidMount = function () {
        return i(this, void 0, void 0, function () {
          var e,
              t,
              n = this;
          return a(this, function (r) {
            switch (r.label) {
              case 0:
                return e = this, [4, f.FlexModule.insightsClient.instantQuery("tr-worker")];

              case 1:
                return e.workersSearch = r.sent().on("searchResult", function (e) {
                  var t = [];
                  Object.keys(e).forEach(function (n) {
                    if (n !== f.FlexModule.state.worker.source.sid) {
                      var r = e[n],
                          o = new d.InsightsWorker(r);
                      h.InsightsEntityCache.updateCache(o), t.push(o);
                    }
                  }), t = t.sort(function (e, t) {
                    var n = e.fullName || "",
                        r = t.fullName || "";
                    return n.localeCompare(r);
                  }), n.setState({
                    workers: t
                  });
                }), this.workersSearch.search(""), t = this, [4, f.FlexModule.insightsClient.instantQuery("tr-queue")];

              case 2:
                return t.queuesSearch = r.sent().on("searchResult", function (e) {
                  var t = [];
                  Object.keys(e).forEach(function (n) {
                    var r = e[n],
                        o = new d.InsightsQueue(r);
                    h.InsightsEntityCache.updateCache(o), t.push(o);
                  }), t = t.sort(function (e, t) {
                    var n = e.name || "",
                        r = t.name || "";
                    return n.localeCompare(r);
                  }), n.setState({
                    queues: t
                  });
                }), this.queuesSearch.search(""), [2];
            }
          });
        });
      }, n.prototype.render = function () {
        var e = this;
        return c.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          vertical: !0,
          noContainers: !0
        }, c.createElement(s.Tabs, {
          key: "tabs",
          className: "Twilio-WorkerDirectory-Tabs"
        }, c.createElement(s.Tab, {
          key: "workers",
          label: c.createElement(s.Template, {
            source: s.templates.WorkerDirectoryAgentsTabLabel
          })
        }, c.createElement(l.TabContainer, {
          key: "workers-container"
        }, c.createElement(l.InputContainer, {
          key: "workers-input-container"
        }, c.createElement(l.StyledInput, {
          key: "workers-input-field",
          inputRef: this.workerSearchInputElementRef,
          onChange: this.onWorkerSearchInputChange,
          placeholder: s.templates.WorkerDirectorySearchPlaceholder()
        })), c.createElement(l.ItemContainer, {
          key: "item-container",
          className: "Twilio-WorkerDirectory-Workers",
          vertical: !0
        }, Array.from(this.state.workers).map(function (t) {
          return c.createElement(u.WorkerItem, {
            worker: t,
            key: t.sid,
            isWarmTransferEnabled: e.props.isWarmTransferEnabled,
            onTransferClick: e.onTransferClick(t)
          });
        })))), c.createElement(s.Tab, {
          key: "queues",
          label: c.createElement(s.Template, {
            source: s.templates.WorkerDirectoryQueuesTabLabel
          })
        }, c.createElement(l.TabContainer, {
          key: "queues-container"
        }, c.createElement(l.InputContainer, {
          key: "queues-input-container"
        }, c.createElement(l.StyledInput, {
          key: "queues-input-field",
          inputRef: this.queueSearchInputElementRef,
          onChange: this.onQueueSearchInputChange,
          placeholder: s.templates.WorkerDirectorySearchPlaceholder()
        })), c.createElement(l.ItemContainer, {
          key: "item-container",
          className: "Twilio-WorkerDirectory-Queues",
          vertical: !0
        }, Array.from(this.state.queues).map(function (t) {
          return c.createElement(p.QueueItem, {
            queue: t,
            key: t.sid,
            isWarmTransferEnabled: e.props.isWarmTransferEnabled,
            onTransferClick: e.onTransferQueueClick(t)
          });
        }))))));
      }, n;
    }(c.PureComponent);

    t.WorkerDirectoryTabsImpl = g;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(396);
    t.WorkerItem = r.WorkerItem, t.WorkerItemProps = r.WorkerItemProps, t.TransferClickPayload = r.TransferClickPayload;
  }, function (e, t, n) {
    "use strict";

    var _r105,
        o = this && this.__extends || (_r105 = function r(e, t) {
      return (_r105 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r105(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(0),
        c = n(2),
        l = n(4),
        u = n(64),
        p = n(397),
        d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onWarmTransferClick = function (e) {
          t.props.onTransferClick({
            mode: "WARM"
          });
        }, t.onColdTransferClick = function (e) {
          t.props.onTransferClick({
            mode: "COLD"
          });
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.worker,
            n = e.isWarmTransferEnabled;
        return a.createElement(u.ItemInnerContainer, {
          className: "Twilio-WorkerDirectory-Worker",
          noGrow: !0,
          noShrink: !0
        }, a.createElement(p.WorkerMarginPlaceholder, {
          noGrow: !0,
          noShrink: !0
        }), a.createElement(s.UserCard, {
          className: "Twilio-WorkerDirectory-UserCard",
          firstLine: a.createElement(s.Template, {
            source: l.templates.WorkerDirectoryItemFirstLine,
            worker: t
          }),
          secondLine: a.createElement(s.Template, {
            source: l.templates.WorkerDirectoryItemSecondLine,
            worker: t
          }),
          isAvailable: t.isAvailable,
          imageUrl: t.attributes.image_url,
          large: !0
        }), a.createElement(u.ButtonContainer, {
          className: "Twilio-WorkerDirectory-ButtonContainer"
        }, n && a.createElement(u.CallButton, {
          icon: "Call",
          onClick: this.onWarmTransferClick,
          themeOverride: this.props.theme.WorkerDirectory.ItemActionButton,
          title: l.templates.WarmTransferTooltip()
        }), a.createElement(s.IconButton, {
          icon: "Transfer",
          onClick: this.onColdTransferClick,
          themeOverride: this.props.theme.WorkerDirectory.ItemActionButton,
          title: l.templates.ColdTransferTooltip()
        })));
      }, t = i([c.withTheme], t);
    }(a.Component);

    t.WorkerItem = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2),
        a = n(0);
    t.WorkerMarginPlaceholder = i.default(a.FlexBox)(o || (o = r(["\n    width: 6px;\n"], ["\n    width: 6px;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(399);
    t.QueueItem = r.QueueItem, t.QueueItemProps = r.QueueItemProps;
  }, function (e, t, n) {
    "use strict";

    var _r106,
        o = this && this.__extends || (_r106 = function r(e, t) {
      return (_r106 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r106(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(2),
        s = n(1),
        c = n(0),
        l = n(4),
        u = n(64),
        p = n(400),
        d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.onWarmTransferClick = function (e) {
          t.props.onTransferClick({
            mode: "WARM"
          });
        }, t.onColdTransferClick = function (e) {
          t.props.onTransferClick({
            mode: "COLD"
          });
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.queue,
            n = e.isWarmTransferEnabled;
        return s.createElement(u.ItemInnerContainer, {
          className: "Twilio-WorkerDirectory-Queue",
          noGrow: !0,
          noShrink: !0
        }, s.createElement(p.QueueAvatar, {
          noGrow: !0,
          noShrink: !0,
          className: "Twilio-WorkerDirectory-QueueAvatar"
        }, s.createElement(c.Icon, {
          icon: "Queue"
        })), s.createElement(p.QueueTitleContainer, {
          className: "Twilio-WorkerDirectory-QueueContent"
        }, s.createElement(c.Template, {
          source: l.templates.WorkerDirectoryQueueItemText,
          queue: t
        })), s.createElement(u.ButtonContainer, {
          className: "Twilio-WorkerDirectory-ButtonContainer"
        }, n && s.createElement(u.CallButton, {
          icon: "Call",
          onClick: this.onWarmTransferClick,
          themeOverride: this.props.theme.WorkerDirectory.ItemActionButton,
          title: l.templates.WarmTransferTooltip()
        }), s.createElement(c.IconButton, {
          icon: "Transfer",
          onClick: this.onColdTransferClick,
          themeOverride: this.props.theme.WorkerDirectory.ItemActionButton,
          title: l.templates.ColdTransferTooltip()
        })));
      }, t = i([a.withTheme], t);
    }(s.Component);

    t.QueueItem = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(2),
        s = n(0);
    t.QueueTitleContainer = a.default("div")(o || (o = r(["\n    flex: 1 1 auto;\n    overflow: hidden;\n    margin-top: auto;\n    margin-bottom: auto;\n    margin-left: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 12px;\n    font-weight: bold;\n"], ["\n    flex: 1 1 auto;\n    overflow: hidden;\n    margin-top: auto;\n    margin-bottom: auto;\n    margin-left: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 12px;\n    font-weight: bold;\n"]))), t.QueueAvatar = a.default(s.FlexBox)(i || (i = r(["\n    width: 44px;\n    justify-content: center;\n    ", ";\n"], ["\n    width: 44px;\n    justify-content: center;\n    ", ";\n"])), function (e) {
      return e.theme.WorkerDirectory.QueueItem.Avatar;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(402);
    t.ContentSplitter = r.ContentSplitter, t.ContentSplitterProps = r.ContentSplitterProps;
  }, function (e, t, n) {
    "use strict";

    var _r107,
        o = this && this.__extends || (_r107 = function r(e, t) {
      return (_r107 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r107(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(3),
        c = n(24),
        l = n(403),
        u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleSelectedViewChanged = function (e, n) {
          n || t.handleSplitterNeedsUpdate();
        }, t.handleSplitterNeedsUpdate = function () {
          setTimeout(function () {
            t.splitter && t.splitter.reInit();
          }, 0);
        }, t.makeSplitterRef = function (e) {
          t.splitter = e;
        }, t.handleResize = function () {
          s.FlexModule.events.emitSplitterResize();
        }, t;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        s.FlexModule.events.addListener(c.FlexEvent.flexSplitterResize, this.handleSplitterNeedsUpdate), s.FlexModule.events.addListener(c.FlexEvent.viewResized, this.handleSplitterNeedsUpdate), s.FlexModule.events.addListener(c.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged);
      }, t.prototype.componentWillUnmount = function () {
        s.FlexModule.events.removeListener(c.FlexEvent.flexSplitterResize, this.handleSplitterNeedsUpdate), s.FlexModule.events.removeListener(c.FlexEvent.viewResized, this.handleSplitterNeedsUpdate), s.FlexModule.events.removeListener(c.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged);
      }, t.prototype.render = function () {
        var e = this,
            n = {
          vertical: !0,
          primMin: "20%",
          secMin: "40%",
          initial: "35%"
        };
        this.props.vertical || (n = {
          vertical: !1,
          primMin: "276",
          secMin: "276",
          initial: "320"
        });
        return i.createElement(a.SplitContentContainer, {
          ref: this.makeSplitterRef,
          vertical: this.props.vertical,
          firstMinSize: n.primMin,
          secondMinSize: n.secMin,
          firstInitialSize: n.initial,
          separator: e.props.vertical ? i.createElement(l.SplitterSeparator, null, i.createElement(a.Icon, {
            icon: "Resize"
          })) : i.createElement(l.SplitterSeparatorVertical, null),
          lastSplitterState: t.lastSplitterState,
          onResize: this.handleResize
        }, this.props.children);
      }, t.lastSplitterState = new a.LastSplitterState(), t;
    }(i.PureComponent);

    t.ContentSplitter = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(2);
    t.SplitterSeparator = a.default("div")(o || (o = r(["\n    display: flex;\n    border-style: solid;\n    border-width: 1px 0 1px 0;\n    height: 24px;\n    width: 100%;\n    div {\n        margin: auto;\n    }\n    ", "\n"], ["\n    display: flex;\n    border-style: solid;\n    border-width: 1px 0 1px 0;\n    height: 24px;\n    width: 100%;\n    div {\n        margin: auto;\n    }\n    ", "\n"])), function (e) {
      return e.theme.AgentDesktopView.ContentSplitter;
    }), t.SplitterSeparatorVertical = a.default("div")(i || (i = r(["\n    height: 100%;\n    width: 1px;\n    background: ", ";\n"], ["\n    height: 100%;\n    width: 1px;\n    background: ", ";\n"])), function (e) {
      return e.theme.AgentDesktopView.ContentSplitter.borderColor;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2);
    t.LeftPanelRootContainer = i.default("div")(o || (o = r(["\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    width: 100%;\n    ", "\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    width: 100%;\n    ", "\n"])), function (e) {
      return e.theme.AgentDesktopView.Panel1;
    });
  }, function (e, t, n) {
    "use strict";

    var _r108,
        o = this && this.__extends || (_r108 = function r(e, t) {
      return (_r108 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r108(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(184),
        c = n(411),
        l = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return i.createElement(a.DynamicComponent, {
          name: t.friendlyName,
          contentStore: t.Content,
          childProps: this.props,
          customChildren: this.props.children,
          vertical: !0
        }, i.createElement(c.RightPanelRootContainer, null, i.createElement(s.CRMContainer, {
          key: "container"
        })));
      }, t.friendlyName = "AgentDesktopView.Panel2", t.displayName = t.friendlyName, t.Content = new a.DynamicContentStore(t.friendlyName), t;
    }(i.PureComponent);

    t.Panel2 = l;
  }, function (e, t, n) {
    "use strict";

    var _r109,
        o = this && this.__extends || (_r109 = function r(e, t) {
      return (_r109 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r109(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(1),
        c = n(0),
        l = n(9),
        u = n(407),
        p = n(2);
    !function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(185));

    var d = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.updateAll = function () {}, n.prototype.render = function () {
        return s.createElement(t.Connected, i({}, this.props));
      }, n.displayName = u.displayName, n.Content = u.contentStore, n.defaultProps = {
        uriCallback: void 0,
        uri: void 0
      }, n = a([c.withDefaultPropsUpdate], n);
    }(s.PureComponent);

    t.CRMContainer = d, t.Connected = p.withTheme(l.withTaskContext(u.CRMContainerImpl));
  }, function (e, t, n) {
    "use strict";

    var _r110,
        o = this && this.__extends || (_r110 = function r(e, t) {
      return (_r110 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r110(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(0),
        c = n(185),
        l = n(408);
    t.displayName = "CRMContainer", t.contentStore = new s.DynamicContentStore(t.displayName);

    var u = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        var e = i(i({}, this.props), {
          uri: this.props.uri || (this.props.uriCallback ? this.props.uriCallback(this.props.task) : void 0)
        });
        return a.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: e,
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, a.createElement(c.Container, null, !e.uri && a.createElement(l.CRMPlaceHolderView, {
          key: "placeholder"
        }), !!e.uri && a.createElement("iframe", {
          title: "CRMContainer",
          key: "iframe",
          src: e.uri
        })));
      }, n;
    }(a.PureComponent);

    t.CRMContainerImpl = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(409);
    t.CRMPlaceHolderView = r.CRMPlaceHolderView;
  }, function (e, t, n) {
    "use strict";

    var _r111,
        o = this && this.__extends || (_r111 = function r(e, t) {
      return (_r111 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r111(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(2),
        s = n(1),
        c = n(0),
        l = n(4),
        u = n(410),
        p = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleButtonClick = function () {
          window.open("https://www.twilio.com/docs/flex/ui-configuration-customization#configure-a-crm-integration", "_blank");
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(u.CRMContainerPlaceholder, {
          className: "Twilio-CRMContainer-PlaceHolder"
        }, s.createElement(u.FirstLineContainer, null, s.createElement(u.FirstLine, null, s.createElement(c.Template, {
          source: l.templates.NoCRMTitle
        }))), s.createElement(u.SecondLine, null, " ", s.createElement(c.Template, {
          source: l.templates.NoCRMConfigured
        }), " "), s.createElement(u.HintLine, null, " ", s.createElement(c.Template, {
          source: l.templates.NoCRMHint
        }), " "), s.createElement(u.StyledIcon, {
          icon: "NoCRM",
          sizeMultiplier: 3
        }), s.createElement(c.Button, {
          roundCorners: !1,
          onClick: this.handleButtonClick,
          themeOverride: this.props.theme.CRMContainer.Placeholder.Button
        }, s.createElement(c.Template, {
          source: l.templates.NoCRMConfiguredAction
        })));
      }, t = i([a.withTheme], t);
    }(s.PureComponent);

    t.CRMPlaceHolderView = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u,
        p = n(2),
        d = n(0);
    t.FirstLineContainer = p.default("div")(o || (o = r(["\n    border-style: solid;\n    border-width: 0px 0px 4px 0px;\n    border-color: ", ";\n"], ["\n    border-style: solid;\n    border-width: 0px 0px 4px 0px;\n    border-color: ", ";\n"])), function (e) {
      return e.theme.colors.flexBlueColor;
    }), t.FirstLine = p.default("div")(i || (i = r(["\n    font-size: 10px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    margin: 0px 12px 4px 12px;\n"], ["\n    font-size: 10px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    margin: 0px 12px 4px 12px;\n"]))), t.SecondLine = p.default("div")(a || (a = r(["\n    font-size: 24px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    text-align: center;\n    margin: 34px 20px 0px 20px;\n"], ["\n    font-size: 24px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    text-align: center;\n    margin: 34px 20px 0px 20px;\n"]))), t.HintLine = p.default("div")(s || (s = r(["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 16px 20px;\n    ", "\n"], ["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 16px 20px;\n    ", "\n"])), function (e) {
      return e.theme.CRMContainer.Placeholder.Hint;
    }), t.NameLine = p.default("div")(c || (c = r(["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 0px 20px;\n"], ["\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    margin: 12px 20px 0px 20px;\n"]))), t.StyledIcon = p.default(d.Icon)(l || (l = r(["\n    ", "\n    margin-bottom: 26px;\n"], ["\n    ", "\n    margin-bottom: 26px;\n"])), function (e) {
      return e.theme.CRMContainer.Placeholder.Icon;
    }), t.CRMContainerPlaceholder = p.default("div")(u || (u = r(["\n    flex: 1 1 auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    ", "\n"], ["\n    flex: 1 1 auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    ", "\n"])), function (e) {
      return e.theme.CRMContainer.Placeholder.Container;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(0),
        a = n(2);
    t.RightPanelRootContainer = a.default(i.FlexBoxColumn)(o || (o = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.AgentDesktopView.Panel2;
    });
  }, function (e, t, n) {
    "use strict";

    var _r112,
        o = this && this.__extends || (_r112 = function r(e, t) {
      return (_r112 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r112(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(0),
        c = n(3),
        l = n(24),
        u = n(413),
        p = n(9),
        d = n(179),
        f = n(183),
        h = n(2),
        m = n(18),
        g = n(6);
    t.displayName = "AgentDesktopView", t.contentStore = new s.DynamicContentStore(t.displayName);

    var y = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.notificationFilter = function (e) {
          return !t.props.isViewActive || e.id !== m.IncomingTask;
        }, t.handleSelectedViewChanged = function (e, n) {
          n || t.handleSplitterNeedsUpdate();
        }, t.handleSplitterNeedsUpdate = function () {
          setTimeout(function () {
            t.splitter && (t.splitter.reInit(), t.forceUpdate());
          }, 0);
        }, t.handleResize = function () {
          c.FlexModule.events.emitSplitterResize();
        }, t.makeSplitterRef = function (e) {
          t.splitter = e;
        }, t;
      }

      return o(n, e), n.prototype.componentDidMount = function () {
        c.FlexModule.events.addListener(l.FlexEvent.flexSplitterResize, this.handleSplitterNeedsUpdate), c.FlexModule.events.addListener(l.FlexEvent.viewResized, this.handleSplitterNeedsUpdate), c.FlexModule.events.addListener(l.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged), this.removeFilter = s.Notifications.handlers.inapp.addFilter(this.notificationFilter);
      }, n.prototype.componentWillUnmount = function () {
        c.FlexModule.events.removeListener(l.FlexEvent.flexSplitterResize, this.handleSplitterNeedsUpdate), c.FlexModule.events.removeListener(l.FlexEvent.viewResized, this.handleSplitterNeedsUpdate), c.FlexModule.events.removeListener(l.FlexEvent.selectedViewChanged, this.handleSelectedViewChanged), this.removeFilter();
      }, n.prototype.componentDidUpdate = function () {
        var e = this.getTaskSidFromRoute(this.props.route);
        e && this.props.isViewActive && !c.FlexModule.state.worker.tasks.get(e) && setTimeout(function () {
          g.tryInvokeAction("SelectTask", {
            task: null
          });
        }, 0);
      }, n.prototype.getTaskSidFromRoute = function (e) {
        return e.match && e.match.params.taskSid;
      }, n.prototype.renderContents = function (e) {
        var t = {
          selectedTaskSid: e,
          route: this.props.route,
          tasks: this.props.tasks
        };
        if (!this.props.showPanel2) return a.createElement(d.Panel1, i({
          key: "panel1"
        }, t));
        var r = this.props.splitterOptions ? this.props.splitterOptions : {};
        return a.createElement(s.ContentFragment, {
          align: "start"
        }, a.createElement(s.SplitContentContainer, {
          key: "splitter",
          onResize: this.handleResize,
          ref: this.makeSplitterRef,
          firstInitialSize: r.initialFirstPanelSize || "50%",
          firstMinSize: r.minimumFirstPanelSize || "276",
          secondMinSize: r.minimumSecondPanelSize || "40%",
          vertical: !1,
          separator: a.createElement(u.SplitterSeparator, null),
          lastSplitterState: n.splitterState
        }, a.createElement(v, i({
          key: "panel1"
        }, t)), a.createElement(b, i({
          key: "panel2"
        }, t))));
      }, n.prototype.render = function () {
        var e = this.getTaskSidFromRoute(this.props.route);
        return a.createElement(p.TaskContextSource, {
          key: "container",
          taskSid: e
        }, a.createElement(s.DynamicComponent, {
          name: t.displayName,
          contentStore: t.contentStore,
          childProps: this.props,
          customChildren: this.props.children
        }, this.renderContents(e)));
      }, n.splitterState = new s.LastSplitterState(), n;
    }(a.PureComponent);

    t.AgentDesktopViewImpl = y;
    var v = h.withTheme(d.Panel1),
        b = h.withTheme(f.Panel2);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2);
    t.SplitterSeparator = i.default("div")(o || (o = r(["\n    height: 100%;\n    width: 0;\n    background: ", ";\n"], ["\n    height: 100%;\n    width: 0;\n    background: ", ";\n"])), function (e) {
      return e.theme.AgentDesktopView.ContentSplitter.borderColor;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(415);
    t.LoginView = r.LoginView, t.LoginViewProps = r.LoginViewProps;
  }, function (e, t, n) {
    "use strict";

    var _r113,
        o = this && this.__extends || (_r113 = function r(e, t) {
      return (_r113 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r113(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(1),
        c = n(0),
        l = n(3),
        u = n(416);
    !function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(186));

    var p = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(d, i({}, this.props));
      }, t.displayName = "LoginView", t.defaultProps = {
        logoUrl: void 0
      }, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.LoginView = p;
    var d = l.connect(function (e) {
      return {
        session: e.session,
        ssoConfig: e.config.sso
      };
    })(u.LoginViewImpl);
  }, function (e, t, n) {
    "use strict";

    var _r114,
        o = this && this.__extends || (_r114 = function r(e, t) {
      return (_r114 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r114(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(2),
        s = n(1),
        c = n(186),
        l = n(417),
        u = n(26),
        p = n(0),
        d = n(4),
        f = n(33),
        h = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleLoginClick = function () {
          var e = t.props.ssoConfig;
          return f.SSOLoginHandler.create(e).then(function (e) {
            u.Actions.ssoLogin(e);
          });
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.session,
            n = e.logoUrl;
        return s.createElement(c.Container, {
          className: "Twilio-LoginView-Container"
        }, s.createElement(c.LogoContainer, {
          className: "Twilio-LoginView-LogoContainer"
        }, s.createElement(l.LoginLogo, {
          url: n
        })), s.createElement(c.ControlsContainer, {
          className: "Twilio-LoginView-Controls"
        }, t.loginState !== u.LoginState.LoggingIn && s.createElement(c.LoginButton, {
          className: "Twilio-LoginView-LoginButton",
          themeOverride: this.props.theme.LoginView.LoginButton,
          onClick: this.handleLoginClick,
          roundCorners: !1
        }, s.createElement(p.Template, {
          source: d.templates.LoginLogin
        })), t.loginState === u.LoginState.LoggingIn && s.createElement(c.LoadingContainer, {
          className: "Twilio-LoginView-Loading"
        }, s.createElement(p.Template, {
          source: d.templates.LoginLoading
        }))));
      }, t = i([a.withTheme], t);
    }(s.PureComponent);

    t.LoginViewImpl = h;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(418);
    t.LoginLogo = r.LoginLogo;
  }, function (e, t, n) {
    "use strict";

    var _r115,
        o = this && this.__extends || (_r115 = function r(e, t) {
      return (_r115 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r115(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(419),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props.url;
        return e ? i.createElement(s.LoginLogoImage, {
          src: e
        }) : i.createElement(a.Icon, {
          icon: "Twilio",
          sizeMultiplier: 3
        });
      }, t;
    }(i.PureComponent);

    t.LoginLogo = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2);
    t.LoginLogoImage = i.default("img")(o || (o = r(["\n    display: block;\n    max-height: 80px;\n"], ["\n    display: block;\n    max-height: 80px;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r116,
        o = this && this.__extends || (_r116 = function r(e, t) {
      return (_r116 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r116(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    },
        s = this && this.__metadata || function (e, t) {
      if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var c,
        l = n(0),
        u = n(2),
        p = n(1),
        d = n(4),
        f = n(43),
        h = n(421),
        m = n(5),
        g = n(28),
        y = n(33),
        v = n(34),
        b = n(187),
        C = n(8),
        _ = n(132);

    !function (e) {
      e.Initial = "Initial", e.RuntimeLoginInput = "RuntimeLoginInput", e.AccountSidLoading = "AccountSidLoading", e.PublicConfigLoading = "PublicConfigLoading", e.LoggingIn = "LoggingIn", e.LoginForm = "LoginForm", e.Final = "Final";
    }(c || (c = {}));
    var k = new Set([c.AccountSidLoading, c.PublicConfigLoading, c.LoggingIn, c.Final]);

    var w = {
      runtimeLogin: {
        mapDomainToLookup: function mapDomainToLookup(e) {
          return C.flexPublicConfigServiceUrl + "?RuntimeDomain=" + e;
        },
        adminLoginUrl: C.twilioServiceLoginUrl + "?localPort=" + (window.location.protocol.indexOf("https") > -1 && !window.location.port ? 443 : window.location.port)
      }
    },
        T = function (e) {
      function t(t) {
        var r = e.call(this, t) || this;
        return r.handleAdminLoginClick = function (e) {
          return n.useAdminLogin = !0, e.preventDefault(), r.tryLogin();
        }, r.handleWindowResize = function () {
          r.setSizeFromContainer();
        }, r.setContainerRef = function (e) {
          r._containerRef = e, r.setSizeFromContainer();
        }, r.setDomain = function (e) {
          var t = e.target;
          r.setState({
            runtimeDomain: t.value
          });
        }, r.handleFatalError = function (e) {
          m.log.error("LoginFormView fatal error:", e), r.props.onError && r.props.onError(e);
        }, r.handleSubmit = function (e) {
          switch (e.preventDefault(), r.state.smState) {
            case c.RuntimeLoginInput:
              r.sm.transitionTo(c.AccountSidLoading);
              break;

            case c.LoginForm:
              r.tryLogin();
          }
        }, r.transitionToInit = function () {
          return r.getMergedConfig().sso.accountSid ? r.state.publicConfig ? r.sm.transitionTo(c.LoggingIn) : r.sm.transitionTo(c.PublicConfigLoading) : r.state.runtimeDomain ? r.sm.transitionTo(c.AccountSidLoading) : r.sm.transitionTo(c.RuntimeLoginInput);
        }, r.transitionToFetchingAccountSid = function () {
          return v.fetchRuntimeDomainInfo(r.state.runtimeDomain, r.props.userConfig.runtimeLogin).then(function (e) {
            r.setState({
              determinedConfig: {
                sso: {
                  accountSid: e.account_sid
                }
              }
            }), r.sm.transitionTo(c.PublicConfigLoading);
          }).catch(function (e) {
            r.sm.transitionTo(c.RuntimeLoginInput), r.setState({
              error: e
            }), m.log.warn("Error from fetchRuntimeDomainInfo", e);
          });
        }, r.transitionToFetchingPublicConfig = function () {
          var e = r.getMergedConfig();
          if (!e.sso.accountSid) throw new g.ConfigError(g.ConfigErrorKeys.accountSid);
          return v.fetchPublicConfiguration(e.sso.accountSid, !0, r.props.userConfig.sso).then(function (e) {
            r.setState({
              publicConfig: e
            }), r.sm.transitionTo(c.LoggingIn);
          }).catch(function (e) {
            r.setState({
              error: e
            }), r.sm.transitionTo(c.LoginForm), m.log.warn("Error from fetchPublicConfiguration", e);
          });
        }, r.transitionToFinal = function () {
          var e = r.props.userConfig;
          l.Utils.mergeInto(e || {}, r.state.determinedConfig, !1);
          var t = l.Utils.merge(v.getStoredConfig(), r.state.determinedConfig);
          v.storeConfig(t), r.props.userLoggedOut && y.SSOLoginHandler.create(e.sso).then(function (e) {
            window.location.reload();
          }), r.props.onSuccess && r.props.onSuccess(r.state.determinedConfig);
        }, r.transitionToLoggingIn = function () {
          return r.tryLogin();
        }, r.state = {
          determinedConfig: {},
          error: null,
          runtimeDomain: t.initialRuntimeDomain,
          smState: null,
          publicConfig: void 0
        }, r.sm = new l.StateMachine("LoginFormView"), r.sm.onChange(function (e) {
          return r.setState(function (t) {
            return i(i({}, t), {
              smState: e
            });
          });
        }), r.sm.onEnter(c.Initial, r.transitionToInit), r.sm.onEnter(c.AccountSidLoading, r.transitionToFetchingAccountSid), r.sm.onEnter(c.PublicConfigLoading, r.transitionToFetchingPublicConfig), r.sm.onEnter(c.LoggingIn, r.transitionToLoggingIn), r.sm.onEnter(c.Final, r.transitionToFinal), Object.keys(d.templates).length || l.initWithStrings(f.languages.default), r;
      }

      var n, r;
      return o(t, e), n = t, t.prototype.componentDidMount = function () {
        return window.addEventListener("resize", this.handleWindowResize), this.props.userLoggedOut ? this.props.userConfig.sso && this.props.userConfig.sso.accountSid ? this.sm.transitionTo(c.LoginForm) : this.sm.transitionTo(c.RuntimeLoginInput) : this.sm.transitionTo(c.Initial);
      }, t.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.handleWindowResize);
      }, t.prototype.render = function () {
        var e = this.getDetailedErrorMessageTemplate();
        return p.createElement(h.Container, {
          className: "Twilio Twilio-LoginFormView",
          innerRef: this.setContainerRef
        }, p.createElement(h.VerticalContainer, {
          className: "Twilio-LoginFormView-Container",
          showBorder: this.state.containerWidth >= 1024
        }, p.createElement(h.ContentContainer, {
          className: "Twilio-LoginFormView-ContentContainer"
        }, p.createElement(h.StyledLogoWithCircle, {
          animating: this.isLoadingState(),
          backgroundColor: this.props.theme.LoginFormView.Container.backgroundColor
        }), p.createElement(h.MessageContainer, {
          className: "Twilio-LoginFormView-Message"
        }, p.createElement(l.Template, {
          source: this.getMessageTemplate()
        })), p.createElement(h.FormContainer, {
          className: "Twilio-LoginFormView-FormContainer"
        }, p.createElement(h.Form, {
          onSubmit: this.handleSubmit,
          className: "Twilio-LoginFormView-Form"
        }, this.isRuntimeDomainInputState() && p.createElement(h.RuntimeDomainInput, {
          className: "Twilio-LoginFormView-Input",
          value: this.state.runtimeDomain,
          onChange: this.setDomain,
          autoFocus: !0,
          error: !!this.state.error,
          name: "runtime",
          type: "text",
          placeholder: d.templates.RuntimeLoginPlaceholder()
        }), !this.isLoadingState() && this.doesErrorAllowButton() && p.createElement(h.LoginButton, {
          className: "Twilio-LoginFormView-LoginButton",
          roundCorners: !1,
          disabled: this.isLoginButtonDisabled(),
          onClick: this.handleSubmit,
          themeOverride: this.props.theme.RuntimeLoginView.LoginButton
        }, p.createElement(l.Template, {
          source: this.getLoginButtonTemplate()
        })))), p.createElement(h.ErrorDetailsContainer, {
          className: "Twilio-LoginFormView-ErrorDetails"
        }, !!e && p.createElement(l.Template, {
          source: e
        })), !this.isLoadingState() && p.createElement(h.AdminLinkContainer, {
          className: "Twilio-LoginFormView-AdminLogin"
        }, p.createElement(l.Template, {
          source: d.templates.LoginIsAdmin
        }), p.createElement(h.LoginLink, {
          href: "#",
          onClick: this.handleAdminLoginClick
        }, p.createElement(l.Template, {
          source: d.templates.LoginWithTwilio
        }))))));
      }, t.prototype.setSizeFromContainer = function () {
        this._containerRef && this.setState({
          containerWidth: this._containerRef.clientWidth
        });
      }, t.prototype.getMergedConfig = function (e) {
        void 0 === e && (e = this.props);
        var t = l.Utils.merge(e.userConfig || {}, this.state.determinedConfig),
            n = this.getAdminLoginConfigOverride();
        return n && l.Utils.mergeInto(t, n), t;
      }, t.prototype.getAdminLoginConfigOverride = function () {
        if (n.useAdminLogin) {
          var e = {
            sso: {
              idpUrl: this.getRuntimeConfig().adminLoginUrl
            }
          };

          if (window.location !== window.parent.location) {
            e.sso.loginPopup = !0;
            var t = i(i({}, _.getDefaultLoginWindowFeatures()), {
              width: 1e3
            });
            e.sso.loginPopupFeatures = _.stringifyLoginWindowFeatures(t);
          }

          return e;
        }
      }, t.prototype.tryLogin = function () {
        var e = this,
            t = this.getMergedConfig();
        return y.SSOLoginHandler.tryLogin(t.sso).then(function () {
          e.sm.transitionTo(c.Final);
        }).catch(function (t) {
          t instanceof g.BrowserError && t.key === g.BrowserErrorKeys.redirecting ? m.log.debug("Browser redirecting soon") : (e.setState({
            error: t
          }), e.sm.transitionTo(c.LoginForm), m.log.warn("Error from tryLogin", t), function (e) {
            return e instanceof g.BrowserError || e instanceof g.ValidationError || e instanceof g.ConfigError || e instanceof g.ClientError;
          }(t) || e.handleFatalError(t));
        });
      }, t.prototype.getErrorMessageTemplate = function () {
        var e = this.state.error;
        return e ? e.key === g.ValidationErrorKeys.sso ? d.templates.LoginErrorSso : e.key === g.BrowserErrorKeys.popupBlocked || e.key === g.BrowserErrorKeys.windowClosed ? d.templates.LoginErrorPopupBlocked : e.key === g.ValidationErrorKeys.accountSid ? d.templates.LoginErrorDomain : e.key === g.ValidationErrorKeys.untrustedDomain ? d.templates.LoginErrorUntrustedDomain : e.key === g.ValidationErrorKeys.invalidCertificate ? d.templates.LoginErrorInvalidCertificate : d.templates.LoginErrorGeneric : null;
      }, t.prototype.getDetailedErrorMessageTemplate = function () {
        var e = this.state.error;
        return !e || this.isLoadingState() ? null : e.key === g.ValidationErrorKeys.sso ? d.templates.LoginErrorSsoDetails : e.key === g.BrowserErrorKeys.popupBlocked || e.key === g.BrowserErrorKeys.windowClosed ? d.templates.LoginErrorPopupBlockedDetails : e.key === g.ValidationErrorKeys.accountSid ? d.templates.LoginErrorDomainDetails : e.key === g.ValidationErrorKeys.untrustedDomain ? d.templates.LoginErrorUntrustedDomainDetails : e.key === g.ValidationErrorKeys.invalidCertificate ? d.templates.LoginErrorInvalidCertificateDetails : null;
      }, t.prototype.getLoginButtonTemplate = function () {
        return this.props.userLoggedOut ? d.templates.LoginAgain : this.state.smState === c.RuntimeLoginInput ? d.templates.LoginLaunch : d.templates.LoginContinue;
      }, t.prototype.doesErrorAllowButton = function () {
        return !(this.state.error && this.state.error instanceof g.ValidationError);
      }, t.prototype.isLoginButtonDisabled = function () {
        return this.isRuntimeDomainInputState() && !this.state.runtimeDomain || this.state.smState === c.LoginForm && this.state.error && !(this.state.error instanceof g.BrowserError);
      }, t.prototype.getMessageTemplate = function () {
        return this.isLoadingState() ? d.templates.LoginLoading : this.isErrorState() ? this.getErrorMessageTemplate() : this.props.userLoggedOut ? d.templates.UserLoggedOutSuccess : d.templates.LoginWelcome;
      }, t.prototype.isRuntimeDomainInputState = function () {
        return this.state.smState === c.RuntimeLoginInput;
      }, t.prototype.isLoadingState = function () {
        return k.has(this.state.smState);
      }, t.prototype.isErrorState = function () {
        return !!this.state.error && !this.isLoadingState();
      }, t.prototype.getRuntimeConfig = function () {
        return this.props.userConfig.runtimeLogin || w.runtimeLogin;
      }, t.useAdminLogin = !1, t = n = a([u.withTheme, s("design:paramtypes", ["function" == typeof (r = void 0 !== b.LoginFormViewProps && b.LoginFormViewProps) ? r : Object])], t);
    }(p.PureComponent);

    t.LoginFormViewImpl = T;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u,
        p,
        d,
        f,
        h,
        m,
        g = n(0),
        y = n(65),
        v = n(2),
        b = n(188);
    t.Container = v.default("div")(o || (o = r(["\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1 1 auto;\n    justify-content: center;\n    ", "\n\n    a, a:active, a:hover, a:link, a:visited {\n        color: inherit;\n    }\n"], ["\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1 1 auto;\n    justify-content: center;\n    ", "\n\n    a, a:active, a:hover, a:link, a:visited {\n        color: inherit;\n    }\n"])), function (e) {
      return e.theme.LoginFormView.Container;
    }), t.VerticalContainer = v.default("div")(i || (i = r(["\n    width: ", ";\n    border-style: solid;\n    border-width: ", ";\n    min-height: 430px;\n    display: flex;\n    flex: 0 1 604px;\n    flex-direction: column;\n    ", "\n"], ["\n    width: ", ";\n    border-style: solid;\n    border-width: ", ";\n    min-height: 430px;\n    display: flex;\n    flex: 0 1 604px;\n    flex-direction: column;\n    ", "\n"])), function (e) {
      return e.showBorder ? "426px" : "100%";
    }, function (e) {
      return e.showBorder ? "1px" : "0px";
    }, function (e) {
      return e.theme.LoginFormView.Container;
    }), t.ContentContainer = v.default("div")(a || (a = r(["\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    align-items: center;\n    padding-left: 30px;\n    padding-right: 30px;\n    padding-top: 32px;\n    padding-bottom: 32px;\n"], ["\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    align-items: center;\n    padding-left: 30px;\n    padding-right: 30px;\n    padding-top: 32px;\n    padding-bottom: 32px;\n"]))), t.FormContainer = v.default("div")(s || (s = r(["\n    display: flex;\n    align-items: center;\n    width: 100%;\n"], ["\n    display: flex;\n    align-items: center;\n    width: 100%;\n"]))), t.Form = v.default("form")(c || (c = r(["\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    max-width: 348px;\n    margin: auto;\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    max-width: 348px;\n    margin: auto;\n"]))), t.LoginLink = v.default("a")(l || (l = r(["\n    margin-left: 8px;\n"], ["\n    margin-left: 8px;\n"]))), t.LoginButton = v.default(g.Button)(u || (u = r(["\n    text-transform: uppercase;\n    margin-top: 16px;\n"], ["\n    text-transform: uppercase;\n    margin-top: 16px;\n"]))), t.StyledLogoWithCircle = v.default(b.LogoWithCircle)(p || (p = r(["\n    flex: 0 0 auto;\n    margin-top: 32px;\n"], ["\n    flex: 0 0 auto;\n    margin-top: 32px;\n"]))), t.MessageContainer = v.default("div")(d || (d = r(["\n    font-size: 18px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: normal;\n    text-align: center;\n\n    margin-top: 32px;\n    margin-bottom: 32px;\n"], ["\n    font-size: 18px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: normal;\n    text-align: center;\n\n    margin-top: 32px;\n    margin-bottom: 32px;\n"]))), t.ErrorDetailsContainer = v.default("div")(f || (f = r(["\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: normal;\n    text-align: center;\n\n    margin-top: 40px;\n"], ["\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: normal;\n    text-align: center;\n\n    margin-top: 40px;\n"]))), t.RuntimeDomainInput = v.default(y.default)(h || (h = r(["\n    margin-top: 16px;\n    margin-left: 2px;\n    margin-right: 2px;\n"], ["\n    margin-top: 16px;\n    margin-left: 2px;\n    margin-right: 2px;\n"]))), t.AdminLinkContainer = v.default("div")(m || (m = r(["\n    margin-top: auto;\n    font-size: 12px;\n    font-weight: lighter;\n    text-align: center;\n"], ["\n    margin-top: auto;\n    font-size: 12px;\n    font-weight: lighter;\n    text-align: center;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(1),
        o = n(189),
        i = n(35),
        a = n(0),
        s = n(425);

    t.LogoWithCircle = function (e) {
      return r.createElement(s.CenterContainer, {
        className: i.cx("Twilio-LogoWithCircle", e.className)
      }, r.createElement(s.ProgressContainer, null, r.createElement(a.CircularProgress, {
        animating: e.animating,
        size: 124,
        borderWidth: 3
      })), r.createElement(o.LoginLogo, null));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(1),
        i = n(424);

    t.LoginLogo = function (e) {
      return o.createElement(i.LogoContainer, null, o.createElement("svg", r({
        viewBox: "0 0 173 166",
        width: "173",
        height: "166"
      }, e), o.createElement("g", {
        fill: "#FFF",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M69.449 59.978L81.88 72.413c.269.27.42.634.42 1.015v13.134c0 1.279-1.545 1.919-2.449 1.015L67.42 75.14a1.435 1.435 0 0 1-.42-1.014V60.992c0-1.278 1.545-1.918 2.449-1.014zM68.448 42H99.13c.38 0 .745.151 1.014.42l12.432 12.436c.904.904.264 2.45-1.014 2.45H82.3a1.405 1.405 0 0 0 0 2.81h9.503c.38 0 .745.15 1.014.42L105.25 72.97c.903.904.263 2.45-1.015 2.45H89.573c-.38 0-.745-.152-1.014-.421L67.42 53.898a1.435 1.435 0 0 1-.42-1.014v-9.436c0-.8.649-1.448 1.448-1.448zM15.752 146.59h-5.456V161h-1.65v-14.41H3.3v-1.54h12.21l.242 1.54zm27.42-1.54l-5.016 16.016h-1.452l-4.796-13.706-4.774 13.706h-1.408l-4.972-15.796 1.672-.374 4.114 13.53 4.554-13.376h1.694l4.62 13.376 4.048-13.376h1.716zM51.474 161h-1.672v-15.95h1.672V161zm16.046 0h-8.272v-15.95h1.65v14.41h6.38l.242 1.54zm7.928 0h-1.672v-15.95h1.672V161zm22.008-7.986c0 4.884-3.08 8.294-7.524 8.294s-7.48-3.388-7.48-8.25c0-4.906 3.08-8.294 7.524-8.294s7.48 3.366 7.48 8.25zm-1.738.022c0-4.048-2.288-6.776-5.786-6.776-3.476 0-5.764 2.728-5.764 6.754 0 4.07 2.31 6.776 5.786 6.776 3.498 0 5.764-2.706 5.764-6.754zm25.668-6.446h-6.666v5.566h5.324l.242 1.518h-5.566V161h-1.65v-15.95h8.316v1.54zM135.98 161h-8.272v-15.95h1.65v14.41h6.38l.242 1.54zm14.968 0h-8.866v-15.95h8.624v1.54h-6.974v5.302h5.522l.242 1.54h-5.764v6.05h7.216V161zm18.598-.22l-1.672.352-5.06-7.26L157.93 161h-1.826l5.764-8.294-5.192-7.414 1.65-.352 4.51 6.556 4.4-6.446h1.826l-5.28 7.612 5.764 8.118z"
      }))));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2);
    t.LogoContainer = i.default("div")(o || (o = r(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(2);
    t.CenterContainer = a.default("div")(o || (o = r(["\n    position: relative;\n    overflow: hidden;\n    margin-bottom: 6px;\n"], ["\n    position: relative;\n    overflow: hidden;\n    margin-bottom: 6px;\n"]))), t.ProgressContainer = a.default("div")(i || (i = r(["\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    right: 0;\n    text-align: center;\n"], ["\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    right: 0;\n    text-align: center;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r117,
        o = this && this.__extends || (_r117 = function r(e, t) {
      return (_r117 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r117(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(97),
        c = n(0),
        l = n(192),
        u = n(196),
        p = n(143),
        d = n(197),
        f = n(191),
        h = n(461),
        m = n(157),
        g = n(29),
        y = n(462),
        v = n(4),
        b = n(7),
        C = n(6),
        _ = n(21),
        k = n(16),
        w = n(137);

    t.displayName = "TeamsView", t.contentStore = new c.DynamicContentStore(t.displayName);

    var T = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          isFilterPanelOpen: !1,
          searchText: ""
        }, t.applyFilters = function (e) {
          g.Actions.applyListFilters({
            key: f.FiltersType.filter,
            filters: t.props.filters.map(function (t) {
              return {
                name: t.id,
                condition: t.condition || g.FilterConditions.IN,
                values: e[t.id] || []
              };
            })
          });
        }, t.resetFilters = function (e) {
          Object.keys(e).length ? t.applyFilters(e) : g.Actions.removeListFilters({
            key: f.FiltersType.filter
          });
        }, t.onSearchTextChange = function (e) {
          return t.setState({
            searchText: e
          });
        }, t.onSearchClear = function () {
          C.tryInvokeAction("RemoveListFilters", {
            key: f.FiltersType.search
          }), t.setState({
            searchText: ""
          });
        }, t.onSearchSubmit = function (e) {
          e ? C.tryInvokeAction("ApplyListFilters", {
            key: f.FiltersType.search,
            filters: [{
              name: "data.attributes.full_name",
              condition: g.FilterConditions.CONTAINS,
              values: e
            }]
          }) : C.tryInvokeAction("RemoveListFilters", {
            key: f.FiltersType.search
          }), t.closeFiltersPanel();
        }, t.onFilterButtonClick = function () {
          t.openFiltersPanel();
        }, t.openFiltersPanel = function () {
          t.setState({
            isFilterPanelOpen: !0
          }, function () {
            C.tryInvokeAction("SelectTaskInSupervisor", {}), C.tryInvokeAction("SelectWorkerInSupervisor", {});
          });
        }, t.closeFiltersPanel = function (e) {
          t.setState({
            isFilterPanelOpen: !1
          }, "function" == typeof e ? e : void 0);
        }, t.handleTaskSelection = function (e) {
          t.closeFiltersPanel(function () {
            C.tryInvokeAction("SelectTaskInSupervisor", {
              task: e
            });
          });
        }, t.handleWorkerSelection = function (e) {
          t.closeFiltersPanel(function () {
            C.tryInvokeAction("SelectWorkerInSupervisor", {
              worker: e
            });
          });
        }, t;
      }

      return o(n, e), n.getTaskSidFromRoute = function (e) {
        return e.match && "tasks" === e.match.params.resource && e.match.params.sid;
      }, n.prototype.componentDidMount = function () {
        this.loadChatChannel(), this.loadWorkers();
      }, n.prototype.componentDidUpdate = function (e, t) {
        n.getTaskSidFromRoute(e.route) === n.getTaskSidFromRoute(this.props.route) && t.selectedTask === this.state.selectedTask || this.loadChatChannel();
        var r = this.props,
            o = r.appliedFilters;

        if (r.filtersEnabled && e.appliedFilters !== o) {
          var i = o ? o.query : l.WorkersDataTable.IncludeAllFilter.query;
          k.Actions.setActiveFilterQuery(i, l.WorkersDataTable.taskFilter);
        }
      }, n.getDerivedStateFromProps = function (e, t) {
        var r = s.SupervisorStateHelper.getTaskBySid(n.getTaskSidFromRoute(e.route)),
            o = s.SupervisorStateHelper.getWorkerBySid(n.getWorkerSidFromRoute(e.route));
        return t.selectedTask && r && t.selectedTask.sid === r.sid && t.selectedWorker && o && t.selectedWorker.sid === o.sid ? null : {
          selectedTask: r,
          selectedWorker: o
        };
      }, n.getWorkerSidFromRoute = function (e) {
        return e.match && "workers" === e.match.params.resource && e.match.params.sid;
      }, n.prototype.loadChatChannel = function () {
        var e = this.state.selectedTask;

        if (e && b.TaskHelper.isChatBasedTask(e)) {
          var t = b.TaskHelper.getTaskChatChannelSid(e);
          c.ChatChannelState.Actions.initWithChannelSid(t);
        }
      }, n.prototype.loadWorkers = function () {
        var e = this.props,
            t = e.filters;

        if (e.filtersEnabled) {
          var n = c.FiltersList.getDefaultFilterValues(t);
          this.applyFilters(n);
        }
      }, n.prototype.renderDataTable = function (e, t) {
        return a.createElement(l.WorkersDataTable, {
          selectedTask: e,
          selectedWorker: t,
          monitoredTaskSid: this.props.monitoredTaskSid,
          onTaskSelected: this.handleTaskSelection,
          onWorkerSelected: this.handleWorkerSelection,
          filtersEnabled: this.props.filtersEnabled,
          appliedFilters: this.props.appliedFilters
        });
      }, n.prototype.render = function () {
        var e = this.props,
            n = e.isLoadingWorkers,
            r = e.filtersEnabled,
            o = this.state,
            s = o.selectedTask,
            l = o.selectedWorker;
        return a.createElement(c.DynamicComponent, {
          name: t.displayName,
          contentStore: t.contentStore,
          childProps: this.props,
          customChildren: this.props.children,
          noContainers: !0
        }, a.createElement(h.Container, null, a.createElement(c.FlexBox, {
          key: "agents-table",
          vertical: !0,
          className: _.cx({
            "Twilio-TeamsView-Loaded": !this.props.isLoadingWorkers
          })
        }, r && this.renderFilters(), this.props.isViewActive && this.renderDataTable(s, l), r && this.rendersResultsSummary()), !!s && a.createElement(u.SupervisorTaskContextSource, {
          key: "task-canvas",
          taskSid: s.sid
        }, a.createElement(p.TaskCanvas, null)), !!l && a.createElement(d.WorkerCanvas, {
          key: "worker-canvas",
          worker: l
        }), a.createElement(m.TeamFiltersPanel, i({
          isHidden: Boolean(s) || Boolean(l) || !this.state.isFilterPanelOpen,
          key: "team-filter-panel",
          handleCloseClick: this.closeFiltersPanel,
          handleApplyFilters: this.applyFilters,
          handleResetFilters: this.resetFilters,
          isLoadingWorkers: n
        }, this.props))));
      }, n.prototype.renderFilters = function () {
        var e = this.props.appliedFilters && this.props.appliedFilters.type === f.FiltersType.search;
        return a.createElement(h.FilterContainer, {
          key: "filters",
          className: "Twilio-TeamsView-Filter",
          noGrow: !0
        }, a.createElement(h.SearchContainer, null, a.createElement(y.SearchBar, {
          value: this.state.searchText,
          onChange: this.onSearchTextChange,
          onSubmit: this.onSearchSubmit,
          placeholder: v.templates.TeamsViewClearSearchPlaceholder(),
          disabled: this.props.isLoadingWorkers
        }), e && a.createElement(h.ClearSearchLink, {
          onClick: this.onSearchClear
        }, a.createElement(c.Template, {
          code: "TeamsViewClearSearchAction"
        }))), a.createElement(h.FilterButton, {
          onClick: this.onFilterButtonClick,
          roundCorners: !1,
          disabled: e
        }, a.createElement(c.Template, {
          code: "TeamsViewFilterAction",
          filterCount: !e && this.props.appliedFilters && this.props.appliedFilters.count
        }), a.createElement(c.Icon, {
          icon: "FilterTrigger"
        })));
      }, n.prototype.rendersResultsSummary = function () {
        var e,
            t = this.props.workers,
            n = this.props.appliedFilters && this.props.appliedFilters.type === f.FiltersType.search;
        return t.length > 0 && t.length < w.maxWorkersNumberFromInitialLoad ? null : (e = t.length >= w.maxWorkersNumberFromInitialLoad ? v.templates.TeamsViewResultsSummaryMaxWorkersDisplayed : v.templates.TeamsViewResultsSummaryNoWorkersDisplayed, a.createElement(h.ResultsSummary, null, a.createElement(c.Template, {
          source: e,
          amount: t.length
        }), t.length >= w.maxWorkersNumberFromInitialLoad && a.createElement(h.InlineButton, {
          role: "button",
          onClick: this.onFilterButtonClick,
          disabled: n
        }, a.createElement(c.Template, {
          source: v.templates.TeamsViewResultsSummaryFilterCTA
        }))));
      }, n;
    }(a.PureComponent);

    t.TeamsViewImpl = T;
  }, function (e, t, n) {
    "use strict";

    var _r118,
        o = this && this.__extends || (_r118 = function r(e, t) {
      return (_r118 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r118(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(1),
        c = n(0),
        l = n(3),
        u = n(428);

    t.defaultCompareFunction = function (e, t) {
      var n = e.fullName || "",
          r = t.fullName || "";
      return n.localeCompare(r);
    };

    var p = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      var r;
      return o(n, e), r = n, n.updateAll = function () {}, n.prototype.render = function () {
        return s.createElement(t.ConnectedWorkersDataTableImpl, i({}, this.props));
      }, n.displayName = u.displayName, n.Content = u.contentStore, n.IncludeAllFilter = u.IncludeAllFilter, n.IncludeActiveWorkersFilter = function (e) {
        var t = e.worker.activities,
            n = t && Array.from(t.values()).filter(function (e) {
          return !!e.available;
        });
        if (n && n.length) return {
          query: "data.activity_name IN [" + ('"' + n.map(function (e) {
            return e.name;
          }).join('", "') + '"') + "]",
          text: "Active Agents"
        };
      }, n.defaultFilters = [r.IncludeActiveWorkersFilter, r.IncludeAllFilter], n.taskFilter = 'data.status not_in ["completed", "canceled", "rescinded", "rejected", "timeout"]', n.defaultProps = {
        tablePlaceHolder: void 0,
        initialCompareFunction: t.defaultCompareFunction,
        filters: r.defaultFilters,
        taskFilter: r.taskFilter
      }, n = r = a([c.withDefaultPropsUpdate], n);
    }(s.PureComponent);

    t.WorkersDataTable = p;

    var d = function d(e, t, n) {
      return "function" == typeof e ? e(t, n) : e;
    };

    t.ConnectedWorkersDataTableImpl = l.connect(function (e, t) {
      var n = t.filters.find(function (n) {
        return d(n, e, t).query === e.supervisor.listener.getActiveFilterQuery();
      });
      return {
        workers: e.supervisor.workers,
        legacyActiveFilter: !t.filtersEnabled && d(n || t.filters[0], e, t),
        filters: t.filters.map(function (n) {
          return d(n, e, t);
        }).filter(function (e) {
          return !!e;
        })
      };
    })(u.WorkersDataTableImpl);
  }, function (e, t, n) {
    "use strict";

    var _r119,
        o = this && this.__extends || (_r119 = function r(e, t) {
      return (_r119 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r119(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
        e += arguments[t].length;
      }

      var r = Array(e),
          o = 0;

      for (t = 0; t < n; t++) {
        for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) {
          r[o] = i[a];
        }
      }

      return r;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(16),
        c = n(429),
        l = n(0),
        u = n(193),
        p = n(7),
        d = n(160),
        f = n(437),
        h = n(439);
    t.displayName = "WorkersDataTable", t.contentStore = new l.DynamicContentStore(t.displayName), t.IncludeAllFilter = {
      query: "",
      text: "All Agents"
    };

    var m = function (e) {
      function n() {
        var n = null !== e && e.apply(this, arguments) || this;
        return n.state = {
          legacyActiveFilter: n.props.legacyActiveFilter || t.IncludeAllFilter
        }, n.onUpdate = function () {
          n.forceUpdate();
        }, n.getItemWorkerSid = function (e) {
          return e.worker.sid;
        }, n.renderUserCard = function (e) {
          return a.createElement(f.UserCardWrapper, {
            item: e
          });
        }, n.renderTaskCardListForOthers = function (e, t) {
          return a.createElement(u.TaskCardList, {
            tasks: e.tasks,
            onCardSelected: t.onTaskSelected,
            selectedTaskSid: t.selectedTask && t.selectedTask.sid,
            highlightedTaskSid: t.monitoredTaskSid,
            filter: n.tasksFilter
          });
        }, n.renderTaskCardListForCall = function (e, t) {
          return a.createElement(u.TaskCardList, {
            tasks: e.tasks,
            onCardSelected: t.onTaskSelected,
            selectedTaskSid: t.selectedTask && t.selectedTask.sid,
            highlightedTaskSid: t.monitoredTaskSid,
            filter: n.callsFilter
          });
        }, n.callsFilter = function (e) {
          return p.TaskHelper.isCallTask(e) && p.TaskHelper.isTaskAccepted(e);
        }, n.tasksFilter = function (e) {
          return !p.TaskHelper.isCallTask(e) && p.TaskHelper.isTaskAccepted(e);
        }, n.onLegacyFilterChanged = function (e) {
          n.setState({
            legacyActiveFilter: e
          }), s.Actions.setActiveFilterQuery(e.query, n.props.taskFilter);
        }, n.handleRowClick = function (e) {
          var t = n.props,
              r = t.selectedWorker,
              o = t.onWorkerSelected;
          r && r.sid === e.worker.sid || o && o(e.worker);
        }, n;
      }

      return o(n, e), n.prototype.componentWillUnmount = function () {
        d.removeTickListener(this.onUpdate);
      }, n.prototype.componentDidMount = function () {
        var e = this.props,
            t = e.filtersEnabled,
            n = e.taskFilter,
            r = this.state.legacyActiveFilter.query;
        t || s.Actions.setActiveFilterQuery(r, n), d.addTickListener(this.onUpdate);
      }, n.prototype.render = function () {
        var e,
            n = this.props,
            r = n.tablePlaceHolder,
            o = n.filters,
            s = n.workers,
            u = n.filtersEnabled,
            p = n.selectedWorker,
            d = n.children,
            f = n.initialCompareFunction;
        f && (e = i(s)).sort(function (e, t) {
          return f(e.worker, t.worker, e.tasks, t.tasks);
        });
        var m = {
          selectedTask: this.props.selectedTask,
          monitoredTaskSid: this.props.monitoredTaskSid,
          onTaskSelected: this.props.onTaskSelected
        };
        return a.createElement(h.StyledTableContainer, {
          className: "Twilio-WorkersDataTable"
        }, !u && a.createElement(h.StyledFilterContainer, {
          className: "Twilio-WorkersDataTable-Filter",
          noGrow: !0
        }, a.createElement(c.WorkerListFilterSelect, {
          filters: o,
          activeFilter: this.state.legacyActiveFilter,
          onFilterChanged: this.onLegacyFilterChanged
        })), a.createElement(l.DynamicComponent, {
          childProps: this.props,
          contentStore: t.contentStore,
          name: t.displayName,
          customChildren: d,
          noContainers: !0
        }, a.createElement(l.DataTable, {
          items: e || s,
          itemKey: this.getItemWorkerSid,
          selectedItemKey: p && p.sid,
          placeholder: r,
          onRowClick: this.handleRowClick,
          columnDataCreationContext: m
        }, a.createElement(l.ColumnDefinition, {
          key: "worker",
          header: a.createElement(l.Template, {
            code: "ColumnHeaderAgent"
          }),
          content: this.renderUserCard,
          style: {
            width: "180px"
          }
        }), a.createElement(l.ColumnDefinition, {
          key: "calls",
          header: a.createElement(l.Template, {
            code: "ColumnHeaderCalls"
          }),
          content: this.renderTaskCardListForCall,
          style: {
            width: "180px"
          }
        }), a.createElement(l.ColumnDefinition, {
          key: "tasks",
          header: a.createElement(l.Template, {
            code: "ColumnHeaderTasks"
          }),
          content: this.renderTaskCardListForOthers
        }))));
      }, n.defaultProps = {
        filters: []
      }, n;
    }(a.Component);

    t.WorkersDataTableImpl = m;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(430);
    t.WorkerListFilterSelect = r.WorkerListFilterSelect;
  }, function (e, t, n) {
    "use strict";

    var _r120,
        o = this && this.__extends || (_r120 = function r(e, t) {
      return (_r120 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r120(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(50),
        s = n(4),
        c = n(431),
        l = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleChange = function (e) {
          t.props.onFilterChanged(t.props.filters[e.target.value]);
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            n = e.filters,
            r = e.activeFilter;
        return i.createElement(c.StyledSelect, {
          className: "Twilio-AgentListFilterSelect Twilio-WorkerListFilterSelect",
          value: n.findIndex(function (e) {
            return e.text === r.text;
          }),
          onChange: this.handleChange
        }, n.map(function (e, n) {
          return i.createElement(a.default, {
            key: e.query,
            value: n
          }, t.getFilterText(e));
        }));
      }, t.getFilterText = function (e) {
        return e.text in s.templates ? i.createElement(s.Template, {
          source: s.templates[e.text]
        }) : e.text;
      }, t;
    }(i.PureComponent);

    t.WorkerListFilterSelect = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2),
        a = n(51);
    t.StyledSelect = i.default(a.default)(o || (o = r(["\n    width: 252px;\n"], ["\n    width: 252px;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r121,
        o = this && this.__extends || (_r121 = function r(e, t) {
      return (_r121 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r121(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(0),
        c = n(7),
        l = n(11),
        u = n(98),
        p = n(195),
        d = n(435),
        f = n(2);
    t.displayName = "TaskCard", t.contentStore = new s.DynamicContentStore(t.displayName);

    var h = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleClick = function (e) {
          t.props.onClick && t.props.onClick(t.props.task), e.stopPropagation();
        }, t;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props,
            n = e.firstLine,
            r = e.secondLine,
            o = e.task,
            i = e.selected,
            f = e.icon,
            h = e.channelDefinition,
            m = new c.TaskHelper(o);
        return o && h ? a.createElement(d.StyledButton, {
          onClick: this.handleClick
        }, a.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0
        }, a.createElement(d.Container, {
          className: "Twilio-TaskCard-Container",
          selected: i,
          iconAreaStyleOverride: this.getIconAreaStyleOverride(h),
          contentAreaStyleOverride: this.getContentAreaStyleOverride(h)
        }, a.createElement(d.IconContainer, {
          key: "icon",
          className: "Twilio-TaskCard-IconContainer",
          icon: f || l.TaskChannelHelper.getIcon(o, i ? h.icons.active : h.icons.list, p.TaskCard)
        }), a.createElement(d.Content, {
          key: "content",
          className: "Twilio-TaskCard-Content"
        }, a.createElement(d.FirstLineContainer, {
          className: "Twilio-TaskCard-FirstLine"
        }, n || a.createElement(s.Template, {
          task: o,
          helper: m,
          code: l.TaskChannelHelper.getTemplateForStatus(o, h.templates.TaskCard.firstLine, p.TaskCard)
        })), a.createElement(d.SecondLineContainer, {
          className: "Twilio-TaskCard-SecondLine"
        }, r || a.createElement(s.Template, {
          task: o,
          helper: m,
          code: l.TaskChannelHelper.getTemplateForStatus(o, h.templates.TaskCard.secondLine, p.TaskCard)
        })))))) : a.createElement(u.TaskCardPlaceholder, null);
      }, n.prototype.getIconAreaStyleOverride = function (e) {
        var t = this.props.theme.TaskCard.IconArea.Default;
        return t.backgroundColor = l.TaskChannelHelper.getColor(this.props.task, e.colors.main, p.TaskCard), t;
      }, n.prototype.getContentAreaStyleOverride = function (e) {
        return this.props.highlighted ? this.getIconAreaStyleOverride(e) : c.TaskHelper.isInWrapupMode(this.props.task) || c.TaskHelper.isCompleted(this.props.task) ? this.props.theme.TaskCard.ContentArea.Inactive : this.props.theme.TaskCard.ContentArea.Default;
      }, n.defaultProps = {
        highlighted: !1,
        selected: !1
      }, n = i([f.withTheme], n);
    }(a.Component);

    t.TaskCardImpl = h;
  }, function (e, t, n) {
    "use strict";

    var _r122,
        o = this && this.__extends || (_r122 = function r(e, t) {
      return (_r122 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r122(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(434),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return i.createElement(a.DynamicComponent, {
          contentStore: t.Content,
          name: t.displayName
        }, i.createElement(s.Placeholder, {
          key: "placeholder"
        }));
      }, t.displayName = "TaskCardPlaceholder", t.Content = new a.DynamicContentStore(t.displayName), t;
    }(i.PureComponent);

    t.TaskCardPlaceholder = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2);
    t.Placeholder = i.default("div")(o || (o = r(["\n    height: 38px;\n    width: 132px;\n    margin: 6px 6px 6px 0;\n    border-radius: 2px;\n    border-style: solid;\n    border-width: 1px;\n    ", "\n    ", "\n"], ["\n    height: 38px;\n    width: 132px;\n    margin: 6px 6px 6px 0;\n    border-radius: 2px;\n    border-style: solid;\n    border-width: 1px;\n    ", "\n    ", "\n"])), function (e) {
      return "\n        background: repeating-linear-gradient(\n            127deg,\n            " + e.theme.colors.base2 + ",\n            " + e.theme.colors.base2 + " 3px,\n            " + e.theme.colors.base1 + " 3px,\n            " + e.theme.colors.base1 + " 6px\n        );\n    ";
    }, function (e) {
      return e.theme.TaskCardPlaceholder;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u = n(2),
        p = n(0);
    t.Container = u.default("div")(o || (o = r(["\n    display: flex;\n    height: 38px;\n    width: 132px;\n    overflow-y: hidden;\n    margin-top: 6px;\n    margin-bottom: 6px;\n    margin-left: 6px;\n    margin-right: 6px;\n\n    &:first-child {\n        margin-left: 0px;\n    }\n\n    border-radius: 2px;\n    border-style: solid;\n    cursor: pointer;\n    border-width: 1px;\n    ", "\n    ", "\n    & .Twilio-TaskCard-IconContainer {\n        background: ", ";\n        color: ", ";\n    }\n    & .Twilio-TaskCard-Content {\n        ", ";\n    }\n    &:hover {\n        ", "\n        & .Twilio-TaskCard-IconContainer {\n            ", ";\n        }\n        & .Twilio-TaskCard-Content {\n            ", ";\n        }\n    }\n"], ["\n    display: flex;\n    height: 38px;\n    width: 132px;\n    overflow-y: hidden;\n    margin-top: 6px;\n    margin-bottom: 6px;\n    margin-left: 6px;\n    margin-right: 6px;\n\n    &:first-child {\n        margin-left: 0px;\n    }\n\n    border-radius: 2px;\n    border-style: solid;\n    cursor: pointer;\n    border-width: 1px;\n    ", "\n    ", "\n    & .Twilio-TaskCard-IconContainer {\n        background: ", ";\n        color: ", ";\n    }\n    & .Twilio-TaskCard-Content {\n        ", ";\n    }\n    &:hover {\n        ", "\n        & .Twilio-TaskCard-IconContainer {\n            ", ";\n        }\n        & .Twilio-TaskCard-Content {\n            ", ";\n        }\n    }\n"])), function (e) {
      return e.theme.TaskCard.Container.Default;
    }, function (e) {
      return e.selected ? e.theme.TaskCard.Container.Selected : {};
    }, function (e) {
      return e.iconAreaStyleOverride.backgroundColor;
    }, function (e) {
      return e.iconAreaStyleOverride.color;
    }, function (e) {
      return e.contentAreaStyleOverride;
    }, function (e) {
      return e.theme.TaskCard.Container.Hover;
    }, function (e) {
      return p.getBackgroundWithHoverCSS(e.iconAreaStyleOverride.backgroundColor, e.theme.TaskCard.Container.Default.lightHover, !0);
    }, function (e) {
      return p.getBackgroundWithHoverCSS(e.contentAreaStyleOverride.backgroundColor, e.theme.TaskCard.Container.Default.lightHover, !0);
    }), t.SecondLineContainer = u.default("div")(i || (i = r(["\n    font-size: 10px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding-bottom: 4px;\n    text-align: left;\n"], ["\n    font-size: 10px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding-bottom: 4px;\n    text-align: left;\n"]))), t.FirstLineContainer = u.default("div")(a || (a = r(["\n    font-size: 10px;\n    font-weight: bold;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding-top: 4px;\n    text-align: left;\n"], ["\n    font-size: 10px;\n    font-weight: bold;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding-top: 4px;\n    text-align: left;\n"]))), t.Content = u.default("div")(s || (s = r(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    overflow: hidden;\n    padding-left: 8px;\n    padding-right: 8px;\n    flex: 1 1 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    overflow: hidden;\n    padding-left: 8px;\n    padding-right: 8px;\n    flex: 1 1 100%;\n"]))), t.IconContainer = u.default(p.Icon)(c || (c = r(["\n    flex: 0 0 36px;\n"], ["\n    flex: 0 0 36px;\n"]))), t.StyledButton = u.default("button")(l || (l = r(["\n    padding: 0;\n    display: flex;\n    color: inherit;\n    outline: none;\n    background: none;\n    border: none;\n    font-family: inherit;\n    svg {\n        margin: auto;\n    }\n"], ["\n    padding: 0;\n    display: flex;\n    color: inherit;\n    outline: none;\n    background: none;\n    border: none;\n    font-family: inherit;\n    svg {\n        margin: auto;\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(438);
    t.UserCardWrapper = r.UserCardWrapper;
  }, function (e, t, n) {
    "use strict";

    var _r123,
        o = this && this.__extends || (_r123 = function r(e, t) {
      return (_r123 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r123(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(4),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props.item;
        return i.createElement(a.UserCard, {
          className: "Twilio-AgentsDataTable-UserCard Twilio-WorkersDataTable-UserCard",
          imageUrl: e.worker.attributes.image_url,
          large: !0,
          firstLine: i.createElement(a.Template, {
            source: s.templates.SupervisorUserCardFirstLine,
            worker: e.worker
          }),
          secondLine: i.createElement(a.Template, {
            source: s.templates.SupervisorUserCardSecondLine,
            worker: e.worker
          }),
          isAvailable: e.worker.isAvailable
        });
      }, t;
    }(i.Component);

    t.UserCardWrapper = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(2),
        s = n(0);
    t.StyledTableContainer = a.default("div")(o || (o = r(["\n    overflow-y: auto;\n"], ["\n    overflow-y: auto;\n"]))), t.StyledFilterContainer = a.default(s.FlexBox)(i || (i = r(["\n    margin-top: 12px;\n    margin-left: 12px;\n    margin-bottom: 32px;\n"], ["\n    margin-top: 12px;\n    margin-left: 12px;\n    margin-bottom: 32px;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r124,
        o = this && this.__extends || (_r124 = function r(e, t) {
      return (_r124 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r124(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(441),
        u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(l.WorkerCanvasImpl, i({}, this.props));
      }, t.displayName = l.displayName, t.Content = l.contentStore, t.defaultProps = {
        showSkills: !0
      }, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.WorkerCanvas = u;
  }, function (e, t, n) {
    "use strict";

    var _r125,
        o = this && this.__extends || (_r125 = function r(e, t) {
      return (_r125 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r125(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(2),
        s = n(1),
        c = n(0),
        l = n(442),
        u = n(4),
        p = n(198),
        d = n(199),
        f = n(458),
        h = n(6);
    t.displayName = "WorkerCanvas", t.contentStore = new c.DynamicContentStore(t.displayName);

    var m = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleClose = function () {
          h.tryInvokeAction("SelectWorkerInSupervisor", void 0);
        }, t;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props,
            n = e.worker,
            r = e.showSkills;
        return s.createElement(c.SidePanel, {
          displayName: t.displayName,
          contentStore: t.contentStore,
          themeOverride: this.props.theme.Supervisor.WorkerCanvas,
          HeaderComponent: s.createElement(f.WorkerCanvasHeader, {
            key: "header",
            worker: n
          }),
          childrenProps: this.props
        }, s.createElement(l.Caption, {
          key: "profile-title",
          className: "Twilio-WorkerCanvas-SectionHeader"
        }, s.createElement(c.Template, {
          source: u.templates.WorkerCanvasDetailsHeader
        })), s.createElement(p.WorkerProfile, {
          key: "profile",
          worker: n
        }), r && s.createElement(l.Caption, {
          key: "skills-title",
          className: "Twilio-WorkerCanvas-SectionHeader"
        }, s.createElement(c.Template, {
          source: u.templates.WorkerCanvasSkillsHeader
        })), r && s.createElement(d.WorkerSkills, {
          key: "skills",
          worker: n,
          onClose: this.handleClose
        }));
      }, n = i([a.withTheme], n);
    }(s.PureComponent);

    t.WorkerCanvasImpl = m;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2);
    t.Caption = i.default("div")(o || (o = r(["\n    flex: 0 0 auto;\n    font-size: 10px;\n    font-weight: bold;\n    letter-spacing: 2px;\n    border-style: solid;\n    padding-left: 11px;\n    align-items: center;\n    height: 24px;\n    border-width: 0 0 1px 0;\n    text-transform: uppercase;\n    ", "\n"], ["\n    flex: 0 0 auto;\n    font-size: 10px;\n    font-weight: bold;\n    letter-spacing: 2px;\n    border-style: solid;\n    padding-left: 11px;\n    align-items: center;\n    height: 24px;\n    border-width: 0 0 1px 0;\n    text-transform: uppercase;\n    ", "\n"])), function (e) {
      return e.theme.Supervisor.WorkerCanvas.SectionCaption;
    });
  }, function (e, t, n) {
    "use strict";

    var _r126,
        o = this && this.__extends || (_r126 = function r(e, t) {
      return (_r126 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r126(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(444),
        u = n(2),
        p = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(d, i({}, this.props));
      }, t.displayName = l.displayName, t.friendlyName = l.displayName, t.Content = l.contentStore, t.defaultProps = {}, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.WorkerProfile = p;
    var d = u.withTheme(l.WorkerProfileImpl);
  }, function (e, t, n) {
    "use strict";

    var _r127,
        o = this && this.__extends || (_r127 = function r(e, t) {
      return (_r127 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r127(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        a = n(3),
        s = n(0),
        c = n(50),
        l = n(5),
        u = n(6),
        p = n(445);
    t.displayName = "WorkerCanvasProfile", t.contentStore = new s.DynamicContentStore(t.displayName);

    var d = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.renderDetails = function () {
          return l.log.warn("WorkerProfile details prop is deprecated!"), i.createElement("table", null, i.createElement("tbody", null, t.props.details.map(function (e) {
            return i.createElement("tr", {
              key: "detail-row-" + e.name
            }, i.createElement("td", null, i.createElement(p.FirstTemplate, null, i.createElement(s.Template, {
              code: e.name
            }))), i.createElement("td", null, i.createElement(p.SecondTemplate, null, i.createElement(s.Template, {
              code: e.content
            }))));
          })));
        }, t.handleChange = function (e) {
          var n = e.target.value,
              r = t.props.worker.sid;
          u.tryInvokeAction("SetWorkerActivity", {
            workerSid: r,
            activitySid: n
          });
        }, t;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props.worker,
            n = Array.from(a.FlexModule.state.worker.activities.values()).filter(function (e) {
          return "Reserved" !== e.name;
        });
        return i.createElement(p.StyledFlexBox, {
          className: "Twilio-WorkerProfile",
          vertical: !0,
          noGrow: !0,
          noShrink: !0
        }, i.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children
        }, i.createElement(s.FlexBox, null, i.createElement(p.AvatarContainer, {
          key: "avatar",
          className: "Twilio-WorkerProfile-Avatar",
          noGrow: !0,
          noShrink: !0
        }, i.createElement(p.StyledAvatar, {
          imageUrl: e.attributes.image_url,
          available: e.isAvailable,
          large: !0
        })), i.createElement(s.FlexBoxColumn, {
          key: "info",
          className: "Twilio-WorkerProfile-Info",
          overflow: "hidden"
        }, i.createElement(p.NameContainer, {
          className: "Twilio-WorkerProfile-Name"
        }, " ", e.fullName, " "), i.createElement(p.StyledSelect, {
          key: "availability",
          className: "Twilio-WorkerProfile-WorkerActivity",
          value: n.find(function (t) {
            return t.name === e.activityName;
          }).sid,
          onChange: this.handleChange
        }, n.map(function (e, t) {
          return i.createElement(c.default, {
            key: e.sid,
            value: e.sid
          }, e.name);
        }))))), !!this.props.details && this.renderDetails());
      }, n;
    }(i.PureComponent);

    t.WorkerProfileImpl = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u,
        p = n(2),
        d = n(0),
        f = n(51);
    t.FirstTemplate = p.default("div")(o || (o = r(["\n    margin-left: 13px;\n    margin-bottom: 13px;\n"], ["\n    margin-left: 13px;\n    margin-bottom: 13px;\n"]))), t.SecondTemplate = p.default("div")(i || (i = r(["\n    font-weight: bold;\n"], ["\n    font-weight: bold;\n"]))), t.StyledAvatar = p.default(d.Avatar)(a || (a = r(["\n    width: 60px;\n    height: 60px;\n    margin-left: 14px;\n    margin-top: 14px;\n    margin-bottom: 12px;\n"], ["\n    width: 60px;\n    height: 60px;\n    margin-left: 14px;\n    margin-top: 14px;\n    margin-bottom: 12px;\n"]))), t.StyledFlexBox = p.default(d.FlexBox)(s || (s = r(["\n    margin-bottom: 32px;\n"], ["\n    margin-bottom: 32px;\n"]))), t.AvatarContainer = p.default(d.FlexBox)(c || (c = r(["\n    width: 100px;\n"], ["\n    width: 100px;\n"]))), t.NameContainer = p.default("div")(l || (l = r(["\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    font-size: 12px;\n    font-weight: bold;\n    margin-top: 14px;\n    margin-bottom: 14px;\n"], ["\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    font-size: 12px;\n    font-weight: bold;\n    margin-top: 14px;\n    margin-bottom: 14px;\n"]))), t.StyledSelect = p.default(f.default)(u || (u = r(["\n    margin-right: 16px;\n    margin-bottom: auto;\n    overflow-x: hidden;\n    flex: 1 1 auto;\n"], ["\n    margin-right: 16px;\n    margin-bottom: auto;\n    overflow-x: hidden;\n    flex: 1 1 auto;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r128,
        o = this && this.__extends || (_r128 = function r(e, t) {
      return (_r128 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r128(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(13),
        u = n(447),
        p = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this;
        return s.createElement(l.FlexContext.Consumer, null, function (t) {
          return s.createElement(u.WorkerSkillsImpl, i({}, e.props, {
            availableSkills: e.props.availableSkills || t.manager.serviceConfiguration.taskrouter_skills
          }));
        });
      }, t.displayName = u.displayName, t.Content = u.contentStore, t.defaultProps = {}, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.WorkerSkills = p;
  }, function (e, t, n) {
    "use strict";

    var _r129,
        o = this && this.__extends || (_r129 = function r(e, t) {
      return (_r129 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r129(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s,
        c = n(2),
        l = n(1),
        u = n(15),
        p = n(41),
        d = n(99),
        f = n(100),
        h = n(0),
        m = n(4),
        g = n(13),
        y = n(3),
        v = n(5),
        b = n(449),
        C = n(454),
        _ = n(8);

    !function (e) {
      e.Error = "WorkerSkillsError", e.Saved = "WorkerSkillsSaved", e.Reverted = "WorkerSkillsReverted";
    }(s || (s = {})), t.displayName = "WorkerSkills", t.contentStore = new h.DynamicContentStore(t.displayName);

    var k = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          workerSid: void 0,
          skillsByName: void 0,
          skillsByNameOriginal: void 0
        }, t.handleSaveClick = function () {
          var e = t.getMergedAttributes(),
              n = {
            Sid: t.props.worker.sid,
            WorkspaceSid: g.Manager.getInstance().serviceConfiguration.taskrouter_workspace_sid,
            Attributes: JSON.stringify(e)
          },
              r = {
            auth: {
              username: "token",
              password: y.FlexModule.state.session.ssoTokenPayload.token
            },
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          };
          v.log.debug("updating attributes for worker", n);

          var o = _.getFlexServiceUrl(y.FlexModule.state.config);

          u.default.post(o + "/Worker/Instance", p.stringify(n), r).then(function () {
            v.log.debug("worker attributes updated", t.props.worker.sid), t.setState(function (e) {
              return {
                skillsByNameOriginal: e.skillsByName,
                notificationTemplate: s.Saved
              };
            });
          }).catch(function (e) {
            v.log.error("Failed to update worker attributes", e), t.setState({
              notificationTemplate: s.Error
            });
          });
        }, t.handleCancelClick = function () {
          t.setState(function (e) {
            return {
              skillsByName: e.skillsByNameOriginal,
              notificationTemplate: s.Reverted
            };
          });
        }, t.handleSkillUpdate = function (e) {
          t.setState(function (t) {
            var n;
            return {
              skillsByName: i(i({}, t.skillsByName), (n = {}, n[e.name] = e, n)),
              notificationTemplate: void 0
            };
          });
        }, t.handleSkillRemove = function (e) {
          t.setState(function (t) {
            var n = i({}, t.skillsByName);
            return delete n[e.name], {
              skillsByName: n,
              notificationTemplate: void 0
            };
          });
        }, t;
      }

      var r;
      return o(n, e), r = n, n.getDerivedStateFromProps = function (e, t) {
        return e.worker.sid === t.workerSid ? null : {
          workerSid: e.worker.sid,
          skillsByName: r.getSkillsFromWorker(e.worker, e.availableSkills),
          skillsByNameOriginal: r.getSkillsFromWorker(e.worker, e.availableSkills)
        };
      }, n.prototype.render = function () {
        var e = this,
            n = this.props,
            r = n.availableSkills,
            o = n.theme,
            i = this.state,
            a = i.skillsByName,
            s = i.skillsByNameOriginal,
            c = i.notificationTemplate,
            u = !s,
            p = u ? [] : Object.keys(a).map(function (e) {
          return a[e];
        }).sort(function (e, t) {
          return e.name.localeCompare(t.name);
        }),
            g = !u && JSON.stringify(s) !== JSON.stringify(a),
            y = p.every(f.isSkillLevelOk);
        return l.createElement(h.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, l.createElement(d.Container, {
          className: "Twilio-WorkerSkills",
          vertical: !0,
          noGrow: !0,
          noShrink: !0
        }, l.createElement(b.AddSkillPanel, {
          key: "add-skills",
          allSkillsDefinitions: !u && r || [],
          selectedSkills: a || {},
          onAdd: this.handleSkillUpdate
        }), l.createElement(d.SkillsContainer, {
          key: "skills-container",
          className: "Twilio-WorkerSkills-SkillsContainer",
          vertical: !0,
          noGrow: !0
        }, p.map(function (t) {
          return l.createElement(C.WorkerSkill, {
            key: t.name,
            skill: t,
            onUpdate: e.handleSkillUpdate,
            onRemove: e.handleSkillRemove
          });
        })), 0 === p.length && l.createElement(d.NoSkillsContainer, {
          key: "no-skills",
          className: "Twilio-WorkerSkills-NoSkills",
          noGrow: !0
        }, l.createElement(h.Template, {
          source: u ? m.templates.WorkerSkillsSchemaMismatch : m.templates.WorkerSkillsNoSkills
        })), l.createElement(d.ButtonsContainer, {
          key: "buttons-container",
          className: "Twilio-WorkerSkills-ButtonsContainer",
          noGrow: !0,
          noShrink: !0
        }, l.createElement(h.Button, {
          className: "Twilio-WorkerSkills-SkillsSaveButton",
          disabled: !g || !y,
          onClick: this.handleSaveClick,
          themeOverride: o.WorkerSkills.SaveButton,
          roundCorners: !1
        }, l.createElement(h.Template, {
          source: m.templates.Save
        })), l.createElement(h.Button, {
          className: "Twilio-WorkerSkills-SkillsCancelButton",
          disabled: !g,
          onClick: this.handleCancelClick,
          themeOverride: o.WorkerSkills.CancelButton,
          roundCorners: !1
        }, l.createElement(h.Template, {
          source: m.templates.Reset
        }))), !!c && l.createElement(d.NotificationTextContainer, {
          key: "notification-container",
          className: "Twilio-WorkerSkills-Notification",
          noGrow: !0
        }, l.createElement(h.Template, {
          code: c
        }))));
      }, n.prototype.getMergedAttributes = function () {
        var e = this,
            t = function t(_t2, n) {
          var r = e.state.skillsByName;
          _t2.skills = [], _t2.levels = {}, Object.keys(r).forEach(function (e) {
            var o = r[e];
            o.disabled === n && (_t2.skills.push(o.name), o.multivalue && (_t2.levels[o.name] = o.level));
          });
        },
            n = this.props.worker.attributes || {},
            r = n.disabled_skills || {},
            o = n.routing || {};

        return t(r, !0), t(o, !1), i(i({}, n), {
          routing: o,
          disabled_skills: r
        });
      }, n.getSkillsFromWorker = function (e, t) {
        var n = {};

        if (t) {
          var r = function r(e, _r130) {
            if (void 0 === e) return !0;
            if ("object" != typeof e) return !1;
            if (!Array.isArray(e.skills)) return v.log.warn("skills is not an array", e), void 0 === e.skills;
            var o = !0;
            return e.skills.forEach(function (a) {
              if ("string" != typeof a) return v.log.warn("skill name is not a string", a), void (o = !1);
              var s = t.find(function (e) {
                return e.name === a;
              }) || {
                multivalue: !1
              };
              n[a] = i(i({}, s), {
                disabled: _r130,
                name: a,
                level: e.levels ? e.levels[a] : void 0
              });
            }), o;
          };

          if (e.attributes) {
            var o = r(e.attributes.disabled_skills, !0),
                a = r(e.attributes.routing, !1);
            if (o && a) return n;
          }
        } else v.log.error("No `taskrouter_skills` array present in service configuration.");
      }, n = r = a([c.withTheme], n);
    }(l.PureComponent);

    t.WorkerSkillsImpl = k;
  }, function (e, t) {
    e.exports = require("@material-ui/core/FormControlLabel");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(450);
    t.AddSkillPanel = r.AddSkillPanel;
  }, function (e, t, n) {
    "use strict";

    var _r131,
        o = this && this.__extends || (_r131 = function r(e, t) {
      return (_r131 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r131(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(200),
        u = n(2),
        p = n(4),
        d = n(99),
        f = n(100),
        h = n(451),
        m = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {}, t.handleSkillSelected = function (e) {
          t.setState({
            current: e ? i(i({}, e), {
              disabled: !1
            }) : void 0
          });
        }, t.handleLevelChange = function (e) {
          var n = parseInt(e.target.value, 10);
          t.setState(function (e) {
            return {
              current: i(i({}, e.current), {
                level: Number.isNaN(n) ? void 0 : n
              })
            };
          });
        }, t.handleAddClick = function () {
          t.props.onAdd(t.state.current), t.setState({
            current: void 0
          });
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.state.current,
            t = this.props,
            n = t.allSkillsDefinitions,
            r = t.selectedSkills,
            o = t.theme,
            a = !!e && f.isSkillLevelOk(e),
            u = "";
        e && void 0 !== e.level && (u = String(e.level));
        var m = n.map(function (e) {
          return i(i({}, e), {
            disabled: !!r[e.name]
          });
        }).sort(function (e, t) {
          return e.name.localeCompare(t.name);
        });
        return s.createElement(d.AddPanelContainer, {
          className: "Twilio-WorkerSkills-AddSkillPanel",
          noGrow: !0,
          noShrink: !0,
          vertical: !0
        }, s.createElement(c.FlexBox, {
          noGrow: !0
        }, s.createElement(h.SkillsSelect, {
          values: m,
          selected: m.findIndex(function (t) {
            return t.name === (e && e.name);
          }),
          onChanged: this.handleSkillSelected
        }), s.createElement(d.LevelInputAndButtonContainer, {
          vertical: !0,
          noGrow: !0,
          noShrink: !0
        }, s.createElement(c.FlexBox, {
          noGrow: !0,
          noShrink: !0
        }, s.createElement(d.StyledSkillLevelInput, {
          disabled: !e || !e.multivalue,
          error: !!e && !a,
          value: u,
          placeholder: e && e.multivalue ? "" : "-",
          onChange: this.handleLevelChange
        }), s.createElement(d.RightButtonContainer, null, s.createElement(c.IconButton, {
          icon: "Add",
          themeOverride: o.WorkerSkills.SaveButton,
          onClick: this.handleAddClick,
          disabled: !a
        }))), !a && !!e && s.createElement(l.default, null, s.createElement(c.Template, {
          source: p.templates.WorkerSkillLevelInvalid,
          min: e.minimum,
          max: e.maximum
        })))));
      }, t = a([u.withTheme], t);
    }(s.PureComponent);

    t.AddSkillPanel = m;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(452);
    t.SkillsSelect = r.SkillsSelect;
  }, function (e, t, n) {
    "use strict";

    var _r132,
        o = this && this.__extends || (_r132 = function r(e, t) {
      return (_r132 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r132(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(50),
        c = n(4),
        l = n(453),
        u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleChange = function (e) {
          var n = -1 === e.target.value ? void 0 : t.props.values[e.target.value];
          t.props.onChanged(n);
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.values,
            n = e.selected;
        return i.createElement(l.StyledSelect, {
          className: "Twilio-WorkerSkills-Select",
          value: n,
          onChange: this.handleChange,
          displayEmpty: !0
        }, i.createElement(s.default, {
          value: -1,
          disabled: !0
        }, i.createElement(a.Template, {
          source: c.templates.WorkerSkillPleaseSelect
        })), t.map(function (e, t) {
          return i.createElement(s.default, {
            key: e.name,
            value: t,
            disabled: e.disabled,
            className: e.disabled ? "Twilio-disabled" : ""
          }, i.createElement(a.Template, {
            code: e.name
          }));
        }));
      }, t;
    }(i.PureComponent);

    t.SkillsSelect = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2),
        a = n(51);
    t.StyledSelect = i.default(a.default)(o || (o = r(["\n    margin-right: 16px;\n    margin-bottom: auto;\n    overflow-x: hidden;\n    flex: 1 1 auto;\n"], ["\n    margin-right: 16px;\n    margin-bottom: auto;\n    overflow-x: hidden;\n    flex: 1 1 auto;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(455);
    t.WorkerSkill = r.WorkerSkill;
  }, function (e, t, n) {
    "use strict";

    var _r133,
        o = this && this.__extends || (_r133 = function r(e, t) {
      return (_r133 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r133(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
        a = this && this.__assign || function () {
      return (a = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        s = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var c,
        l = n(2),
        u = n(1),
        p = n(21),
        d = n(0),
        f = n(456),
        h = n(200),
        m = n(4),
        g = n(99),
        y = n(457),
        v = n(100),
        b = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleSkillChecked = function (e) {
          var n = !e.target.checked;
          t.props.onUpdate(a(a({}, t.props.skill), {
            disabled: n
          }));
        }, t.handleLevelChange = function (e) {
          var n = parseInt(e.target.value, 10);
          t.props.onUpdate(a(a({}, t.props.skill), {
            level: Number.isNaN(n) ? void 0 : n
          }));
        }, t.handleRemoveClick = function () {
          t.props.onRemove(t.props.skill);
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props.skill,
            t = {
          label: p.css(c || (c = i(["\n                opacity: 0.4;\n            "], ["\n                opacity: 0.4;\n            "])))
        },
            n = v.isSkillLevelOk(e);
        return u.createElement(y.WorkerSkillContainer, {
          className: "Twilio-WorkerSkill",
          vertical: !0,
          noGrow: !0,
          noShrink: !0
        }, u.createElement(d.FlexBox, {
          noShrink: !0
        }, u.createElement(g.StyledFormControlLabel, {
          classes: e.disabled ? t : void 0,
          control: u.createElement(f.default, {
            checked: !e.disabled,
            onChange: this.handleSkillChecked,
            value: "checked",
            color: "primary"
          }),
          label: u.createElement(d.Template, {
            code: e.name
          })
        }), u.createElement(g.LevelInputAndButtonContainer, {
          vertical: !0,
          noGrow: !0,
          noShrink: !0
        }, u.createElement(d.FlexBox, {
          noGrow: !0,
          noShrink: !0
        }, u.createElement(g.StyledSkillLevelInput, {
          disabled: !e.multivalue,
          error: !v.isSkillLevelOk(e),
          value: void 0 !== e.level || e.multivalue ? e.level || "" : "-",
          placeholder: e.multivalue ? "-" : "",
          onChange: this.handleLevelChange
        }), u.createElement(g.RightButtonContainer, null, u.createElement(d.IconButton, {
          icon: "Close",
          onClick: this.handleRemoveClick,
          themeOverride: this.props.theme.WorkerSkills.DeleteButton
        }))), !n && u.createElement(h.default, null, u.createElement(d.Template, {
          source: m.templates.WorkerSkillLevelInvalid,
          min: e.minimum,
          max: e.maximum
        })))));
      }, t = s([l.withTheme], t);
    }(u.PureComponent);

    t.WorkerSkill = b;
  }, function (e, t) {
    e.exports = require("@material-ui/core/Switch");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2),
        a = n(0);
    t.WorkerSkillContainer = i.default(a.FlexBox)(o || (o = r(["\n    padding-top: 6px;\n    padding-bottom: 6px;\n"], ["\n    padding-top: 6px;\n    padding-bottom: 6px;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(459);
    t.WorkerCanvasHeader = r.WorkerCanvasHeader, t.WorkerCanvasHeaderProps = r.WorkerCanvasHeaderProps;
  }, function (e, t, n) {
    "use strict";

    var _r134,
        o = this && this.__extends || (_r134 = function r(e, t) {
      return (_r134 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r134(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(2),
        s = n(1),
        c = n(0),
        l = n(4),
        u = n(460),
        p = n(6),
        d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleCloseButton = function () {
          p.tryInvokeAction("SelectWorkerInSupervisor", {
            worker: void 0
          });
        }, t;
      }

      var n;
      return o(t, e), n = t, t.prototype.render = function () {
        return s.createElement(c.DynamicComponent, {
          contentStore: n.Content,
          childProps: this.props,
          name: n.friendlyName,
          customChildren: this.props.children,
          noContainers: !0
        }, s.createElement(u.HeaderContainer, {
          noShrink: !0,
          noGrow: !0
        }, s.createElement(c.IconButton, {
          key: "close-button",
          icon: "Close",
          themeOverride: this.props.theme.Supervisor.TaskCanvas.HeaderButton,
          onClick: this.handleCloseButton
        }), s.createElement(u.Text, {
          key: "title"
        }, s.createElement(c.Template, {
          source: l.templates.WorkerCanvasHeader
        }))));
      }, t.friendlyName = "WorkerCanvasHeader", t.displayName = n.friendlyName, t.Content = new c.DynamicContentStore(n.friendlyName), t = n = i([a.withTheme], t);
    }(s.PureComponent);

    t.WorkerCanvasHeader = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(2),
        s = n(0);
    t.Text = a.default(s.FlexBox)(o || (o = r(["\n    align-items: center;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 3px;\n    justify-content: center;\n    padding-right: 44px;\n    text-transform: uppercase;\n"], ["\n    align-items: center;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 3px;\n    justify-content: center;\n    padding-right: 44px;\n    text-transform: uppercase;\n"]))), t.HeaderContainer = a.default(s.FlexBox)(i || (i = r(["\n    height: 56px;\n    padding-left: 11px;\n    padding-right: 11px;\n    align-items: center;\n    ", "\n"], ["\n    height: 56px;\n    padding-left: 11px;\n    padding-right: 11px;\n    align-items: center;\n    ", "\n"])), function (e) {
      return e.theme.Supervisor.WorkerCanvas.Header;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u,
        p = n(0),
        d = n(2);
    t.Container = d.default(p.FlexBox)(o || (o = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.Supervisor.Container;
    }), t.FilterContainer = d.default(p.FlexBox)(i || (i = r(["\n    margin: 32px 18px;\n    justify-content: space-between;\n"], ["\n    margin: 32px 18px;\n    justify-content: space-between;\n"]))), t.FilterButton = d.default(p.Button)(a || (a = r(["\n    width: 107px;\n    height: 32px;\n    padding: 0 8px;\n    text-transform: uppercase;\n    font-weight: bold;\n    text-align: left;\n    letter-spacing: 1px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid;\n    ", ";\n    ", ";\n"], ["\n    width: 107px;\n    height: 32px;\n    padding: 0 8px;\n    text-transform: uppercase;\n    font-weight: bold;\n    text-align: left;\n    letter-spacing: 1px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid;\n    ", ";\n    ", ";\n"])), function (e) {
      return e.theme.Supervisor.FilterButton;
    }, function (e) {
      return p.getBackgroundWithHoverCSS(e.theme.Supervisor.FilterButton.background, e.theme.Supervisor.FilterButton.lightHover);
    }), t.SearchContainer = d.default("div")(s || (s = r(["\n    display: flex;\n    align-items: center;\n    ", ";\n"], ["\n    display: flex;\n    align-items: center;\n    ", ";\n"])), function (e) {
      return e.theme.Supervisor.Search.Container;
    }), t.ClearSearchLink = d.default("div")(c || (c = r(["\n    text-decoration: underline;\n    margin-left: 8px;\n    cursor: pointer;\n"], ["\n    text-decoration: underline;\n    margin-left: 8px;\n    cursor: pointer;\n"]))), t.ResultsSummary = d.default("div")(l || (l = r(["\n    margin-top: 20px;\n    color: ", ";\n    text-align: center;\n    line-height: 20px;\n"], ["\n    margin-top: 20px;\n    color: ", ";\n    text-align: center;\n    line-height: 20px;\n"])), function (e) {
      return e.theme.calculated.textColor;
    }), t.InlineButton = d.default("button")(u || (u = r(["\n    background: none;\n    font-weight: bold;\n    display: inline;\n    border-radius: 3px;\n    box-shadow: none;\n    font-size: inherit;\n    line-height: inherit;\n    padding: 0;\n    border: none;\n    text-decoration: underline;\n    cursor: pointer;\n\n    &:focus {\n        box-shadow: 0 0 0 2px ", ";\n        outline: none;\n    }\n\n    &:disabled {\n        color: ", ";\n        text-decoration: none;\n        font-weight: normal;\n        cursor: default;\n    }\n"], ["\n    background: none;\n    font-weight: bold;\n    display: inline;\n    border-radius: 3px;\n    box-shadow: none;\n    font-size: inherit;\n    line-height: inherit;\n    padding: 0;\n    border: none;\n    text-decoration: underline;\n    cursor: pointer;\n\n    &:focus {\n        box-shadow: 0 0 0 2px ", ";\n        outline: none;\n    }\n\n    &:disabled {\n        color: ", ";\n        text-decoration: none;\n        font-weight: normal;\n        cursor: default;\n    }\n"])), function (e) {
      return e.theme.colors.flexBlueColor;
    }, function (e) {
      return e.theme.calculated.textColor;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(463);
    t.SearchBar = r.SearchBar;
  }, function (e, t, n) {
    "use strict";

    var _r135,
        o = this && this.__extends || (_r135 = function r(e, t) {
      return (_r135 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r135(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(464),
        c = n(5),
        l = function (e) {
      function t() {
        var n = null !== e && e.apply(this, arguments) || this;
        return n.onChange = function (e) {
          var r = e.target.value;
          r.length > t.MAX_CHARACTER_LIMIT ? c.log.debug("Search string exceeds max character limit of " + t.MAX_CHARACTER_LIMIT) : n.props.onChange && n.props.onChange(r);
        }, n.onSubmit = function (e) {
          e.preventDefault(), n.props.onSubmit && !n.props.disabled && n.props.onSubmit(n.props.value);
        }, n;
      }

      return o(t, e), t.prototype.render = function () {
        return i.createElement("div", null, i.createElement(s.StyledForm, {
          onSubmit: this.onSubmit
        }, i.createElement(s.StyledInput, {
          value: this.props.value,
          onChange: this.onChange,
          placeholder: this.props.placeholder
        }), i.createElement(s.SearchButton, {
          roundCorners: !1,
          disabled: this.props.disabled
        }, i.createElement(a.Icon, {
          icon: "Search"
        }))));
      }, t.MAX_CHARACTER_LIMIT = 996, t;
    }(i.PureComponent);

    t.SearchBar = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c = n(2),
        l = n(201),
        u = n(0);
    t.StyledSearchIconButton = c.default("div")(o || (o = r(["\n    position: absolute;\n    right: 0;\n    height: 100%;\n    display: flex;\n    cursor: pointer;\n"], ["\n    position: absolute;\n    right: 0;\n    height: 100%;\n    display: flex;\n    cursor: pointer;\n"]))), t.StyledInput = c.default(l.Input)(i || (i = r(["\n    width: 252px;\n    input {\n        padding-right: 30px;\n    }\n"], ["\n    width: 252px;\n    input {\n        padding-right: 30px;\n    }\n"]))), t.StyledForm = c.default("form")(a || (a = r(["\n    display: flex;\n"], ["\n    display: flex;\n"]))), t.SearchButton = c.default(u.Button)(s || (s = r(["\n    height: 32px;\n    width: 32px;\n    padding: 0;\n    opacity: ", ";\n    ", ";\n    ", ";\n"], ["\n    height: 32px;\n    width: 32px;\n    padding: 0;\n    opacity: ", ";\n    ", ";\n    ", ";\n"])), function (e) {
      return e.disabled && .8;
    }, function (e) {
      return e.theme.Supervisor.Search.Button;
    }, function (e) {
      return u.getBackgroundWithHoverCSS(e.theme.Supervisor.Search.Button.background, e.theme.Supervisor.Search.Button.lightHover);
    });
  }, function (e, t, n) {
    "use strict";

    var _r136,
        o = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
        i = this && this.__extends || (_r136 = function r(e, t) {
      return (_r136 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r136(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        a = this && this.__rest || function (e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(1),
        c = n(0),
        l = n(90),
        u = n(20),
        p = n(466),
        d = n(204),
        f = n(4),
        h = n(62),
        m = n(10),
        g = n(8),
        y = n(73);
    t.displayName = "QueuesStatsView", t.Content = new c.DynamicContentStore(t.displayName);

    var v,
        b = function b(e) {
      var t = e.e,
          n = c.styled("div")(v || (v = o(["\n        flex: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        text-align: center;\n    "], ["\n        flex: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        text-align: center;\n    "])));
      return s.createElement(n, null, s.createElement("p", null, "There was an error loading Queues Stats. Please contact support with the following error:", s.createElement("br", null), t.message));
    },
        C = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.isAdmin = function (e) {
          return e.manager.user.roles.indexOf("admin") >= 0;
        }, t;
      }

      return i(n, e), n.prototype.componentDidMount = function () {
        u.Actions.init();
      }, n.prototype.componentWillUnmount = function () {
        u.Actions.close();
      }, n.prototype.render = function () {
        var e = this,
            n = this.props,
            r = n.children,
            o = a(n, ["children"]),
            i = o.isLoading,
            u = o.hasNoData,
            v = o.error;
        if (v) return s.createElement(b, {
          e: v
        });
        if (i) return s.createElement(p.LoadingContainer, null, s.createElement(c.CircularProgress, {
          animating: !0,
          size: 80,
          borderWidth: 3
        }));

        if (u) {
          var C = m.Manager.getInstance().serviceConfiguration.taskrouter_workspace_sid;
          return s.createElement(p.Container, null, s.createElement(h.FlexContext.Consumer, null, function (t) {
            return s.createElement(d.NoDataPlaceholder, {
              heading: s.createElement(f.Template, {
                source: f.templates.QueuesNoDataHeading
              }),
              body: s.createElement(f.Template, {
                source: e.isAdmin(t) ? f.templates.QueuesNoDataBodyForAdmin : f.templates.QueuesNoDataBodyForSupervisor
              }),
              linkText: e.isAdmin(t) ? s.createElement(f.Template, {
                source: f.templates.QueuesNoDataLinkLabelForAdmin
              }) : void 0,
              linkUrl: e.isAdmin(t) ? g.getTwilioTaskQueuesUrl(C) : void 0,
              image: s.createElement(c.Icon, {
                icon: "NoData",
                sizeMultiplier: 3
              })
            });
          }));
        }

        return s.createElement(c.DynamicComponent, {
          name: t.displayName,
          contentStore: t.Content,
          childProps: o,
          customChildren: r,
          vertical: !0
        }, s.createElement(p.Container, {
          vertical: !0
        }, s.createElement(y.QueueStatsConnectionStatusInfo, {
          key: "connection-info"
        }), s.createElement(l.AggregatedQueuesDataTiles, {
          key: "tiles"
        }), s.createElement(l.QueuesDataTable, {
          key: "table"
        })));
      }, n;
    }(s.PureComponent);

    t.QueuesStatsViewImpl = C;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(2),
        s = n(0);
    t.LoadingContainer = a.default("div")(o || (o = r(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 48px;\n    width: 100%;\n    ", "\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 48px;\n    width: 100%;\n    ", "\n"])), function (e) {
      return e.theme.QueuesStats.Container;
    }), t.Container = a.default(s.FlexBox)(i || (i = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.QueuesStats.Container;
    });
  }, function (e, t, n) {
    "use strict";

    var _r137,
        o = this && this.__extends || (_r137 = function r(e, t) {
      return (_r137 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r137(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(468),
        s = n(21),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.heading,
            n = e.body,
            r = e.image,
            o = e.linkUrl,
            c = e.linkText;
        return i.createElement(a.Wrapper, {
          className: s.cx("Twilio-NoDataPlaceholder-Wrapper")
        }, r && i.createElement(a.ImageContainer, {
          className: s.cx("Twilio-NoDataPlaceholder-ImageContainer")
        }, r), i.createElement(a.Heading, {
          className: s.cx("Twilio-NoDataPlaceholder-Heading")
        }, t), i.createElement(a.Body, {
          className: s.cx("Twilio-NoDataPlaceholder-Body")
        }, n), o && c && i.createElement(a.StyledLink, {
          href: o,
          roundCorners: !1,
          className: s.cx("Twilio-NoDataPlaceholder-Link"),
          target: "_blank"
        }, c) || "");
      }, t;
    }(i.PureComponent);

    t.NoDataPlaceholder = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l = n(2),
        u = n(0);
    t.Wrapper = l.default("div")(o || (o = r(["\n    max-width: 480px;\n    padding: 24px;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: flex-start;\n    padding-bottom: 72px;\n"], ["\n    max-width: 480px;\n    padding: 24px;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: flex-start;\n    padding-bottom: 72px;\n"]))), t.ImageContainer = l.default("div")(i || (i = r(["\n    margin-bottom: 24px;\n"], ["\n    margin-bottom: 24px;\n"]))), t.Heading = l.default("div")(a || (a = r(["\n    font-size: 14px;\n    margin-top: 0;\n    margin-bottom: 12px;\n    font-weight: normal;\n    line-height: 1;\n"], ["\n    font-size: 14px;\n    margin-top: 0;\n    margin-bottom: 12px;\n    font-weight: normal;\n    line-height: 1;\n"]))), t.Body = l.default("div")(s || (s = r(["\n    font-size: 32px;\n    line-height: 1.25;\n"], ["\n    font-size: 32px;\n    line-height: 1.25;\n"]))), t.StyledLink = l.default(u.Link)(c || (c = r(["\n    .Twilio &:link,\n    .Twilio &:visited {\n        background: ", ";\n        color: white;\n        margin-top: 32px;\n        text-transform: uppercase;\n        margin-left: 0;\n        margin-right: auto;\n    }\n"], ["\n    .Twilio &:link,\n    .Twilio &:visited {\n        background: ", ";\n        color: white;\n        margin-top: 32px;\n        text-transform: uppercase;\n        margin-left: 0;\n        margin-right: auto;\n    }\n"])), function (e) {
      return e.theme.colors.defaultButtonColor;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(470),
        o = n(203);
    t.FullscreenableQueuesStatsView = r.makeFullscreenable(o.QueuesStatsViewComponent);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(471);
    t.makeFullscreenable = r.makeFullscreenable, t.isFullscreen = r.isFullscreen;
    var o = n(474);
    t.FullscreenConfig = o.FullscreenConfig;
  }, function (e, t, n) {
    "use strict";

    var _r138,
        o = this && this.__extends || (_r138 = function r(e, t) {
      return (_r138 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r138(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(139),
        c = n(472),
        l = {
      enabled: !1,
      renderButton: null,
      wrapperStyles: {}
    };
    t.makeFullscreenable = function (e) {
      var t;
      return s(((t = function (t) {
        function n() {
          return null !== t && t.apply(this, arguments) || this;
        }

        return o(n, t), n.prototype.render = function () {
          var t = i(i({}, l), n.fullscreen);
          return document.fullscreenEnabled && t.enabled ? a.createElement(c.FullscreenableImpl, {
            renderButton: t.renderButton,
            wrapperStyles: t.wrapperStyles
          }, a.createElement(e, i({}, this.props))) : a.createElement(e, i({}, this.props));
        }, n;
      }(a.PureComponent)).displayName = "Fullscreenable(" + e.displayName + ")", t.fullscreen = i({}, l), t), e);
    }, t.isFullscreen = function () {
      return !!document.fullscreenElement;
    };
  }, function (e, t, n) {
    "use strict";

    var _r139,
        o = this && this.__extends || (_r139 = function r(e, t) {
      return (_r139 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r139(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(473),
        s = n(0),
        c = function c(e) {
      return i.createElement(a.FullscreenButtonWrapper, {
        onClick: e.toggleFullscreen
      }, e.isFullscreen ? i.createElement(s.Icon, {
        icon: "Minimize"
      }) : i.createElement(s.Icon, {
        icon: "Fullscreen"
      }));
    },
        l = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.wrapper = i.createRef(), t.state = {
          isFullscreen: t.isFullscreen()
        }, t.handleButtonClick = function () {
          t.wrapper.current && (t.isFullscreen() ? document.exitFullscreen() : t.wrapper.current.requestFullscreen());
        }, t.fullscreenChangeHandler = function () {
          t.isFullscreen() ? t.setState({
            isFullscreen: !0
          }) : t.setState({
            isFullscreen: !1
          });
        }, t.fullscreenErrorHandler = function () {
          t.setState({
            isFullscreen: !1
          });
        }, t;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        this.wrapper.current && (this.wrapper.current.addEventListener("fullscreenchange", this.fullscreenChangeHandler), this.wrapper.current.addEventListener("fullscreenerror", this.fullscreenErrorHandler));
      }, t.prototype.componentWillUnmount = function () {
        this.wrapper.current && (this.wrapper.current.removeEventListener("fullscreenchange", this.fullscreenChangeHandler), this.wrapper.current.removeEventListener("fullscreenerror", this.fullscreenErrorHandler));
      }, t.prototype.isFullscreen = function () {
        return !!this.wrapper.current && document.fullscreenElement === this.wrapper.current;
      }, t.prototype.renderButton = function () {
        return (this.props.renderButton || c)({
          isFullscreen: this.state.isFullscreen,
          toggleFullscreen: this.handleButtonClick
        });
      }, t.prototype.render = function () {
        return i.createElement(a.FullscreenableWrapper, {
          style: this.props.wrapperStyles,
          innerRef: this.wrapper
        }, this.props.children, this.renderButton());
      }, t;
    }(i.PureComponent);

    t.FullscreenableImpl = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(0);
    t.FullscreenableWrapper = a.styled("div")(o || (o = r(["\n    display: flex;\n    width: 100%;\n    position: relative;\n    background-color: ", ";\n"], ["\n    display: flex;\n    width: 100%;\n    position: relative;\n    background-color: ", ";\n"])), function (e) {
      return e.theme.palette && e.theme.palette.background ? e.theme.palette.background.default : "#FFF";
    }), t.FullscreenButtonWrapper = a.styled("div")(i || (i = r(["\n    position: absolute;\n    bottom: 0em;\n    right: 0em;\n    width: 2em;\n    height: 2em;\n    z-index: 1;\n    color: ", ";\n"], ["\n    position: absolute;\n    bottom: 0em;\n    right: 0em;\n    width: 2em;\n    height: 2em;\n    z-index: 1;\n    color: ", ";\n"])), function (e) {
      return e.theme.palette && e.theme.palette.text ? e.theme.palette.text.primary : "#000";
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(476);
    t.RuntimeLoginView = r.RuntimeLoginView, t.RuntimeLoginProps = r.RuntimeLoginProps, t.RuntimeLookupResponse = r.RuntimeLookupResponse;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(1),
        i = n(53),
        a = n(5),
        s = n(477);

    t.RuntimeLoginView = function (e) {
      return a.log.warn("Warning! RuntimeLoginView component has been deprecated, please use 'LoginFormView' component instead!"), o.createElement(i.StorelessThemeProvider, {
        themeConf: {
          baseName: "FlexDark"
        }
      }, o.createElement(s.RuntimeLoginViewImpl, r({}, e)));
    };
  }, function (e, t, n) {
    "use strict";

    var _r140,
        o = this && this.__extends || (_r140 = function r(e, t) {
      return (_r140 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r140(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    },
        a = this && this.__metadata || function (e, t) {
      if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(1),
        c = n(0),
        l = n(65),
        u = n(2),
        p = n(28),
        d = n(43),
        f = n(478),
        h = n(8),
        m = d.languages.default;

    var g = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.getErrorMessage = function () {
          return n.state.error ? n.state.error.key === p.ValidationErrorKeys.sso ? m.RuntimeLoginErrorSso : m.RuntimeLoginErrorDomain : "";
        }, n.state = {
          domain: "",
          error: null
        }, n.setDomain = n.setDomain.bind(n), n.fetchSid = n.fetchSid.bind(n), n.getErrorMessage = n.getErrorMessage.bind(n), n;
      }

      return o(t, e), t.prototype.setDomain = function (e) {
        var t = e.target;
        this.setState(function (e) {
          return {
            domain: t.value,
            error: null
          };
        });
      }, t.prototype.validate = function (e) {
        if (!e.sso) throw new p.ValidationError(p.ValidationErrorKeys.sso);
        if (!e.accountSid) throw new p.ValidationError(p.ValidationErrorKeys.accountSid);
        return e;
      }, t.prototype.fetchSid = function (e) {
        var t = this;
        e.preventDefault();
        var n = this.state.domain.endsWith("/") ? this.state.domain.replace(/\/$/, "") : this.state.domain,
            r = this.props.onSuccess,
            o = this.props.mapDomainToLookup(n),
            i = "https://" + n + "/";
        fetch(o).then(function (e) {
          return e.json();
        }).then(function (e) {
          return t.validate(e);
        }).then(function (e) {
          return r(e, i);
        }).catch(function (e) {
          t.setState(function () {
            return {
              error: e
            };
          });
        });
      }, t.prototype.render = function () {
        return s.createElement(f.Container, null, s.createElement(f.Logo, null), s.createElement(f.Form, {
          onSubmit: this.fetchSid
        }, s.createElement(f.Label, null, m.RuntimeLoginLabel), s.createElement(l.default, {
          onChange: this.setDomain,
          autoFocus: !0,
          error: !!this.state.error,
          name: "runtime",
          type: "text",
          placeholder: m.RuntimeLoginPlaceholder,
          fullWidth: !0
        }), s.createElement(f.ErrorMessage, null, s.createElement(c.Template, {
          source: this.getErrorMessage
        })), s.createElement(f.Controls, null, s.createElement(f.LoginButton, {
          className: "error",
          roundCorners: !1,
          disabled: !this.state.domain,
          onClick: this.fetchSid,
          themeOverride: this.props.theme.RuntimeLoginView.LoginButton
        }, m.RuntimeLoginLaunch), s.createElement(f.AdminLogin, null, m.RuntimeLoginIsAdmin, s.createElement(f.LoginLink, {
          href: this.props.adminLoginUrl
        }, m.RuntimeLoginWithTwilio)))));
      }, t.defaultProps = {
        mapDomainToLookup: function mapDomainToLookup(e) {
          return h.deprecatedFlexLookupServiceUrl + "/" + e;
        },
        adminLoginUrl: h.twilioServiceLoginUrl + "?localPort=" + (window.location.protocol.indexOf("https") > -1 && !window.location.port ? 443 : window.location.port)
      }, t = i([u.withTheme, a("design:paramtypes", [Object])], t);
    }(s.PureComponent);

    t.RuntimeLoginViewImpl = g;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s,
        c,
        l,
        u,
        p,
        d,
        f = n(0),
        h = n(2),
        m = n(189);
    t.Container = h.default("div")(o || (o = r(["\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1 0 auto;\n    justify-content: center;\n    ", "\n"], ["\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1 0 auto;\n    justify-content: center;\n    ", "\n"])), function (e) {
      return e.theme.RuntimeLoginView.Container;
    }), t.Form = h.default("form")(i || (i = r(["\n    width: 342px;\n"], ["\n    width: 342px;\n"]))), t.Label = h.default("div")(a || (a = r(["\n    font-size: 10px;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    font-weight: lighter;\n    margin-bottom: 8px;\n"], ["\n    font-size: 10px;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    font-weight: lighter;\n    margin-bottom: 8px;\n"]))), t.Controls = h.default("div")(s || (s = r(["\n    margin-top: 22px;\n"], ["\n    margin-top: 22px;\n"]))), t.Logo = h.default(m.LoginLogo)(c || (c = r(["\n    margin-bottom: 53px;\n"], ["\n    margin-bottom: 53px;\n"]))), t.AdminLogin = h.default("div")(l || (l = r(["\n    display: inline-block;\n    margin-left: 16px;\n    font-size: 10px;\n    font-weight: lighter;\n"], ["\n    display: inline-block;\n    margin-left: 16px;\n    font-size: 10px;\n    font-weight: lighter;\n"]))), t.LoginLink = h.default("a")(u || (u = r(["\n    color: #fff;\n    font-weight: bold;\n    margin-left: 4px;\n"], ["\n    color: #fff;\n    font-weight: bold;\n    margin-left: 4px;\n"]))), t.ErrorMessage = h.default("div")(p || (p = r(["\n    font-size: 12px;\n    font-weight: lighter;\n    min-height: 17px;\n    margin-top: 9px;\n\n    b {\n        font-weight: bold;\n    }\n"], ["\n    font-size: 12px;\n    font-weight: lighter;\n    min-height: 17px;\n    margin-top: 9px;\n\n    b {\n        font-weight: bold;\n    }\n"]))), t.LoginButton = h.default(f.Button)(d || (d = r(["\n    text-transform: uppercase;\n"], ["\n    text-transform: uppercase;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(480));
  }, function (e, t, n) {
    "use strict";

    var _r141,
        o = this && this.__extends || (_r141 = function r(e, t) {
      return (_r141 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r141(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(481),
        s = n(482),
        c = n(485),
        l = n(488),
        u = n(491),
        p = n(0),
        d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return i.createElement(p.DynamicComponent, {
          name: t.displayName,
          contentStore: t.Content,
          customChildren: this.props.children,
          childProps: this.props,
          noContainers: !0
        }, i.createElement(a.Grid, {
          className: "Twilio-AggregatedQueuesDataTiles-Grid",
          key: "aggregated-data-view"
        }, i.createElement(s.ActiveTasksTile, {
          key: "ActiveTasksTile"
        }), i.createElement(c.WaitingTasksTile, {
          key: "WaitingTasksTile"
        }), i.createElement(u.LongestWaitTimeTile, {
          key: "LongestWaitTimeTile"
        }), i.createElement(l.AgentsByActivityChartTile, {
          key: "AgentsByActivityChartTile"
        })));
      }, t.displayName = "AggregatedQueuesDataTiles", t.Content = new p.DynamicContentStore(t.displayName), t;
    }(i.PureComponent);

    t.AggregatedQueuesDataTiles = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(35);
    t.Grid = i.default("div")(o || (o = r(["\n    display: flex;\n    padding-left: 56px;\n    padding-right: 56px;\n    width: 100%;\n    max-width: 1600px;\n    margin-top: 56px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 0;\n    height: auto;\n    box-sizing: border-box;\n    flex: 0 0 auto;\n\n    > * {\n        flex: 1 1 25%;\n    }\n\n    > * + * {\n        margin-left: 8px;\n    }\n\n    ", "\n"], ["\n    display: flex;\n    padding-left: 56px;\n    padding-right: 56px;\n    width: 100%;\n    max-width: 1600px;\n    margin-top: 56px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 0;\n    height: auto;\n    box-sizing: border-box;\n    flex: 0 0 auto;\n\n    > * {\n        flex: 1 1 25%;\n    }\n\n    > * + * {\n        margin-left: 8px;\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.QueueStats.TilesGrid;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(483));
  }, function (e, t, n) {
    "use strict";

    var _r142,
        o = this && this.__extends || (_r142 = function r(e, t) {
      return (_r142 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r142(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(484),
        c = n(3),
        l = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return a.createElement(s.ActiveTasksTileImpl, {
          activeTasks: this.props.activeTasks.toString()
        });
      }, t = i([c.connect(function (e) {
        return {
          activeTasks: e.queues.aggregatedData.activeTasks
        };
      })], t);
    }(a.PureComponent);

    t.ActiveTasksTile = l;
  }, function (e, t, n) {
    "use strict";

    var _r143,
        o = this && this.__extends || (_r143 = function r(e, t) {
      return (_r143 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r143(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(4),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return i.createElement(a.AggregatedDataTile, {
          title: i.createElement(s.Template, {
            source: s.templates.ActiveTasksTileTitle
          }),
          content: this.props.activeTasks
        });
      }, t;
    }(i.PureComponent);

    t.ActiveTasksTileImpl = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(486));
  }, function (e, t, n) {
    "use strict";

    var _r144,
        o = this && this.__extends || (_r144 = function r(e, t) {
      return (_r144 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r144(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(487),
        c = n(3),
        l = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return a.createElement(s.WaitingTasksTileImpl, {
          waitingTasks: this.props.waitingTasks.toString()
        });
      }, t = i([c.connect(function (e) {
        return {
          waitingTasks: e.queues.aggregatedData.waitingTasks
        };
      })], t);
    }(a.PureComponent);

    t.WaitingTasksTile = l;
  }, function (e, t, n) {
    "use strict";

    var _r145,
        o = this && this.__extends || (_r145 = function r(e, t) {
      return (_r145 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r145(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(4),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return i.createElement(a.AggregatedDataTile, {
          title: i.createElement(s.Template, {
            source: s.templates.WaitingTasksTileTitle
          }),
          content: this.props.waitingTasks
        });
      }, t;
    }(i.PureComponent);

    t.WaitingTasksTileImpl = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(489));
  }, function (e, t, n) {
    "use strict";

    var _r146,
        o = this && this.__extends || (_r146 = function r(e, t) {
      return (_r146 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r146(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(490),
        l = n(3),
        u = n(4),
        p = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.availableAgents,
            n = e.unavailableAgents,
            r = e.offlineAgents;
        return s.createElement(c.AgentsByActivityChartTileImpl, {
          availableAgents: {
            value: t,
            label: u.templates.AgentStatusAvailable()
          },
          unavailableAgents: {
            value: n,
            label: u.templates.AgentStatusUnavailable()
          },
          offlineAgents: {
            value: r,
            label: u.templates.AgentStatusOffline()
          }
        });
      }, t = a([l.connect(function (e) {
        return i({}, e.queues.aggregatedData.agentByActivity);
      })], t);
    }(s.PureComponent);

    t.AgentsByActivityChartTile = p;
  }, function (e, t, n) {
    "use strict";

    var _r147,
        o = this && this.__extends || (_r147 = function r(e, t) {
      return (_r147 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r147(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(4),
        u = n(2),
        p = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.availableAgents,
            n = e.unavailableAgents,
            r = e.offlineAgents,
            o = e.theme.colors,
            a = [i(i({}, t), {
          color: o.agentAvailableColor
        }), i(i({}, n), {
          color: o.agentUnavailableColor
        }), i(i({}, r), {
          color: o.agentOfflineColor
        })];
        return s.createElement(c.AggregatedDataTile, {
          title: s.createElement(l.Template, {
            source: l.templates.AgentsByActivityTileTitle
          })
        }, s.createElement(c.StackedBarChart, {
          items: a
        }), s.createElement(c.Legend, {
          items: a,
          showLabels: !0
        }));
      }, t = a([u.withTheme], t);
    }(s.PureComponent);

    t.AgentsByActivityChartTileImpl = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(492));
  }, function (e, t, n) {
    "use strict";

    var _r148,
        o = this && this.__extends || (_r148 = function r(e, t) {
      return (_r148 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r148(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(493),
        c = n(3),
        l = n(0),
        u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.waitTime,
            n = e.queueName,
            r = t > 0 ? n : "";
        return a.createElement(s.LongestWaitTimeTileImpl, {
          waitTime: l.Utils.formatTimeDuration(1e3 * t, "short"),
          queueName: r
        });
      }, t.defaultProps = {
        waitTime: 0
      }, t = i([c.connect(function (e) {
        var t = e.queues.aggregatedData.longestWaitQueue;
        return {
          waitTime: t.time,
          queueName: t.friendlyName
        };
      })], t);
    }(a.PureComponent);

    t.LongestWaitTimeTile = u;
  }, function (e, t, n) {
    "use strict";

    var _r149,
        o = this && this.__extends || (_r149 = function r(e, t) {
      return (_r149 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r149(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(4),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return i.createElement(a.AggregatedDataTile, {
          title: i.createElement(s.Template, {
            source: s.templates.LongestWaitTimeTileTitle
          }),
          content: this.props.waitTime,
          description: this.props.queueName
        });
      }, t;
    }(i.PureComponent);

    t.LongestWaitTimeTileImpl = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(495);
    t.QueuesDataTableProps = r.QueuesDataTableProps, t.QueuesDataTable = r.QueuesDataTable;
  }, function (e, t, n) {
    "use strict";

    var _r150,
        o = this && this.__extends || (_r150 = function r(e, t) {
      return (_r150 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r150(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(3),
        l = n(496),
        u = function u(e) {
      var t = e.queues.queuesList;
      return {
        queuesList: Object.keys(t).map(function (e) {
          return t[e];
        })
      };
    },
        p = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(l.QueuesDataTableImpl, i({}, this.props));
      }, t.displayName = l.displayName, t.Content = l.Content, t = a([c.connect(u)], t);
    }(s.PureComponent);

    t.QueuesDataTable = p;
  }, function (e, t, n) {
    "use strict";

    var _r151,
        o = this && this.__extends || (_r151 = function r(e, t) {
      return (_r151 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r151(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(2),
        c = n(0),
        l = n(497),
        u = n(81),
        p = n(4);
    t.displayName = "QueuesDataTable", t.Content = new c.DynamicContentStore(t.displayName);

    var d = c.DataTable,
        f = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.getTaskQueueSid = function (e) {
          return e.task_queue_sid;
        }, t.renderFriendlyName = function (e) {
          return a.createElement(l.FirstCellContent, null, e.friendly_name);
        }, t.renderActiveTasks = function (e) {
          var t = e.tasks_by_status,
              n = t.assigned,
              r = t.wrapping;
          return a.createElement("span", null, n + r);
        }, t.renderWaitingTasks = function (e) {
          var t = e.tasks_by_status,
              n = t.pending,
              r = t.reserved;
          return a.createElement("span", null, n + r);
        }, t.renderLongestWaitingTime = function (e) {
          return a.createElement("span", null, c.Utils.formatTimeDuration(1e3 * e.longest_task_waiting_age, "short"));
        }, t.mappedColors = {
          availableAgents: t.props.theme.colors.agentAvailableColor,
          unavailableAgents: t.props.theme.colors.agentUnavailableColor,
          offlineAgents: t.props.theme.colors.agentOfflineColor
        }, t.renderAgents = function (e) {
          var n = u.AggregatedDataHelpers.getQueueAgentsByActivity({}, e),
              r = [{
            label: p.templates.AgentStatusAvailable(),
            value: n.availableAgents,
            color: t.mappedColors.availableAgents
          }, {
            label: p.templates.AgentStatusUnavailable(),
            value: n.unavailableAgents,
            color: t.mappedColors.unavailableAgents
          }, {
            label: p.templates.AgentStatusOffline(),
            value: n.offlineAgents,
            color: t.mappedColors.offlineAgents
          }];
          return a.createElement(c.Legend, {
            items: r,
            showLabels: !1
          });
        }, t;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.props.queuesList;
        return a.createElement(l.TableContainer, {
          className: "Twilio-QueuesDataTable"
        }, a.createElement(c.DynamicComponent, {
          childProps: this.props,
          contentStore: t.Content,
          name: t.displayName,
          customChildren: this.props.children,
          noContainers: !0
        }, a.createElement(d, {
          items: e,
          itemKey: this.getTaskQueueSid,
          columnDataCreationContext: {},
          hasHoverStyle: !1
        }, a.createElement(c.ColumnDefinition, {
          key: "friendlyName",
          header: "Queues",
          content: this.renderFriendlyName
        }), a.createElement(c.ColumnDefinition, {
          key: "active-tasks",
          header: "Active tasks",
          content: this.renderActiveTasks
        }), a.createElement(c.ColumnDefinition, {
          key: "waiting-tasks",
          header: "Waiting tasks",
          content: this.renderWaitingTasks
        }), a.createElement(c.ColumnDefinition, {
          key: "longest-wait-time",
          header: "Longest wait",
          content: this.renderLongestWaitingTime
        }), a.createElement(c.ColumnDefinition, {
          key: "agents",
          header: "Agents by activity",
          content: this.renderAgents
        }))));
      }, n = i([s.withTheme], n);
    }(a.PureComponent);

    t.QueuesDataTableImpl = f;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(35);
    t.FirstCellContent = a.default("span")(o || (o = r(["\n    padding-left: 6px;\n"], ["\n    padding-left: 6px;\n"]))), t.TableContainer = a.default("div")(i || (i = r(["\n    overflow-y: auto;\n    padding-left: 56px;\n    padding-right: 56px;\n    width: 100%;\n    max-width: 1600px;\n    margin: 48px auto 0;\n    box-sizing: border-box;\n\n    td {\n        font-size: 12px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    ", "\n"], ["\n    overflow-y: auto;\n    padding-left: 56px;\n    padding-right: 56px;\n    width: 100%;\n    max-width: 1600px;\n    margin: 48px auto 0;\n    box-sizing: border-box;\n\n    td {\n        font-size: 12px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.QueueStats.TableContainer;
    });
  }, function (e, t, n) {
    "use strict";

    var _r152,
        o = this && this.__extends || (_r152 = function r(e, t) {
      return (_r152 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r152(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(3),
        c = n(499),
        l = n(2),
        u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return a.createElement(p, i({}, this.props));
      }, t.friendlyName = c.displayName, t.displayName = c.displayName, t.Content = c.contentStore, t;
    }(a.PureComponent);

    t.RootContainer = u;
    var p = s.connect(function (e) {
      return {
        identity: e.session.identity,
        currentLoginState: e.session.loginState,
        config: e.config
      };
    })(l.withTheme(c.RootContainerImpl));
  }, function (e, t, n) {
    "use strict";

    var _r153,
        o = this && this.__extends || (_r153 = function r(e, t) {
      return (_r153 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r153(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        a = n(0),
        s = n(96),
        c = n(26),
        l = n(165),
        u = n(500),
        p = n(17),
        d = n(569);
    t.displayName = "RootContainer", t.contentStore = new a.DynamicContentStore(t.displayName);

    var f = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.componentDidMount = function () {
        p.Notifications.isNotificationHandlerEnabled(a.DefaultNotificationHandlerType.Browser) && window.Notification && "default" === window.Notification.permission && p.Notifications.showNotification(p.NotificationIds.RequestBrowserNotificationPermissions);
      }, n.prototype.render = function () {
        return this.props.identity ? i.createElement(a.DynamicComponent, {
          name: t.displayName,
          contentStore: t.contentStore,
          childProps: this.props,
          customChildren: this.props.children,
          vertical: !0
        }, i.createElement(d.Container, null, i.createElement(l.MainHeader, {
          key: "header"
        }), i.createElement(u.MainContainer, {
          key: "container"
        }))) : i.createElement(s.LoginFormView, {
          userConfig: this.props.config,
          userLoggedOut: this.props.currentLoginState === c.LoginState.LoggedOut
        });
      }, n;
    }(i.PureComponent);

    t.RootContainerImpl = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(207);
    t.MainContainer = r.MainContainer, t.MainContainerProps = r.MainContainerProps, t.MainContainerChildrenProps = r.MainContainerChildrenProps;
  }, function (e, t, n) {
    "use strict";

    var _r154,
        o = this && this.__extends || (_r154 = function r(e, t) {
      return (_r154 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r154(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(502),
        c = n(13),
        l = n(208),
        u = n(212),
        p = n(215),
        d = n(178),
        f = n(190),
        h = n(202),
        m = n(549),
        g = n(553),
        y = n(555),
        v = n(556),
        b = n(557),
        C = n(217),
        _ = n(19),
        k = n(42),
        w = n(23),
        T = n(45);

    function O() {
      return k.FeatureFlags.isEnabled(_.FeatureFlag.FlexQueuesStats) || c.Manager.getInstance().configuration.showRealtimeQueuesStats;
    }

    t.displayName = "MainContainer", t.contentStore = new a.DynamicContentStore(t.displayName);

    var P = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleWindowResize = function () {
          t.props.keepSideNavOpen || t.forceUpdate();
        }, t.showSupervisor = function (e) {
          var t = e.manager.user.roles;
          return t.indexOf("supervisor") >= 0 || t.indexOf("admin") >= 0;
        }, t;
      }

      return o(n, e), n.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.handleWindowResize);
      }, n.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.handleWindowResize);
      }, n.prototype.render = function () {
        var e = this,
            n = window.innerWidth > 640 || this.props.keepSideNavOpen;
        return i.createElement(s.Router, null, i.createElement(c.FlexContext.Consumer, null, function (r) {
          return i.createElement(a.DynamicComponent, {
            name: t.displayName,
            contentStore: t.contentStore,
            childProps: e.props,
            customChildren: e.props.children
          }, i.createElement(a.FlexBox, {
            className: "Twilio-MainContainer"
          }, i.createElement(l.SideNav, {
            key: "sidenav",
            reserveSpace: n
          }), e.props.showOutboundDialer && i.createElement(C.OutboundDialerPanel, {
            key: "outbound-dialer-panel"
          }), i.createElement(y.StyledFlexBox, {
            key: "content",
            className: "Twilio-MainContainer-Content",
            vertical: !0,
            overflow: "hidden"
          }, e.props.showLiveCommsBar && i.createElement(u.LiveCommsBar, null), i.createElement(a.FlexBox, {
            overflow: "hidden"
          }, e.props.showNotificationBar && i.createElement(a.NotificationBar, null), i.createElement(p.ViewCollection, null, i.createElement(a.ContentFragment, null, i.createElement(p.View, {
            key: "agent-desktop",
            name: "agent-desktop",
            route: {
              path: "/agent-desktop"
            },
            mountRule: p.ViewMountRule.Always
          }, i.createElement(d.AgentDesktopView, null)), e.showSupervisor(r) && i.createElement(p.View, {
            key: "teams",
            name: "teams",
            route: {
              path: "/teams"
            },
            keepMounted: !0,
            mountRule: p.ViewMountRule.WhenHasBeenActive
          }, i.createElement(f.TeamsView, null)), e.showSupervisor(r) && O() && i.createElement(p.View, {
            key: "queues-stats",
            name: "queues-stats",
            route: {
              path: "/queues-stats"
            },
            mountRule: p.ViewMountRule.WhenActive
          }, i.createElement(h.QueuesStatsView, null)), e.showSupervisor(r) && c.Manager.getInstance().configuration.showQueuesStatsView && !O() && i.createElement(p.View, {
            key: "queue-stats",
            name: "queue-stats",
            route: {
              path: "/queue-stats"
            },
            mountRule: p.ViewMountRule.WhenActive
          }, i.createElement(m.QueueStatsView, null)), T.InsightsService.hasPermission(w.DashboardsView.permissions) && i.createElement(p.View, {
            key: "dashboards",
            name: "dashboards",
            route: {
              path: "/dashboards"
            },
            mountRule: p.ViewMountRule.WhenHasBeenActive
          }, i.createElement(w.DashboardsView, null)), T.InsightsService.hasPermission(w.AnalyzeView.permissions) && i.createElement(p.View, {
            key: "analyze",
            name: "analyze",
            route: {
              path: "/analyze"
            },
            mountRule: p.ViewMountRule.WhenHasBeenActive
          }, i.createElement(w.AnalyzeView, null)), T.InsightsService.hasPermission(w.QuestionnairesView.permissions) && i.createElement(p.View, {
            key: "questionnaires",
            name: "questionnaires",
            route: {
              path: "/questionnaires"
            },
            mountRule: p.ViewMountRule.WhenHasBeenActive
          }, i.createElement(w.QuestionnairesView, null)), T.InsightsService.hasPermission(w.InspectionsView.permissions) && i.createElement(p.View, {
            key: "inspections",
            name: "inspections",
            route: {
              path: "/inspections"
            },
            mountRule: p.ViewMountRule.WhenHasBeenActive
          }, i.createElement(w.InspectionsView, null)), T.InsightsService.hasPermission(w.AgentsView.permissions) && i.createElement(p.View, {
            key: "agents",
            name: "agents",
            route: {
              path: "/agents"
            },
            mountRule: p.ViewMountRule.WhenHasBeenActive
          }, i.createElement(w.AgentsView, null)), T.InsightsService.hasPermission(w.SpeechSearchesView.permissions) && i.createElement(p.View, {
            key: "speech-searches",
            name: "speech-searches",
            route: {
              path: "/speech-searches"
            },
            mountRule: p.ViewMountRule.WhenHasBeenActive
          }, i.createElement(w.SpeechSearchesView, null)), i.createElement(p.View, {
            key: "logout",
            name: "logout"
          }, i.createElement(g.LogoutView, null)))))), i.createElement(v.FeatureFlagGuard, {
            id: _.FeatureFlag.InsightsPlayer,
            key: "player-module-feature-guard"
          }, i.createElement(b.Player, {
            key: "player-module"
          }))));
        }));
      }, n;
    }(i.PureComponent);

    t.MainContainerImpl = P;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(503);
    t.Router = r.Router;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(1),
        i = n(59),
        a = n(3),
        s = n(82),
        c = n(80);

    t.Router = function (e) {
      var t = {
        dispatch: function dispatch(e) {
          return a.FlexModule.dispatch(r(r({}, e), {
            type: c.FLEX_LOCATION_CHANGE
          }));
        }
      };
      return o.createElement(i.ConnectedRouter, {
        history: s.default(),
        store: t
      }, e.children);
    };
  }, function (e, t, n) {
    "use strict";

    var _r155,
        o = this && this.__extends || (_r155 = function r(e, t) {
      return (_r155 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r155(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(3),
        c = n(7),
        l = n(505),
        u = n(209),
        p = n(210),
        d = n(211),
        f = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return a.createElement(h, i({}, this.props));
      }, t.friendlyName = l.displayName, t.displayName = l.displayName, t.Content = l.contentStore, t.AgentDesktop = u.SideLinkAgentDesktop, t.Teams = p.SideLinkTeams, t.QueuesStats = d.SideLinkQueuesStats, t;
    }(a.PureComponent);

    t.SideNav = f;
    var h = s.connect(function (e) {
      return {
        incomingTasks: !!Array.from(e.worker.tasks.values()).find(function (e) {
          return c.TaskHelper.isPending(e);
        }),
        isOpen: e.view.isSideNavOpen,
        activeView: e.view.activeView
      };
    })(l.SideNavImpl);
  }, function (e, t, n) {
    "use strict";

    var _r156,
        o = this && this.__extends || (_r156 = function r(e, t) {
      return (_r156 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r156(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(0),
        c = n(13),
        l = n(21),
        u = n(506),
        p = n(6),
        d = n(209),
        f = n(210),
        h = n(211),
        m = n(42),
        g = n(19),
        y = n(514),
        v = n(524),
        b = n(526),
        C = n(528),
        _ = n(530),
        k = n(532),
        w = n(45),
        T = n(23);

    function O() {
      return m.FeatureFlags.isEnabled(g.FeatureFlag.FlexQueuesStats) || c.Manager.getInstance().configuration.showRealtimeQueuesStats;
    }

    t.displayName = "SideNav", t.contentStore = new s.DynamicContentStore(t.displayName);

    var P = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.doNavigate = function (e) {
          return function () {
            p.tryInvokeAction("NavigateToView", {
              viewName: e
            });
          };
        }, t.showSupervisor = function (e) {
          var t = e.manager.user.roles;
          return t.indexOf("supervisor") >= 0 || t.indexOf("admin") >= 0;
        }, t;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this,
            n = this.props,
            r = n.reserveSpace,
            o = n.activeView,
            p = n.isOpen;
        if (!r && !p) return null;
        var m = p;
        return a.createElement(c.FlexContext.Consumer, null, function (n) {
          return a.createElement(u.StyledSideNav, {
            wideLayout: r,
            className: l.cx("Twilio", "Twilio-SideNav-Container")
          }, a.createElement(u.StyledIconBar, {
            isOpen: m,
            wideLayout: r,
            className: l.cx("Twilio", "Twilio-" + t.displayName)
          }, a.createElement(s.DynamicComponent, {
            contentStore: t.contentStore,
            childProps: i(i({}, e.props), {
              showLabel: m
            }),
            name: t.displayName,
            customChildren: e.props.children,
            vertical: !0
          }, a.createElement(a.Fragment, null, a.createElement(s.ContentFragment, {
            align: "start"
          }, a.createElement(d.SideLinkAgentDesktop, {
            key: "agent-desktop",
            showLabel: m,
            activeView: o
          }), e.showSupervisor(n) && a.createElement(f.SideLinkTeams, {
            key: "teams",
            showLabel: m,
            activeView: o
          }), e.showSupervisor(n) && O() && a.createElement(h.SideLinkQueuesStats, {
            key: "queues-stats",
            showLabel: m,
            activeView: o,
            viewName: "queues-stats"
          }), e.showSupervisor(n) && c.Manager.getInstance().configuration.showQueuesStatsView && !O() && a.createElement(h.SideLinkQueuesStats, {
            key: "queue-stats",
            showLabel: m,
            activeView: o,
            viewName: "queue-stats"
          }), w.InsightsService.hasPermission(T.DashboardsView.permissions) && a.createElement(v.SideLinkInsightsDashboards, {
            key: "dashboards",
            showLabel: m,
            activeView: o
          }), w.InsightsService.hasPermission(T.AnalyzeView.permissions) && a.createElement(y.SideLinkInsightsAnalyze, {
            key: "analyze",
            showLabel: m,
            activeView: o
          }), w.InsightsService.hasPermission(T.QuestionnairesView.permissions) && a.createElement(b.SideLinkInsightsQuestionnaires, {
            key: "questionnaires",
            showLabel: m,
            activeView: o
          }), w.InsightsService.hasPermission(T.InspectionsView.permissions) && a.createElement(C.SideLinkInsightsInspections, {
            key: "inspections",
            showLabel: m,
            activeView: o
          }), w.InsightsService.hasPermission(T.AgentsView.permissions) && a.createElement(_.SideLinkInsightsAgents, {
            key: "agents",
            showLabel: m,
            activeView: o
          }), w.InsightsService.hasPermission(T.SpeechSearchesView.permissions) && a.createElement(k.SideLinkInsightsSpeechSearches, {
            key: "speech-searches",
            showLabel: m,
            activeView: o
          })), a.createElement(s.ContentFragment, {
            align: "end"
          })))));
        });
      }, n.displayName = t.displayName, n;
    }(a.PureComponent);

    t.SideNavImpl = P;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(2),
        s = n(0);
    t.StyledSideNav = a.default("div")(o || (o = r(["\n    display: flex;\n    position: relative;\n    outline: none;\n    flex: 0 0 ", ";\n"], ["\n    display: flex;\n    position: relative;\n    outline: none;\n    flex: 0 0 ", ";\n"])), function (e) {
      return e.wideLayout ? "44px" : "0px";
    }), t.StyledIconBar = a.default("div")(i || (i = r(["\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 100%;\n    z-index: 10;\n    left: 0;\n    bottom: 0;\n    top: 0;\n    position: absolute;\n    border-style: solid;\n    border-width: 0 1px 0 0;\n    width: ", ";\n    ", "\n    ", "\n    ", "\n    ", "\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 100%;\n    z-index: 10;\n    left: 0;\n    bottom: 0;\n    top: 0;\n    position: absolute;\n    border-style: solid;\n    border-width: 0 1px 0 0;\n    width: ", ";\n    ", "\n    ", "\n    ", "\n    ", "\n"])), function (e) {
      return e.isOpen ? "240px" : "44px";
    }, function (e) {
      return s.Animations.SlideInTransition(e.isOpen);
    }, function (e) {
      return e.isOpen && "box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.4);";
    }, function (e) {
      return !e.wideLayout && s.Animations.AppearAnimation(s.Animations.FADE_IN_DURATION);
    }, function (e) {
      return e.theme.SideNav.Container;
    });
  }, function (e, t, n) {
    "use strict";

    var _r157,
        o = this && this.__extends || (_r157 = function r(e, t) {
      return (_r157 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r157(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(0),
        c = n(4),
        l = n(55),
        u = n(6),
        p = n(69),
        d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.gotoAgentDesktop = function () {
          u.tryInvokeAction("NavigateToView", {
            viewName: "agent-desktop"
          });
        }, t;
      }

      var n;
      return o(t, e), n = t, t.prototype.render = function () {
        var e = this.props,
            t = e.activeView,
            n = e.showLabel,
            r = e.Badge;
        return a.createElement(l.SideLink, {
          icon: "Agent",
          iconActive: "AgentBold",
          isActive: "agent-desktop" === t,
          onClick: this.gotoAgentDesktop,
          showLabel: n,
          Badge: r
        }, a.createElement(s.Template, {
          source: c.templates.SideNavTaskView
        }));
      }, t.getBadgeChildren = function (e) {
        var t = new p.AppStateHelper(e);
        return t.isAgentView() ? 0 : t.getPendingTasks() + t.getUnconsumedMessagesCount();
      }, t.defaultProps = {
        Badge: {
          children: n.getBadgeChildren,
          variant: s.Badge.variants.dot
        }
      }, t = n = i([s.withDefaultPropsUpdate], t);
    }(a.PureComponent);

    t.SideLinkAgentDesktop = d;
  }, function (e, t, n) {
    "use strict";

    var _r158,
        o = this && this.__extends || (_r158 = function r(e, t) {
      return (_r158 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r158(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(509),
        c = n(3),
        l = n(9),
        u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return a.createElement(p, i({}, this.props));
      }, t.displayName = s.displayName, t;
    }(a.PureComponent);

    t.SideLink = u;
    var p = l.withTaskContext(c.connect(function (e, t) {
      var n = t.Badge && t.Badge.children;
      return i(i({}, t), {
        Badge: i(i({}, t.Badge), {
          children: "function" == typeof n ? n(e, t) : n
        })
      });
    })(s.SideLinkImpl));
  }, function (e, t, n) {
    "use strict";

    var _r159,
        o = this && this.__extends || (_r159 = function r(e, t) {
      return (_r159 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r159(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(0),
        c = n(510),
        l = n(93);
    t.displayName = "SideLink";

    var u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.shouldComponentUpdate = function (e) {
        return !l(this.props, e);
      }, t.prototype.render = function () {
        var e = this.props,
            t = e.isActive,
            n = e.onClick,
            r = e.icon,
            o = e.iconActive,
            l = e.showLabel,
            u = e.children,
            p = e.Badge,
            d = t && o ? o : r;
        return a.createElement(c.StyledSidelinkContainer, {
          className: t ? "Twilio-Side-Link--Active" : "Twilio-Side-Link",
          onClick: n,
          isActive: t
        }, a.createElement(c.StyledSideLinkIcon, {
          isActive: t,
          className: "Twilio-Side-Link-IconContainer"
        }, a.createElement(s.Icon, {
          icon: d
        }), p && a.createElement(s.Badge, i({}, p))), a.createElement(c.StyledSideLinkLabel, {
          show: l
        }, u));
      }, t;
    }(a.Component);

    t.SideLinkImpl = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s = n(2),
        c = n(0);
    t.StyledSideLinkLabel = s.default("div")(o || (o = r(["\n    flex: 1 1 auto;\n    text-align: left;\n    padding: 8px 16px 8px 8px;\n    opacity: 0;\n    white-space: nowrap;\n\n    ", "\n"], ["\n    flex: 1 1 auto;\n    text-align: left;\n    padding: 8px 16px 8px 8px;\n    opacity: 0;\n    white-space: nowrap;\n\n    ", "\n"])), function (e) {
      return c.Animations.FadeInOutTransition(e.show, c.Animations.SLIDE_IN_DURATION / 2, c.Animations.SLIDE_IN_DURATION / 2, c.Animations.SLIDE_IN_DURATION / 2);
    }), t.StyledSideLinkIcon = s.default("div")(i || (i = r(["\n    flex: 0 0 44px;\n    justify-content: center;\n    overflow: hidden;\n    position: relative;\n    background: inherit;\n    padding: 8px 0;\n    ", ";\n"], ["\n    flex: 0 0 44px;\n    justify-content: center;\n    overflow: hidden;\n    position: relative;\n    background: inherit;\n    padding: 8px 0;\n    ", ";\n"])), function (e) {
      return e.theme.SideNav.Icon;
    }), t.StyledSidelinkContainer = s.default("button")(a || (a = r(["\n    display: flex;\n    font-size: 12px;\n    font-weight: bold;\n    height: 44px;\n    outline: none;\n    align-items: center;\n    padding: 0 0 0 0;\n    border-style: none;\n    position: relative;\n    ", ";\n    ", "\n    &:hover {\n        // Hack to change outer circle color on hover\n        & .Twilio-Side-Link-IconContainer,\n        & .Twilio-Badge-OuterCircle {\n            ", "\n        }\n    }\n"], ["\n    display: flex;\n    font-size: 12px;\n    font-weight: bold;\n    height: 44px;\n    outline: none;\n    align-items: center;\n    padding: 0 0 0 0;\n    border-style: none;\n    position: relative;\n    ", ";\n    ", "\n    &:hover {\n        // Hack to change outer circle color on hover\n        & .Twilio-Side-Link-IconContainer,\n        & .Twilio-Badge-OuterCircle {\n            ", "\n        }\n    }\n"])), function (e) {
      return e.theme.SideNav.Icon;
    }, function (e) {
      return c.getBackgroundWithHoverCSS(e.theme.SideNav.Button.background, e.theme.SideNav.Button.lightHover);
    }, function (e) {
      return c.getBackgroundWithHoverCSS(e.theme.SideNav.Button.background, e.theme.SideNav.Button.lightHover, !0);
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r160,
        o = this && this.__extends || (_r160 = function r(e, t) {
      return (_r160 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r160(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(0),
        c = n(4),
        l = n(55),
        u = n(6),
        p = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.gotoTeams = function () {
          u.tryInvokeAction("NavigateToView", {
            viewName: "teams"
          });
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.activeView,
            n = e.showLabel,
            r = e.Badge;
        return a.createElement(l.SideLink, {
          icon: "Agents",
          iconActive: "AgentsBold",
          isActive: "teams" === t,
          onClick: this.gotoTeams,
          showLabel: n,
          Badge: r
        }, a.createElement(s.Template, {
          source: c.templates.SideNavTeamsView
        }));
      }, t.defaultProps = {}, t = i([s.withDefaultPropsUpdate], t);
    }(a.PureComponent);

    t.SideLinkTeams = p;
  }, function (e, t, n) {
    "use strict";

    var _r161,
        o = this && this.__extends || (_r161 = function r(e, t) {
      return (_r161 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r161(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(0),
        c = n(4),
        l = n(55),
        u = n(6),
        p = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.gotoView = function () {
          u.tryInvokeAction("NavigateToView", {
            viewName: t.props.viewName
          });
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.activeView,
            n = e.showLabel,
            r = e.Badge,
            o = e.viewName;
        return a.createElement(l.SideLink, {
          icon: "Queues",
          iconActive: "QueuesBold",
          isActive: t === o,
          onClick: this.gotoView,
          showLabel: n,
          Badge: r
        }, a.createElement(s.Template, {
          source: c.templates.SideNavQueuesStatsView
        }));
      }, t.defaultProps = {}, t = i([s.withDefaultPropsUpdate], t);
    }(a.PureComponent);

    t.SideLinkQueuesStats = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(515);
    t.SideLinkInsightsAnalyze = r.SideLinkInsightsAnalyze;
  }, function (e, t, n) {
    "use strict";

    var _r162,
        o = this && this.__extends || (_r162 = function r(e, t) {
      return (_r162 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r162(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(4),
        u = n(37),
        p = n(23),
        d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(u.SideLinkView, i({}, this.props, {
          viewName: p.AnalyzeView.viewName,
          icon: p.AnalyzeView.icon,
          iconActive: p.AnalyzeView.iconActive,
          template: l.templates.SideNavInsightsAnalyzeView
        }));
      }, t.defaultProps = {}, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.SideLinkInsightsAnalyze = d;
  }, function (e, t, n) {
    "use strict";

    var _r163,
        o = this && this.__extends || (_r163 = function r(e, t) {
      return (_r163 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r163(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        a = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(38),
        l = n(8),
        u = n(13),
        p = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.getUrl = function (e) {
          return i(t, void 0, void 0, function () {
            var t;
            return a(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, e.getServiceSsoUrl("app", l.getFlexInsightsBaseUrl(u.Manager.getInstance().configuration) + "/realtime/", {
                    account_id: e.user && e.user.account_id
                  })];

                case 1:
                  return [2, "string" == typeof (t = n.sent()) ? t : ""];
              }
            });
          });
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(c.default, {
          getUrl: this.getUrl,
          isActive: this.props.isViewActive,
          name: "realtime"
        });
      }, t.icon = "AgentsView", t.iconActive = "AgentsViewBold", t.viewName = "agents", t.permissions = "coaching.view", t;
    }(s.Component);

    t.AgentsView = p;
  }, function (e, t, n) {
    "use strict";

    var _r164,
        o = this && this.__extends || (_r164 = function r(e, t) {
      return (_r164 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r164(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(0),
        c = n(24),
        l = n(13),
        u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          isLoaded: !1
        }, t.iframeRef = a.createRef(), t.onIframeLoad = function () {
          t.setState({
            isLoaded: !0
          }), t.setFlexToken(), t.sendActiveStateToIframe();
        }, t.sendAppEvent = function (e) {
          var n = i({
            app: t.props.name
          }, e);
          t.iframeRef && t.iframeRef.current && t.iframeRef.current.contentWindow && t.iframeRef.current.contentWindow.postMessage(n, "*");
        }, t.setFlexToken = function () {
          t.sendAppEvent({
            type: "setFlexToken",
            value: {
              token: l.Manager.getInstance().user.token,
              expiration: l.Manager.getInstance().user.tokenExpirationDate
            }
          });
        }, t.sendActiveStateToIframe = function () {
          t.sendAppEvent({
            type: "setIsFlexTabActive",
            value: t.props.isActive
          });
        }, t.messageListener = function (e) {
          t.props.onMessage && t.iframeRef.current && e.source === t.iframeRef.current.contentWindow && t.props.onMessage(e);
        }, t;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        window.addEventListener("message", this.messageListener), l.Manager.getInstance().events.addListener(c.FlexEvent.tokenUpdated, this.setFlexToken);
      }, t.prototype.componentWillUnmount = function () {
        window.removeEventListener("message", this.messageListener), l.Manager.getInstance().events.removeListener(c.FlexEvent.tokenUpdated, this.setFlexToken);
      }, t.prototype.componentDidUpdate = function (e) {
        e.isActive !== this.props.isActive && this.sendActiveStateToIframe();
      }, Object.defineProperty(t.prototype, "appEmbedUrl", {
        get: function get() {
          var e;

          try {
            return (e = new URL(this.props.src)).searchParams.append("flex", "true"), e.href;
          } catch (e) {
            return this.props.src;
          }
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.render = function () {
        return a.createElement(a.Fragment, null, a.createElement("iframe", {
          frameBorder: "0",
          title: "insights-view-" + this.props.name,
          id: "insights-view-" + this.props.name,
          scrolling: "yes",
          src: this.appEmbedUrl,
          style: {
            width: "100%",
            display: this.state.isLoaded ? "block" : "none"
          },
          onLoad: this.onIframeLoad,
          ref: this.iframeRef
        }), !this.state.isLoaded && a.createElement(s.CircularProgress, {
          borderWidth: 3
        }));
      }, t;
    }(a.Component);

    t.YticaApp = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(1),
        o = n(0),
        i = n(6),
        a = function a(e) {
      return "" + e[0].toUpperCase() + e.slice(1) + " view";
    },
        s = function s(e) {
      return "There's an issue with accessing " + (e ? a(e) : "Insights") + " in Flex, sorry about this. Please refresh your screen and try again.\n    If you continue to see this message, contact your support team.\n    ";
    };

    t.NotAvailable = function (e) {
      var t = e.name;
      return r.createElement(o.ErrorMessage, {
        title: t ? a(t) + " is unavailable" : "Insights unavailable",
        description: s(t),
        primaryAction: function primaryAction() {
          return i.tryInvokeAction("ReloadWindow");
        },
        primaryActionTitle: "Refresh",
        hideBranding: !0
      });
    };
  }, function (e, t, n) {
    "use strict";

    var _r165,
        o = this && this.__extends || (_r165 = function r(e, t) {
      return (_r165 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r165(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        a = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(38),
        l = n(8),
        u = n(13),
        p = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.getUrl = function (e) {
          return i(t, void 0, void 0, function () {
            var t;
            return a(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, e.getServiceSsoUrl("app", l.getFlexInsightsBaseUrl(u.Manager.getInstance().configuration) + "/dashboards/analyze", {
                    account_id: e.user && e.user.account_id
                  })];

                case 1:
                  return [2, "string" == typeof (t = n.sent()) ? t : ""];
              }
            });
          });
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(c.default, {
          getUrl: this.getUrl,
          isActive: this.props.isViewActive,
          name: "analyze"
        });
      }, t.icon = "Analyze", t.iconActive = "AnalyzeBold", t.viewName = "analyze", t.permissions = "dashboards.analyze", t;
    }(s.Component);

    t.AnalyzeView = p;
  }, function (e, t, n) {
    "use strict";

    var _r166,
        o = this && this.__extends || (_r166 = function r(e, t) {
      return (_r166 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r166(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        a = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(38),
        l = n(8),
        u = n(13),
        p = n(5),
        d = n(0),
        f = n(42),
        h = n(19),
        m = n(61),
        g = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.ref = s.createRef(), t.getUrl = function (e) {
          return i(t, void 0, void 0, function () {
            var t, n;
            return a(this, function (r) {
              switch (r.label) {
                case 0:
                  return [4, e.getServiceSsoUrl("app", l.getFlexInsightsBaseUrl(u.Manager.getInstance().configuration) + "/dashboards/id/908818325360", {
                    account_id: e.user && e.user.account_id
                  })];

                case 1:
                  return t = r.sent(), n = e.user && e.user.workspace_id, [2, "string" == typeof t ? t + "&workspace_id=" + n + "&link_prevent_default=true" : ""];
              }
            });
          });
        }, t.handleUiLink = function (e, n) {
          try {
            new URL(e.url);
            d.Actions.invokeAction("HistoricalReporting:view", e.url);
          } catch (e) {
            p.log.info("Cannot parse URL. Falling back to original handler.", e.message), t.delegateEventToOriginal(n);
          }
        }, t.handleIncomingMessage = function (e) {
          var n = e.data,
              r = n.name,
              o = n.data,
              i = n.id;

          switch (r) {
            case "com.twilio.wfo.link":
              t.handleUiLink(o, i);
          }
        }, t;
      }

      return o(t, e), t.prototype.delegateEventToOriginal = function (e) {
        this.ref.current && this.ref.current.iframeRef && this.ref.current.iframeRef.contentWindow && this.ref.current.iframeRef.contentWindow.postMessage({
          type: "Insights:handleEvent",
          eventId: e
        }, "*");
      }, t.prototype.componentDidMount = function () {
        var e = this;
        d.Actions.registerAction("HistoricalReporting:view", function (t) {
          return i(e, void 0, void 0, function () {
            var e, n, r, o;
            return a(this, function (i) {
              switch (i.label) {
                case 0:
                  return e = new URL(t), n = e.pathname.match(/player\/segment\/([0-9a-zA-Z-]+)/), r = f.FeatureFlags.isEnabled(h.FeatureFlag.InsightsPlayer), null !== n && 2 === n.length && r ? [3, 1] : (window.open(t, "_blank"), [3, 3]);

                case 1:
                  return o = n[1], [4, d.Actions.invokeAction(m.INSIGHTS_PLAYER_PLAY, {
                    segmentId: o
                  })];

                case 2:
                  i.sent(), i.label = 3;

                case 3:
                  return [2];
              }
            });
          });
        });
      }, t.prototype.render = function () {
        return s.createElement(c.default, {
          getUrl: this.getUrl,
          isActive: this.props.isViewActive,
          name: t.viewName,
          onMessage: this.handleIncomingMessage,
          ref: this.ref
        });
      }, t.icon = "Dashboards", t.iconActive = "DashboardsBold", t.viewName = "dashboards", t.permissions = "dashboards.view", t;
    }(s.Component);

    t.DashboardsView = g;
  }, function (e, t, n) {
    "use strict";

    var _r167,
        o = this && this.__extends || (_r167 = function r(e, t) {
      return (_r167 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r167(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        a = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(38),
        l = n(8),
        u = n(13),
        p = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.getUrl = function (e) {
          return i(t, void 0, void 0, function () {
            var t;
            return a(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, e.getServiceSsoUrl("app", l.getFlexInsightsBaseUrl(u.Manager.getInstance().configuration) + "/inspections/", {
                    account_id: e.user && e.user.account_id
                  })];

                case 1:
                  return [2, "string" == typeof (t = n.sent()) ? t : ""];
              }
            });
          });
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(c.default, {
          getUrl: this.getUrl,
          isActive: this.props.isViewActive,
          name: "inspections"
        });
      }, t.icon = "Inspections", t.iconActive = "InspectionsBold", t.viewName = "inspections", t.permissions = "inspections.view", t;
    }(s.Component);

    t.InspectionsView = p;
  }, function (e, t, n) {
    "use strict";

    var _r168,
        o = this && this.__extends || (_r168 = function r(e, t) {
      return (_r168 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r168(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        a = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(38),
        l = n(8),
        u = n(13),
        p = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.getUrl = function (e) {
          return i(t, void 0, void 0, function () {
            var t;
            return a(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, e.getServiceSsoUrl("app", l.getFlexInsightsQuestionnairesUrl(u.Manager.getInstance().configuration), {
                    account_id: e.user && e.user.account_id
                  })];

                case 1:
                  return [2, "string" == typeof (t = n.sent()) ? t : ""];
              }
            });
          });
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(c.default, {
          getUrl: this.getUrl,
          isActive: this.props.isViewActive,
          name: "questionnaires"
        });
      }, t.icon = "Questionnaires", t.iconActive = "QuestionnairesBold", t.viewName = "questionnaires", t.permissions = "assessment.manage", t;
    }(s.Component);

    t.QuestionnairesView = p;
  }, function (e, t, n) {
    "use strict";

    var _r169,
        o = this && this.__extends || (_r169 = function r(e, t) {
      return (_r169 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r169(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        a = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(38),
        l = n(8),
        u = n(13),
        p = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.getUrl = function (e) {
          return i(t, void 0, void 0, function () {
            var t;
            return a(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, e.getServiceSsoUrl("app", l.getFlexInsightsBaseUrl(u.Manager.getInstance().configuration) + "/phrases/", {
                    account_id: e.user && e.user.account_id
                  })];

                case 1:
                  return [2, "string" == typeof (t = n.sent()) ? t : ""];
              }
            });
          });
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(c.default, {
          getUrl: this.getUrl,
          isActive: this.props.isViewActive,
          name: "speech-searches"
        });
      }, t.icon = "SpeechSearches", t.iconActive = "SpeechSearchesBold", t.viewName = "speech-searches", t.permissions = "phrases.view", t;
    }(s.Component);

    t.SpeechSearchesView = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(525);
    t.SideLinkInsightsDashboards = r.SideLinkInsightsDashboards;
  }, function (e, t, n) {
    "use strict";

    var _r170,
        o = this && this.__extends || (_r170 = function r(e, t) {
      return (_r170 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r170(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(4),
        u = n(37),
        p = n(23),
        d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(u.SideLinkView, i({}, this.props, {
          viewName: p.DashboardsView.viewName,
          icon: p.DashboardsView.icon,
          iconActive: p.DashboardsView.iconActive,
          template: l.templates.SideNavInsightsDashboardsView
        }));
      }, t.defaultProps = {}, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.SideLinkInsightsDashboards = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(527);
    t.SideLinkInsightsQuestionnaires = r.SideLinkInsightsQuestionnaires;
  }, function (e, t, n) {
    "use strict";

    var _r171,
        o = this && this.__extends || (_r171 = function r(e, t) {
      return (_r171 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r171(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(4),
        u = n(37),
        p = n(23),
        d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(u.SideLinkView, i({}, this.props, {
          viewName: p.QuestionnairesView.viewName,
          icon: p.QuestionnairesView.icon,
          iconActive: p.QuestionnairesView.iconActive,
          template: l.templates.SideNavInsightsQuestionnairesView
        }));
      }, t.defaultProps = {}, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.SideLinkInsightsQuestionnaires = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(529);
    t.SideLinkInsightsInspections = r.SideLinkInsightsInspections;
  }, function (e, t, n) {
    "use strict";

    var _r172,
        o = this && this.__extends || (_r172 = function r(e, t) {
      return (_r172 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r172(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(4),
        u = n(37),
        p = n(23),
        d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(u.SideLinkView, i({}, this.props, {
          viewName: p.InspectionsView.viewName,
          icon: p.InspectionsView.icon,
          iconActive: p.InspectionsView.iconActive,
          template: l.templates.SideNavInsightsInspectionsView
        }));
      }, t.defaultProps = {}, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.SideLinkInsightsInspections = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(531);
    t.SideLinkInsightsAgents = r.SideLinkInsightsAgents;
  }, function (e, t, n) {
    "use strict";

    var _r173,
        o = this && this.__extends || (_r173 = function r(e, t) {
      return (_r173 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r173(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(4),
        u = n(37),
        p = n(23),
        d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(u.SideLinkView, i({}, this.props, {
          viewName: p.AgentsView.viewName,
          icon: p.AgentsView.icon,
          iconActive: p.AgentsView.iconActive,
          template: l.templates.SideNavInsightsAgentsView
        }));
      }, t.defaultProps = {}, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.SideLinkInsightsAgents = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(533);
    t.SideLinkInsightsSpeechSearches = r.SideLinkInsightsSpeechSearches;
  }, function (e, t, n) {
    "use strict";

    var _r174,
        o = this && this.__extends || (_r174 = function r(e, t) {
      return (_r174 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r174(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(4),
        u = n(37),
        p = n(23),
        d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(u.SideLinkView, i({}, this.props, {
          viewName: p.SpeechSearchesView.viewName,
          icon: p.SpeechSearchesView.icon,
          iconActive: p.SpeechSearchesView.iconActive,
          template: l.templates.SideNavInsightsSpeechSearchesView
        }));
      }, t.defaultProps = {}, t = a([c.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.SideLinkInsightsSpeechSearches = d;
  }, function (e, t, n) {
    "use strict";

    var _r175,
        o = this && this.__extends || (_r175 = function r(e, t) {
      return (_r175 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r175(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(1),
        c = n(3),
        l = n(0),
        u = n(7),
        p = n(535),
        d = [];

    t.mapTaskStateToProps = function (e) {
      var t = Array.from(e.worker.tasks.values()).find(function (e) {
        return u.TaskHelper.isLiveCall(e);
      });
      return {
        currentCallTask: t,
        currentCallOnHold: t && u.TaskHelper.isCallOnHold(t),
        selectedView: e.view.activeView,
        monitoredTask: e.supervisor.callMonitoring.task,
        monitoredWorkers: e.supervisor.callMonitoring.workers || d,
        monitoringState: e.supervisor.callMonitoring.status
      };
    };

    var f = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return s.createElement(h, i({}, this.props));
      }, t.friendlyName = p.displayName, t.displayName = p.displayName, t.Content = p.contentStore, t = a([l.withDefaultPropsUpdate], t);
    }(s.PureComponent);

    t.LiveCommsBar = f;
    var h = c.connect(t.mapTaskStateToProps)(p.LiveCommsBarImpl);
  }, function (e, t, n) {
    "use strict";

    var _r176,
        o = this && this.__extends || (_r176 = function r(e, t) {
      return (_r176 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r176(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(16),
        c = n(0),
        l = n(536),
        u = n(213);
    t.displayName = "LiveCommsBar", t.contentStore = new c.DynamicContentStore(t.displayName);

    var p = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.prototype.render = function () {
        return this.props.monitoringState === s.CallMonitoringStatus.monitoring || this.props.currentCallTask && "agent-desktop" !== this.props.selectedView ? a.createElement(c.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, a.createElement(l.LiveCommsBarContainer, {
          className: "Twilio-LiveCommsBarItem-LiveCommsBarContainer"
        }, a.createElement(u.LiveCommsBarItem, i({
          key: "item"
        }, this.props)))) : null;
      }, n;
    }(a.PureComponent);

    t.LiveCommsBarImpl = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2);
    t.LiveCommsBarContainer = i.default("div")(o || (o = r(["\n    display: flex;\n    width: 100%;\n    z-index: 3;\n    overflow: hidden;\n    flex-direction: column;\n    flex: 0 0 auto;\n"], ["\n    display: flex;\n    width: 100%;\n    z-index: 3;\n    overflow: hidden;\n    flex-direction: column;\n    flex: 0 0 auto;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r177,
        o = this && this.__extends || (_r177 = function r(e, t) {
      return (_r177 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r177(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(16),
        c = n(538),
        l = n(539),
        u = n(214),
        p = n(4),
        d = n(7),
        f = n(5),
        h = n(6),
        m = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.getMessage = function () {
          if (t.props.monitoringState === s.CallMonitoringStatus.monitoring) {
            var e = t.props.monitoredTask,
                n = t.props.monitoredWorkers;
            return 0 === n.length ? i.createElement(a.Template, {
              source: p.templates.LiveCommsMonitoringMessageNoWorkers,
              task: e
            }) : 1 === n.length ? i.createElement(a.Template, {
              source: p.templates.LiveCommsMonitoringMessage,
              worker: n[0],
              task: e
            }) : i.createElement(a.Template, {
              source: p.templates.LiveCommsMonitoringMessageMoreWorkers,
              workers: n,
              task: e
            });
          }

          if (t.props.currentCallTask) {
            e = t.props.currentCallTask;
            return i.createElement(a.Template, {
              source: p.templates.LiveCommsOngoingCallMessage,
              task: e
            });
          }

          return null;
        }, t.getActions = function () {
          if (t.props.monitoringState === s.CallMonitoringStatus.monitoring) {
            var e = t.props.monitoredTask;
            return [{
              onClick: function onClick() {
                a.Actions.invokeAction("NavigateToView", {
                  viewName: "teams"
                }).then(function () {
                  return h.tryInvokeAction("SelectTaskInSupervisor", {
                    task: e
                  });
                }).catch(function (e) {
                  f.log.error(e);
                });
              },
              caption: p.templates.LiveCommsBarReturnToCall
            }, {
              onClick: function onClick() {
                return h.tryInvokeAction("StopMonitoringCall", {
                  task: e
                });
              },
              caption: p.templates.LiveCommsBarStopListening,
              actionsToListen: ["StopMonitoringCall"]
            }];
          }

          if (t.props.currentCallTask) {
            var n = t.props.currentCallTask,
                r = [{
              onClick: function onClick() {
                a.Actions.invokeAction("NavigateToView", {
                  viewName: "agent-desktop"
                }).then(function () {
                  return h.tryInvokeAction("SelectTask", {
                    task: n
                  });
                }).catch(function (e) {
                  return f.log.error(e);
                });
              },
              caption: p.templates.LiveCommsBarReturnToCall
            }];
            return d.TaskHelper.canHold(n) && (!d.TaskHelper.isRegularConferenceCall(n) || n.conference.liveParticipantCount <= 2) && r.push({
              actionsToListen: ["UnholdCall", "HoldCall"],
              onClick: function onClick() {
                var e = t.props.currentCallOnHold ? "UnholdCall" : "HoldCall";
                h.tryInvokeAction(e, {
                  task: n
                });
              },
              caption: t.props.currentCallOnHold ? p.templates.LiveCommsBarUnHold : p.templates.LiveCommsBarHold
            }), r;
          }

          return [];
        }, t;
      }

      return o(t, e), t.prototype.render = function () {
        var e = "",
            n = !1;
        return this.props.monitoringState === s.CallMonitoringStatus.monitoring ? e = "MonitorSmall" : this.props.currentCallTask && (e = this.props.currentCallOnHold ? "HoldBoldSmall" : "CallSmall", n = this.props.currentCallOnHold), i.createElement(a.DynamicComponent, {
          contentStore: t.Content,
          childProps: this.props,
          name: t.friendlyName,
          customChildren: this.props.children
        }, i.createElement(c.LiveCommsBarItemContainer, {
          showHold: n,
          className: "Twilio-LiveCommsBarItem-LiveCommsBarItemContainer"
        }, i.createElement(l.LiveCommsIcon, {
          key: "icon",
          icon: e
        }), i.createElement(c.MessageContainer, {
          key: "message",
          className: "Twilio-LiveCommsBarItem-MessageContainer"
        }, this.getMessage()), i.createElement(u.LiveCommsBarItemActions, {
          key: "actions",
          actions: this.getActions()
        })));
      }, t.friendlyName = "LiveCommsBarItem", t.displayName = t.friendlyName, t.Content = new a.DynamicContentStore(t.friendlyName), t;
    }(i.PureComponent);

    t.LiveCommsBarItem = m;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(2);
    t.LiveCommsBarItemContainer = a.default("div")(o || (o = r(["\n    display: flex;\n    min-height: 24px;\n    flex: 1 1 auto;\n    position: relative;\n    align-items: center;\n    padding-right: 4px;\n    padding-left: 4px;\n    padding-top: 4px;\n    padding-bottom: 4px;\n    background-color: ", ";\n    color: ", ";\n"], ["\n    display: flex;\n    min-height: 24px;\n    flex: 1 1 auto;\n    position: relative;\n    align-items: center;\n    padding-right: 4px;\n    padding-left: 4px;\n    padding-top: 4px;\n    padding-bottom: 4px;\n    background-color: ", ";\n    color: ", ";\n"])), function (e) {
      return e.showHold ? e.theme.colors.holdColor : e.theme.colors.flexBlueColor;
    }, function (e) {
      return e.theme.colors.lightTextColor;
    }), t.MessageContainer = a.default("div")(i || (i = r(["\n    margin-left: 8px;\n    margin-right: 4px;\n    align-self: center;\n    font-size: 12px;\n    flex-grow: 2;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n"], ["\n    margin-left: 8px;\n    margin-right: 4px;\n    align-self: center;\n    font-size: 12px;\n    flex-grow: 2;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(540);
    t.LiveCommsIcon = r.LiveCommsIcon;
  }, function (e, t, n) {
    "use strict";

    var _r178,
        o = this && this.__extends || (_r178 = function r(e, t) {
      return (_r178 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r178(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(541),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props.icon;
        return i.createElement(s.IconContainer, {
          className: "Twilio-LiveCommsBarItem-Icon"
        }, i.createElement(a.Icon, {
          icon: e
        }));
      }, t;
    }(i.PureComponent);

    t.LiveCommsIcon = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2);
    t.IconContainer = i.default("div")(o || (o = r(["\n    width: 24px;\n    max-height: 24px;\n"], ["\n    width: 24px;\n    max-height: 24px;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r179,
        o = this && this.__extends || (_r179 = function r(e, t) {
      return (_r179 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r179(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(0),
        s = n(543),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return i.createElement(a.DynamicComponent, {
          contentStore: t.Content,
          childProps: this.props,
          name: t.friendlyName,
          customChildren: this.props.children
        }, i.createElement(s.LiveCommsBarItemActionsContainer, {
          className: "Twilio-LiveCommsBarItemActionsContainer",
          noGrow: !0
        }, this.renderContents()));
      }, t.prototype.renderContents = function () {
        for (var e = [], t = function t(_t3) {
          var r = n.props.actions[_t3];
          e.push(i.createElement(a.ActionStateListener, {
            key: _t3,
            action: r.actionsToListen
          }, function (e) {
            return i.createElement(s.ActionButton, {
              onClick: r.onClick,
              disabled: e.disabled
            }, i.createElement(a.Template, {
              source: r.caption
            }));
          })), _t3 < n.props.actions.length - 1 && e.push("|");
        }, n = this, r = 0; r < this.props.actions.length; r++) {
          t(r);
        }

        return e;
      }, t.friendlyName = "LiveCommsBarItemActions", t.displayName = t.friendlyName, t.Content = new a.DynamicContentStore(t.friendlyName), t;
    }(i.Component);

    t.LiveCommsBarItemActions = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(2),
        s = n(0);
    t.ActionButton = a.default("button")(o || (o = r(["\n    padding-right: 10px;\n    padding-left: 10px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: normal;\n    background: inherit;\n    color: inherit;\n    border: none;\n    outline: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n"], ["\n    padding-right: 10px;\n    padding-left: 10px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: normal;\n    background: inherit;\n    color: inherit;\n    border: none;\n    outline: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n"]))), t.LiveCommsBarItemActionsContainer = a.default(s.FlexBox)(i || (i = r(["\n    font-size: 12px;\n    align-items: center;\n"], ["\n    font-size: 12px;\n    align-items: center;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r180,
        o = this && this.__extends || (_r180 = function r(e, t) {
      return (_r180 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r180(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(0),
        l = n(3),
        u = n(545),
        p = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(n, e), n.updateAll = function () {}, n.prototype.render = function () {
        return s.createElement(t.Connected, i({}, this.props));
      }, n.displayName = u.displayName, n.Content = u.contentStore, n.defaultProps = {
        defaultLocation: "/agent-desktop"
      }, n = a([c.withDefaultPropsUpdate], n);
    }(s.PureComponent);

    t.ViewCollection = p, t.Connected = l.connect(function (e) {
      return {
        router: e.router
      };
    })(u.ViewCollectionImpl);
  }, function (e, t, n) {
    "use strict";

    var _r181,
        o = this && this.__extends || (_r181 = function r(e, t) {
      return (_r181 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r181(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
        e += arguments[t].length;
      }

      var r = Array(e),
          o = 0;

      for (t = 0; t < n; t++) {
        for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) {
          r[o] = i[a];
        }
      }

      return r;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = n(1),
        s = n(63),
        c = n(0),
        l = n(216),
        u = n(67),
        p = n(3);
    t.displayName = "ViewCollection", t.contentStore = new c.DynamicContentStore(t.displayName);

    var d = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.keysOfViewsThatHaveBeenMounted = [], t.getActiveChild = function (e, n) {
          var r,
              o = a.Children.only(e);
          return a.Children.forEach(o.props.children, function (e) {
            a.isValidElement(e) && t.isActiveView(e, n) && !r && (r = e);
          }), r && r.props.name;
        }, t.debouncedWindowResizeListeners = u(function () {
          p.FlexModule.events.emitViewResized(window.innerWidth), p.FlexModule.events.emitSelectedViewChanged(t.getActiveChild(t.props.children, t.props.router), !0);
        }, 100), t.renderRouteChildren = function (e, n) {
          if ("start" !== n) return e;
          var r = t.props,
              o = r.router,
              i = r.defaultLocation;
          e = e.filter(function (e) {
            return a.isValidElement(e);
          });
          var c = o.location && !e.some(function (e) {
            return t.isActiveView(e);
          }),
              l = e.map(function (e) {
            var n = t.getRouteFromView(e);
            return t.shallRenderView(e) ? a.createElement(s.Route, {
              key: "view-" + e.props.name,
              exact: n.exact,
              path: "/" + e.props.name
            }, t.updateChildren(e)) : null;
          });
          return c ? [a.createElement(s.Redirect, {
            key: "redirect",
            to: {
              pathname: i,
              search: o.location.search
            }
          })] : l;
        }, t.updateChildren = function (e) {
          return function (n) {
            var r = t.isActiveView(e);
            return t.registerViewHavingBeenMounted(e.props.name), t.shallRenderView(e) && a.createElement(l.ViewImpl, {
              name: e.props.name,
              isViewActive: r,
              route: n
            }, e.props.children);
          };
        }, t;
      }

      return o(n, e), n.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.debouncedWindowResizeListeners);
      }, n.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.debouncedWindowResizeListeners);
      }, n.prototype.getPathnameFromRouter = function (e) {
        return e.location && e.location.pathname;
      }, n.prototype.getRouteFromView = function (e) {
        if (e.props.route) {
          if (Array.isArray(e.props.route.path)) {
            var t = e.props.route.path;
            return {
              path: i(t, ["/" + e.props.name])
            };
          }

          return {
            path: [e.props.route.path, "/" + e.props.name]
          };
        }

        return {
          path: "/" + e.props.name
        };
      }, n.prototype.isActiveView = function (e, t) {
        void 0 === t && (t = this.props.router);
        var n = this.getRouteFromView(e),
            r = this.getPathnameFromRouter(t);
        return !!s.matchPath(r, n);
      }, n.prototype.shallRenderView = function (e) {
        if (this.isActiveView(e)) return !0;
        if ("mountRule" in e.props) switch (e.props.mountRule) {
          case l.ViewMountRule.Always:
            return !0;

          case l.ViewMountRule.WhenHasBeenActive:
            return this.keysOfViewsThatHaveBeenMounted.indexOf(e.props.name) > -1;

          default:
            return !1;
        }
        return "keepMounted" in e.props && !1 !== e.props.keepMounted;
      }, n.prototype.registerViewHavingBeenMounted = function (e) {
        this.keysOfViewsThatHaveBeenMounted.indexOf(e) > -1 || this.keysOfViewsThatHaveBeenMounted.push(e);
      }, n.prototype.render = function () {
        return a.createElement(c.DynamicComponent, {
          name: t.displayName,
          contentStore: t.contentStore,
          childProps: this.props,
          customChildren: this.props.children,
          renderChildren: this.renderRouteChildren,
          noContainers: !0
        }, a.createElement(c.FlexBox, {
          className: "Twilio-ViewCollection",
          overflow: "hidden"
        }));
      }, n;
    }(a.PureComponent);

    t.ViewCollectionImpl = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.View = function () {
      return null;
    }, function (e) {
      e.Always = "Always", e.WhenActive = "WhenActive", e.WhenHasBeenActive = "WhenHasBeenActive";
    }(t.ViewMountRule || (t.ViewMountRule = {}));
  }, function (e, t, n) {
    "use strict";

    var _r182,
        o = this && this.__extends || (_r182 = function r(e, t) {
      return (_r182 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r182(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(21),
        c = n(548),
        l = n(29),
        u = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        this.conditionallySetActiveView();
      }, t.prototype.componentDidUpdate = function (e) {
        var t = this.props.route;
        e.isViewActive && t.location.pathname === e.route.location.pathname || this.conditionallySetActiveView();
      }, t.prototype.conditionallySetActiveView = function () {
        var e = this;
        this.props.isViewActive && setTimeout(function () {
          l.Actions.setActiveView(e.props.name);
        });
      }, t.prototype.render = function () {
        var e = this.props,
            t = e.isViewActive,
            n = e.children,
            r = e.route,
            o = e.name,
            l = e.className;
        return a.createElement(c.StyledViewFlexBox, {
          className: s.cx("Twilio-View", "Twilio-View-" + o, l),
          isViewActive: t
        }, a.Children.map(n, function (e) {
          var n = e;
          return a.isValidElement(e) ? a.cloneElement(n, i(i({}, e.props), {
            isViewActive: t,
            route: r
          })) : e;
        }));
      }, t;
    }(a.PureComponent);

    t.ViewImpl = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2);
    t.StyledViewFlexBox = i.default("div")(o || (o = r(["\n    display: ", ";\n    flex: 1 1 auto;\n    overflow: hidden;\n"], ["\n    display: ", ";\n    flex: 1 1 auto;\n    overflow: hidden;\n"])), function (e) {
      return e.isViewActive ? "flex" : "none";
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(550));
  }, function (e, t, n) {
    "use strict";

    var _r183,
        o = this && this.__extends || (_r183 = function r(e, t) {
      return (_r183 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r183(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(101),
        l = n(551),
        u = n(3),
        p = function p(e) {
      var t = e.queues,
          n = t.queuesList && !Object.keys(t.queuesList).length;
      return {
        isLoading: n && !t.hasFetchedList,
        hasNoData: n && t.hasFetchedList
      };
    },
        d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.isLoading,
            n = e.hasNoData,
            r = e.context;
        return s.createElement(l.QueueStatsViewImpl, i({
          isLoading: t,
          hasNoData: n,
          context: r
        }, this.props));
      }, t.displayName = l.displayName, t.Content = l.Content, t.Tiles = c.AggregatedQueuesDataTiles, t.Table = c.QueuesDataTable, t = a([u.connect(p)], t);
    }(s.PureComponent);

    t.QueueStatsView = d;
  }, function (e, t, n) {
    "use strict";

    var _r184,
        o = this && this.__extends || (_r184 = function r(e, t) {
      return (_r184 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r184(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        a = n(0),
        s = n(101),
        c = n(81),
        l = n(552),
        u = n(204),
        p = n(4),
        d = n(62),
        f = n(10),
        h = n(8),
        m = n(73);
    t.displayName = "QueueStatsView", t.Content = new a.DynamicContentStore(t.displayName);

    var g = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.isAdmin = function (e) {
          return e.manager.user.roles.indexOf("admin") >= 0;
        }, t;
      }

      return o(n, e), n.prototype.componentDidMount = function () {
        c.Actions.startPolling();
      }, n.prototype.componentWillUnmount = function () {
        c.Actions.stopPolling();
      }, n.prototype.render = function () {
        var e = this,
            n = this.props,
            r = n.isLoading,
            o = n.hasNoData,
            c = n.children;
        if (r) return i.createElement(l.LoadingContainer, null, i.createElement(a.CircularProgress, {
          animating: !0,
          size: 80,
          borderWidth: 3
        }));

        if (o) {
          var g = f.Manager.getInstance().serviceConfiguration.taskrouter_workspace_sid;
          return i.createElement(l.Container, null, i.createElement(d.FlexContext.Consumer, null, function (t) {
            return i.createElement(u.NoDataPlaceholder, {
              heading: i.createElement(p.Template, {
                source: p.templates.QueuesNoDataHeading
              }),
              body: i.createElement(p.Template, {
                source: e.isAdmin(t) ? p.templates.QueuesNoDataBodyForAdmin : p.templates.QueuesNoDataBodyForSupervisor
              }),
              linkText: e.isAdmin(t) ? i.createElement(p.Template, {
                source: p.templates.QueuesNoDataLinkLabelForAdmin
              }) : void 0,
              linkUrl: e.isAdmin(t) ? h.getTwilioTaskQueuesUrl(g) : void 0,
              image: i.createElement(a.Icon, {
                icon: "NoData",
                sizeMultiplier: 3
              })
            });
          }));
        }

        return i.createElement(a.DynamicComponent, {
          name: t.displayName,
          contentStore: t.Content,
          childProps: this.props,
          customChildren: c,
          vertical: !0
        }, i.createElement(l.Container, {
          vertical: !0
        }, i.createElement(m.QueueStatsConnectionStatusInfo, {
          key: "connection-info"
        }), i.createElement(s.AggregatedQueuesDataTiles, {
          key: "tiles"
        }), i.createElement(s.QueuesDataTable, {
          key: "table"
        })));
      }, n;
    }(i.PureComponent);

    t.QueueStatsViewImpl = g;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a = n(2),
        s = n(0);
    t.LoadingContainer = a.default("div")(o || (o = r(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 48px;\n    width: 100%;\n    ", "\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 48px;\n    width: 100%;\n    ", "\n"])), function (e) {
      return e.theme.QueueStats.Container;
    }), t.Container = a.default(s.FlexBox)(i || (i = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.QueueStats.Container;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(554);
    t.LogoutView = r.LogoutView;
  }, function (e, t, n) {
    "use strict";

    var _r185,
        o = this && this.__extends || (_r185 = function r(e, t) {
      return (_r185 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r185(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(63),
        s = n(6),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        s.tryInvokeAction("Logout", {
          forceLogout: !1
        });
      }, t.prototype.render = function () {
        return i.createElement(a.Redirect, {
          to: "/"
        });
      }, t;
    }(i.Component);

    t.LogoutView = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(2),
        a = n(0);
    t.StyledFlexBox = i.default(a.FlexBox)(o || (o = r(["\n    position: relative;\n    ", "\n"], ["\n    position: relative;\n    ", "\n"])), function (e) {
      return e.theme.MainContainer;
    });
  }, function (e, t, n) {
    "use strict";

    var _r186,
        o = this && this.__extends || (_r186 = function r(e, t) {
      return (_r186 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r186(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(1),
        a = n(3),
        s = n(27),
        c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.children,
            n = e.feature,
            r = e.disabledComponent;
        return n && n.enabled ? t : r || null;
      }, t;
    }(i.Component);

    t.FeatureFlagGuardComponent = c, t.FeatureFlagGuard = a.connect(function (e, t) {
      return {
        feature: s.featureFlagsSelector(e)[t.id]
      };
    })(c);
  }, function (e, t, n) {
    "use strict";

    var _r187,
        o = this && this.__extends || (_r187 = function r(e, t) {
      return (_r187 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r187(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        a = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        s = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var c = n(1),
        l = n(0),
        u = n(558),
        p = n(74),
        d = n(61),
        f = n(102),
        h = n(32),
        m = n(162),
        g = n(44),
        y = n(45),
        v = n(3),
        b = n(10),
        C = n(24),
        _ = n(8),
        k = n(18),
        w = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.state = {
          flexToken: b.Manager.getInstance().user.token,
          visible: !1
        }, n.onInitialized = function () {
          return a(n, void 0, void 0, function () {
            return s(this, function (e) {
              return [2, !0];
            });
          });
        }, n.show = function () {
          return a(n, void 0, void 0, function () {
            return s(this, function (e) {
              return [2, this.setState({
                visible: !0
              })];
            });
          });
        }, n.hide = function () {
          return a(n, void 0, void 0, function () {
            return s(this, function (e) {
              return [2, this.setState({
                visible: !1
              })];
            });
          });
        }, n.play = function (e) {
          return a(n, void 0, void 0, function () {
            var t;
            return s(this, function (n) {
              switch (n.label) {
                case 0:
                  if (!e) throw new Error("payload not provided");
                  return "segmentId" in e ? (t = e.segmentId, [3, 7]) : [3, 1];

                case 1:
                  if (!("taskSid" in e)) return [3, 6];
                  n.label = 2;

                case 2:
                  return n.trys.push([2, 4,, 5]), [4, f.getSegmentByTaskSid(e.taskSid, y.InsightsService.getInstance().identityClient)];

                case 3:
                  return t = n.sent(), [3, 5];

                case 4:
                  return n.sent(), l.Notifications.showNotification(k.FlexInsightsPlayerLoadingSegmentFailed), [3, 5];

                case 5:
                  return [3, 7];

                case 6:
                  throw new Error("segmentId or taskSid not provided");

                case 7:
                  return this.setState({
                    segmentId: t
                  }, function () {
                    l.Actions.invokeAction(d.INSIGHTS_PLAYER_SHOW);
                  }), [2];
              }
            });
          });
        }, n.setFlexToken = function (e) {
          n.setState({
            flexToken: e.token
          });
        }, n.onCloseClick = function () {
          l.Actions.invokeAction(d.INSIGHTS_PLAYER_HIDE), n.props.onPlayerClosed();
        }, n.openInConvScreen = function () {
          var e;
          n.props.mediaLink && ("url" in n.props.mediaLink ? e = encodeURIComponent(n.props.mediaLink.url) : "sid" in n.props.mediaLink && (e = encodeURIComponent(n.props.mediaLink.sid))), window.open(_.getFlexInsightsBaseUrl(b.Manager.getInstance().configuration) + "/player/segment/" + n.state.segmentId + "?mediaLinkId=" + e);
        }, n.playerConfig = i(i({}, p.defaultEnvConfig), _.getFlexInsightsPlayerConfig(b.Manager.getInstance().configuration)), n;
      }

      return o(t, e), t.prototype.componentDidUpdate = function (e, t) {
        (t.segmentId !== this.state.segmentId || t.visible !== this.state.visible) && this.state.segmentId && this.state.visible && this.fetchMediaLinks();
      }, t.prototype.getMediaUrl = function (e) {
        return this.playerConfig.mediaApiUrl + "/data/" + e;
      }, t.prototype.fetchMediaLinks = function () {
        return a(this, void 0, void 0, function () {
          var e, t, n, r, o;
          return s(this, function (i) {
            switch (i.label) {
              case 0:
                if (!(e = this.state.segmentId)) return [2];
                t = this.getMediaUrl(e), i.label = 1;

              case 1:
                return i.trys.push([1, 3,, 4]), [4, this.identityClient.axios.get(t)];

              case 2:
                return n = i.sent(), r = n.data._links.content, e === this.state.segmentId && (o = r.filter(function (e) {
                  return e.type !== h.InsightsPlayerMediaLinkType.Raw;
                }), this.props.onMediaLinksFetched(o)), [3, 4];

              case 3:
                return i.sent(), l.Notifications.dismissNotificationById(k.FlexInsightsPlayerLoadingSegmentFailed), l.Notifications.showNotification(k.FlexInsightsPlayerLoadingSegmentFailed), this.props.onMediaLinksFetched([]), [3, 4];

              case 4:
                return [2];
            }
          });
        });
      }, t.prototype.registerActions = function () {
        l.Actions.registerAction(d.INSIGHTS_PLAYER_PLAY, this.play), l.Actions.registerAction(d.INSIGHTS_PLAYER_SHOW, this.show), l.Actions.registerAction(d.INSIGHTS_PLAYER_HIDE, this.hide), l.Actions.registerAction(d.INSIGHTS_PLAYER_INITIALIZED, this.onInitialized);
      }, t.prototype.componentDidMount = function () {
        v.FlexModule.events.addListener(C.FlexEvent.tokenUpdated, this.setFlexToken), this.registerActions(), l.Actions.invokeAction(d.INSIGHTS_PLAYER_INITIALIZED, this);
      }, t.prototype.componentWillUnmount = function () {
        v.FlexModule.events.removeListener(C.FlexEvent.tokenUpdated, this.setFlexToken);
      }, t.prototype.render = function () {
        var e = this;
        return c.createElement(m.InsightsController, null, function (t) {
          var n = t.status,
              r = t.client;
          return e.identityClient = e.identityClient || r, n === g.InsightsServiceStatus.Ready ? c.createElement(u.PlayerComponent, {
            visible: e.state.visible,
            onClose: e.onCloseClick,
            segmentId: e.state.segmentId,
            identityClient: r,
            flexToken: e.state.flexToken,
            mediaLink: e.props.mediaLink,
            env: e.playerConfig,
            onOpenInConversationScreen: e.openInConvScreen
          }) : null;
        });
      }, t;
    }(c.PureComponent);

    t.Player = v.connect(function (e) {
      return {
        mediaLink: void 0 !== e.insights.selectedMediaLink ? e.insights.playerMediaLinks[e.insights.selectedMediaLink] : void 0
      };
    }, function (e) {
      return {
        onMediaLinksFetched: function onMediaLinksFetched(t) {
          return e({
            type: h.INSIGHTS_PLAYER_SET_MEDIA_LINKS,
            payload: t
          });
        },
        onPlayerClosed: function onPlayerClosed() {
          e({
            type: h.INSIGHTS_PLAYER_SET_MEDIA_LINKS,
            payload: []
          });
        }
      };
    })(w);
  }, function (e, t, n) {
    "use strict";

    var _r188,
        o = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
        i = this && this.__extends || (_r188 = function r(e, t) {
      return (_r188 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r188(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a,
        s,
        c = n(1),
        l = n(74),
        u = n(32),
        p = n(102),
        d = n(559),
        f = n(560),
        h = n(564),
        m = n(565),
        g = n(0),
        y = n(2),
        v = n(566),
        b = new g.DynamicContentStore("TranscriptPlayer"),
        C = y.default("div")(a || (a = o(["\n    position: absolute;\n    top: 5px;\n    left: 72px;\n    z-index: 1;\n"], ["\n    position: absolute;\n    top: 5px;\n    left: 72px;\n    z-index: 1;\n"]))),
        _ = y.default("div")(s || (s = o(["\n    display: flex;\n    ", "\n"], ["\n    display: flex;\n    ", "\n"])), function (e) {
      return e.theme.TranscriptPlayer.Sidepanel;
    }),
        k = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return i(t, e), t.prototype.renderContentByMediaType = function () {
        var e = this.props.mediaLink;
        return e ? e.type === u.InsightsPlayerMediaLinkType.VoiceRecording ? c.createElement(d.WrapperPlayer, null, c.createElement(C, null, c.createElement(f.MediaSelectDropdown, {
          width: 200
        })), c.createElement(l.default, {
          id: "Insights-Player_player",
          segmentId: this.props.segmentId,
          identityClient: this.props.identityClient,
          flexToken: this.props.flexToken,
          env: this.props.env
        }), c.createElement(d.CloseButton, {
          id: "Insights-Player_close-button",
          onClick: this.props.onClose
        }, "×")) : c.createElement(_, null, c.createElement(g.SidePanel, {
          displayName: "TranscriptPlayer",
          contentStore: b,
          handleCloseClick: this.props.onClose,
          title: p.getTitleForLink(e),
          rightButton: c.createElement(g.IconButton, {
            onClick: this.props.onOpenInConversationScreen,
            icon: "OpenInNewWindow",
            title: "Open in new window",
            sizeMultiplier: .7
          })
        }, c.createElement(d.WrapperSidebar, {
          key: "wrapper-sidebar"
        }, c.createElement(f.MediaSelectDropdown, {
          width: 285,
          key: "select"
        }), function () {
          switch (e.type) {
            case u.InsightsPlayerMediaLinkType.Embedded:
              return c.createElement(h.EmbeddedContent, {
                mediaLink: e,
                key: "embedded-content"
              });

            case u.InsightsPlayerMediaLinkType.Referenced:
              return c.createElement(m.ReferencedContent, {
                mediaLink: e,
                key: "referenced-content"
              });

            case u.InsightsPlayerMediaLinkType.ChatTranscript:
              return c.createElement(v.TranscriptContent, {
                mediaLink: e,
                key: "transcript-content"
              });

            default:
              return c.createElement("div", {
                key: "unknown-media"
              }, "Unknown Media Link type.");
          }
        }()))) : null;
      }, t.prototype.render = function () {
        return this.props.visible && this.props.segmentId && this.props.mediaLink ? this.renderContentByMediaType() : null;
      }, t;
    }(c.PureComponent);

    t.PlayerComponent = k;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s = n(0);
    t.WrapperPlayer = s.styled("div")(o || (o = r(["\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 180px;\n    background: #fff;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.35);\n    z-index: 10;\n"], ["\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 180px;\n    background: #fff;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.35);\n    z-index: 10;\n"]))), t.WrapperSidebar = s.styled("div")(i || (i = r(["\n    display: flex;\n    padding: 0 17px;\n    flex-direction: column;\n    flex: 1 1 auto;\n"], ["\n    display: flex;\n    padding: 0 17px;\n    flex-direction: column;\n    flex: 1 1 auto;\n"]))), t.CloseButton = s.styled("div")(a || (a = r(["\n    position: absolute;\n    top: 3px;\n    right: 4px;\n    font-size: 32px;\n    line-height: 32px;\n    color: #969696;\n    outline: none;\n    padding: 0 5px;\n    cursor: pointer;\n"], ["\n    position: absolute;\n    top: 3px;\n    right: 4px;\n    font-size: 32px;\n    line-height: 32px;\n    color: #969696;\n    outline: none;\n    padding: 0 5px;\n    cursor: pointer;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(561));
    var r = n(562);
    t.MediaSelectDropdown = r.MediaSelectDropdown;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(3),
        o = n(563),
        i = n(32);
    t.MediaSelectDropdown = r.connect(function (e) {
      return {
        mediaLinks: e.insights.playerMediaLinks,
        selectedIndex: e.insights.selectedMediaLink
      };
    }, function (e) {
      return {
        onLinkSelected: function onLinkSelected(t) {
          return e({
            type: i.INSIGHTS_PLAYER_MEDIA_SELECT,
            payload: t
          });
        }
      };
    })(o.MediaSelectDropdownImpl);
  }, function (e, t, n) {
    "use strict";

    var _r189,
        o = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
        i = this && this.__extends || (_r189 = function r(e, t) {
      return (_r189 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r189(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a,
        s,
        c = n(1),
        l = n(201),
        u = n(102),
        p = n(2),
        d = p.default("div")(a || (a = o(["\n    margin-bottom: 17px;\n    ", "\n"], ["\n    margin-bottom: 17px;\n    ", "\n"])), function (e) {
      var t = e.width;
      return t ? "width: " + t + "px" : "";
    }),
        f = p.default(l.MenuItem)(s || (s = o(["\n    box-sizing: border-box;\n    ", "\n"], ["\n    box-sizing: border-box;\n    ", "\n"])), function (e) {
      var t = e.width;
      return t ? "width: " + (t - 2) + "px" : "";
    }),
        h = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleChange = function (e) {
          t.props.onLinkSelected(parseInt(e.target.value, 10));
        }, t.getMediaLink = function (e, n) {
          return c.createElement(f, {
            value: n,
            key: n,
            width: t.props.width
          }, u.getTitleForLink(e));
        }, t;
      }

      return i(t, e), t.prototype.render = function () {
        return this.props.mediaLinks.length < 2 ? null : c.createElement(d, {
          width: this.props.width
        }, "Select a conversation", c.createElement(l.FormControl, {
          fullWidth: !0
        }, c.createElement(l.Select, {
          value: this.props.selectedIndex,
          onChange: this.handleChange
        }, this.props.mediaLinks.map(this.getMediaLink))));
      }, t;
    }(c.PureComponent);

    t.MediaSelectDropdownImpl = h;
  }, function (e, t, n) {
    "use strict";

    var _r190,
        o = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
        i = this && this.__extends || (_r190 = function r(e, t) {
      return (_r190 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r190(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a,
        s = n(1),
        c = n(2).default("iframe")(a || (a = o(["\n    width: 100%;\n    flex: 1;\n"], ["\n    width: 100%;\n    flex: 1;\n"]))),
        l = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return i(t, e), t.prototype.render = function () {
        return "url" in this.props.mediaLink ? s.createElement(c, {
          src: this.props.mediaLink.url,
          title: this.props.mediaLink.title,
          "data-test": "embedded-content"
        }) : null;
      }, t;
    }(s.PureComponent);

    t.EmbeddedContent = l;
  }, function (e, t, n) {
    "use strict";

    var _r191,
        o = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
        i = this && this.__extends || (_r191 = function r(e, t) {
      return (_r191 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r191(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        a = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s,
        c = n(1),
        l = n(0),
        u = n(2),
        p = (u.default("span")(s || (s = o(["\n    text-decoration: underline;\n    cursor: pointer;\n    &:hover {\n        text-decoration: none;\n    }\n"], ["\n    text-decoration: underline;\n    cursor: pointer;\n    &:hover {\n        text-decoration: none;\n    }\n"]))), function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.openLink = function () {
          "url" in t.props.mediaLink && window.open(t.props.mediaLink.url, "_blank");
        }, t;
      }

      return i(t, e), t.prototype.render = function () {
        var e = this.props.theme ? this.props.theme.colors.lightTextColor : l.BaseTheme.colors.lightTextColor,
            t = this.props.theme ? this.props.theme.colors.defaultButtonColor : l.BaseTheme.colors.defaultButtonColor;
        return "url" in this.props.mediaLink ? c.createElement("div", null, c.createElement("p", null, c.createElement("strong", null, "Referenced URL:"), c.createElement("br", null), this.props.mediaLink.url), c.createElement(l.Button, {
          onClick: this.openLink,
          roundCorners: !1,
          themeOverride: {
            color: e,
            background: t
          }
        }, "Open in a new tab")) : null;
      }, t = a([u.withTheme], t);
    }(c.PureComponent));
    t.ReferencedContent = p;
  }, function (e, t, n) {
    "use strict";

    var _r192,
        o = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
        i = this && this.__extends || (_r192 = function r(e, t) {
      return (_r192 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r192(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a,
        s = n(1),
        c = n(0),
        l = n(3),
        u = c.styled("div")(a || (a = o(["\n    display: flex;\n    flex: 1;\n    justify-content: center;\n\n    .Twilio-MessageList {\n        padding: 0;\n        padding-bottom: 1em;\n    }\n"], ["\n    display: flex;\n    flex: 1;\n    justify-content: center;\n\n    .Twilio-MessageList {\n        padding: 0;\n        padding-bottom: 1em;\n    }\n"]))),
        p = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return i(t, e), t.prototype.render = function () {
        return "sid" in this.props.mediaLink ? s.createElement(u, null, this.props.isLoading && s.createElement(c.CircularProgress, {
          animating: !0,
          size: 64
        }), this.props.hasError && s.createElement("div", null, "Could not load the chat transcript."), s.createElement(c.MessagingCanvas, {
          sid: this.props.mediaLink.sid,
          autoInitChannel: !0,
          hideFooterOnInactive: !0,
          showWelcomeMessage: !1
        })) : null;
      }, t;
    }(s.PureComponent);

    t.TranscriptContent = l.connect(function (e, t) {
      if ("sid" in t.mediaLink) {
        var n = e.chat.channels[t.mediaLink.sid];
        return {
          hasError: !!n && !!n.errorWhileLoadingChannel,
          isLoading: !!n && !!n.isLoadingChannel
        };
      }

      return {
        hasError: !1,
        isLoading: !1
      };
    })(p);
  }, function (e, t, n) {
    "use strict";

    var _r193,
        o = this && this.__extends || (_r193 = function r(e, t) {
      return (_r193 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r193(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        a = n(0),
        s = n(6),
        c = n(568),
        l = n(218),
        u = n(4),
        p = n(10),
        d = n(83);
    t.displayName = "OutboundDialerPanel", t.contentStore = new a.DynamicContentStore(t.displayName);

    var f = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          phoneNumber: "",
          selectedQueueSid: "",
          inProgress: !1,
          errorString: ""
        }, t.renderError = function (e) {
          return e === d.OutboundCallingErrors.missingDestination ? i.createElement(a.Template, {
            source: u.templates.OutboundErrorMissingDestination
          }) : e === d.OutboundCallingErrors.missingQueue ? i.createElement(a.Template, {
            source: u.templates.OutboundErrorMissingQueue
          }) : e === d.OutboundCallingErrors.generic ? i.createElement(a.Template, {
            source: u.templates.OutboundErrorGeneral
          }) : i.createElement(i.Fragment, null, i.createElement(a.Template, {
            source: u.templates.OutboundErrorGeneral
          }), i.createElement("br", null), i.createElement(a.Template, {
            code: "[ " + e + " ]"
          }));
        }, t.handleDial = function () {
          var e = t.state,
              n = e.phoneNumber,
              r = e.selectedQueueSid;
          n && (t.setState({
            inProgress: !0,
            errorString: ""
          }), s.tryInvokeAction("StartOutboundCall", {
            destination: n,
            queueSid: r
          }).then(function () {
            t.setState({
              inProgress: !1
            }), s.tryInvokeAction("ToggleOutboundDialer");
          }).catch(function (e) {
            t.setState({
              inProgress: !1,
              errorString: e.message
            });
          }));
        }, t.handleClose = function () {
          s.tryInvokeAction("ToggleOutboundDialer");
        }, t.handlePhoneNumberChange = function (e) {
          return t.setState({
            phoneNumber: e,
            errorString: ""
          });
        }, t.handleQueueChange = function (e) {
          return t.setState({
            selectedQueueSid: e,
            errorString: ""
          });
        }, t;
      }

      return o(n, e), n.prototype.render = function () {
        var e = this.state,
            n = e.inProgress,
            r = e.phoneNumber,
            o = e.errorString,
            s = e.selectedQueueSid,
            d = p.Manager.getInstance().serviceConfiguration.outbound_call_flows,
            f = d && d.default && d.default.location,
            h = p.Manager.getInstance().serviceConfiguration.taskrouter_offline_activity_sid,
            m = this.props.worker.activity.sid !== h;
        return i.createElement(l.Container, null, i.createElement(l.StyledSidePanel, {
          displayName: t.displayName,
          themeOverride: this.props.theme && this.props.theme.OutboundDialerPanel,
          handleCloseClick: this.handleClose,
          title: i.createElement(a.Template, {
            source: u.templates.OutboundDialerPanelTitle
          })
        }, m && i.createElement(a.DynamicComponent, {
          contentStore: t.contentStore,
          name: t.displayName,
          vertical: !0,
          childProps: this.props,
          noContainers: !0
        }, i.createElement(l.DialerContainer, {
          disabled: n
        }, i.createElement(l.Caption, {
          key: "dialer-phone-input",
          htmlFor: "dialer-phone-input",
          className: "Twilio-OutboundDialerPanel-PhoneInput-Caption"
        }, i.createElement(a.Template, {
          source: u.templates.OutboundDialerPanelPhoneInputCaption
        })), i.createElement(a.Dialer, {
          key: "dialer",
          onDial: this.handleDial,
          defaultPhoneNumber: r,
          onPhoneNumberChange: this.handlePhoneNumberChange,
          hideActions: !0,
          disabled: n,
          defaultCountryAlpha2Code: f
        }), i.createElement(l.Caption, {
          key: "queue-select-caption",
          className: "Twilio-OutboundDialerPanel-QueueSelect-Caption"
        }, i.createElement(a.Template, {
          source: u.templates.OutboundDialerPanelQueueSelectCaption
        })), i.createElement(c.OutboundDialerPanelQueueSelect, {
          key: "queue-select",
          selectedQueueSid: s,
          onChange: this.handleQueueChange,
          disabled: n
        }), i.createElement(l.CallControls, {
          key: "call-button"
        }, i.createElement(l.CallButton, {
          icon: "Call",
          disabled: n || !r || !s,
          onClick: this.handleDial,
          themeOverride: this.props.theme && this.props.theme.Dialer.CallButton
        }), n && i.createElement(l.CallAnimation, null, i.createElement(a.ConnectingAnimation, {
          sizeMultiplier: 2
        }))), o && i.createElement(l.ErrorMessage, {
          key: "error"
        }, this.renderError(o)))), !m && i.createElement(l.OfflineContainer, null, i.createElement(l.ErrorIcon, null), i.createElement(a.Template, {
          source: u.templates.NoOutboundCallingWhenOffline,
          offlineName: this.props.worker.activity.name
        }))));
      }, n;
    }(i.PureComponent);

    t.OutboundDialerPanelImpl = f;
  }, function (e, t, n) {
    "use strict";

    var _r194,
        o = this && this.__extends || (_r194 = function r(e, t) {
      return (_r194 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r194(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        a = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        c = n(50),
        l = n(3),
        u = n(40),
        p = n(25),
        d = n(218),
        f = n(4),
        h = n(10),
        m = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          queues: []
        }, t._isMounted = !1, t.handleQueuesResults = function (e) {
          var n = Object.keys(e).map(function (t) {
            var n = e[t],
                r = new u.InsightsQueue(n);
            return p.InsightsEntityCache.updateCache(r), r;
          }).sort(function (e, t) {
            var n = e.name || "",
                r = t.name || "";
            return n.localeCompare(r);
          });
          t.setState({
            queues: n
          });
          var r = h.Manager.getInstance().serviceConfiguration.outbound_call_flows,
              o = r && r.default && r.default.queue_sid;
          n.some(function (e) {
            return e.sid === o;
          }) ? t.props.onChange(o) : n.length && t.props.onChange(n[0].sid);
        }, t.handleChange = function (e) {
          t.props.onChange(e.target.value);
        }, t;
      }

      return o(t, e), t.prototype.componentDidMount = function () {
        return i(this, void 0, void 0, function () {
          var e;
          return a(this, function (t) {
            switch (t.label) {
              case 0:
                return this._isMounted = !0, e = this, [4, l.FlexModule.insightsClient.instantQuery("tr-queue")];

              case 1:
                return e.queuesSearch = t.sent(), this._isMounted && this.queuesSearch.on("searchResult", this.handleQueuesResults).search(""), [2];
            }
          });
        });
      }, t.prototype.componentWillUnmount = function () {
        this._isMounted = !1, this.queuesSearch && this.queuesSearch.removeAllListeners("searchResult");
      }, t.prototype.render = function () {
        return s.createElement(d.StyledSelect, {
          className: "Twilio-OutboundDialerPanel-QueueSelect",
          value: this.props.selectedQueueSid,
          onChange: this.handleChange,
          displayEmpty: !0,
          disabled: this.props.disabled
        }, s.createElement(c.default, {
          key: "placeholder",
          value: "",
          disabled: !0
        }, f.templates.OutboundDialerPanelQueueSelectCaption()), this.state.queues.map(function (e) {
          return s.createElement(c.default, {
            key: e.name,
            value: e.sid
          }, e.name);
        }));
      }, t.defaultProps = {
        selectedQueueSid: ""
      }, t;
    }(s.PureComponent);

    t.OutboundDialerPanelQueueSelect = m;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i = n(0),
        a = n(2);
    t.Container = a.default(i.FlexBoxColumn)(o || (o = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.RootContainer;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(217);
    t.OutboundDialerPanel = r.OutboundDialerPanel;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(133));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(49),
        o = n(48),
        i = n(574),
        a = n(575),
        s = n(576);

    t.registerActions = function () {
      r.WorkerActions.registerActions(), o.VoiceActions.registerActions(), i.SupervisorActions.registerActions(), a.GeneralActions.registerActions(), s.MessageActions.registerActions();
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(0),
        a = n(3),
        s = n(16),
        c = n(97),
        l = n(29),
        u = n(6),
        p = function () {
      function e() {}

      return e.registerActions = function () {
        i.Actions.registerAction("MonitorCall", e.monitorCall, this.updateTaskActionPayload), i.Actions.registerAction("StopMonitoringCall", e.stopMonitoringCall, this.updateTaskActionPayload), i.Actions.registerAction("SelectTaskInSupervisor", this.selectTaskInSupervisor, this.updateTaskActionPayload), i.Actions.registerAction("SelectWorkerInSupervisor", this.selectWorkerInSupervisor, this.updateSelectWorkerActionPayload);
      }, e.monitorCall = function (e) {
        return r(this, void 0, Promise, function () {
          var t;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return (t = a.FlexModule.state.worker.source) ? (t.monitor(e.task.taskSid, e.task.sid, e.extraParams), [4, s.Actions.monitorCall(e.task)]) : [3, 2];

              case 1:
                n.sent(), n.label = 2;

              case 2:
                return [2];
            }
          });
        });
      }, e.stopMonitoringCall = function (e) {
        return r(this, void 0, Promise, function () {
          return o(this, function (e) {
            return a.FlexModule.state.phone.connection && a.FlexModule.state.phone.connection.source.disconnect(), [2];
          });
        });
      }, e.selectTaskInSupervisor = function (e) {
        return r(this, void 0, Promise, function () {
          var t, n;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return t = e.task, l.Actions.selectTaskInSupervisor(t && t.sid), s.Actions.setStickyWorkerSid(t && t.workerSid, t && t.sid), l.Actions.selectWorkerInSupervisor(void 0), n = t ? t.sid : "", [4, u.tryInvokeAction("HistoryReplace", "/teams/tasks/" + n)];

              case 1:
                return r.sent(), [2];
            }
          });
        });
      }, e.selectWorkerInSupervisor = function (e) {
        return r(this, void 0, Promise, function () {
          var t, n;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return t = e.worker, l.Actions.selectTaskInSupervisor(void 0), s.Actions.setStickyWorkerSid(t && t.sid, void 0), l.Actions.selectWorkerInSupervisor(t && t.sid), n = t ? t.sid : "", [4, u.tryInvokeAction("HistoryReplace", "/teams/workers/" + n)];

              case 1:
                return r.sent(), [2];
            }
          });
        });
      }, e.updateSelectWorkerActionPayload = function (e) {
        return e.worker && (e.workerSid = e.worker.sid), e.workerSid && !e.worker && (e.worker = c.SupervisorStateHelper.getWorkerBySid(e.workerSid)), e;
      }, e.updateTaskActionPayload = function (e) {
        return e.task && (e.sid = e.task.sid), e.sid && !e.task && (e.task = c.SupervisorStateHelper.getTaskBySid(e.sid)), e;
      }, e;
    }();

    t.SupervisorActions = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function s(i) {
        return function (s) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }

                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }

                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }

                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(0),
        a = n(3),
        s = n(29),
        c = n(6),
        l = function () {
      function e() {}

      return e.registerActions = function () {
        i.Actions.registerAction("NavigateToView", e.navigateToView), i.Actions.registerAction("HistoryPush", s.Actions.push), i.Actions.registerAction("HistoryReplace", s.Actions.replace), i.Actions.registerAction("HistoryGo", s.Actions.go), i.Actions.registerAction("HistoryGoBack", s.Actions.goBack), i.Actions.registerAction("HistoryGoForward", s.Actions.goForward), i.Actions.registerAction("ShowDirectory", e.showDirectory), i.Actions.registerAction("HideDirectory", e.hideDirectory), i.Actions.registerAction("ToggleSidebar", e.toggleSidebar), i.Actions.registerAction("SetComponentState", e.setComponentState), i.Actions.registerAction("ApplyListFilters", e.applyListFilters), i.Actions.registerAction("RemoveListFilters", e.removeListFilters), i.Actions.registerAction("ReloadWindow", e.reloadWindow);
      }, e.navigateToView = function (e) {
        return r(this, void 0, Promise, function () {
          var t, n;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return "agent-desktop" !== e.viewName ? [3, 4] : a.FlexModule.state.view.selectedTaskSid ? [4, c.tryInvokeAction("HistoryPush", "/agent-desktop/" + a.FlexModule.state.view.selectedTaskSid)] : [3, 2];

              case 1:
                return r.sent(), [3, 3];

              case 2:
                c.tryInvokeAction("HistoryPush", "/agent-desktop/"), r.label = 3;

              case 3:
                return [3, 13];

              case 4:
                return "teams" !== e.viewName ? [3, 11] : a.FlexModule.state.view.selectedTaskInSupervisorSid ? [4, c.tryInvokeAction("HistoryPush", "/teams/tasks/" + a.FlexModule.state.view.selectedTaskInSupervisorSid)] : [3, 6];

              case 5:
                return r.sent(), [3, 10];

              case 6:
                return a.FlexModule.state.view.selectedWorkerInSupervisorSid ? [4, c.tryInvokeAction("HistoryPush", "/teams/workers/" + a.FlexModule.state.view.selectedWorkerInSupervisorSid)] : [3, 8];

              case 7:
                return r.sent(), [3, 10];

              case 8:
                return [4, c.tryInvokeAction("HistoryPush", "/teams/")];

              case 9:
                r.sent(), r.label = 10;

              case 10:
                return [3, 13];

              case 11:
                return t = /\//g, n = (n = e.viewName).replace(t, ""), [4, c.tryInvokeAction("HistoryPush", "/" + n + "/")];

              case 12:
                r.sent(), r.label = 13;

              case 13:
                return [2];
            }
          });
        });
      }, e.showDirectory = function () {
        return r(this, void 0, Promise, function () {
          return o(this, function (e) {
            return s.Actions.showDirectory(void 0), [2];
          });
        });
      }, e.hideDirectory = function () {
        return r(this, void 0, Promise, function () {
          return o(this, function (e) {
            return s.Actions.hideDirectory(), [2];
          });
        });
      }, e.toggleSidebar = function (e) {
        return r(this, void 0, Promise, function () {
          return o(this, function (t) {
            return e && void 0 !== e.open ? [2, e.open ? s.Actions.showSidebar() : s.Actions.hideSidebar()] : [2, s.Actions.toggleSidebar()];
          });
        });
      }, e.setComponentState = function (e) {
        return r(this, void 0, void 0, function () {
          return o(this, function (t) {
            return [2, s.Actions.setComponentState(e.name, e.state)];
          });
        });
      }, e.applyListFilters = function (e) {
        return r(this, void 0, Promise, function () {
          return o(this, function (t) {
            return e && s.Actions.applyListFilters(e), [2];
          });
        });
      }, e.removeListFilters = function (e) {
        return r(this, void 0, Promise, function () {
          return o(this, function (t) {
            return e && s.Actions.removeListFilters(e), [2];
          });
        });
      }, e.reloadWindow = function () {
        return r(this, void 0, Promise, function () {
          return o(this, function (e) {
            return window.location.reload(!0), [2];
          });
        });
      }, e;
    }();

    t.GeneralActions = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(0),
        o = n(7),
        i = n(12),
        a = n(17),
        s = function () {
      function e() {}

      return e.registerActions = function () {
        r.Actions.addListener("beforeSendMessage", this.beforeSendMessage);
      }, e.beforeSendMessage = function (e, t) {
        var n = e.body.trim().length,
            r = o.TaskHelper.getTaskFromChannelSid(e.channelSid),
            s = i.TaskChannels.getForTask(r).charLimit;
        n > s && (a.Notifications.showNotification(a.NotificationIds.MessageSizeExceeded, {
          currentCharCount: n,
          maxCharCount: s
        }), t());
      }, e;
    }();

    t.MessageActions = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(1),
        o = n(130),
        i = n(0),
        a = n(206),
        s = n(578),
        c = n(62),
        l = n(53),
        u = n(10),
        p = n(33),
        d = n(28),
        f = n(96),
        h = n(34),
        m = n(5),
        g = n(76);

    function y(e) {
      var t;
      return void 0 === e && (e = "body"), t = "string" == typeof e ? b(e) : e, o.unmountComponentAtNode(t), o.render(r.createElement(l.StorelessThemeProvider, {
        themeConf: {
          baseName: "FlexDark"
        }
      }, r.createElement(s.LoadingView, null)), t), this;
    }

    function v(e, t) {
      void 0 === e && (e = {}), void 0 === t && (t = "body");
      var n,
          a = h.getStoredConfig();
      return i.Utils.mergeInto(e, a, !1), p.SSOLoginHandler.hasValidToken() ? Promise.resolve() : (h.clearStoredConfig(), n = "string" == typeof t ? b(t) : t, e.sso = e.sso || {}, new Promise(function (t, i) {
        var a = function a(e) {
          t();
        };

        new Promise(function (t, n) {
          try {
            p.SSOLoginHandler.tryValidateConfig(e.sso), t();
          } catch (e) {
            n(e);
          }
        }).then(function () {
          return void 0 === e.sso.loginPopup ? h.fetchPublicConfiguration(e.sso.accountSid) : Promise.resolve({
            sso: {}
          });
        }).then(function () {
          return p.SSOLoginHandler.tryLogin(e.sso).then(function () {
            return t();
          });
        }).catch(function (t) {
          var s = t instanceof d.ConfigError && t.key === d.ConfigErrorKeys.accountSid,
              c = t instanceof d.BrowserError && (t.key === d.BrowserErrorKeys.popupBlocked || t.key === d.BrowserErrorKeys.windowClosed || t.key === d.BrowserErrorKeys.noWindowOpener),
              l = t instanceof d.ValidationError && (t.key === d.ValidationErrorKeys.sso || t.key === d.ValidationErrorKeys.accountSid),
              u = t instanceof d.ValidationError && t.key === d.ValidationErrorKeys.untrustedDomain,
              p = t instanceof d.ValidationError && t.key === d.ValidationErrorKeys.invalidCertificate;
          s || c || l || u || p ? o.render(r.createElement(f.LoginFormView, {
            userConfig: e,
            onError: i,
            onSuccess: a
          }), n) : (i(t), m.log.warn("error when trying to log in"));
        });
      }));
    }

    function b(e) {
      var t = document.querySelector(e);
      if (!t) throw new Error("Unable to find element for selector: " + t);
      return t;
    }

    t.create = function (e) {
      return C.create(e);
    }, t.progress = y, t.provideLoginInfo = v, t.runDefault = function (e, t) {
      return void 0 === e && (e = {}), void 0 === t && (t = "body"), y(t), v(e, t).then(function () {
        return window.history.replaceState({}, document.title, g.getDestinationURLFromLocation()), C.create(e);
      }).then(function (e) {
        return e.init(t);
      }).catch(function (e) {
        if (!(e instanceof d.BrowserError && e.key === d.BrowserErrorKeys.redirecting || e instanceof d.ClientError && e.key === d.ClientErrorKeys.metaNoReferrerMissing)) throw m.log.error("Unable to launch Flex:", e), e;
        m.log.debug("Flex redirecting");
      });
    }, t.tryLogin = function (e) {
      return void 0 === e && (e = {}), p.SSOLoginHandler.tryLogin(e);
    };

    var C = function () {
      function e(e) {
        this._manager = e;
      }

      return e.create = function (t) {
        return u.Manager.create(t).then(function (t) {
          return new e(t);
        });
      }, Object.defineProperty(e.prototype, "manager", {
        get: function get() {
          return this._manager;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.init = function (e) {
        var t;
        void 0 === e && (e = "body"), t = "string" == typeof e ? b(e) : e, o.unmountComponentAtNode(t), o.render(r.createElement(c.ContextProvider, {
          manager: this.manager
        }, r.createElement(a.RootContainer, null)), t);
      }, e;
    }();
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(579);
    t.LoadingView = r.LoadingView;
  }, function (e, t, n) {
    "use strict";

    var _r195,
        o = this && this.__extends || (_r195 = function r(e, t) {
      return (_r195 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r195(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__decorate || function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, n, a), a;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(1),
        s = n(2),
        c = n(43),
        l = n(188),
        u = n(580),
        p = c.languages.default.LoginLoading,
        d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return o(t, e), t.prototype.render = function () {
        return a.createElement(u.Container, {
          className: "Twilio-LoadingView"
        }, a.createElement(u.CenterContainer, {
          className: "Twilio-LoadingView-Container"
        }, a.createElement(l.LogoWithCircle, {
          animating: !0,
          backgroundColor: this.props.theme.LoadingView.Container.backgroundColor
        }), a.createElement(u.Label, {
          className: "Twilio-LoadingView-Label"
        }, p)));
      }, t = i([s.withTheme], t);
    }(a.PureComponent);

    t.LoadingView = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o,
        i,
        a,
        s = n(2);
    t.Container = s.default("div")(o || (o = r(["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    height: 100%;\n    ", "\n"], ["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    height: 100%;\n    ", "\n"])), function (e) {
      return e.theme.LoadingView.Container;
    }), t.Label = s.default("div")(i || (i = r(["\n    position: relative;\n    font-size: 14px;\n    margin-top: 30px;\n    text-align: center;\n"], ["\n    position: relative;\n    font-size: 14px;\n    margin-top: 30px;\n    text-align: center;\n"]))), t.CenterContainer = s.default("div")(a || (a = r(["\n    position: relative;\n    margin: auto;\n"], ["\n    position: relative;\n    margin: auto;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(56),
        o = n(12),
        i = n(0),
        a = n(83);

    t.initialize = function () {
      o.registerDefaultTaskChannels(r), i.resetCSS(), i.registerStyles(), i.initialize(), a.OutboundCalling.initialize();
    };
  }]);
});